// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27white%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%276%27 viewBox=%270 0 10 6%27 fill=%27none%27%3E%3Cpath d=%27M1 1L5 5L9 1%27 stroke=%27%236B6960%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%275%27 viewBox=%270 0 8 5%27 fill=%27none%27%3E%3Cpath d=%27M1 1L4 4L7 1%27 stroke=%27%236B6960%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%275%27 viewBox=%270 0 8 5%27 fill=%27none%27%3E%3Cpath d=%27M1 1L4 4L7 1%27 stroke=%27white%27 stroke-width=%271.5%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2710%27 height=%2710%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%274%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%2720 6 9 17 4 12%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reusable UI components — sidebar, header, footer, buttons, cards, tables, forms, badges, drawers, reports, charts
   Colors: var(--c-*), var(--text2), var(--ink-*), var(--border-*), var(--shadow-*) from tokens.css */

/* Sidebar */
.sidebar {
  width: 260px;
  min-width: 260px;
  background: var(--c-white);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow: visible;
  z-index: 50;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.sidebar.collapsed {
  width: 64px;
  min-width: 64px;
}

.logo {
  box-sizing: border-box;
  min-height: var(--layout-logo-block-height);
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--border);
  overflow: hidden;
}

.sidebar.collapsed .logo {
  padding: 20px 0;
  display: flex;
  justify-content: center;
}

.sidebar-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.sidebar.collapsed .sidebar-header {
  flex-direction: column;
  gap: 12px;
}

.sidebar-toggle-btn {
  background: transparent;
  border: 1px solid var(--border-color-strong);
  color: var(--text2);
  width: 24px;
  height: 24px;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.1s;
}

.sidebar-toggle-btn:hover {
  background: var(--c-black);
  color: var(--c-white);
  border-color: var(--ink-emphasis);
}

.logo-mark {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
  white-space: nowrap;
}

.logo-icon {
  width: var(--logo-icon-size);
  height: var(--logo-icon-size);
  background: var(--c-neon);
  border: 2px solid var(--border-color-strong);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 600;
  color: var(--ink-emphasis);
  letter-spacing: -0.5px;
  flex-shrink: 0;
}

.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.2;
}

.logo-name {
  font-size: 22px;
  font-weight: 600;
  color: var(--c-black);
  letter-spacing: -0.3px;
}

.logo-sub {
  font-size: 12px;
  color: var(--text3);
  padding-left: 0;
}

.nav {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: visible;
  padding: 12px 0;
}

.sidebar.collapsed .nav {
  overflow: visible;
}

.nav-section-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  padding: 10px 20px 4px;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  margin: 2px 12px;
  font-size: 13px !important;
  font-weight: 500;
  color: var(--c-black);
  cursor: pointer;
  transition: all 0.15s;
  border-radius: 8px;
  position: relative;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
}

.sidebar.collapsed .nav-item {
  padding: 10px 0;
  margin: 2px 4px;
  justify-content: center;
  gap: 0;
}

.sidebar.collapsed .nav-item .nav-icon {
  margin: 0;
}

.nav-item:hover {
  background: var(--c-white);
  color: var(--c-black);
  border-radius: 8px;
}

.nav-item.active {
  background: var(--text3);
  color: var(--c-white);
  font-weight: 500;
  border-radius: 8px;
}

.nav-item.active.black-active {
  background: var(--c-black);
  color: var(--c-white);
}

/* Accordion parents (State Insurance Filings, Nexus, SEC Filing, Prompt Pulse): grey only */
.nav-item-group > .nav-item.active,
.nav-item-group > .nav-item.active.black-active {
  background: var(--text3);
  color: var(--c-white);
}

.nav-item-group > .nav-item.active .nav-icon,
.nav-item-group > .nav-item.active.black-active .nav-icon {
  color: var(--c-white);
}

.nav-item.active.black-active .nav-icon {
  color: var(--c-white);
}

.nav-item--disabled {
  cursor: default;
  opacity: 0.4;
  color: var(--c-black);
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.nav-item--disabled .sidebar-style-1 {
  color: var(--c-black);
}

.nav-sub {
  display: flex;
  flex-direction: column;
  margin-top: 2px;
  margin-bottom: 6px;
}

.nav-sub-item {
  display: flex;
  align-items: center;
  padding: 6px 16px 6px 42px;
  margin: 2px 12px;
  font-size: 12px !important;
  font-weight: 500;
  color: var(--c-black);
  cursor: pointer;
  text-decoration: none;
  transition: all 0.15s;
  white-space: nowrap;
  border-radius: 8px;
}

.nav-sub-item:hover {
  color: var(--c-black);
  background: var(--c-white);
  border-radius: 8px;
}

.nav-sub-item.active {
  color: var(--c-white);
  font-weight: 500;
  background: var(--c-black);
  border-radius: 8px;
}

.sidebar.collapsed .nav-sub,
.sidebar.collapsed .nav-sub--collapsed-flyout {
  display: flex;
  position: absolute;
  left: calc(100% + 8px);
  top: 0;
  min-width: 150px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 6px;
  box-shadow: var(--shadow-dropdown);
  z-index: 200;
  transform-origin: left center;
}

.sidebar.collapsed .nav-sub--collapsed-flyout {
  opacity: 0;
  transform: translateX(-10px) scale(0.98);
  transition:
    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: none;
}

.sidebar.collapsed .nav-sub--collapsed-flyout.is-open {
  opacity: 1;
  transform: translateX(0) scale(1);
  pointer-events: auto;
}

@media (prefers-reduced-motion: reduce) {
  .sidebar.collapsed .nav-sub--collapsed-flyout {
    transition: none;
  }
}

.sidebar.collapsed .nav-item-group {
  position: relative;
  overflow: visible;
}

.sidebar.collapsed .nav-sub-item {
  margin: 0;
  padding: 8px 10px;
  font-size: 12px;
}

.nav-icon {
  width: 16px;
  height: 16px;
  opacity: 0.5;
  flex-shrink: 0;
}

.nav-item.active .nav-icon {
  opacity: 1;
  color: var(--c-white);
}

.nav-badge {
  margin-left: auto;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 10px;
  background: var(--red-bg);
  color: var(--red-text);
}

.nav-badge.amber {
  background: var(--orange-bg);
  color: var(--amber-text);
}

.sidebar-footer {
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  background: var(--c-white);
  transition: all 0.2s;
}

.sidebar.collapsed .sidebar-footer {
  padding: 16px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.sidebar-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  margin-bottom: 12px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
  color: var(--text2);
  transition: all 0.1s;
  white-space: nowrap;
}

.sidebar.collapsed .sidebar-toggle {
  padding: 8px;
  margin-bottom: 0;
}

.sidebar-toggle:hover {
  background: var(--c-white);
  color: var(--c-black);
  border-color: var(--border2);
}

.sf-user {
  overflow: hidden;
}


.sf-label {
  font-size: 10px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sf-time {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 2px;
}

.sf-status {
  font-size: 11px;
  color: var(--c-teal-active);
  margin-top: 1px;
}

.sf-logout {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin-top: 10px;
  padding: 7px 9px;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--c-white);
  color: var(--ink-body);
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}

.sf-logout:hover {
  border-color: var(--border-hover);
  background: var(--bar-track-bg);
  color: var(--c-black);
}

.sf-logout--collapsed {
  width: 40px;
  height: 40px;
  margin-top: 0;
  padding: 0;
  flex-shrink: 0;
}

.sidebar.collapsed .sf-logout {
  margin-top: 0;
}

.sidebar-style-1 {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sidebar-style-2 {
  flex-shrink: 0;
  width: 14px;
  height: 14px;
  transition: transform 0.2s;
  opacity: 0.5;
}

.login-shell {
  min-height: 100vh;
  display: grid;
  place-items: center;
  position: relative;
  overflow: hidden;
  padding: 32px;
  background:
    radial-gradient(circle at 20% 20%, var(--glow-neon), transparent 26%),
    radial-gradient(circle at 78% 18%, var(--glow-purple), transparent 30%),
    radial-gradient(circle at 80% 86%, var(--glow-teal), transparent 28%),
    var(--login-bg-base);
}

.login-shell::before {
  content: '';
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(var(--grid-line) 1px, transparent 1px),
    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(circle at center, black 0%, transparent 74%);
}

.login-orb {
  position: absolute;
  border-radius: 999px;
  filter: blur(1px);
  opacity: 0.75;
  animation: loginFloat 9s ease-in-out infinite;
}

.login-orb-one {
  width: 280px;
  height: 280px;
  top: 9%;
  right: 12%;
  background: radial-gradient(circle, var(--glow-blue), transparent 68%);
}

.login-orb-two {
  width: 230px;
  height: 230px;
  bottom: 14%;
  left: 10%;
  background: radial-gradient(circle, var(--glow-orange), transparent 68%);
  animation-delay: 1.5s;
}

.login-orb-three {
  width: 170px;
  height: 170px;
  top: 36%;
  left: 18%;
  background: radial-gradient(circle, var(--glow-teal-soft), transparent 68%);
  animation-delay: 3s;
}

@keyframes loginFloat {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  50% {
    transform: translate3d(10px, -16px, 0) scale(1.04);
  }
}

.login-card {
  width: min(100%, 440px);
  position: relative;
  z-index: 1;
  padding: 28px;
  border: 1px solid var(--border-panel);
  border-radius: 24px;
  background: var(--surface-glass);
  box-shadow:
    var(--shadow-card),
    inset 0 1px 0 var(--surface-highlight);
  backdrop-filter: blur(18px);
}

.login-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 28px;
}

.login-brand-mark {
  width: 44px;
  height: 44px;
  display: grid;
  place-items: center;
  border: 2px solid var(--ink-mark);
  border-radius: 12px;
  background: var(--c-neon);
  color: var(--ink-overlay);
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.04em;
}

.login-brand-name {
  color: var(--c-black);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.1;
}

.login-brand-subtitle {
  color: var(--text2);
  font-size: 12px;
}

.login-copy {
  margin-bottom: 24px;
}

.login-kicker {
  margin: 0 0 8px;
  color: var(--c-teal-active);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.login-copy h1 {
  margin: 0;
  color: var(--c-black);
  font-family: var(--font-display);
  font-size: 36px;
  line-height: 0.95;
  letter-spacing: -0.04em;
}

.login-copy p:last-child {
  margin: 10px 0 0;
  color: var(--text2);
  font-size: 13px;
  line-height: 1.55;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  color: var(--ink-body-strong);
  font-size: 12px;
  font-weight: 600;
}

.login-input-wrap {
  min-height: 46px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 13px;
  border: 1px solid var(--border-input);
  border-radius: 14px;
  background: var(--surface-glass);
  color: var(--text3);
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}

.login-input-wrap:focus-within {
  border-color: var(--focus-border-blue);
  background: var(--c-white);
  box-shadow: 0 0 0 4px var(--focus-shadow-blue);
}

.login-input-wrap input {
  min-width: 0;
  flex: 1 1;
  border: 0;
  outline: 0;
  background: transparent;
  color: var(--c-black);
  font: inherit;
  font-size: 13px;
  font-weight: 500;
}

.login-input-wrap input::placeholder {
  color: var(--ink-subtle);
}

.login-password-toggle {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 9px;
  background: transparent;
  color: var(--ink-faint);
  cursor: pointer;
}

.login-password-toggle:hover {
  background: var(--border-subtle);
  color: var(--ink-emphasis);
}

.login-form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 24px;
}

.login-remember {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--text2);
  font-size: 12px;
  font-weight: 500;
}

.login-remember input {
  width: 14px;
  height: 14px;
  accent-color: var(--c-blue-1);
}

.login-error {
  padding: 10px 12px;
  border: 1px solid var(--error-border);
  border-radius: 12px;
  background: var(--red-bg);
  color: var(--red-text);
  font-size: 12px;
  line-height: 1.4;
}

.login-submit {
  height: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border: 0;
  border-radius: 14px;
  background: var(--c-black);
  color: var(--c-white);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}

.login-submit:hover:not(:disabled) {
  transform: translateY(-1px);
  background: var(--ink-overlay);
  box-shadow: var(--shadow-submit);
}

.login-submit:disabled {
  cursor: not-allowed;
  opacity: 0.68;
}

@media (max-width: 560px) {
  .login-shell {
    padding: 18px;
  }

  .login-card {
    padding: 22px;
    border-radius: 20px;
  }

  .login-copy h1 {
    font-size: 31px;
  }
}


/* Page header (topbar) */
.topbar {
  box-sizing: border-box;
  min-height: var(--layout-logo-block-height);
  background: var(--c-white);
  border-bottom: 1px solid var(--border);
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
}

.topbar-left {
  display: flex;
  flex-direction: column;
}

.topbar-title {
  font-family: var(--font-display);
  font-size: 20px;
  font-weight: 500;
  color: var(--c-black);
  letter-spacing: -0.3px;
}

.back-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  color: var(--text3);
  transition: all 0.1s;
  border: 1px solid transparent;
}

.back-btn:hover {
  background: var(--c-white);
  color: var(--c-black);
  border-color: var(--border);
}

.topbar-sub {
  font-size: 12px;
  color: var(--text3);
  margin-top: 1px;
}

.topbar-right {
  display: flex;
  gap: 8px;
  align-items: center;
}

.page-header-filters {
  display: flex;
  gap: 12px;
  align-items: center;
}

.page-tabs-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 24px;
  background: var(--c-white);
  border-bottom: 1px solid var(--border-panel);
  position: sticky;
  top: 53px;
  z-index: 9;
}

.page-tabs {
  display: inline-flex;
  background: var(--c-white);
  border: 1px solid var(--ui-border-input);
  border-radius: 8px;
  padding: 4px;
  gap: 4px;
}

.page-tab {
  padding: 6px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text2);
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  background: transparent;
  text-align: center;
}

.page-tab:hover {
  color: var(--c-black);
}

.page-tab.active {
  background: var(--ink-overlay);
  color: var(--c-white);
  box-shadow: var(--shadow-control);
  font-weight: 500;
}

.chip {
  font-size: 11px;
  padding: 4px 10px;
  border-radius: 20px;
  border: 1px solid var(--border);
  color: var(--text2);
  background: var(--c-white);
}

/* Report / document header & footer */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2.5px solid var(--c-blue-1);
  padding-bottom: 10px;
  margin-bottom: 13px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-logo {
  height: 36px;
  width: auto;
}

.header-divider {
  width: 1.5px;
  height: 32px;
  background: var(--c-white);
}

.header-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.report-label {
  font-size: var(--fs-xs);
  font-weight: 700;
  letter-spacing: .14em;
  text-transform: uppercase;
  color: var(--c-blue-2);
}

.report-title {
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--c-blue-1);
}

.header-right {
  text-align: right;
  color: var(--text3);
  font-size: var(--fs-xs);
  line-height: 1.75;
}

.week-badge {
  display: inline-block;
  background: var(--c-blue-1);
  color: var(--c-white);
  font-size: var(--fs-xs);
  font-weight: 700;
  padding: 3px 11px;
  border-radius: 20px;
}

.footer {
  margin-top: 10px;
  padding-top: 6px;
  border-top: 1px solid var(--c-white);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 8.5px;
  color: var(--text3);
}

.footer-logo {
  height: 18px;
  width: auto;
  opacity: 0.6;
}

.btn {
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  padding: 7px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--border2);
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
  transition: all 0.15s;
}

.btn:hover {
  background: var(--c-white);
}

.btn-export {
  background: var(--c-white);
  color: var(--ink-emphasis);
  border: 1px solid var(--border-color-strong);
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.btn-export:hover {
  background: var(--text2);
  color: var(--c-white);
  /* border-color: var(--c-purple-1); */
}

.btn-primary {
  background: var(--c-black);
  color: var(--c-white);
  border-color: var(--ink-emphasis);
}

.btn-primary:hover {
  background: var(--ink-emphasis);
}

/* Map Toggle Buttons */
.btn-map-toggle {
  padding: 8px 16px !important;
  font-size: 11px !important;
  height: 36px !important;
  display: inline-flex !important;
  align-items: center !important;
}

/* Content */
.content {
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1 1;
  overflow-y: auto;
}
/* Stats */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  flex-shrink: 0;
}

.stat-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 18px;
}

.stat-label {
  font-size: 11px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.stat-value {
  font-size: 28px;
  font-weight: 600;
  color: var(--c-black);
  margin-top: 4px;
  letter-spacing: -1px;
}

.stat-sub {
  font-size: 12px;
  color: var(--text2);
  margin-top: 3px;
}

.stat-delta {
  font-size: 11px;
  margin-top: 6px;
}

.stat-delta.up {
  color: var(--c-teal-active);
}

.stat-delta.down {
  color: var(--c-orange);
}

/* Panels */
.panel {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.panel-header {
  padding: 14px 18px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.panel-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--c-black);
}

.panel-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Pills */
.pill {
  display: inline-flex;
  align-items: center;
  font-size: 11px;
  font-weight: 500;
  padding: 3px 8px;
  border-radius: var(--radius);
}

.pill-blue {
  background: var(--c-cyan-1);
  color: var(--c-blue-1);
}

.pill-green {
  background: var(--c-aqua-mass);
  color: var(--green-text);
}

.pill-amber {
  background: var(--orange-bg);
  color: var(--amber-text);
}

.pill-red {
  background: var(--red-bg);
  color: var(--red-text);
}

.pill-outline {
  background: transparent;
  color: var(--text2);
  border: 1px solid var(--border);
}

.pill-purple {
  background: var(--c-purple-4);
  color: var(--c-purple-1);
}

/* Table */
.table-wrap {
  flex: 1 1;
  overflow: auto;
  /* min-height: 480px; */
}

.table-wrap table,
.table-wrap-inline table {
  table-layout: auto;
}

.table-wrap-inline {
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
  background: var(--c-white);
}

th {
  text-align: left;
  padding: 16px;
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink-emphasis);
  text-transform: none;
  letter-spacing: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: 1px solid var(--border);
}

.th-sort {
  display: flex;
  align-items: center;
  gap: 2px;
}

.sort-arrow {
  font-size: 10px;
  opacity: 0.3;
}

.sort-arrow.active {
  opacity: 1;
  color: var(--c-black);
}

.col-tn {
  /* Dynamic width */
}

.col-company {
  /* No fixed width, will take remaining space */
}

.col-state {
  /* Dynamic width */
}

.col-type {
  /* Dynamic width */
}

.col-toi {
  /* Dynamic width */
}

.col-status {
  /* Dynamic width */
}

.date-cell {
  width: 100px;
  text-transform: uppercase;
}

.col-count {
  width: 60px;
  text-align: center;
}

.col-zip {
  width: 60px;
  text-align: center;
}

td {
  padding: 18px 16px;
  border-bottom: 1px solid var(--border);
  color: var(--c-black);
  vertical-align: middle;
}

tr {
  height: 64px;
}

tr:last-child td {
  border-bottom: none;
}

tr:hover td {
  background: var(--c-white);
}

tr.selected td,
tr.selected:hover td {
  background: var(--c-cyan-0);
}

.tn {
  font-family: var(--font);
  font-size: 13px;
  color: var(--c-black);
  font-weight: 500;
  text-decoration: underline;
  cursor: pointer;
}

.company {
  font-weight: 500;
  color: var(--c-black);
  max-width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.zip-yes {
  color: var(--c-teal-active);
  font-weight: 500;
  font-size: 11px;
}

.zip-no {
  color: var(--text3);
  font-size: 11px;
}

/* Filters */
.filters {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 18px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
}

.select-wrap {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  background: var(--c-white);
  border: 1px solid var(--border-color-strong);
  border-radius: var(--radius);
  height: 32px;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.15s;
}

.select-wrap:hover {
  background: var(--ink-emphasis);
  border-color: var(--ink-emphasis);
}

.select-wrap:hover .filter-select,
.select-wrap:hover .select-measure {
  color: var(--c-white);
}

.select-wrap:hover::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.select-wrap:focus-within {
  border-color: var(--c-black);
}

.select-measure {
  display: inline-block;
  visibility: hidden;
  white-space: pre;
  padding: 0 28px 0 10px;
  font-size: 12px;
  font-family: var(--font);
  height: 30px;
  line-height: 30px;
  min-width: 60px;
  pointer-events: none;
}

.filter-select {
  position: absolute;
  top: 0;
  left: 0;
  width: auto;
  min-width: 100%;
  height: 100%;
  font-family: var(--font);
  font-size: 12px;
  padding: 0 28px 0 10px;
  border: none !important;
  background: transparent !important;
  color: var(--c-black);
  cursor: pointer;
  appearance: none;
  outline: none !important;
  box-shadow: none !important;
  margin: 0;
  z-index: 1;
}

.filter-select:focus {
  border-color: var(--c-black);
}

.select-wrap::after {
  content: '';
  position: absolute;
  right: 10px;
  top: 50%;
  width: 10px;
  height: 6px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-size: contain;
  transform: translateY(-50%);
  transition: transform 0.2s ease;
  pointer-events: none;
}

.select-wrap.is-open::after {
  transform: translateY(-50%) rotate(180deg);
}

.filter-select option {
  font-family: var(--font);
  background: var(--c-white);
  color: var(--c-black);
}

.search-input {
  font-family: var(--font);
  font-size: 12px;
  padding: 0 10px;
  height: 36px;
  box-sizing: border-box;
  border: 1px solid var(--ui-border-input);
  border-radius: var(--radius);
  background: var(--c-white);
  color: var(--c-black);
  width: 220px;
}

.search-input::placeholder {
  font-family: var(--font);
  color: var(--text3);
}

.search-input:focus {
  outline: none;
  border-color: var(--c-black);
}
/* Detail drawer */
.drawer {
  width: 360px;
  min-width: 0; /* Allow interpolation */
  min-height: 0; /* Allow flex shrink so drawer-body can scroll */
  background: var(--c-white);
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-header {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-shrink: 0;
  background: var(--c-white);
}

.drawer-tn {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.drawer-company {
  font-size: 18px;
  font-weight: 600;
  color: var(--c-black);
  margin-top: 3px;
  letter-spacing: -0.2px;
}

.drawer-toi {
  font-size: 12px;
  color: var(--text2);
  margin-top: 3px;
  line-height: 1.4;
}

.drawer-close {
  color: var(--text3);
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  padding: 2px;
  flex-shrink: 0;
}

.drawer-close:hover {
  color: var(--c-black);
}

.drawer-tabs {
  display: flex;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.dt {
  flex: 1 1;
  padding: 9px 8px;
  font-size: 11px;
  font-weight: 500;
  color: var(--text2);
  text-align: center;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.dt:hover {
  color: var(--c-black);
}

.dt.active {
  color: var(--c-black);
  border-bottom-color: var(--c-black);
}

.drawer-body {
  flex: 1 1;
  min-height: 0; /* Required for overflow-y in nested flex layouts */
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.drawer-body > * {
  flex-shrink: 0; /* Scroll instead of squashing preview card / sections */
}

/* Detail sections */
.detail-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 14px;
}

.detail-section:last-child {
  border-bottom: none;
}

.ds-title {
  font-size: 16px;
  font-weight: 400;
  color: var(--c-black);
  margin-bottom: 4px;
}

.field-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.field-label {
  font-size: 11px;
  font-weight: 400;
  color: var(--c-black);
}

.field-val {
  font-size: 14px;
  font-weight: 400;
  color: var(--c-black);
}

.field-val.danger {
  color: var(--c-orange);
}

.field-val.success {
  color: var(--c-teal-active);
}

/* Change timeline in drawer */
.change-entry {
  display: flex;
  gap: 10px;
  align-items: flex-start;
}

.ce-dot-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.ce-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
  margin-top: 4px;
}

.ce-line {
  width: 1px;
  flex: 1 1;
  background: var(--border);
  min-height: 16px;
  margin: 3px 0;
}

.ce-body {
  flex: 1 1;
  min-width: 0;
  padding-bottom: 12px;
}

.ce-time {
  font-size: 10px;
  color: var(--text3);
}

.ce-type {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 1px;
}

.ce-detail {
  font-size: 11px;
  color: var(--text2);
  margin-top: 2px;
  line-height: 1.4;
}

.ce-approved {
  background: var(--c-teal-active);
}

.ce-rejected {
  background: var(--c-orange);
}

.ce-objection {
  background: var(--c-orange);
}

.ce-document {
  background: var(--c-purple-1);
}

.ce-status {
  background: var(--c-blue-1);
}

.ce-new {
  background: var(--text2);
}

/* Panel bars (doc count visual) */
.panel-bars {
  display: flex;
  gap: 6px;
  align-items: flex-end;
  height: 32px;
}

.pb-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
}

.pb-bar {
  width: 24px;
  border-radius: 3px 3px 0 0;
}

.pb-label {
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.02em;
}

.drawer-actions {
  display: flex;
  gap: 18px;
  padding: 12px 16px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

.drawer-actions .btn {
  flex: 1 1;
  text-align: center;
  font-size: 12px;
  height: 36px;
}

/* Filings Grid View */
.filings-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 16px;
  padding: 20px;
  overflow-y: auto;
  flex: 1 1;
  align-content: start;
}

.filter-btn-wrap {
  position: relative;
}

.table-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-pagination__control {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-pagination__label {
  font-size: 11px;
  color: var(--c-black);
}

.table-pagination__measure {
  height: 28px;
  line-height: 28px;
  display: inline-flex;
  align-items: center;
  visibility: visible;
  min-width: 40px;
}

.table-pagination__select {
  height: 28px;
  color: transparent;
}

.table-pagination__option {
  color: var(--c-black);
}

.filing-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  cursor: pointer;
  transition: all 0.15s;
}

.filing-card:hover {
  border-color: var(--border-color-strong);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--surface-pressed-tint);
}

.filing-card.selected,
.filing-card.selected:hover {
  border-color: var(--c-blue-1);
  background: var(--c-cyan-1);
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.card-tn {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.card-company {
  font-family: var(--font-display);
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 4px;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.card-pills {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.field-label {
  font-family: var(--font);
  font-size: 11px;
  font-weight: 400;
  color: var(--c-black);
}

.field-val {
  font-family: var(--font);
  font-size: var(--fs-base);
  color: var(--c-black);
  margin-top: 1px;
}

.card-footer {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  font-size: 11px;
  color: var(--text3);
}

.view-toggle {
  display: flex;
  border: 1px solid var(--border-color-strong);
  border-radius: var(--radius);
  overflow: hidden;
  height: 32px;
  box-sizing: border-box;
}

.vt-btn {
  height: 100%;
  padding: 0 10px;
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
  border: none;
  font-family: var(--font);
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.vt-btn:not(:last-child) {
  border-right: 1px solid var(--border-color-strong);
}

.vt-btn:hover:not(.active) {
  background: var(--ink-emphasis);
  color: var(--c-white);
}

.vt-btn.active {
  background: var(--ink-emphasis);
  color: var(--ink-emphasis);
}

.vt-btn.active:hover {
  background: var(--c-neon);
}

.filters-right {
  margin-left: auto;
  display: flex;
  gap: 8px;
  align-items: center;
}

/* Pagination */
.pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 20px;
  border-top: 1px solid var(--border);
  background: var(--c-white);
  flex-shrink: 0;
}

.pg-info {
  font-size: 12px;
  color: var(--c-black);
}

.pg-controls {
  display: flex;
  gap: 4px;
}

.pg-btn {
  width: 28px;
  height: 28px;
  border-radius: var(--radius);
  border: 1px solid var(--border-color-strong);
  background: var(--c-white);
  color: var(--c-black);
  font-size: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pg-btn:hover:not(.active):not(:disabled) {
  background: var(--text2);
  color: var(--c-white);
  border-color: var(--border-color-strong);
}

.pg-btn.active {
  background: var(--c-white);
  color: var(--ink-emphasis);
  border: 1px solid var(--border-color-strong);
}

.pg-input {
  width: 32px;
  height: 28px;
  border-radius: var(--radius);
  border: 1px solid var(--border-color-strong);
  border-bottom: 2px solid var(--ink-emphasis);
  background: var(--c-white);
  color: var(--ink-emphasis);
  font-size: 12px;
  text-align: center;
  outline: none;
  font-family: var(--font);
  display: flex;
  align-items: center;
  justify-content: center;
}

.pg-input:focus {
  border-color: var(--c-black);
  border-bottom-color: var(--c-black);
}

.pg-btn.active:hover {
  background: var(--c-neon);
  border: 1px solid var(--border-color-strong);
}

.pg-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pg-select {
  font-family: var(--font);
  font-size: 12px;
  padding: 0 24px 0 8px;
  border: 1px solid var(--border-color-strong);
  border-radius: var(--radius);
  background: var(--c-white);
  color: var(--c-black);
  height: 28px;
  box-sizing: border-box;
  transition: all 0.15s;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 8px 5px;
}

.pg-select:hover {
  background-color: var(--ink-emphasis);
  color: var(--c-white);
  border-color: var(--ink-emphasis);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

/* Filters Bar */
.filters-bar {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  flex-shrink: 0;
  flex-wrap: wrap;
}

.topbar .filters-bar,
.filters-bar.page-header-filters {
  margin: 0;
  padding: 0;
  background: transparent;
  border: none;
  border-bottom: none;
  box-shadow: none;
  flex-wrap: nowrap;
}

/* Secondary outline action — chart “View full report”, Prompts “Edit Prompts”, etc. */
.geo-card-action-btn.filters-drawer-btn-reset,
.geo-insights-top-prompts-card__action.filters-drawer-btn-reset {
  flex: 0 0 auto !important;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: auto !important;
  min-width: auto !important;
  padding: 0 14px;
  text-decoration: none;
  white-space: nowrap;
}

.page-header-edit-prompts {
  flex-shrink: 0;
}

/* Search */
.search-wrap {
  position: relative;
}

.search-wrap .search-input {
  padding-left: 30px;
  width: 240px;
}

.search-icon {
  position: absolute;
  left: 9px;
  top: 50%;
  transform: translateY(-50%);
  opacity: 0.8;
}
.btn-sm {
  padding: 4px 10px;
  font-size: 11px;
}

.btn-sm:hover:not(.btn-primary):not(.btn-filters):not(.filings-style-18):not(.filters-drawer-btn-apply) {
  background: var(--ink-emphasis) !important;
  color: var(--c-white) !important;
  border-color: var(--ink-emphasis) !important;
}

.btn-clear {
  background: var(--c-white);
  border: 1px solid var(--border2);
  color: var(--c-black);
  cursor: pointer;
  border-radius: var(--radius);
  font-weight: 500;
  transition: all 0.15s;
}

.btn-clear:hover {
  background: var(--c-white);
  color: var(--c-black);
  border-color: var(--text3);
}
/* Details Drawer Styles */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--shadow-overlay);
  z-index: 1000;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.drawer-overlay.open {
  opacity: 1;
  visibility: visible;
}

.details-drawer {
  position: fixed;
  top: 0;
  right: -400px;
  width: 400px;
  height: 100vh;
  background: var(--c-white);
  z-index: 1001;
  box-shadow: var(--shadow-drawer);
  transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  font-family: var(--font) !important;
}

.details-drawer * {
  font-family: var(--font) !important;
}

.details-drawer.open {
  right: 0;
}

.details-drawer .drawer-header {
  padding: 20px 24px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
  background: var(--c-white);
}

.details-drawer .drawer-title {
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  color: var(--c-black);
}

.details-drawer .drawer-close {
  background: transparent;
  border: none;
  cursor: pointer;
  color: var(--text2);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: var(--border-radius-sm);
}

.details-drawer .drawer-close:hover {
  background: var(--c-white);
  color: var(--c-black);
}

.details-drawer .drawer-body {
  padding: 24px;
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.details-drawer .drawer-section {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.details-drawer .drawer-label {
  font-size: 12px;
  font-weight: 500;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.details-drawer .drawer-value {
  font-size: 14px;
  color: var(--c-black);
  font-weight: 500;
}

.details-drawer .drawer-footer {
  padding: 20px 24px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 12px;
  background: var(--c-white);
}

.details-drawer .drawer-footer .btn {
  flex: 1 1;
}

/* Filters Drawer Custom Styles */
.filters-drawer-body {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 24px;
  overflow-y: auto;
}

.filters-drawer-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filters-drawer-label {
  font-weight: 500;
  font-size: 12px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.filters-select-wrap {
  position: relative;
  overflow: visible;
  cursor: pointer;
  width: 100%;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
}

.filters-select-wrap.active-filter {
  background: var(--c-black);
}

.filters-select-measure {
  color: var(--c-black);
  visibility: visible !important;
  display: flex;
  align-items: center;
  height: 100% !important;
  padding-left: 14px;
}

.filters-select-wrap.active-filter .filters-select-measure {
  color: var(--c-white);
}

.filters-popover {
  left: 0;
  right: 0;
  width: 100%;
  min-width: auto;
  top: 100%;
}

.filters-popover-list {
  max-height: 280px;
}

.filters-badge-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
}

.filters-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: 1px solid var(--border2);
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black) !important;
  line-height: 1.2;
}

.filters-badge-cancel {
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  color: var(--c-black) !important;
  transition: color 0.15s ease;
}

.filters-badge-cancel:hover {
  color: var(--c-orange) !important;
}

.filters-drawer-title-wrap {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  font-weight: 500;
}

.filters-drawer-close {
  font-size: 24px;
  line-height: 1;
}

.filters-drawer-footer {
  border-top: 1px solid var(--border);
  display: flex;
  gap: 12px;
  padding: 20px 24px;
}

.filters-drawer-btn-reset {
  flex: 1 1;
  background-color: var(--c-white);
  color: var(--c-black);
  border: 1px solid var(--text3);
  border-radius: 6px;
  height: 36px;
  font-weight: 500;
  cursor: pointer;
}

.filters-drawer-btn-apply {
  flex: 1 1;
  background-color: var(--c-neon);
  color: var(--c-black);
  border: none;
  border-radius: 6px;
  height: 36px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;
}

/* Filters Drawer Accordion Design */
.filters-drawer-body {
  padding: 0 !important;
  gap: 0 !important;
  flex: 1 1 auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
}

.accordion-item {
  border-bottom: 1px solid var(--border2);
  background: var(--c-white);
}

.accordion-header {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 20px !important;
  height: 52px !important;
  cursor: pointer !important;
  -webkit-user-select: none !important;
          user-select: none !important;
  box-sizing: border-box !important;
  transition: background-color 0.15s ease !important;
}

.accordion-header:hover {
  background-color: var(--c-white) !important;
}

.accordion-header-left {
  display: flex !important;
  align-items: center !important;
  gap: 12px !important;
  height: 100% !important;
}

.accordion-header-icon {
  color: var(--text2) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.accordion-header-title {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: var(--c-black) !important;
  display: flex !important;
  align-items: center !important;
}

.accordion-header-right {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  height: 100% !important;
}

@keyframes countPop {
  0% { transform: scale(0.6); opacity: 0.4; }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); opacity: 1; }
}

.accordion-selected-count {
  font-size: 11px;
  background: transparent;
  border: 1px solid var(--border2);
  padding: 2px 6px;
  border-radius: 4px;
  color: var(--text2);
  animation: countPop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  display: inline-block;
}

.accordion-chevron {
  color: var(--text3);
  transition: transform 0.2s ease;
}

.accordion-chevron.is-open {
  transform: rotate(180deg);
}

@keyframes accordionSlideDown {
  from {
    max-height: 0;
    opacity: 0;
  }

  to {
    max-height: 500px;
    opacity: 1;
  }
}

/* Animated expand/collapse (grid 0fr → 1fr; avoids max-height clipping) */
.accordion-panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.accordion-panel.is-open {
  grid-template-rows: 1fr;
}

.accordion-panel__inner {
  overflow: hidden;
  min-height: 0;
}

.accordion-panel:not(.is-open) {
  pointer-events: none;
}

/* Content is always painted; __inner clips it as the row height animates */
.accordion-panel .accordion-content {
  overflow: hidden;
}

@media (prefers-reduced-motion: reduce) {
  .accordion-panel {
    transition: none;
  }

  .accordion-panel:not(.is-open) {
    display: none;
  }
}

.accordion-content {
  padding: 0;
}

/* Top rule below accordion header (search sections use .custom-dropdown-header instead) */
.accordion-content-divider {
  border-top: 1px solid var(--border2);
}

.accordion-content .custom-dropdown-header {
  border-radius: 0 !important;
  padding: 12px 20px !important;
  background: var(--c-white) !important;
  border-top: 1px solid var(--border2) !important;
}

.accordion-content .custom-dropdown-item {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.accordion-content .date-input {
  width: calc(100% - 40px) !important;
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.accordion-content .filters-badge-container {
  margin-left: 20px !important;
  margin-right: 20px !important;
  margin-top: 12px !important;
}

.accordion-search-container {
  margin-bottom: 12px;
}

.accordion-search-input {
  width: 100%;
}

.accordion-dropdown-list {
  position: static !important;
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
  padding: 0 !important;
}

/* Fixed filters panel only (Answers/Filings FiltersDrawer) — not inline Filings table details */
.details-drawer.filters-details-drawer {
  --filters-drawer-width: 420px;
  width: var(--filters-drawer-width) !important;
  right: calc(-1 * var(--filters-drawer-width)) !important;
  transition: right 0.38s cubic-bezier(0.16, 1, 0.3, 1) !important;
}

.details-drawer.filters-details-drawer.open {
  right: 0 !important;
}

/* Answers / shared filters drawer: instant backdrop, smooth panel slide */
.drawer-overlay:has(+ .details-drawer.filters-details-drawer) {
  transition: none;
}

.drawer-overlay:has(+ .details-drawer.filters-details-drawer.open) {
  opacity: 1;
  visibility: visible;
}

@media (prefers-reduced-motion: reduce) {
  .details-drawer.filters-details-drawer {
    transition: none !important;
  }
}

.filters-details-drawer .drawer-header,
.filters-details-drawer .filters-drawer-header {
  align-items: flex-start !important;
  background: var(--c-white) !important;
}

.filters-drawer-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.filters-drawer-header-sub {
  margin: 0;
  padding-left: 26px;
  color: var(--text2);
  font-size: 12px;
  line-height: 1.35;
}

/* Accordion panels: avoid max-height animation clipping list bottoms */
.filters-details-drawer .accordion-panel .accordion-content {
  max-height: none !important;
  animation: none !important;
  overflow: hidden !important;
  padding: 0 !important;
}

/* Rule between accordion section title and its options */
.filters-details-drawer .accordion-panel.is-open .accordion-content {
  border-top: 1px solid var(--border2);
}

.filters-details-drawer .accordion-content > .custom-dropdown-header:first-child {
  border-top: none !important;
}

.filters-details-drawer .accordion-content .custom-dropdown-list.filters-popover-list,
.filters-details-drawer .accordion-content .accordion-dropdown-list {
  max-height: min(260px, calc(100vh - 320px)) !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  padding-bottom: 0;
  box-sizing: border-box;
  border-bottom: 1px solid var(--border2) !important;
}

.filters-details-drawer .accordion-content .accordion-dropdown-list .custom-dropdown-item {
  height: 38px;
  padding: 0 20px !important;
  border-bottom: 1px solid var(--border2);
  box-sizing: border-box;
}

.filters-details-drawer .accordion-content .accordion-dropdown-list .custom-dropdown-item:last-child {
  border-bottom: none;
}

.filters-details-drawer .accordion-content .filters-badge-container {
  margin-bottom: 12px !important;
}

/* Premium Search Bar Custom Accordion Style */
.accordion-content .custom-dropdown-search-wrap {
  position: relative !important;
  display: flex !important;
  align-items: center !important;
  background: var(--c-white) !important;
  border: 1px solid var(--border2) !important;
  border-radius: 6px !important;
  padding: 0 12px !important;
  height: 36px !important;
  gap: 8px !important;
}

.accordion-content .custom-dropdown-search-icon {
  position: static !important;
  color: var(--text3) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.accordion-content .custom-dropdown-search-input {
  border: none !important;
  background: transparent !important;
  outline: none !important;
  font-size: 13.5px !important;
  color: var(--c-black) !important;
  width: 100% !important;
  padding: 0 !important;
  font-family: inherit !important;
}

.accordion-content .custom-dropdown-search-input::placeholder {
  color: var(--text3) !important;
  font-weight: 500 !important;
}

/* Locked Select All Option Styling */
.accordion-content .select-all {
  border-bottom: 1px solid var(--border2) !important;
  font-weight: normal !important;
  background: var(--c-white) !important;
  display: flex !important;
  align-items: center !important;
  height: 38px !important;
  padding: 0 20px !important;
  /* Matches accordion padding */
  gap: 8px !important;
  box-sizing: border-box !important;
}

.accordion-content .select-all input[type="checkbox"] {
  margin: 0 !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.accordion-content .select-all span {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 1 !important;
  display: flex !important;
  align-items: center !important;
}

/* Filters Drawer Title and Close Button Refinements */
.filters-details-drawer .drawer-title {
  font-weight: 500 !important;
  /* Non-bold premium weight */
}

.filters-details-drawer .drawer-close,
.filters-drawer-close {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 24px !important;
  height: 24px !important;
  border-radius: 4px !important;
  font-size: 24px !important;
  line-height: 1 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  background: transparent !important;
  border: none !important;
  color: var(--text2) !important;
  cursor: pointer !important;
}

.filters-details-drawer .drawer-close:hover,
.filters-drawer-close:hover {
  background: var(--c-black) !important;
  color: var(--c-white) !important;
  transform: rotate(90deg) !important;
}

/* Filters Drawer Footer Buttons Styling */
.filters-drawer-footer {
  display: flex !important;
  gap: 12px !important;
  padding: 16px 20px !important;
  border-top: 1px solid var(--border2) !important;
  background: var(--c-white) !important;
}

.filters-drawer-btn-reset {
  flex: 1 1 !important;
  background: transparent !important;
  border: 1px solid var(--ui-border-input) !important;
  color: var(--c-black) !important;
  font-weight: 500 !important;
  height: 36px !important;
  border-radius: 8px !important;
  transition: all 0.15s ease !important;
  cursor: pointer !important;
}

.filters-drawer-btn-reset:hover {
  background: var(--c-white) !important;
  border-color: var(--border-color-strong) !important;
}

.filters-drawer-btn-apply {
  flex: 1 1 !important;
  background: var(--c-neon) !important;
  border: none !important;
  color: var(--c-black) !important;
  font-weight: 500 !important;
  height: 36px !important;
  border-radius: 8px !important;
  transition: all 0.15s ease !important;
  cursor: pointer !important;
}

.filters-drawer-btn-apply:hover {
  background-color: var(--neon-btn-bg-hover) !important;
  background: var(--neon-btn-bg-hover) !important;
  color: var(--c-black) !important;
  transform: translateY(-1px);
}

.filters-drawer-btn-apply:active {
  transform: translateY(0);
}

/* Answers (RAG) — same drawer shell as FiltersDrawer; fields live in accordion content */
.filters-details-drawer .filters-drawer-summary-bar {
  display: grid;
  gap: var(--space-1);
  padding: var(--space-3) var(--space-5);
  border-bottom: 1px solid var(--border2);
  background: var(--bar-track-bg);
}

.filters-details-drawer .filters-drawer-summary-title {
  color: var(--c-black);
  font-size: var(--fs-sm);
  font-weight: 500;
}

.filters-details-drawer .filters-drawer-summary-sub {
  color: var(--text2);
  font-size: calc(var(--fs-sm) - 1px);
  line-height: 1.35;
}

.answers-shell > .drawer-overlay.open {
  z-index: 1100;
}

.answers-shell > .details-drawer.filters-details-drawer {
  z-index: 1101;
}

.filters-details-drawer .form-group {
  position: relative;
  margin: 0;
  padding: var(--space-3) var(--space-5);
  border-bottom: 1px solid var(--border2);
}

.filters-details-drawer .form-group > label,
.filters-details-drawer .form-group > .filters-drawer-label {
  display: block;
  margin: 0 0 var(--space-2);
}

.filters-details-drawer .rag-date-range-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--space-2);
}

.filters-details-drawer .rag-date-field {
  min-width: 0;
}

.filters-details-drawer .rag-date-field label {
  display: block;
  margin: 0 0 var(--space-2);
  color: var(--text3);
  font-size: var(--fs-xs);
  font-weight: 700;
  text-transform: uppercase;
}

.filters-details-drawer .rag-objections-dropdown,
.filters-details-drawer .rag-date-field input,
.filters-details-drawer .rag-multiselect {
  width: 100%;
  min-height: calc(var(--space-6) + var(--space-2));
  border: 1px solid var(--border2);
  border-radius: var(--border-radius-md);
  background: var(--c-white);
  color: var(--c-black);
  font-size: var(--fs-sm);
}

.filters-details-drawer .rag-date-field input,
.filters-details-drawer .rag-objections-dropdown {
  padding: 0 var(--space-3);
}

.filters-details-drawer .rag-multiselect {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  padding: 0;
  cursor: pointer;
  text-align: left;
}

.filters-details-drawer .rag-multiselect:hover,
.filters-details-drawer .rag-multiselect.p-focus,
.filters-details-drawer .rag-objections-dropdown:focus,
.filters-details-drawer .rag-date-field input:focus {
  border-color: color-mix(in srgb, var(--c-teal-active) 38%, transparent);
  box-shadow: 0 0 0 var(--space-2) color-mix(in srgb, var(--c-teal-active) 8%, transparent);
  outline: none;
}

.filters-details-drawer .p-multiselect-label {
  min-width: 0;
  flex: 1 1;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
  padding: var(--space-2);
}

.filters-details-drawer .rag-multiselect-trigger {
  width: calc(var(--space-6) + var(--space-2));
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text3);
}

.filters-details-drawer .p-multiselect-token,
.filters-details-drawer .rag-multiselect-more-label,
.filters-details-drawer .rag-multiselect-clear-all {
  display: inline-flex;
  align-items: center;
  min-height: calc(var(--space-4) + var(--space-3));
  border-radius: var(--border-radius-pill);
  font-size: var(--fs-xs);
  font-weight: 700;
  line-height: 1.2;
}

.filters-details-drawer .p-multiselect-token {
  max-width: 100%;
  gap: var(--space-2);
  padding: 0 var(--space-2);
  border: 1px solid color-mix(in srgb, var(--c-teal-active) 18%, transparent);
  background: color-mix(in srgb, var(--c-teal-active) 8%, transparent);
  color: var(--c-teal-active);
}

.filters-details-drawer .p-multiselect-token-label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filters-details-drawer .p-multiselect-token-icon,
.filters-details-drawer .rag-multiselect-clear-all {
  color: var(--text2);
  cursor: pointer;
}

.filters-details-drawer .rag-multiselect-placeholder-text {
  color: var(--text3);
  font-size: calc(var(--fs-base) - 1px);
}

.filters-details-drawer .rag-multiselect-more-label {
  padding: 0 var(--space-2);
  background: var(--bar-track-bg);
  color: var(--text2);
}

.filters-details-drawer .rag-multiselect-panel {
  position: absolute;
  left: var(--space-5);
  right: var(--space-5);
  top: calc(100% - var(--space-3));
  z-index: 1200;
  overflow: hidden;
  border: 1px solid var(--border2);
  border-radius: var(--border-radius-lg);
  background: var(--c-white);
  box-shadow: 0 var(--space-4) calc(var(--space-7) + var(--space-2)) color-mix(in srgb, var(--c-black) 12%, transparent);
}

.filters-details-drawer .rag-multiselect-search {
  width: 100%;
  min-height: calc(var(--space-7) + var(--space-1));
  border: none;
  border-bottom: 1px solid var(--border2);
  outline: none;
  padding: 0 var(--space-3);
  color: var(--c-black);
  font-size: var(--fs-sm);
}

.filters-details-drawer .rag-multiselect-options {
  max-height: 210px;
  overflow-y: auto;
  padding: var(--space-2);
}

.filters-details-drawer .rag-multiselect-option {
  min-height: calc(var(--space-6) + var(--space-2));
  display: flex;
  align-items: center;
  gap: 9px;
  border-radius: var(--border-radius);
  color: var(--c-black);
  cursor: pointer;
  font-size: var(--fs-sm);
  padding: var(--space-2) 7px;
}

.filters-details-drawer .rag-multiselect-option:hover {
  background: color-mix(in srgb, var(--c-teal-active) 8%, transparent);
}

.filters-details-drawer .rag-multiselect-empty {
  padding: var(--space-3);
  color: var(--text2);
  font-size: calc(var(--fs-base) - 1px);
}

/* Clear All Filters Button Styling - Matching Filters Button Style */
.btn-clear-filters {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  height: 36px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  border: 1px solid var(--border) !important;
  background: var(--c-white) !important;
  color: var(--c-black) !important;
  font-size: 12px !important;
  font-weight: 500 !important;
  text-decoration: none !important;
  cursor: pointer !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-sizing: border-box !important;
}

.btn-clear-filters-icon {
  display: flex !important;
  align-items: center !important;
  color: var(--c-black) !important;
  transition: all 0.2s ease !important;
}

.btn-clear-filters:hover {
  background: var(--c-black) !important;
  /* Turns solid black on hover */
  border-color: var(--c-black) !important;
  color: var(--c-white) !important;
  /* Turns text white on hover */
}

.btn-clear-filters:hover .btn-clear-filters-icon {
  transform: scale(1.1) rotate(90deg) !important;
  color: var(--c-white) !important;
  /* Turns close icon white on hover */
}

/* Filters button — neon yellow toolbar control */
.btn-filters,
.filings-style-18 {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 6px !important;
  height: 36px !important;
  padding: 0 16px !important;
  border-radius: 8px !important;
  border: none !important;
  /* Removes the border completely */
  background: var(--c-neon) !important;
  /* Signature Comply Logo Neon Yellow (var(--c-neon)) */
  color: var(--c-black) !important;
  /* Dark black text by default for perfect contrast */
  font-size: 12px !important;
  font-weight: 500 !important;
  /* Semi-bold for clean visibility on neon */
  cursor: pointer !important;
  transition: background-color 0.2s ease, transform 0.2s ease, color 0.2s ease !important;
  box-sizing: border-box !important;
}

.configure-btn:hover,
.add-btn:hover:not(:disabled),
.btn-filters:hover:not(.btn-primary),
.filings-style-18:hover,
button.btn.btn-sm.btn-filters:hover:not(.btn-primary),
button.btn.btn-filters:hover:not(.btn-primary),
button.btn.filings-style-18:hover,
.filters-drawer-btn-apply:hover,
button.btn.btn-sm.filters-drawer-btn-apply:hover {
  background-color: var(--neon-btn-bg-hover) !important;
  background: var(--neon-btn-bg-hover) !important;
  color: var(--c-black) !important;
  transform: translateY(-1px) !important;
}

.configure-btn:active,
.add-btn:active:not(:disabled),
.btn-filters:active:not(.btn-primary),
button.btn.btn-filters:active:not(.btn-primary),
.filters-drawer-btn-apply:active,
button.btn.btn-sm.filters-drawer-btn-apply:active {
  transform: translateY(0) !important;
}

.btn-filters svg,
.filings-style-18 svg {
  color: var(--c-black) !important;
  /* Dark black icon by default */
  transition: color 0.2s ease !important;
}

.btn-filters:hover svg,
.filings-style-18:hover svg {
  color: var(--c-black) !important;
  /* Retains icon black on hover */
}

/* Active-filter indicator dot on filters button */
.btn-filters-dot,
.filings-style-19 {
  background-color: var(--c-black) !important;
  /* Black dot by default against neon yellow background */
  width: 6px !important;
  height: 6px !important;
  border-radius: 50% !important;
  display: inline-block !important;
  margin-left: 6px !important;
  transition: background-color 0.15s ease !important;
}

/* The applied indicator dot naturally retains its default black color for flawless visibility against the neon yellow background across all hover/active states. */

/* Filters open (black control) — white indicator dot */
.btn.btn-sm.btn-primary.btn-filters .btn-filters-dot,
button.btn.btn-sm.btn-primary.btn-filters .btn-filters-dot {
  background-color: var(--c-white) !important;
}

/* Filters drawer open — black control (pairs with PageHeader / Filings when panel is active) */
.btn.btn-sm.btn-primary.btn-filters,
button.btn.btn-sm.btn-primary.btn-filters {
  background: var(--ink-emphasis) !important;
  color: var(--c-white) !important;
  border: none !important;
}

.btn.btn-sm.btn-primary.btn-filters svg,
button.btn.btn-sm.btn-primary.btn-filters svg {
  color: var(--c-white) !important;
}

.btn.btn-sm.btn-primary.btn-filters:hover,
button.btn.btn-sm.btn-primary.btn-filters:hover {
  background: var(--ink-muted) !important;
  color: var(--c-white) !important;
}

.btn.btn-sm.btn-primary.btn-filters:hover svg,
button.btn.btn-sm.btn-primary.btn-filters:hover svg {
  color: var(--c-white) !important;
}

/* Toolbar square dismiss — next to Filters (e.g. Answers back) */
.answers-shell-header .btn-icon-dismiss {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
  border: 1px solid var(--border2);
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  box-sizing: border-box;
  flex-shrink: 0;
}

.answers-shell-header .btn-icon-dismiss:hover {
  border-color: var(--text3);
  color: var(--c-black);
  background: var(--c-white);
}

/* Filters drawer date inputs — do not use .filter-select (absolute overlay for toolbar selects) */
.filters-date-input {
  position: static;
  width: auto;
  min-width: 0;
  height: 36px;
  flex: 0 0 auto;
  padding: 0 10px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-sm);
  box-sizing: border-box;
  cursor: pointer;
  appearance: none;
  outline: none;
  z-index: auto;
}

.filters-date-input:focus {
  border-color: var(--c-black);
}

.filters-date-range-item .filters-date-range-header {
  cursor: default;
  justify-content: flex-start !important;
  height: 52px !important;
  min-height: 52px !important;
  padding: 0 20px !important;
  gap: 12px !important;
}

.filters-date-range-item .filters-date-range-header .accordion-header-left {
  width: auto;
  flex-shrink: 0;
}

.filters-date-range-item .filters-date-range-controls {
  flex: 1 1;
  min-width: 0;
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  height: 100% !important;
}

.filters-date-range-fields {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
}

.filters-date-range-separator {
  color: var(--text3);
  font-size: 12px;
  flex-shrink: 0;
}

.filters-date-range-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.filters-date-range-picker {
  position: relative;
  display: block;
  width: 100%;
}

.filters-date-range-picker .react-datepicker-wrapper,
.filters-date-range-picker .react-datepicker__input-container {
  display: block;
  width: 100%;
}


/* Filters Drawer Date Range Section */
.static-filter-section {
  margin-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
}

.static-filter-section-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 12px;
}

.custom-date-input-wrapper {
  position: relative;
  width: 100%;
  cursor: pointer;
}

.custom-date-input-icon {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--c-black);
  pointer-events: none;
}

.custom-date-input-field {
  width: 100% !important;
  height: 32px !important;
  padding: 0 36px 0 12px !important;
  box-sizing: border-box !important;
  text-align: left !important;
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  background-color: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  outline: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.custom-date-input-field:focus {
  border-color: var(--c-black);
  background-color: var(--c-white);
}

/* Animated State-Driven Detail Drawer: bidirectional interpolation for entrance and exit */
.drawer {
  width: 0 !important;
  min-width: 0 !important;
  flex-basis: 0 !important;
  opacity: 0 !important;
  border-left-color: transparent !important; /* Hide border when closed */
  overflow: hidden;
  transition: all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);
}

.drawer.drawer-open {
  width: 360px !important;
  min-width: 360px !important;
  flex-basis: 360px !important;
  opacity: 1 !important;
  border-left-color: var(--border) !important;
}

/* Keep content rigid during flex width interpolation so text doesn't wrap/jitter */
.drawer > * {
  min-width: 360px;
}

/* Dropdown, datepicker, map tooltip */
/* Custom premium design filter dropdown */
.custom-dropdown-popover {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: 9999;
  background: var(--c-white);
  border: 1px solid var(--text3);
  border-radius: 8px;
  box-shadow: var(--shadow-popover);
  min-width: 230px;
  max-width: 280px;
  display: flex;
  flex-direction: column;
}

.custom-dropdown-popover::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 24px;
  border-width: 6px;
  border-style: solid;
  border-color: transparent transparent var(--c-white) transparent;
}

.custom-dropdown-popover::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 23px;
  border-width: 7px;
  border-style: solid;
  border-color: transparent transparent var(--text3) transparent;
  z-index: -1;
}

.custom-dropdown-header {
  background: var(--c-white);
  padding: 8px 10px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  border-bottom: 1px solid var(--border2);
}

.custom-dropdown-search-wrap {
  position: relative;
  display: flex;
  align-items: center;
  background: var(--c-white);
  border: 1px solid var(--text3);
  border-radius: 6px;
  padding: 0 10px;
  height: 28px;
}

.custom-dropdown-search-input {
  border: none;
  background: transparent;
  outline: none;
  font-size: 12px;
  color: var(--c-black);
  width: 100%;
  padding-right: 18px;
  font-family: inherit;
}

.custom-dropdown-search-icon {
  position: absolute;
  right: 10px;
  color: var(--text2);
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-dropdown-list {
  max-height: 200px;
  overflow-y: auto;
  padding: 4px 0;
}

/* Slim scrollbar design */
.custom-dropdown-list::-webkit-scrollbar {
  width: 10px;
}

.custom-dropdown-list::-webkit-scrollbar-track {
  background: transparent;
}

.custom-dropdown-list::-webkit-scrollbar-thumb {
  background: var(--border2);
  border-radius: 9999px;
}

.custom-dropdown-list::-webkit-scrollbar-thumb:hover {
  background: var(--text2);
}

.custom-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  font-size: 12px;
  color: var(--c-black) !important;
  cursor: pointer;
  transition: background 0.1s ease;
}

.custom-dropdown-item:hover {
  background: var(--c-white);
}

.custom-dropdown-item.select-all {
  font-weight: 500;
  color: var(--c-black);
  border-bottom: 1px solid var(--c-white);
}

.custom-dropdown-checkbox {
  appearance: none;
  -webkit-appearance: none;
  width: 14px;
  height: 14px;
  border: 1.5px solid var(--text3);
  border-radius: 3px;
  outline: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--c-white);
  flex-shrink: 0;
  position: relative;
  transition: all 0.1s ease;
}

.custom-dropdown-checkbox:checked {
  background-color: var(--c-black);
  border-color: var(--c-black);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 75%;
}

/* --- Custom Premium DatePicker Theme --- */
.react-datepicker {
  font-family: inherit !important;
  background-color: var(--c-white) !important;
  border: 1px solid var(--text3) !important;
  border-radius: 8px !important;
  box-shadow: var(--shadow-popover) !important;
  overflow: hidden !important;
  padding: 0 !important;
}

.react-datepicker__month-container {
  padding: 0 !important;
  margin: 0 !important;
}

@keyframes calendarMonthIn {
  0% {
    opacity: 0.3;
    transform: scale(0.98);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

.react-datepicker__month {
  margin: 12px 14px 14px 14px !important;
  animation: calendarMonthIn 0.22s cubic-bezier(0.2, 0.8, 0.2, 1) forwards !important; /* Seamless re-render animation */
}

.react-datepicker__children-container {
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}

.react-datepicker__header {
  background-color: var(--c-white) !important;
  border-bottom: 1px solid var(--border2) !important;
  padding-top: 12px !important;
  padding-bottom: 8px !important;
  border-top-left-radius: 8px !important;
  border-top-right-radius: 8px !important;
}

.react-datepicker__current-month {
  display: none !important;
  /* Hide redundant duplicate title now that interactive selectors are enabled */
}

/* Premium Interactive Dropdown Capsules */
.react-datepicker__header__dropdown {
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  gap: 8px !important;
  width: 100% !important;
}

/* Group the sub-dropdown container modules closer together to cluster in center */
.react-datepicker__month-dropdown-container,
.react-datepicker__year-dropdown-container {
  flex: 0 0 auto !important;
  display: inline-block !important;
  margin: 0 2px !important;
}

/* Ultimate High-Fidelity Popover Menus */
.react-datepicker__month-dropdown,
.react-datepicker__year-dropdown {
  background-color: var(--c-white) !important;
  background: var(--c-white) !important;
  border: 1px solid var(--border) !important;
  border-radius: 8px !important;
  box-shadow: var(--shadow-popover) !important;
  padding: 6px !important;
  z-index: 999 !important;
  min-width: 120px !important;
  max-height: 240px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
}

/* Elegant Micro-Scrollbar for month/year selectors */
.react-datepicker__month-dropdown::-webkit-scrollbar,
.react-datepicker__year-dropdown::-webkit-scrollbar {
  width: 4px !important;
}
.react-datepicker__month-dropdown::-webkit-scrollbar-track,
.react-datepicker__year-dropdown::-webkit-scrollbar-track {
  background: transparent !important;
}
.react-datepicker__month-dropdown::-webkit-scrollbar-thumb,
.react-datepicker__year-dropdown::-webkit-scrollbar-thumb {
  background-color: var(--text3) !important;
  border-radius: 4px !important;
}

.react-datepicker__month-option,
.react-datepicker__year-option {
  padding: 6px 12px !important;
  font-size: 12.5px !important;
  font-weight: 450 !important;
  color: var(--text2) !important;
  line-height: 1.4 !important;
  cursor: pointer !important;
  transition: all 0.12s ease !important;
  text-align: center !important;
  border-radius: 5px !important;
  margin: 1px 0 !important;
  outline: none !important; /* Terminate default heavy browser focus rings */
}

.react-datepicker__month-option:hover,
.react-datepicker__year-option:hover {
  background-color: var(--c-white) !important;
  color: var(--c-black) !important;
}

.react-datepicker__month-option--selected_month,
.react-datepicker__year-option--selected_year {
  background-color: var(--border) !important;
  color: var(--c-black) !important;
  font-weight: 600 !important;
}

/* Clean standard item ticks if they exist */
.react-datepicker__month-option--selected,
.react-datepicker__year-option--selected {
  display: none !important; /* Text alignment and explicit background are superior anchors */
}

/* Nuke the legacy navigation footer/header artifacts that now clash with our native scrolling engine */
.react-datepicker__navigation--years {
  display: none !important;
}

.react-datepicker__month-read-view,
.react-datepicker__year-read-view {
  display: inline-flex !important;
  align-items: center !important;
  flex-direction: row-reverse !important; /* Forces dropdown span to position visually on the RIGHT of the text */
  justify-content: center !important;
  background: var(--c-white) !important;
  border: 1px solid var(--border) !important;
  border-radius: 6px !important;
  padding: 4px 10px !important;
  font-size: 13px !important;
  font-weight: 500 !important;
  color: var(--c-black) !important;
  cursor: pointer !important;
  transition: all 0.15s ease !important;
  min-width: 60px !important;
  height: 28px !important;
  box-sizing: border-box !important;
}

.react-datepicker__month-read-view:hover,
.react-datepicker__year-read-view:hover {
  background: var(--c-white) !important;
  border-color: var(--text3) !important;
  color: var(--c-black) !important;
}

/* Custom Arrow Inside Capsules */
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__year-read-view--down-arrow {
  display: inline-block !important;
  position: static !important;
  vertical-align: middle !important;
  margin-left: 6px !important;
  margin-right: 0 !important;
  margin-top: -3px !important;
  border-color: var(--text3) !important;
  border-style: solid !important;
  border-width: 1.5px 1.5px 0 0 !important;
  height: 4.5px !important;
  width: 4.5px !important;
  transform: rotate(135deg) !important;
}

.react-datepicker__day-name {
  color: var(--text2) !important;
  opacity: 0.7 !important; /* Softened modern layout emphasis */
  font-weight: 400 !important; /* Slightly thinner for premium layout feel */
  font-size: 10.5px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.02em !important;
  width: 34px !important;
  line-height: 32px !important;
  margin: 2px 0 !important;
  display: inline-block !important;
}

/* Day Cells */
.react-datepicker__day {
  color: var(--text2) !important;
  font-size: 11.5px !important;
  width: 34px !important;
  line-height: 32px !important;
  margin: 2px 0 !important;
  border-radius: 6px !important;
  transition: all 0.1s ease !important;
  display: inline-block !important;
}

.react-datepicker__day:hover {
  background-color: var(--c-white) !important;
  color: var(--c-black) !important;
}

.react-datepicker__day--outside-month {
  color: var(--text3) !important;
}

/* Selected Days & Range Days */
.react-datepicker .react-datepicker__day--selected,
.react-datepicker .react-datepicker__day--keyboard-selected {
  background-color: var(--c-neon) !important;
  background: var(--c-neon) !important;
  color: var(--c-black) !important;
  font-weight: 500 !important;
}

.react-datepicker .react-datepicker__day--in-range,
.react-datepicker .react-datepicker__day--in-selecting-range {
  background-color: var(--bg-neon-soft) !important;
  background: var(--bg-neon-soft) !important;
  color: var(--c-black) !important;
  border-radius: 0 !important;
}

.react-datepicker .react-datepicker__day--range-start,
.react-datepicker .react-datepicker__day--selecting-range-start {
  background-color: var(--c-neon) !important;
  background: var(--c-neon) !important;
  color: var(--c-black) !important;
  border-radius: 0 !important;
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
}

.react-datepicker .react-datepicker__day--range-end,
.react-datepicker .react-datepicker__day--selecting-range-end {
  background-color: var(--ink-overlay) !important;
  background: var(--ink-overlay) !important;
  color: var(--c-white) !important;
  border-radius: 0 !important;
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.react-datepicker .react-datepicker__day--selected:hover,
.react-datepicker .react-datepicker__day--keyboard-selected:hover,
.react-datepicker .react-datepicker__day--range-start:hover,
.react-datepicker .react-datepicker__day--selecting-range-start:hover {
  background-color: var(--c-neon) !important;
  background: var(--c-neon) !important;
  color: var(--c-black) !important;
}

.react-datepicker .react-datepicker__day--range-end:hover,
.react-datepicker .react-datepicker__day--selecting-range-end:hover {
  background-color: var(--ink-overlay) !important;
  background: var(--ink-overlay) !important;
  color: var(--c-white) !important;
  border-radius: 0 !important;
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.react-datepicker__day--disabled {
  color: var(--text3) !important;
  cursor: not-allowed !important;
}

/* Triangle navigation arrow */
.react-datepicker__triangle {
  display: none !important;
}

/* Navigation next/prev arrows */
.react-datepicker__navigation {
  top: 10px !important;
}

.react-datepicker__navigation-icon::before {
  border-color: var(--border-color-strong) !important;
  border-width: 2px 2px 0 0 !important;
}

/* Confirm Bar & Button */
.calendar-confirm-bar {
  margin: 0 !important;
  width: 100% !important;
  border-top: 1px solid var(--border2) !important;
  background-color: var(--c-white) !important;
  padding: 10px 12px !important;
  border-bottom-left-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  box-sizing: border-box !important;
  display: flex !important;
  justify-content: flex-end !important;
}

.calendar-confirm-bar .btn {
  background-color: var(--c-neon) !important;
  background: var(--c-neon) !important;
  color: var(--c-black) !important;
  border: none !important;
  border-radius: 6px !important;
  padding: 6px 14px !important;
  font-size: 11.5px !important;
  font-weight: 500 !important;
  cursor: pointer !important;
  transition: background-color 0.1s ease !important;
}

.calendar-confirm-bar .btn:hover {
  background-color: var(--c-neon) !important;
  background: var(--c-neon) !important;
  color: var(--c-black) !important;
}

.calendar-confirm-bar .btn:disabled {
  background-color: var(--border) !important;
  background: var(--border) !important;
  color: var(--text3) !important;
  opacity: 0.65 !important;
  cursor: not-allowed !important;
}

/* Custom Premium Close/Cancel Button inside Input */
.react-datepicker__close-icon::after {
  background-color: var(--c-black) !important;
  border-radius: 6px !important;
  font-size: 11px !important;
  height: 18px !important;
  width: 18px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  line-height: 1 !important;
  font-weight: 500 !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important; /* Dynamic global interaction curve */
}

.react-datepicker__close-icon:hover::after {
  background-color: var(--c-black) !important;
  transform: rotate(90deg) !important; /* Matched dynamic kinematics */
}

/* Quick Select Chips */
.quick-select-chips-container {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
}

.quick-select-chip {
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  border: 1px solid var(--border);
  background-color: var(--c-white);
  color: var(--text2);
  cursor: pointer;
  transition: all 0.15s ease;
}

.quick-select-chip:hover {
  background-color: var(--surface-subtle-tint);
  color: var(--c-black);
}

.quick-select-chip.is-selected {
  border-color: var(--c-black);
  background-color: var(--c-black);
  color: var(--c-white);
}

/* Map Hover Tooltip Architecture */
.map-hover-tooltip {
  position: fixed;
  background: var(--bg, var(--c-white));
  color: var(--text, var(--c-black));
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  box-shadow: var(--shadow-elevated);
  pointer-events: none;
  z-index: 999999;
  backdrop-filter: blur(8px);
  border: 1px solid var(--border2, var(--border-panel));
  display: flex;
  flex-direction: column;
  gap: 2px;
  max-width: min(420px, 90vw);
  line-height: 1.45;
  white-space: normal;
  word-break: break-word;
}

/* App shell & shared page layout (from global.css) */
.layout {
  display: flex;
  min-height: 100vh;
}

/* Main */
.main {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.body {
  display: flex;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.table-area,
.feed-area {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  position: relative;
}

/* Filing Timeline */
.filing-timeline {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ft-event {
  display: flex;
  gap: 12px;
}

.ft-dot-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12px;
  flex-shrink: 0;
}

.ft-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid var(--c-white);
  box-shadow: 0 0 0 1px var(--border);
  z-index: 2;
  background: var(--text3);
  margin-top: 4px;
}

.ft-line {
  width: 2px;
  flex: 1 1;
  background: var(--border);
  margin: -2px 0;
}

.ft-body {
  flex: 1 1;
  padding-bottom: 20px;
}

.ft-time {
  font-size: 10px;
  color: var(--text3);
  font-weight: 500;
  text-transform: uppercase;
}

.ft-type {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 2px;
}

.ft-detail {
  font-size: 11px;
  color: var(--text2);
  margin-top: 2px;
}

/* Two column */
.two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  flex-shrink: 0;
}

/* Change log */
.change-item {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  padding: 11px 18px;
  border-bottom: 1px solid var(--border);
}

.scrollable-changes {
  max-height: 380px;
  /* Adjusted to fit exactly 5 entries */
  overflow-y: auto;
}

.change-item:last-child {
  border-bottom: none;
}

.change-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 4px;
  flex-shrink: 0;
}

.dot-approved {
  background: var(--c-teal-active);
}

.dot-rejected {
  background: var(--c-orange);
}

.dot-objection {
  background: var(--c-orange);
}

.dot-document {
  background: var(--c-purple-1);
}

.dot-status {
  background: var(--c-blue-1);
}

.dot-new {
  background: var(--text2);
}

.change-body {
  flex: 1 1;
  min-width: 0;
}

.change-tn {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
}

.change-company {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 1px;
}

.change-detail {
  font-size: 11px;
  color: var(--text2);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 280px;
}

.change-time {
  font-size: 11px;
  color: var(--text3);
  white-space: nowrap;
}

/* State pills */
.state-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px 18px;
}

.state-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 10px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: var(--c-white);
  min-width: 60px;
}

.state-code {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
}

.state-count {
  font-size: 11px;
  color: var(--text2);
}

/* Analytics — toolbar aligns labels then controls (avoids flex-end drift vs competitor helper text) */
.analytics-toolbar {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 20;
  padding: 12px 24px 14px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  box-shadow: 0 2px 8px color-mix(in srgb, var(--c-black) 6%, transparent);
}

.analytics-toolbar-grid {
  display: grid;
  grid-template-columns: minmax(240px, auto) minmax(280px, 1fr) auto;
  column-gap: 20px;
  row-gap: 6px;
  align-items: stretch;
}

.analytics-toolbar-grid--two-col {
  grid-template-columns: minmax(240px, auto) auto;
}

.analytics-toolbar-grid>.df-label {
  margin: 0;
  align-self: end;
  line-height: 1.2;
}

.analytics-toolbar-grid>.analytics-toolbar-label-spacer {
  visibility: hidden;
  -webkit-user-select: none;
          user-select: none;
}

.analytics-toolbar-select.filter-select {
  max-width: none;
  width: 100%;
  min-width: 260px;
  min-height: 40px;
  padding: 8px 12px;
  font-size: 13px;
}

.analytics-toolbar-loading {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
}

.analytics-toolbar-control-competitors {
  min-width: 0;
}

.analytics-toolbar-actions {
  display: flex;
  align-items: stretch;
}

.analytics-toolbar-actions .btn {
  align-self: stretch;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

.analytics-toolbar-hint {
  margin: 10px 0 0;
  padding: 0;
  font-size: 11px;
  color: var(--text3);
  line-height: 1.4;
  max-width: 960px;
}

@media (max-width: 760px) {
  .analytics-toolbar {
    padding-left: 16px;
    padding-right: 16px;
  }
}

/* Changelog Specific Styles */
.stats-strip {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  flex-shrink: 0;
}

.stat-strip-item {
  flex: 1 1;
  padding: 12px 18px;
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.stat-strip-item:last-child {
  border-right: none;
}

.ssl-label {
  font-size: 10px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.ssl-val {
  font-size: 20px;
  font-weight: 600;
  color: var(--c-black);
  letter-spacing: -0.5px;
}

.ssl-sub {
  font-size: 11px;
  color: var(--c-black);
}

.type-filters {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
  padding: 8px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  flex-shrink: 0;
}

.type-chip {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  padding: 5px 12px;
  border-radius: 20px;
  border: 1px solid var(--border);
  background: var(--c-white);
  color: var(--c-black);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
          user-select: none;
}

.type-chip:hover {
  border-color: var(--border2);
  background: var(--c-white);
  color: var(--c-black);
  transform: translateY(-1px);
}

.type-chip.active {
  border-color: var(--c-black);
  background: var(--c-black);
  color: var(--c-white);
  box-shadow: var(--shadow-chip);
}

.type-chip-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
}

.type-chip-count {
  font-size: 10px;
  background: var(--c-white);
  color: var(--c-black);
  padding: 1px 6px;
  border-radius: 10px;
  margin-left: 2px;
  font-weight: 500;
  min-width: 16px;
  text-align: center;
}

.pill {
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.type-chip.active .type-chip-count {
  background: var(--surface-glass-faint);
  color: var(--c-white);
}

.feed-area {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.feed {
  flex: 1 1;
  overflow-y: auto;
}

.date-group-header {
  position: sticky;
  top: 0;
  z-index: 5;
  padding: 7px 20px;
  font-size: 11px;
  font-weight: 600;
  color: var(--c-black);
  background: var(--c-white);
  border-bottom: 1px solid var(--border);
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-transform: uppercase;
}

.event-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 12px 20px;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.12s;
}

.event-row:hover {
  background: var(--c-white);
}

.event-row.active {
  background: var(--c-cyan-1);
}

/* Date Filters */
.date-filters {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-left: 8px;
}

.df-group {
  display: flex;
  align-items: center;
  gap: 6px;
}

.df-label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.date-input {
  font-family: var(--font);
  background: var(--c-white);
  border: 1px solid var(--border-color-strong);
  border-radius: 8px !important;
  padding: 0 10px;
  height: 32px;
  font-size: 12px !important;
  color: var(--c-black);
  outline: none;
  transition: all 0.15s;
  width: 175px;
  box-sizing: border-box;
}

.date-input::placeholder {
  font-family: var(--font);
}

.date-input:focus {
  border-color: var(--c-black);
}

.calendar-confirm-bar {
  padding: 10px;
  border-top: 1px solid var(--border);
  display: flex;
  justify-content: flex-end;
  background: var(--c-white);
}

.state-pill-mini {
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--c-white);
  border: 1px solid var(--border);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 11px;
}

.spm-code {
  font-weight: 500;
  color: var(--c-black);
}

.spm-count {
  color: var(--c-black);
}

.spm-more {
  font-size: 11px;
  color: var(--text3);
  align-self: center;
  padding-left: 4px;
}

.event-type-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-top: 3px;
  flex-shrink: 0;
}

.event-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.event-time {
  font-size: 10px;
  color: var(--text3);
  white-space: nowrap;
}

.event-body {
  flex: 1 1;
  min-width: 0;
}

.event-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.event-tn {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.event-company {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
}

.event-state {
  font-size: 10px;
  color: var(--text3);
}

.event-change {
  margin-top: 4px;
}

.event-change-type {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
}

.event-values {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  font-size: 11px;
  flex-wrap: wrap;
}

.ev-old {
  color: var(--c-black);
  background: var(--c-white);
  padding: 2px 7px;
  border-radius: 3px;
  border: 1px solid var(--border);
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ev-arrow {
  color: var(--text3);
}

.ev-new {
  color: var(--c-black);
  background: var(--c-white);
  padding: 2px 7px;
  border-radius: 3px;
  border: 1px solid var(--border2);
  font-weight: 500;
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.ev-new.approved {
  background: var(--c-aqua-mass);
  color: var(--green-text);
  border-color: var(--c-teal-2);
}

.ev-new.rejected {
  background: var(--red-bg);
  color: var(--red-text);
  border-color: var(--c-orange);
}

.ev-new.objection {
  background: var(--orange-bg);
  color: var(--amber-text);
  border-color: var(--c-orange);
}

.ev-new.document {
  background: var(--c-purple-4);
  color: var(--c-purple-1);
  border-color: var(--c-purple-3);
}

.event-notes {
  font-size: 11px;
  color: var(--c-black);
  margin-top: 3px;
}

.event-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
  flex-shrink: 0;
}

.detail-panel {
  width: 340px;
  min-width: 340px;
  background: var(--c-white);
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dp-header {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  flex-shrink: 0;
}

.dp-tn {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.dp-company {
  font-size: 15px;
  font-weight: 600;
  color: var(--c-black);
  margin-top: 3px;
}

.dp-meta {
  font-size: 11px;
  color: var(--c-black);
  margin-top: 2px;
}

.dp-close {
  float: right;
  color: var(--text3);
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  margin-top: -2px;
}

.dp-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.dp-section-title {
  font-size: 10px;
  font-weight: 600;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-bottom: 8px;
}

.event-detail-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 12px 14px;
}

.edc-type {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  display: flex;
  align-items: center;
  gap: 8px;
}

.edc-time {
  font-size: 11px;
  color: var(--text3);
  margin-top: 3px;
}

.value-comparison {
  margin-top: 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.vc-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.vc-label {
  font-size: 10px;
  color: var(--text3);
  width: 28px;
  flex-shrink: 0;
}

.vc-val {
  font-size: 11px;
  padding: 3px 8px;
  border-radius: 4px;
  flex: 1 1;
}

.vc-old {
  background: var(--c-white);
  border: 1px solid var(--border);
  color: var(--c-black);
  text-decoration: line-through;
}

.vc-new {
  background: var(--orange-bg);
  border: 1px solid var(--c-orange);
  color: var(--amber-text);
  font-weight: 500;
}

.vc-new.approved {
  background: var(--c-aqua-mass);
  border-color: var(--c-teal-2);
  color: var(--green-text);
}

.vc-new.rejected {
  background: var(--red-bg);
  border-color: var(--c-orange);
  color: var(--red-text);
}

.vc-notes {
  font-size: 11px;
  color: var(--c-black);
  margin-top: 6px;
  padding: 6px 8px;
  background: var(--c-white);
  border-radius: 4px;
  border: 1px solid var(--border);
  line-height: 1.5;
}

.dp-actions {
  padding: 12px 16px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.dp-actions .btn {
  flex: 1 1;
  text-align: center;
  font-size: 12px;
}

/* Table Column Widths */
.col-tn {
  /* Dynamic width */
}

.col-company {
  /* No fixed width */
}

.col-state {
  /* Dynamic width */
}

.col-type {
  /* Dynamic width */
}

.col-status {
  /* Dynamic width */
}

.col-date {
  width: 100px;
}

.col-count {
  width: 65px;
  text-align: center;
}

.col-zip {
  width: 65px;
  text-align: center;
}

table {
  table-layout: fixed;
}

td,
th {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Pagination */
/* .pagination {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  background: var(--c-white);
  border-top: 1px solid var(--border);
}

.pagination-sticky {
  position: sticky;
  bottom: 0;
  background: var(--c-white);
  border-top: 1px solid var(--border);
  box-shadow: 0 -2px 10px var(--surface-pressed-tint);
  z-index: 50;
}

.pg-info {
  font-size: 12px;
  color: var(--c-black);
}

.pg-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pg-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  border: 1px solid var(--border-color-strong);
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.1s;
}

.pg-btn:hover:not(.active):not(:disabled) {
  background: var(--text2);
  color: var(--c-white);
  border-color: var(--border-color-strong);
}

.pg-btn.active {
  background: var(--c-white);
  color: var(--ink-emphasis);
  border: 1px solid var(--border-color-strong);
}

.pg-btn.active:hover {
  background: var(--c-neon);
  border: 1px solid var(--border-color-strong);
}

.pg-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.pg-select {
  font-family: var(--font);
  font-size: 11px;
  padding: 0 20px 0 4px;
  border: 1px solid var(--border-color-strong);
  border-radius: 6px;
  background: var(--c-white);
  cursor: pointer;
  height: 28px;
  box-sizing: border-box;
  transition: all 0.15s;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='%236B6960' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 6px center;
  background-size: 8px 5px;
}

.pg-select:hover {
  background-color: var(--ink-emphasis);
  color: var(--c-white);
  border-color: var(--ink-emphasis);
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
} */

/* Role Switcher */
.role-switcher {
  margin: 16px 20px;
  padding-top: 16px;
  border-top: 1px solid var(--border);
}

.rs-label {
  font-size: 10px;
  font-weight: 600;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 8px;
}

.rs-group {
  display: flex;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 2px;
}

.rs-btn {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 6px 4px;
  font-size: 11px;
  font-weight: 500;
  color: var(--text2);
  cursor: pointer;
  border-radius: 4px;
  transition: all 0.15s;
}

.rs-btn.active {
  background: var(--c-white);
  color: var(--c-black);
  box-shadow: var(--shadow-control);
}

/* Filing Mini Summary */
.filing-mini {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.fm-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.fm-label {
  font-size: 11px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 500;
}

.fm-val {
  font-size: 12px;
  color: var(--c-black);
  font-weight: 500;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Detail Panel Extras */
.detail-panel {
  width: 400px;
  background: var(--c-white);
  border-left: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.dp-header {
  padding: 20px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
}

.dp-close {
  float: right;
  cursor: pointer;
  color: var(--text3);
}

.dp-tn {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--c-blue-1);
}

.dp-company {
  font-size: 18px;
  font-weight: 600;
  margin-top: 4px;
}

.dp-meta {
  font-size: 12px;
  color: var(--text3);
  margin-top: 2px;
}

.dp-body {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
}

.dp-section-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 12px;
  margin-top: 20px;
}

.dp-section-title:first-child {
  margin-top: 0;
}

.dp-actions {
  padding: 16px 20px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 12px;
  background: var(--c-white);
}

/* ── Objections Layout ── */
.filing-list {
  width: 280px;
  min-width: 280px;
  background: var(--c-white);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.list-header {
  padding: 12px 16px;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.list-header-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.list-search {
  padding: 10px 12px;
  border-bottom: 1px solid var(--border);
}

.list-search input {
  width: 100%;
  font-family: var(--font);
  font-size: 12px;
  padding: 6px 10px;
  border: 1px solid var(--border2);
  border-radius: var(--radius);
  background: var(--c-white);
  color: var(--c-black);
}

.list-search input:focus {
  outline: none;
  border-color: var(--c-black);
}

.list-items {
  flex: 1 1;
  overflow-y: auto;
}

.filing-item {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  cursor: pointer;
  transition: background 0.12s;
}

.filing-item:hover {
  background: var(--c-white);
}

.filing-item.active {
  background: var(--c-cyan-1);
  border-left: 3px solid var(--c-blue-1);
  padding-left: 11px;
}

.fi-tn {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.fi-co {
  font-size: 12px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.fi-meta {
  display: flex;
  gap: 5px;
  margin-top: 5px;
  align-items: center;
  flex-wrap: wrap;
}

.fi-date {
  font-size: 10px;
  color: var(--text3);
  margin-top: 2px;
}

.detail {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.detail-content {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.filing-header-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.fhc-top {
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
}

.fhc-left {
  flex: 1 1;
}

.fhc-tn {
  font-family: var(--mono);
  font-size: 12px;
  color: var(--c-blue-1);
  font-weight: 500;
}

.fhc-company {
  font-size: 18px;
  font-weight: 600;
  color: var(--c-black);
  margin-top: 4px;
  letter-spacing: -0.3px;
}

.fhc-toi {
  font-size: 12px;
  color: var(--text2);
  margin-top: 3px;
}

.fhc-meta {
  display: flex;
  gap: 0;
  border-top: 1px solid var(--border);
}

.fhc-field {
  flex: 1 1;
  padding: 12px 16px;
  border-right: 1px solid var(--border);
}

.fhc-field:last-child {
  border-right: none;
}

.fhc-label {
  font-size: 10px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.fhc-val {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-top: 3px;
}

.fhc-val.danger {
  color: var(--c-orange);
}

.fhc-val.success {
  color: var(--c-teal-active);
}

.timeline-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 16px 20px;
}

.timeline-title {
  font-size: 11px;
  font-weight: 600;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 14px;
}

.timeline {
  display: flex;
  align-items: flex-start;
  position: relative;
}

.timeline::before {
  content: '';
  position: absolute;
  top: 12px;
  left: 12px;
  right: 12px;
  height: 1px;
  background: var(--border);
  z-index: 0;
}

.tl-step {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  position: relative;
  z-index: 1;
}

.tl-dot {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 600;
  border: 2px solid transparent;
}

.tl-done {
  background: var(--c-aqua-mass);
  color: var(--green-text);
  border-color: var(--c-teal-active);
}

.tl-active {
  background: var(--orange-bg);
  color: var(--amber-text);
  border-color: var(--c-orange);
}

.tl-pending {
  background: var(--c-white);
  color: var(--text3);
  border-color: var(--border2);
}

.tl-label {
  font-size: 10px;
  color: var(--text2);
  text-align: center;
  font-weight: 500;
  line-height: 1.3;
}

.tl-date {
  font-size: 10px;
  color: var(--text3);
  text-align: center;
}

.section-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  gap: 10px;
}

.section-title::after {
  content: '';
  flex: 1 1;
  height: 1px;
  background: var(--border);
}

.obj-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.obj-card-header {
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--c-white);
  border-bottom: 1px solid var(--border);
}

.obj-card-num {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  display: flex;
  align-items: center;
  gap: 8px;
}

.obj-card-num-badge {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: var(--red-bg);
  color: var(--red-text);
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.obj-card-num-badge.responded {
  background: var(--c-aqua-mass);
  color: var(--green-text);
}

.obj-card-body {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.text-block-label {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: var(--text3);
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.text-block-label::before {
  content: '';
  width: 3px;
  height: 12px;
  border-radius: 2px;
}

.objection-label::before {
  background: var(--c-orange);
}

.response-label::before {
  background: var(--c-teal-active);
}

.related-label::before {
  background: var(--c-orange);
}

.changed-items-label::before {
  background: var(--c-purple-1);
}

.text-block {
  font-size: 12px;
  color: var(--c-black);
  line-height: 1.7;
  padding: 12px 14px;
  background: var(--c-white);
  border-radius: var(--radius);
  border: 1px solid var(--border);
}

.no-response {
  font-size: 12px;
  color: var(--text3);
  font-style: italic;
  padding: 10px 14px;
  background: var(--c-white);
  border-radius: var(--radius);
  border: 1px dashed var(--border2);
  display: flex;
  align-items: center;
  gap: 8px;
}

.divider {
  height: 1px;
  background: var(--border);
  margin: 4px 0;
}

.intro-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.intro-header {
  padding: 10px 16px;
  background: var(--c-white);
  border-bottom: 1px solid var(--border);
  font-size: 12px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.intro-body {
  padding: 14px 16px;
  font-size: 12px;
  color: var(--text2);
  line-height: 1.7;
}

.stats-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 4px;
}

.stat-mini {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 10px 14px;
}

.sm-label {
  font-size: 10px;
  color: var(--text3);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.sm-val {
  font-size: 20px;
  font-weight: 600;
  color: var(--c-black);
  margin-top: 2px;
  letter-spacing: -0.5px;
}

.letter-tabs {
  display: flex;
  gap: 0;
  border-bottom: 1px solid var(--border);
  background: var(--c-white);
  padding: 0 20px;
  flex-shrink: 0;
}

.letter-tab {
  padding: 10px 16px;
  font-size: 12px;
  font-weight: 500;
  color: var(--text2);
  cursor: pointer;
  border-bottom: 2px solid transparent;
  transition: all 0.15s;
  white-space: nowrap;
}

.letter-tab:hover {
  color: var(--c-black);
}

.letter-tab.active {
  color: var(--c-black);
  border-bottom-color: var(--c-black);
}

/* Shared primitives migrated from global.css (Tier 1+2) */
.chart-thumb-bars {
  display: flex;
  align-items: flex-end;
  gap: 6px;
  height: 40px;
  padding-bottom: 4px;
}

.chart-thumb-bars__bar {
  width: 10px;
  height: 60%;
  background: linear-gradient(180deg, var(--c-black), var(--c-black));
  border-radius: 2px;
}

.chart-thumb-bars__bar {
  width: 10px;
  height: 85%;
  background: linear-gradient(180deg, var(--ink-emphasis), var(--ink-emphasis));
  border-radius: 2px;
}

.chart-thumb-bars__bar {
  width: 10px;
  height: 40%;
  background: linear-gradient(180deg, var(--c-blue-1), var(--text2));
  border-radius: 2px;
}

.chart-thumb-bars__bar {
  width: 10px;
  height: 95%;
  background: linear-gradient(180deg, var(--c-blue-1), var(--ink-half));
  border-radius: 2px;
}

.chart-thumb-line {
  overflow: visible;
}

.chart-thumb-dots {
  position: relative;
  width: 70px;
  height: 40px;
}

.chart-thumb-dots__dot {
  position: absolute;
  left: 10px;
  top: 20px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-blue-1);
  opacity: 0.8;
}

.chart-thumb-dots__dot {
  position: absolute;
  left: 25px;
  top: 8px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--ink-muted);
  opacity: 0.9;
}

.chart-thumb-dots__dot {
  position: absolute;
  left: 20px;
  top: 25px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--c-black);
  opacity: 0.7;
}

.chart-thumb-dots__dot {
  position: absolute;
  left: 40px;
  top: 15px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: var(--ink-emphasis);
  opacity: 0.8;
}

.chart-thumb-dots__dot {
  position: absolute;
  left: 55px;
  top: 22px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c-blue-1);
  opacity: 0.6;
}

.chart-thumb-pie {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 5px solid var(--border);
  border-top-color: var(--c-black);
  border-right-color: var(--ink-emphasis);
  transform: rotate(45deg);
}

.chart-thumb-area {
  overflow: visible;
}

.chart-thumb-progress {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 70px;
  justify-content: center;
}

.chart-thumb-progress__labels {
  display: flex;
  justify-content: space-between;
  font-size: 9px;
  color: var(--ink-emphasis);
  font-weight: 500;
}

.chart-thumb-progress__track {
  width: 100%;
  height: 4px;
  background: var(--surface-pressed-tint);
  border-radius: 2px;
  overflow: hidden;
}

.chart-thumb-progress__fill {
  width: 98%;
  height: 100%;
  background: var(--ink-emphasis);
  border-radius: 2px;
}

.chart-thumb-dual {
  display: flex;
  gap: 10px;
  align-items: flex-end;
  height: 40px;
}

.chart-thumb-dual__group {
  display: flex;
  gap: 3px;
  align-items: flex-end;
  height: 100%;
}

.chart-thumb-dual__bar {
  width: 6px;
  height: 80%;
  background: var(--ink-muted);
  border-radius: 1.5px;
}

.chart-thumb-dual__bar {
  width: 6px;
  height: 50%;
  background: var(--border);
  border-radius: 1.5px;
}

.chart-thumb-dual__group {
  display: flex;
  gap: 3px;
  align-items: flex-end;
  height: 100%;
}

.chart-thumb-dual__bar {
  width: 6px;
  height: 95%;
  background: var(--ink-muted);
  border-radius: 1.5px;
}

.chart-thumb-dual__bar {
  width: 6px;
  height: 65%;
  background: var(--border);
  border-radius: 1.5px;
}

.chart-thumb-sentiment {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 70px;
  justify-content: center;
}

.chart-thumb-sentiment__row {
  display: flex;
  justify-content: space-between;
  font-size: 8px;
  color: var(--text3);
}

.chart-thumb-sentiment__label {
  color: var(--ink-emphasis);
  font-weight: 500;
}

.chart-thumb-sentiment__track {
  position: relative;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, var(--ink-muted), var(--c-blue-1), var(--ink-emphasis));
  border-radius: 2px;
}

.chart-thumb-sentiment__fill {
  position: absolute;
  left: 75%;
  top: -3px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--c-white);
  border: 2px solid var(--c-black);
  box-shadow: var(--shadow-control);
}

.analytics-workspace {
  padding: 30px;
  background: var(--c-white);
  border-radius: 12px;
  border: 1px solid var(--border-subtle);
  margin-top: 20px;
  box-shadow: 0 4px 20px var(--surface-faint-tint);
}

.analytics-workspace__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  border-bottom: 1px solid var(--border-subtle);
  padding-bottom: 15px;
}

.analytics-workspace__badge-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.analytics-workspace__badge {
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.analytics-workspace__title {
  margin: 0;
  font-size: 22px;
  font-weight: 500;
  color: var(--c-black);
}

.analytics-workspace__sub {
  margin: 5px 0 0 0;
  color: var(--text2);
  font-size: 14px;
}

.analytics-workspace__run-btn {
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.analytics-workspace__filters {
  padding: 12px 15px;
  background: var(--c-white);
  border-radius: 8px;
  border: 1px solid var(--border-subtle);
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 25px;
  align-items: center;
}

.analytics-workspace__select {
  background: var(--c-white);
  border: 1px solid var(--border);
  flex: 1 1;
  min-width: 120px;
}

.analytics-workspace__select-measure {
  font-size: 11.5px;
  height: 32px;
  line-height: 32px;
}

.analytics-workspace__select-input {
  height: 32px;
  font-size: 11.5px;
}

.analytics-workspace__select {
  background: var(--c-white);
  border: 1px solid var(--border);
  flex: 1 1;
  min-width: 120px;
}

.analytics-workspace__select-measure {
  font-size: 11.5px;
  height: 32px;
  line-height: 32px;
}

.analytics-workspace__select-input {
  height: 32px;
  font-size: 11.5px;
}

.analytics-workspace__select {
  background: var(--c-white);
  border: 1px solid var(--border);
  flex: 1 1;
  min-width: 120px;
}

.analytics-workspace__select-measure {
  font-size: 11.5px;
  height: 32px;
  line-height: 32px;
}

.analytics-workspace__select-input {
  height: 32px;
  font-size: 11.5px;
}

.analytics-workspace__select {
  background: var(--c-white);
  border: 1px solid var(--border);
  flex: 1 1;
  min-width: 120px;
}

.analytics-workspace__select-measure {
  font-size: 11.5px;
  height: 32px;
  line-height: 32px;
}

.analytics-workspace__select-input {
  height: 32px;
  font-size: 11.5px;
}

.analytics-workspace__select {
  background: var(--c-white);
  border: 1px solid var(--border);
  flex: 1 1;
  min-width: 120px;
}

.analytics-workspace__select-measure {
  font-size: 11.5px;
  height: 32px;
  line-height: 32px;
}

.analytics-workspace__select-input {
  height: 32px;
  font-size: 11.5px;
}

.analytics-workspace__simulate-btn {
  height: 32px;
  font-size: 12px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 6px;
}

.page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  background: var(--c-white);
  border-radius: 12px;
  border: 1px solid var(--bar-track-bg);
  padding: 40px;
  margin-top: 20px;
}

.page-empty__icon {
  padding: 16px;
  border-radius: 50%;
  margin-bottom: 16px;
}

.page-empty__title {
  font-size: 16px;
  font-weight: 500;
  color: var(--c-black);
  margin: 0 0 6px 0;
}

.page-empty__text {
  font-size: 14px;
  color: var(--text2);
  margin: 0;
  text-align: center;
  max-width: 440px;
  line-height: 1.5;
}

.report-results-grid {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 24px;
  padding: 24px;
  margin-top: 12px;
  background: var(--c-white);
  border-radius: 12px;
  border: 1px solid var(--border-subtle);
}

.report-results-grid__chart-title {
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--c-black);
  letter-spacing: 0.5px;
  margin-bottom: 16px;
}

.report-results-grid__chart {
  overflow: visible;
}

.report-results-grid__insights {
  border-left: 1px solid var(--border-subtle);
  padding-left: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.report-results-grid__insights-title {
  font-size: 15px;
  font-weight: 500;
  text-transform: uppercase;
  color: var(--c-black);
  letter-spacing: 0.5px;
  margin-bottom: 24px;
  border-bottom: none;
  padding-bottom: 0;
}

.insight-list {
  padding-left: 0;
  list-style-type: none;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: var(--ink-emphasis);
  font-size: 14px;
  line-height: 1.8;
}

.insight-list__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.insight-list__bullet {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 8px;
  flex-shrink: 0;
}

.insight-list__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.insight-list__bullet {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--c-black);
  margin-top: 8px;
  flex-shrink: 0;
}

.insight-list__item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.insight-list__bullet {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--ink-emphasis);
  margin-top: 8px;
  flex-shrink: 0;
}

.analytics-page-body {
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  min-height: 0;
  background: var(--c-white);
}

.template-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.template-card {
  background: var(--c-white);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 20px;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 220px;
  box-shadow: 0 4px 6px -1px var(--surface-faint-tint), 0 2px 4px -1px var(--surface-faint-tint);
}

.template-card__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.template-card__icon-wrap {
  padding: 6px;
  border-radius: 6px;
  display: flex;
  align-items: center;
}

.template-card__badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: 500;
  letter-spacing: 0.05em;
}

.template-card__title {
  font-size: 15px;
  font-weight: 500;
  color: var(--c-black);
  margin: 0 0 4px 0;
}

.template-card__sub {
  font-size: 11px;
  color: var(--text3);
  margin: 0 0 10px 0;
}

.template-card__desc {
  font-size: 12px;
  color: var(--text2);
  line-height: 1.4;
  margin: 0;
}

.template-card__footer {
  margin-top: 15px;
  border-top: 1px solid var(--bar-track-bg);
  padding-top: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.template-card__cta {
  font-size: 11px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.analytics-back-row {
  margin-bottom: 20px;
}

.analytics-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ink-emphasis);
  cursor: pointer;
  box-shadow: 0 1px 2px var(--surface-pressed-tint);
  transition: background 0.2s;
}

.analytics-toolbar-panel {
  background: var(--c-white);
  border: 1px solid var(--border-subtle);
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 4px 20px var(--shadow-ghost);
}

.analytics-toolbar-panel__grid {
  display: grid;
  gap: 20px;
}

.analytics-toolbar-panel__field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.analytics-toolbar-panel__label {
  font-size: 11px;
  font-weight: 500;
  color: var(--text2);
  text-transform: uppercase;
}

.analytics-toolbar-panel__actions {
  display: flex;
  align-items: flex-end;
}

.analytics-toolbar-panel__run {
  height: 38px;
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.changelog-stat--approvals {
  color: var(--c-teal-active);
}

.changelog-stat--rejections {
  color: var(--c-orange);
}

.changelog-stat--objections {
  color: var(--c-orange);
}

.changelog-stat--documents {
  color: var(--c-purple-1);
}

.table-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-pagination__control {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-pagination__label {
  font-size: 11px;
  color: var(--text3);
}

.pagination__pages {
  display: flex;
  gap: 4px;
}

.pagination__ellipsis {
  font-size: 12px;
  color: var(--text3);
  padding: 0 4px;
}

.changelog-tracking {
  font-family: var(--mono);
  font-size: 11px;
  color: var(--c-blue-1);
}

.changelog-highlight {
  color: var(--c-orange);
  font-weight: 500;
}

.changelog-pill-meta {
  font-size: 10px;
}

.link-back {
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  color: var(--text2);
  cursor: pointer;
  font-size: 11px;
  padding: 0;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.link-back:hover {
  color: var(--c-black);
}

.milestone-track {
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 0 20px;
}

.milestone-track__line {
  position: absolute;
  left: 40px;
  right: 40px;
  top: 15px;
  height: 2px;
  background: var(--surface-pressed-tint);
  z-index: 1;
}

.milestone-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  z-index: 2;
  position: relative;
}

.milestone-step__dot {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.milestone-step__dot.pending {
  background: var(--c-white);
  border: 1px solid var(--border);
  color: var(--text3);
}

.milestone-step__dot.submitted {
  background: var(--c-white);
  border: 2px solid var(--milestone-decision);
  color: var(--milestone-decision);
  box-shadow: var(--shadow-teal-sm);
}

.milestone-step__dot.assigned {
  background: var(--c-white);
  border: 2px solid var(--milestone-decision);
  color: var(--milestone-decision);
  box-shadow: var(--shadow-teal-sm);
}

.milestone-step__dot.objection-issued {
  background: var(--c-white);
  border: 2px solid var(--milestone-objection);
  color: var(--milestone-objection);
  box-shadow: var(--shadow-orange-sm);
}

.milestone-step__dot.response-due {
  background: var(--c-white);
  border: 2px solid var(--milestone-decision);
  color: var(--milestone-decision);
  box-shadow: var(--shadow-teal-sm);
}

.milestone-step__dot.in-review {
  background: var(--c-white);
  border: 2px solid var(--milestone-decision);
  color: var(--milestone-decision);
  box-shadow: var(--shadow-teal-sm);
}

.milestone-step__dot.final-decision {
  background: var(--c-white);
  border: 2px solid var(--milestone-decision);
  color: var(--milestone-decision);
  box-shadow: var(--shadow-teal-sm);
}

.milestone-step__label {
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.milestone-step__label.pending {
  color: var(--text3);
}

.milestone-step__label.submitted {
  color: var(--milestone-decision);
}

.milestone-step__label.assigned {
  color: var(--milestone-decision);
}

.milestone-step__label.objection-issued {
  color: var(--milestone-objection);
}

.milestone-step__label.response-due {
  color: var(--milestone-decision);
}

.milestone-step__label.in-review {
  color: var(--milestone-decision);
}

.milestone-step__label.final-decision {
  color: var(--milestone-decision);
}

.milestone-step__date {
  font-size: 10px;
  color: var(--text3);
}

.enhanced-timeline {
  position: relative;
}

.page-empty {
  text-align: center;
  padding: 60px 0;
}

.page-empty__icon {
  margin-bottom: 16px;
}

.page-empty__text {
  color: var(--text3);
  font-size: 14px;
}

.insights-panel {
  min-height: 0;
}

.report-outer--flush {
  padding: 0;
}

.report-page--flush {
  margin: 0;
  box-shadow: none;
  background: transparent;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
  margin-top: 0;
  font-family: var(--font);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.kpi-strip {
  display: flex;
  align-items: center;
}

.kpi-strip__col {
  flex: 1 1;
}

.kpi-strip__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.kpi-strip__label {
  font-size: 11px;
  color: var(--text2);
  margin-bottom: 4px;
}

.kpi-strip__value {
  font-size: 22px;
  font-weight: 500;
  color: var(--c-black);
}

.kpi-strip__aside {
  text-align: right;
}

.kpi-strip-delta {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 500;
}

.kpi-strip-delta--up,
.kpi-strip-delta--neutral {
  background: var(--teal-tint);
  color: var(--c-teal-active);
}

.kpi-strip-delta--down {
  background: var(--red-bg);
  color: var(--c-orange);
}

.kpi-strip-delta__hint {
  font-size: 9px;
  color: var(--text3);
  margin-top: 4px;
}

.kpi-strip__divider {
  width: 1px;
  height: 40px;
  background: var(--surface-pressed-tint);
  margin: 0 32px;
}

.insights-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.metric-panel {
  position: relative;
  height: 180px;
}

.metric-panel__spacer {
  position: absolute;
  left: 100px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--surface-pressed-tint);
}

.metric-panel__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
}

.metric-row {
  display: flex;
  align-items: center;
}

.metric-row__label {
  width: 90px;
  text-align: right;
  font-size: 9px;
  color: var(--text2);
  padding-right: 10px;
}

.metric-row__track {
  flex: 1 1;
  height: 10px;
  background: var(--surface-faint-tint);
  border-radius: 2px;
  position: relative;
}

.metric-row__fill {
  height: 100%;
  border-radius: 2px;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-chart-area {
  height: 180px;
  position: relative;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.metric-bars {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.metric-bars__row {
  display: flex;
  align-items: center;
}

.metric-bars__label {
  width: 70px;
  font-size: 9px;
  color: var(--text2);
}

.metric-bars__track {
  flex: 1 1;
  height: 16px;
  background: var(--surface-faint-tint);
  border-radius: 2px;
  position: relative;
}

.metric-bars__fill {
  height: 100%;
  border-radius: 2px;
  opacity: 0.8;
}

.metric-bars__value {
  position: absolute;
  left: 5px;
  top: 2px;
  font-size: 8px;
}

.insights-row {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-chart-area {
  height: 200px;
  position: relative;
}

.insights-chart-labels {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.insights-chart-labels__item {
  font-size: 9px;
  color: var(--text3);
}

.insights-chart-legend {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.insights-chart-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-chart-legend__swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-blue-1);
}

.insights-chart-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-chart-legend__swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-blue-2);
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-chart-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.insights-donut-legend {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-top: 16px;
  width: 100%;
}

.insights-donut-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-donut-legend__swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.insights-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.metric-panel {
  position: relative;
  height: 180px;
}

.metric-panel__list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
}

.metric-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-row__label {
  font-size: 9px;
  color: var(--text2);
}

.metric-row__track {
  width: 100%;
  height: 8px;
  background: var(--surface-faint-tint);
  border-radius: 4px;
}

.metric-row__fill {
  height: 100%;
  border-radius: 4px;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-chart-area {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.insights-card {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-section-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.metric-bars {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.metric-bars__row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.metric-bars__label {
  width: 60px;
  font-size: 9px;
  color: var(--text2);
}

.metric-bars__track {
  flex: 1 1;
  height: 6px;
  background: var(--surface-faint-tint);
  border-radius: 3px;
}

.metric-bars__fill {
  height: 100%;
  border-radius: 3px;
}

.insights-footer-note {
  margin-top: 30px;
}

.insights-panel {
  padding: 0;
}

.report-outer--flush {
  margin: 0;
  box-shadow: none;
  background: transparent;
}

.insights-row {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  position: relative;
  height: 180px;
}

.metric-panel {
  position: absolute;
  left: 100px;
  top: 0;
  bottom: 0;
  width: 1px;
  background: var(--surface-pressed-tint);
}

.metric-panel__spacer {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
}

.metric-panel__list {
  display: flex;
  align-items: center;
}

.metric-row {
  width: 90px;
  text-align: right;
  font-size: 9px;
  color: var(--text2);
  padding-right: 10px;
}

.metric-row__label {
  flex: 1 1;
  height: 10px;
  background: var(--surface-faint-tint);
  border-radius: 2px;
  position: relative;
}

.metric-row__track {
  height: 100%;
  border-radius: 2px;
}

.metric-row__fill {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  height: 180px;
  position: relative;
}

.insights-chart-area {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.insights-chart-placeholder {
  font-size: 9px;
  color: var(--text2);
}

.insights-chart-placeholder__bar {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.metric-bars {
  display: flex;
  align-items: center;
}

.metric-bars__row {
  width: 70px;
  font-size: 9px;
  color: var(--text2);
}

.metric-bars__label {
  flex: 1 1;
  height: 16px;
  background: var(--surface-faint-tint);
  border-radius: 2px;
  position: relative;
}

.metric-bars__track {
  height: 100%;
  border-radius: 2px;
  opacity: 0.8;
}

.metric-bars__fill {
  position: absolute;
  left: 5px;
  top: 2px;
  font-size: 8px;
}

.metric-bars__value {
  display: grid;
  grid-template-columns: 1.6fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-row {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  height: 200px;
  position: relative;
}

.insights-chart-area {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.insights-chart-labels {
  font-size: 9px;
  color: var(--text3);
}

.insights-chart-labels__item {
  display: flex;
  gap: 20px;
  margin-top: 15px;
}

.insights-chart-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-chart-legend__item {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-blue-2);
}

.insights-chart-legend__swatch {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-chart-legend__item {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--c-blue-1);
}

.insights-chart-legend__swatch {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.insights-chart-area {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
  margin-top: 16px;
  width: 100%;
}

.insights-donut-legend {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--text2);
}

.insights-donut-legend__item {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.insights-donut-legend__swatch {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-row {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  position: relative;
  height: 180px;
}

.metric-panel {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 10px;
}

.metric-panel__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.metric-row {
  font-size: 9px;
  color: var(--text2);
}

.metric-row__label {
  width: 100%;
  height: 8px;
  background: var(--surface-faint-tint);
  border-radius: 4px;
}

.metric-row__track {
  height: 100%;
  border-radius: 4px;
}

.metric-row__fill {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.insights-chart-area {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 16px;
  justify-content: center;
}

.insights-pie-legend {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 9px;
  color: var(--text2);
}

.insights-pie-legend__item {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}

.insights-pie-legend__swatch {
  padding: 24px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-card {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-section-title {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.metric-bars {
  display: flex;
  align-items: center;
  gap: 10px;
}

.metric-bars__row {
  width: 80px;
  font-size: 9px;
  color: var(--text2);
}

.metric-bars__label {
  flex: 1 1;
  height: 6px;
  background: var(--surface-faint-tint);
  border-radius: 3px;
}

.metric-bars__track {
  height: 100%;
  border-radius: 3px;
}

.metric-bars__fill {
  margin-top: 30px;
}

.insights-panel {
  padding: 0;
}

.report-outer--flush {
  margin: 0;
  box-shadow: none;
  background: transparent;
}

.insights-row {
  padding: 16px;
  position: relative;
  background: var(--c-white);
  border-radius: 12px;
  border: 1px solid var(--border);
}

.insights-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.insights-section-title {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  margin: 0;
  padding: 0;
  border: none;
}

.metric-panel {
  display: block;
}

.metric-panel__spacer {
  padding: 16px;
  position: relative;
  background: var(--c-white);
  border-radius: 12px;
  border: 1px solid var(--border);
}

.metric-panel__list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
}

.metric-row {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  margin: 0;
  padding: 0;
  border: none;
}

.metric-row__label {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.insights-card {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  margin-top: 20px;
}

.insights-section-title {
  padding: 16px;
  border-radius: 12px;
  border: 1px solid var(--border);
  background: var(--c-white);
}

.insights-chart-area {
  font-size: 13px;
  font-weight: 500;
  color: var(--c-black);
  margin-bottom: 24px;
}

.insights-chart-labels {
  position: relative;
}

.insights-pie-legend__item {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 400px;
}

.insights-pie-legend__swatch {
  text-align: center;
}

.insights-card {
  color: var(--c-black);
  margin-bottom: 8px;
}

.insights-section-title {
  color: var(--text3);
  font-size: 14px;
}

@keyframes filingsInsightsIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Opacity-only — use inside overflow scroll panels to avoid scrollbar / width glitches */
@keyframes filingsInsightsFadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes filingsInsightsCardIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.99);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.table-area.insights-panel,
.table-area.alerts-panel,
.table-area.filings-table-panel {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0;
}

.body.insights-panel {
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  padding: 0;
}

.table-area.alerts-panel > .report-outer--embedded {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.table-area.alerts-panel .report-page > .report-card {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;
}

.forward-looking-alerts-panel .forward-looking-alerts-panel__scope {
  margin: 10px 0 0;
  font-size: 16px;
  font-weight: 500;
  color: var(--text2);
}

/* .forward-looking-alerts-panel .forward-looking-alerts-panel__title::before {
  content: '⚡';
  margin-right: 8px;
  color: var(--c-neon);
} */

.forward-looking-alerts-panel__body {
  padding: 16px 24px 24px;
}

.forward-looking-alert-row__label {
  display: flex;
  align-items: flex-start;
}

.forward-looking-alert__badge {
  display: inline-block;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  padding: 4px 10px;
  border-radius: 10px;
  white-space: nowrap;
}

.forward-looking-alert__badge--allianz {
  background: var(--bg-red-soft);
  color: var(--c-red);
}

.forward-looking-alert__badge--fg-life {
  background: var(--bg-purple-soft);
  color: var(--c-purple-1);
}

.forward-looking-alert__badge--ny-life {
  background: var(--bg-teal-soft);
  color: var(--c-teal-active);
}

.forward-looking-alert__badge--massmutual {
  background: var(--bg-orange-soft);
  color: var(--c-orange);
}

.forward-looking-alert__badge--athene {
  background: var(--bg-blue-soft);
  color: var(--c-blue-1);
}

.forward-looking-alert__copy {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.forward-looking-alert__desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--c-black);
}

.table-area.insights-panel > .report-outer--embedded,
.table-area.insights-panel > .report-outer--flush {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.table-area.insights-panel .header {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;
}

.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > * {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(1) { animation-delay: 0.12s; }
.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(2) { animation-delay: 0.18s; }
.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(3) { animation-delay: 0.24s; }
.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(4) { animation-delay: 0.3s; }
.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(n + 5) { animation-delay: 0.36s; }

.table-area.insights-panel .report-page > .report-card {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.insights-panel .report-page > .report-card:nth-of-type(1) { animation-delay: 0.14s; }
.table-area.insights-panel .report-page > .report-card:nth-of-type(2) { animation-delay: 0.22s; }
.table-area.insights-panel .report-page > .report-card:nth-of-type(3) { animation-delay: 0.3s; }
.table-area.insights-panel .report-page > .report-card:nth-of-type(n + 4) { animation-delay: 0.38s; }

/* Insights chart / graph draw-in */
@keyframes filingsBarGrowUp {
  from {
    opacity: 0.35;
    transform: scaleY(0);
  }

  to {
    opacity: 1;
    transform: scaleY(1);
  }
}

@keyframes filingsBarGrowRight {
  from {
    opacity: 0.35;
    transform: scaleX(0);
  }

  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

@keyframes filingsHeatmapCellIn {
  from {
    opacity: 0;
    transform: scale(0.85);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes filingsChartSvgIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.table-area.insights-panel .chart-panel__body > svg,
.table-area.insights-panel .chart-panel__body > div > svg,
.table-area.insights-panel .insights-chart-area > svg,
.table-area.insights-panel .insights-chart-area svg {
  animation: filingsChartSvgIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.2s;
}

.table-area.insights-panel .volume-chart-stacked-bar {
  transform-origin: bottom center;
  animation: filingsBarGrowUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: var(--chart-bar-delay, 0.22s);
}

.table-area.insights-panel .product-depth-bar-row__fill,
.table-area.insights-panel .metric-bars__fill,
.table-area.insights-panel .metric-row__fill {
  transform-origin: left center;
  animation: filingsBarGrowRight 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.insights-panel .product-depth-row:nth-child(1) .product-depth-bar-row__fill { animation-delay: 0.28s; }
.table-area.insights-panel .product-depth-row:nth-child(2) .product-depth-bar-row__fill { animation-delay: 0.34s; }
.table-area.insights-panel .product-depth-row:nth-child(3) .product-depth-bar-row__fill { animation-delay: 0.4s; }
.table-area.insights-panel .product-depth-row:nth-child(4) .product-depth-bar-row__fill { animation-delay: 0.46s; }
.table-area.insights-panel .product-depth-row:nth-child(n + 5) .product-depth-bar-row__fill { animation-delay: 0.52s; }

.table-area.insights-panel .region-ranking-bar-row .product-depth-bar-row__fill {
  animation-delay: calc(0.24s + (var(--rank-delay, 0) * 0.04s));
}

.table-area.insights-panel .cadence-heatmap-cell-active {
  animation: filingsHeatmapCellIn var(--heatmap-cell-duration) cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(var(--heatmap-stagger-start) + var(--heatmap-cell-delay, 0) * var(--heatmap-stagger-span));
}

.table-area.insights-panel .cadence-heatmap-row {
  animation: filingsHeatmapCellIn var(--heatmap-row-duration) cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(var(--heatmap-stagger-start) + var(--heatmap-row-delay, 0) * var(--heatmap-stagger-span));
}

.table-area.insights-panel .geo-map__state {
  animation: filingsHeatmapCellIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.15s + (var(--geo-state-delay, 0) * 0.01s));
}

.table-area.insights-panel .insights-chart-line-path {
  stroke-dasharray: var(--line-length, 1000);
  stroke-dashoffset: var(--line-length, 1000);
  animation: filingsLineDraw 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: 0.15s;
}

.table-area.insights-panel .insights-chart-line-area {
  opacity: 0;
  animation: filingsChartAreaFade 0.8s ease forwards;
  animation-delay: 0.45s;
}

.table-area.insights-panel .insights-chart-donut-segment {
  transition: stroke-dasharray 0.85s cubic-bezier(0.16, 1, 0.3, 1);
}

.table-area.insights-panel .insights-chart-line-point {
  opacity: 0;
  animation: filingsChartPointIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: var(--point-delay, 0.4s);
}

.table-area.insights-panel .metric-bars__row:nth-child(1) .metric-bars__fill { animation-delay: 0.26s; }
.table-area.insights-panel .metric-bars__row:nth-child(2) .metric-bars__fill { animation-delay: 0.32s; }
.table-area.insights-panel .metric-bars__row:nth-child(3) .metric-bars__fill { animation-delay: 0.38s; }
.table-area.insights-panel .metric-bars__row:nth-child(4) .metric-bars__fill { animation-delay: 0.44s; }
.table-area.insights-panel .metric-bars__row:nth-child(5) .metric-bars__fill { animation-delay: 0.5s; }
.table-area.insights-panel .metric-bars__row:nth-child(n + 6) .metric-bars__fill { animation-delay: 0.56s; }

.table-area.insights-panel .metric-panel__list .metric-row:nth-child(1) .metric-row__fill { animation-delay: 0.26s; }
.table-area.insights-panel .metric-panel__list .metric-row:nth-child(2) .metric-row__fill { animation-delay: 0.32s; }
.table-area.insights-panel .metric-panel__list .metric-row:nth-child(3) .metric-row__fill { animation-delay: 0.38s; }
.table-area.insights-panel .metric-panel__list .metric-row:nth-child(4) .metric-row__fill { animation-delay: 0.44s; }
.table-area.insights-panel .metric-panel__list .metric-row:nth-child(n + 5) .metric-row__fill { animation-delay: 0.5s; }

.table-area.insights-panel .product-depth-bar-row__fill {
  animation-delay: var(--chart-bar-delay, 0.3s);
}

.table-area.insights-panel .insights-chart-trend-line {
  stroke-dasharray: var(--line-length, 600);
  stroke-dashoffset: var(--line-length, 600);
  animation: filingsLineDraw 1.1s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.table-area.insights-panel .insights-chart-trend-line--delayed {
  animation-delay: 0.25s;
}

@keyframes filingsChartPointIn {
  from {
    opacity: 0;
    transform: scale(0.6);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}

@keyframes filingsLineDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes filingsChartAreaFade {
  to {
    opacity: 0.05;
  }
}

/* Filings table tab — list / grid enter */
@keyframes filingsTableHeadIn {
  from {
    opacity: 0;
    transform: translateY(-6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes filingsTableRowIn {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.table-area.filings-table-panel .table-wrap,
.table-area.filings-table-panel .filings-grid {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.table-area.filings-table-panel thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.table-area.filings-table-panel tbody tr,
.sec-filing-panel.filings-table-panel tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.table-area.filings-table-panel .filing-card {
  animation: filingsInsightsFadeIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.08s + min(var(--table-row-delay, 0), 20) * 0.028s);
}

.table-area.filings-table-panel .pagination-sticky {
  flex-shrink: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;
}

/* State Insurance Filings table — compress with drawer (avoid columns under drawer) */
.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap {
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
}

.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap table {
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
}

.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap th,
.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-area.filings-table-panel:not(.sec-filing-panel) .col-tn { width: 7%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-company { width: 11%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-state { width: 5%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-type { width: 8%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-toi { width: 6%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-sub-toi { width: 6%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-product-name { width: 12%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-status { width: 8%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-date { width: 11%; }
.table-area.filings-table-panel:not(.sec-filing-panel) .col-actions {
  width: 7%;
  text-align: center;
}

.filings-data-table__actions {
  text-align: center;
  vertical-align: middle;
}

.table-drawer-action-btn,
.sec-filing-insights-data-table__action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: transparent;
  color: var(--c-black);
  cursor: pointer;
  text-decoration: none;
  flex-shrink: 0;
}

.table-drawer-action-btn:hover,
.sec-filing-insights-data-table__action-btn:hover,
.sec-filing-insights-data-table__action-btn.is-link:hover {
  background: color-mix(in srgb, var(--c-black) 6%, var(--c-white));
  color: var(--c-black);
}

.table-drawer-action-btn.is-active,
.sec-filing-insights-data-table__action-btn.is-active {
  background: var(--c-black);
  color: var(--c-white);
}

.table-drawer-action-btn:focus-visible,
.sec-filing-insights-data-table__action-btn.is-link:focus-visible,
.sec-filing-insights-data-table__action-btn:focus-visible {
  outline: 2px solid var(--c-black);
  outline-offset: 1px;
}

.table-drawer-action-btn svg,
.sec-filing-insights-data-table__action-btn svg {
  flex-shrink: 0;
}

.table-area.filings-table-panel:not(.sec-filing-panel) .company-cell .company-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-area.filings-table-panel:not(.sec-filing-panel) .date-cell {
  width: auto;
  max-width: 100%;
}

/* News / PR table */
.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap table {
  table-layout: fixed;
  width: 100%;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-date {
  width: 112px;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-image {
  width: 80px;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-company {
  width: 15%;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-headline {
  width: 24%;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-summary {
  width: auto;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-source {
  width: 124px;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap th.col-date,
.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap td.date-cell {
  width: 112px;
  min-width: 112px;
  max-width: 112px;
  overflow: visible;
  text-overflow: clip;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-preview,
.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-preview-cell {
  width: 80px;
  min-width: 80px;
  max-width: 80px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  vertical-align: middle;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-company {
  width: 15%;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .sec-filing-table__company-name {
  font-size: 13px;
  line-height: 1.35;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .geo-brand-name-cell {
  width: 100%;
  min-width: 0;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .geo-brand-name-cell__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-product-name {
  width: 24%;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-type {
  width: auto;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap th.col-status,
.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap td:last-child {
  width: 124px;
  min-width: 124px;
  max-width: 124px;
  overflow: visible;
  text-overflow: clip;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-status {
  width: 124px;
  text-align: center;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) th,
.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) td {
  padding: 14px 10px;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .date-cell {
  text-transform: none;
  white-space: nowrap;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-source-cell {
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-source-link {
  margin: 0 auto;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-table-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 0;
}

.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-table-cell__text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-pr-table-thumb {
  width: 64px;
  height: 40px;
  margin: 0 auto;
  flex-shrink: 0;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--c-grey-2, #e5e7eb);
  background-color: var(--c-gray-1, #f3f4f6);
}

.news-pr-table-thumb--empty {
  display: block;
}

.news-pr-table-thumb__img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.news-pr-drawer-card {
  margin-bottom: 24px;
  overflow: visible; /* Drawer scrolls full summary; keep radius on inner creative */
}

.drawer-body .news-pr-drawer-card__creative {
  overflow: hidden;
  border-radius: 0;
}

.news-pr-drawer-card__source {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  padding: 16px 16px 12px;
  min-width: 0;
  border-bottom: 1px solid var(--border, #e5e7eb);
}

.news-pr-drawer-card__source-top {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
  line-height: 0;
}

.news-pr-drawer-card__source-top .news-pr-drawer-card__source-name {
  line-height: 1.3;
}

.news-pr-drawer-card__source-name {
  flex: 1 1;
  min-width: 0;
  font-size: 17px;
  font-weight: 600;
  color: var(--c-black);
  word-break: break-word;
}

.news-pr-drawer-card__url {
  display: block;
  font-size: 12px;
  line-height: 1.3;
  color: var(--text2);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.news-pr-drawer-card__headline {
  margin: 0;
  padding: 12px 16px 8px;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.4;
  color: var(--c-black);
}

.news-pr-drawer-card__summary {
  padding: 12px 16px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--c-black);
  border-top: 1px solid var(--border, #e5e7eb);
}

.news-pr-drawer-card__creative {
  width: 100%;
  line-height: 0;
}

.news-pr-drawer-card__creative .mi-detail-creative-empty {
  min-height: 120px;
  margin: 0;
  padding: 24px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 13px;
  line-height: 1.4;
  color: var(--text3);
  background: var(--c-gray-1, #f3f4f6);
}

.news-pr-drawer-card__image {
  width: 100%;
  height: auto;
  display: block;
  vertical-align: top;
}

/* News / PR article detail — side metadata + iframe */
.mi-detail-page--news-article {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  height: 100%;
}

.mi-detail-page--news-article > .mi-detail-page {
  flex: 1 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.mi-detail-page--news-article .mi-detail-content {
  flex: none;
  min-height: auto;
  overflow: visible;
  padding-bottom: 48px;
}

.mi-detail-page--news-article .mi-detail-content > .news-article-view {
  flex: none;
}

.news-article-view {
  display: grid;
  grid-template-columns: minmax(220px, 280px) 1fr;
  gap: 16px;
  align-items: start;
}

.news-article-view__aside {
  padding: 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.news-article-view__aside-label {
  margin: 13px 0 0;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text2);
  letter-spacing: 0.05em;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.news-article-view__aside-label:first-child {
  margin-top: 0;
}

.news-article-view__aside-company {
  margin: 0;
}

.news-article-view__aside-company .geo-brand-name-cell__label {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black, #111);
}

.news-article-view__aside-value {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black, #111);
}

.news-article-view__aside-summary {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--text2, #4b5563);
  white-space: normal;
}

.news-article-view__main {
  min-width: 0;
  border-radius: 12px;
  overflow: hidden;
}

.mi-news-iframe-panel {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 0;
  overflow: hidden;
  flex: none;
  border-radius: 12px;
  border: 1px solid var(--c-grey-2, #e5e7eb);
  background: var(--c-white, #fff);
}

.mi-news-iframe-frame {
  position: relative;
  width: 100%;
  min-height: 200px;
}

.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe-frame {
  min-height: calc(100vh - 40px);
}

.mi-news-iframe-loading {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: var(--c-gray-1, #f3f4f6);
}

.mi-news-iframe-loading__spinner {
  width: 36px;
  height: 36px;
  border: 3px solid color-mix(in srgb, var(--c-blue-1) 18%, transparent);
  border-top-color: var(--c-blue-1);
  border-radius: 50%;
  animation: miNewsIframeSpin 0.8s linear infinite;
}

.mi-news-iframe-loading__text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--text2);
}

@keyframes miNewsIframeSpin {
  to {
    transform: rotate(360deg);
  }
}

.mi-news-iframe--loading {
  opacity: 0;
}

.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe {
  display: block;
  width: 100%;
  height: calc(100vh - 40px);
  min-height: 520px;
  max-height: none;
  border: 0;
  background: #fff;
}

.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe-fallback {
  padding: 10px 14px 12px;
  background: var(--c-white, #fff);
  border-top: 1px solid var(--c-grey-2, #e5e7eb);
}

.mi-news-iframe-fallback {
  margin: 0;
  padding: 0 4px 8px;
  font-size: 13px;
  line-height: 1.5;
  color: var(--text3, #6b7280);
}

.mi-news-iframe-fallback a {
  color: var(--c-blue-1, #2563eb);
  text-decoration: underline;
}

.mi-news-iframe-empty {
  padding: 24px;
  font-size: 14px;
  color: var(--text2);
}

@media (max-width: 960px) {
  .news-article-view {
    grid-template-columns: 1fr;
  }
}

@media (prefers-reduced-motion: reduce) {
  .table-area.insights-panel > .report-outer--embedded,
  .table-area.insights-panel > .report-outer--flush,
  .table-area.insights-panel .header,
  .table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *,
  .table-area.insights-panel .report-page > .report-card,
  .table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-period-table__panel,
  .table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-data-table tbody tr,
  .table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered
    .sec-filing-insights-period-table__panel--period-switch,
  .table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered
    .sec-filing-insights-period-table__panel--period-switch
    .sec-filing-insights-data-table tbody tr,
  .table-area.alerts-panel > .report-outer--embedded,
  .table-area.alerts-panel .report-page > .report-card,
  .table-area.filings-table-panel .table-wrap,
  .table-area.filings-table-panel .filings-grid,
  .table-area.filings-table-panel thead tr,
  .table-area.filings-table-panel tbody tr,
  .sec-filing-panel.filings-table-panel tbody tr,
  .table-area.filings-table-panel .filing-card,
  .table-area.filings-table-panel .pagination-sticky,
  .geo-prompts-table-panel .geo-prompts-content .table-wrap,
  .geo-prompts-table-panel .geo-prompts-content thead tr,
  .geo-prompts-table-panel .geo-prompts-content tbody tr,
  .geo-prompts-table-panel .geo-prompts-content .pagination-sticky,
  .geo-prompt-edit-backdrop,
  .configure-dialog.configure-dialog--geo-prompts,
  .configure-dialog--geo-prompts .p-dialog-header,
  .configure-dialog--geo-prompts .modal-desc,
  .configure-dialog--geo-prompts .geo-prompt-edit-toolbar,
  .configure-dialog--geo-prompts .config-hint,
  .configure-dialog--geo-prompts .geo-prompt-edit-column,
  .configure-dialog--geo-prompts .geo-prompt-edit-list--entered .competitor-item,
  .configure-dialog--geo-prompts .p-dialog-footer,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table thead tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table tbody tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) thead tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) tbody tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-card .geo-insights-table-wrap,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table thead tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table tbody tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table-wrap,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table thead tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table tbody tr,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip,
  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__dot,
  .table-area.insights-panel .cadence-heatmap-cell-active,
  .table-area.insights-panel .cadence-heatmap-row {
    animation: none;
    opacity: 1;
    transform: none;
  }

  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip {
    transform: scaleX(1);
  }
}

.body.insights-panel > .content {
  padding-bottom: 0;
}

.table-area.insights-panel .footer,
.body.insights-panel .footer {
  display: none;
}

.table-area.insights-panel .report-page--flush > *:last-child,
.table-area.insights-panel .report-page > *:last-child {
  margin-bottom: 0 !important;
}

.table-area.insights-panel .product-depth-panel {
  margin-bottom: 0;
}

.table-area.insights-panel .product-depth-grid {
  padding-bottom: 0;
}

.page-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 400px;
}

.page-empty__inner {
  text-align: center;
}

.page-empty__title {
  color: var(--c-black);
  margin-bottom: 8px;
}

.page-empty__text {
  color: var(--text3);
  font-size: 14px;
}

.chip-picker {
  position: relative;
  width: 100%;
}

.chip-picker__control {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  min-height: 40px;
  padding: 6px 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--c-white);
}

.chip-picker__chip {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 3px 8px 3px 10px;
  border-radius: 16px;
  background: var(--c-white);
  border: 1px solid var(--border);
  font-size: 12px;
  color: var(--c-black);
  max-width: 100%;
}

.chip-picker__chip-label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chip-picker__chip-remove {
  border: none;
  background: none;
  cursor: pointer;
  padding: 2px;
  display: flex;
  color: var(--text3);
  border-radius: 4px;
}

.chip-picker__input {
  flex: 1 1 140px;
  min-width: 140px;
  border: none;
  outline: none;
  font-size: 13px;
  background: transparent;
  color: var(--c-black);
}

.chip-picker__menu {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 4px;
  max-height: 240px;
  overflow-y: auto;
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 10px 28px color-mix(in srgb, var(--c-black) 12%, transparent);
  z-index: 40;
}

.chip-picker__menu-hint {
  padding: 10px 12px;
  font-size: 12px;
  color: var(--text3);
}

.chip-picker__menu-add {
  width: 100%;
  text-align: left;
  padding: 10px 12px;
  font-size: 13px;
  border: none;
  background: none;
  cursor: pointer;
  color: var(--c-black);
}

.chip-picker__menu-option {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  font-size: 12px;
  border: none;
  background: none;
  cursor: pointer;
  color: var(--c-black);
}

.page-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  text-align: center;
}

.page-empty__title {
  font-size: 28px;
  color: var(--c-black);
  margin-bottom: 16px;
}

.page-empty__text {
  font-size: 16px;
  color: var(--text2);
}

.table-pagination {
  display: flex;
  align-items: center;
  gap: 12px;
}

.table-pagination__control {
  display: flex;
  align-items: center;
  gap: 6px;
}

.table-pagination__label {
  font-size: 11px;
  color: var(--c-black);
}

.table-pagination__measure {
  height: 28px;
  line-height: 28px;
  display: inline-flex;
  align-items: center;
  visibility: visible;
  min-width: 40px;
}

.table-pagination__select {
  height: 28px;
  color: transparent;
}

.table-pagination__option {
  color: var(--c-black);
}

.table-pagination__option {
  color: var(--c-black);
}

.table-pagination__option {
  color: var(--c-black);
}


/* Companies pages — legacy auto-generated classes (revisit / rename later) */

.companies-style-1 {
  padding: 0;
}

.companies-style-2 {
  padding: 40px;
  text-align: center;
  color: var(--text3);
}

.companies-style-3 {
  align-content: start;
}

.companies-style-4 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.companies-style-5 {
  font-size: 15px;
  margin-top: 4px;
}

.companies-style-6 {
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 4px;
}

.companies-style-7 {
  font-size: 10px;
  padding: 1px 6px;
}

.companies-style-8 {
  color: var(--text3);
}

.companydetails-style-1 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: -4px;
}

.companydetails-style-2 {
  margin-left: 36px;
}

.companydetails-style-3 {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
}

.companydetails-style-4 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.companydetails-style-5 {
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.companydetails-style-6 {
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
}

.companydetails-style-7 {
  display: flex;
  gap: 4px;
  background: var(--c-white);
  padding: 2px;
  border-radius: var(--radius);
}

.companydetails-style-8,
.companydetails-style-9,
.companydetails-style-10,
.companydetails-style-11,
.companydetails-style-12 {
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 6px;
}

.companydetails-style-13 {
  display: flex;
  gap: 20px;
  padding: 16px;
}

.companydetails-style-14 {
  flex: 1.2 1;
}

.companydetails-style-15 {
  flex: 0.8 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.companydetails-style-16 {
  font-size: 11px;
  font-weight: 500;
  color: var(--text3);
  text-transform: uppercase;
}

.companydetails-style-17 {
  padding: 0 8px 0 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 280px;
  overflow-y: auto;
}

.companydetails-style-18 {
  gap: 10px;
}

.companydetails-style-19 {
  width: 30px;
  font-size: 11px;
}

.companydetails-style-20 {
  height: 5px;
}

.companydetails-style-21 {
  width: 30px;
}

.companydetails-style-22 {
  gap: 16px;
}

.companydetails-style-23 {
  display: flex;
  gap: 8px;
  flex: 1 1;
}

.companydetails-style-24 {
  width: 100px;
}

.companydetails-style-25 {
  font-size: 11px;
  padding: 6px 8px;
  border-radius: 4px;
}

.companydetails-style-26 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.companydetails-style-27 {
  display: flex;
  align-items: center;
  gap: 6px;
}

.companydetails-style-28 {
  font-size: 11px;
  color: var(--c-black);
}

.companydetails-style-29 {
  height: 28px;
  line-height: 28px;
  display: inline-flex;
  align-items: center;
  visibility: visible;
  min-width: 40px;
}

.companydetails-style-30 {
  height: 28px;
  color: transparent;
}

.companydetails-style-31,
.companydetails-style-32 {
  color: var(--c-black);
}

.companydetails-style-33 {
  display: flex;
  gap: 4px;
}

/* Report shell & competitive intelligence layout */
.report-outer {
  background: var(--c-white);
  overflow-x: auto;
  padding: 16px 0 32px;
  width: 100%;
}

.report-outer.report-outer--embedded {
  background: transparent;
  overflow-x: hidden;
  padding: 0;
  box-sizing: border-box;
}

.report-outer.report-outer--embedded .report-scope {
  background: transparent;
}

.report-outer.report-outer--embedded .report-page {
  width: 100%;
  max-width: 100%;
  margin: 0;
  box-sizing: border-box;
}

@media (max-width: 900px) {
  .report-outer.report-outer--embedded {
    padding-left: 16px;
    padding-right: 16px;
  }
}

.report-scope *,
.report-scope *::before,
.report-scope *::after {
  box-sizing: border-box;
}

.report-scope {
  font-family: var(--font);
  font-size: var(--fs-sm);
  color: var(--c-black);
  background: var(--c-white);
  print-color-adjust: exact;
}

@page {
  size: A3 landscape;
  margin: 8mm;
}

@media print {
  .report-scope {
    background: var(--c-white);
  }

  .report-outer.report-outer--embedded {
    padding: 0;
  }

  .report-scope .report-page {
    margin: 0;
    box-shadow: none;
    border-radius: 0;
    width: 100%;
    min-height: unset;
  }

  .no-print {
    display: none !important;
  }
}

.report-page {
  width: 1460px;
  margin: 24px auto;
  background: var(--c-white);
  padding: 22px 26px 20px;
  box-shadow: 0 4px 32px color-mix(in srgb, var(--c-black) 12%, transparent);
}

.report-grid--asymmetric {
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 10px;
  margin-bottom: 10px;
}

.report-grid--half {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 10px;
}

.report-charts-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
}

.report-charts-row > .report-card {
  min-width: 0;
}

.chart-panel__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--border);
  padding-bottom: 8px;
}

.chart-panel__header .report-card-title {
  margin: 0;
  border: none;
  padding: 0;
}

.chart-panel__body {
  flex: 1 1;
  min-height: 420px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
}

.chart-panel__body .volume-chart-container,
.chart-panel__body .cadence-heatmap-container {
  flex: 1 1;
  min-width: 0;
  width: 100%;
}

/* Undo misapplied metric-row label width when used as chart wrapper */
.chart-panel__body.metric-row__label,
.chart-panel__body {
  width: 100%;
  min-width: 0;
  text-align: inherit;
  padding-right: 0;
}

/* Product category depth — annuities / life insurance columns (--c-company-bar, --c-orange from tokens.css) */
.product-depth-panel {
  width: 100%;
  margin-bottom: 10px;
}

.product-depth-panel .chart-panel__header,
.volume-chart-panel .chart-panel__header {
  flex-direction: column;
  align-items: flex-start;
  gap: 0;
  margin-bottom: 0;
  padding: 12px 24px 12px;
  border-bottom: none;
}

.product-depth-panel .chart-panel__header .report-card-title,
.volume-chart-panel .chart-panel__header .report-card-title {
  width: 100%;
  margin-bottom: 0;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.volume-chart-panel .chart-panel__header-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding-bottom: 8px;
  border-bottom: 1px solid var(--border);
}

.volume-chart-panel .chart-panel__header-toolbar .report-card-title {
  width: auto;
  flex: 1 1;
  min-width: 0;
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.product-depth-legend {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
  align-items: center;
  margin-top: 10px;
}

.product-depth-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.product-depth-legend__swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
  box-shadow: 0 1px 2px var(--border);
}

.product-depth-legend__swatch--ours {
  background: var(--c-orange);
}

.product-depth-legend__swatch--competitor {
  background: var(--c-company-bar);
}

.product-depth-legend__label {
  font-size: 12px;
  color: var(--text2);
  font-weight: 500;
}

.product-depth-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
  width: 100%;
  min-width: 0;
  padding: 16px 24px 24px;
  align-items: start;
}

.product-depth-grid--quad {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 28px 32px;
}

.product-depth-grid--quad .product-depth-column + .product-depth-column {
  border-left: none;
  padding-left: 0;
}

.product-depth-column {
  min-width: 0;
}

.product-depth-column + .product-depth-column {
  border-left: 1px solid var(--border);
  padding-left: 32px;
}

.page-empty--compact {
  min-height: 140px;
  height: auto;
}

.product-depth-column__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--ui-text-heading);
  margin: 0 0 16px;
}

.product-depth-chart {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.product-depth-row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid var(--border);
}

.product-depth-row:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border-bottom: none;
}

.product-depth-row__category {
  flex: 0 0 200px;
  min-width: 0;
  font-size: 13px;
  color: var(--text2);
  font-weight: 600;
  line-height: 1.35;
  padding-right: 16px;
  border-right: 1px solid var(--border);
  word-break: break-word;
}

/* Alerts: column must fit badge; generic product-depth min-width:0 caused overlap with border-right */
.forward-looking-alert-row .product-depth-row__category {
  flex: 0 0 auto;
  width: max-content;
  min-width: 320px;
  padding-right: 32px;
  box-sizing: border-box;
  overflow: visible;
}

.product-depth-row__category-parent {
  font-size: 11px;
  font-weight: 500;
  color: var(--text3);
  line-height: 1.3;
  margin-bottom: 2px;
}

.product-depth-row__category-sub {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  line-height: 1.35;
}

.product-depth-row__bars {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.product-depth-bar-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
}

.product-depth-bar-row__company {
  flex: 0 0 140px;
  min-width: 0;
  font-size: 12px;
  color: var(--text2);
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.product-depth-bar-row__track {
  flex: 1 1;
  min-width: 60px;
  height: 8px;
  background: var(--bar-track-bg);
  border-radius: 4px;
  overflow: hidden;
}

.product-depth-bar-row__fill {
  height: 100%;
  border-radius: 4px;
  border: none;
  box-shadow: 0 1px 2px var(--border);
}

.product-depth-bar-row__fill--competitor {
  background: var(--c-company-bar);
}

.product-depth-bar-row__fill--ours {
  background: var(--c-orange);
}

.product-depth-bar-row__value {
  flex: 0 0 28px;
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  text-align: right;
}

.region-ranking-chart {
  gap: 6px;
}

.region-ranking-bar-row__state {
  flex: 0 0 36px;
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
}

.region-ranking-bar-row__track {
  position: relative;
}

.region-ranking-bar-row__track .geo-bar-fill--other {
  border-radius: 4px;
}

.region-ranking-bar-row__track .geo-bar-fill--overlay {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
  border-radius: 4px;
}

.region-ranking-bar-row__value {
  flex: 0 0 auto;
  min-width: 52px;
}

/* Geographical distribution — map + rankings layout */
.geo-distribution-panel .chart-panel__body {
  min-height: 0;
  padding: 0 24px 16px;
}

.geo-distribution-grid {
  display: grid;
  grid-template-columns: 1.4fr 1fr;
  gap: 24px;
  align-items: start;
}

.geo-distribution-map {
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 380px;
}

.geo-distribution-map__inner {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
}

.geo-distribution-rankings {
  display: flex;
  flex-direction: column;
  min-height: 380px;
}

.geo-distribution-rankings .region-ranking-chart {
  flex: 1 1;
  gap: var(--geo-ranking-row-gap, 6px);
  padding-bottom: var(--space-4);
  box-sizing: border-box;
}

.geo-rankings__heading {
  font-size: 18px;
  font-weight: 500;
  color: var(--c-black);
  letter-spacing: 0.05em;
  margin: 0 0 8px;
}

/* Geographical distribution — map, legend, rankings (token-backed) */
.geo-legend {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding-bottom: 4px;
  flex-wrap: wrap;
}

.geo-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.geo-legend__swatch {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.geo-legend__swatch--ours {
  background: var(--c-teal-active);
}

.geo-legend__swatch--other {
  background: var(--c-aqua-mass);
}

.geo-legend__label {
  font-size: 12px;
  color: var(--text2);
  font-weight: 500;
}

.geo-map__state--ours {
  fill: var(--c-teal-active);
}

.geo-map__state--other {
  fill: var(--c-aqua-mass);
}

.geo-map__state--empty {
  fill: var(--bar-track-bg);
}

.geo-bar-fill--ours {
  background: var(--c-teal-active);
}

.geo-bar-fill--other {
  background: var(--c-aqua-mass);
}

.geo-bar-value--ours {
  color: var(--c-teal-active);
}

.report-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: var(--border-radius-md);
  /* padding: 11px 13px; */
}

.report-card-title {
  font-size: var(--fs-lg);
  font-weight: 400;
  text-transform: capitalize;
  color: var(--c-black);
  margin-bottom: 9px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--border);
}

.report-chip--gap {
  display: inline-block;
  background: var(--orange-bg);
  border-radius: var(--border-radius-sm);
  font-size: 9.5px;
  padding: 2px 7px;
  margin: 2px 3px;
  color: var(--c-orange);
  font-weight: 600;
}

.report-note {
  font-size: 9.5px;
  color: var(--text3);
  margin-top: 7px;
  border-top: 1px solid var(--border);
  padding-top: 6px;
  line-height: 1.45;
}

.report-divider {
  border: none;
  border-top: 1px solid var(--border);
  margin: 7px 0;
}

/* Charts — KPIs, bar charts, heatmaps, legends, map tooltips */

.custom-pie-chart-wrapper {
  position: relative;
  width: 240px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Filing Details page (/filings/:id) — scroll shell + entrance animations */
.filing-details-page {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
}

.filing-details-page .topbar {
  flex-shrink: 0;
  animation: filingsInsightsIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;
}

.filing-details-page .content {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;
}

.filing-details-page .kpi-banner-grid > * {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.filing-details-page .kpi-banner-grid > *:nth-child(1) { animation-delay: 0.1s; }

.filing-details-page .report-card {
  padding: 18px 22px 22px;
}

.filing-details-page .report-card-title {
  margin-bottom: 14px;
}

.filing-details-page .kpi-banner-grid > *:nth-child(2) { animation-delay: 0.16s; }
.filing-details-page .kpi-banner-grid > *:nth-child(3) { animation-delay: 0.22s; }

.filing-details-page .content > .report-card {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.14s;
}

.filing-details-page .content > div[style*='grid'] > .report-card:nth-child(1) {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.22s;
}

.filing-details-page .content > div[style*='grid'] > .report-card:nth-child(2) {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.28s;
}

.filing-details-page .content > .report-card:last-of-type {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.4s;
}

.filing-details-summary__body {
  padding: 0;
}

.filing-details-summary__text {
  margin: 0;
  font-size: 13px;
  color: var(--ui-text-primary);
  line-height: 1.6;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.filing-details-summary__empty {
  margin: 0;
  font-size: 13px;
  color: var(--ui-text-primary);
  line-height: 1.5;
}

.filing-details-page .custom-pie-chart-wrapper {
  animation: filingsChartSvgIn 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.3s;
}

.filing-details-page .pie-chart-center {
  animation: filingsInsightsIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.5s backwards;
}

.filing-details-page .milestone-step {
  animation: filingsInsightsIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.filing-details-page .milestone-track .milestone-step:nth-child(2) { animation-delay: 0.38s; }
.filing-details-page .milestone-track .milestone-step:nth-child(3) { animation-delay: 0.44s; }
.filing-details-page .milestone-track .milestone-step:nth-child(4) { animation-delay: 0.5s; }
.filing-details-page .milestone-track .milestone-step:nth-child(5) { animation-delay: 0.56s; }
.filing-details-page .milestone-track .milestone-step:nth-child(6) { animation-delay: 0.62s; }

.filing-details-page .report-card .custom-pie-chart-wrapper + div > div {
  animation: filingsInsightsIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(1) { animation-delay: 0.36s; }
.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(2) { animation-delay: 0.4s; }
.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(3) { animation-delay: 0.44s; }
.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(4) { animation-delay: 0.48s; }

@media (prefers-reduced-motion: reduce) {
  .filing-details-page .topbar,
  .filing-details-page .content,
  .filing-details-page .kpi-banner-grid > *,
  .filing-details-page .report-card,
  .filing-details-page .custom-pie-chart-wrapper,
  .filing-details-page .pie-chart-center,
  .filing-details-page .milestone-step {
    animation: none;
  }

  .filing-details-page .pie-chart-segment {
    transition: none !important;
  }
}

.chart-side {
  flex: 1 1;
  min-width: 0;
}

.map-container svg {
  width: 100%;
  height: auto;
  max-height: 280px;
}

.report-outer.report-outer--embedded .kpi-grid {
  grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));
}

.kpi-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
  margin-bottom: 13px;
}

.kpi {
  background: var(--c-white);
  border-radius: 6px;
  padding: 9px 11px;
  border-left: 3px solid var(--c-blue-2);
}

.kpi.warn {
  border-left-color: var(--c-orange);
}

.kpi.good {
  border-left-color: var(--c-teal-active);
}

.kpi.amber {
  border-left-color: var(--c-orange);
}

.kpi-lbl {
  font-size: var(--fs-xs);
  color: var(--text2);
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .05em;
  margin-bottom: 3px;
}

.kpi-val {
  font-size: var(--fs-xl);
  font-weight: 700;
  color: var(--c-blue-1);
  line-height: 1;
  margin-bottom: 2px;
}

.kpi-sub {
  font-size: 9.5px;
  font-weight: 600;
}

.cr {
  color: var(--c-orange);
}

.cg {
  color: var(--c-teal-active);
}

.ca {
  color: var(--c-orange);
}

.cb {
  color: var(--c-blue-1);
}

.legend {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
  font-size: var(--fs-sm);
  color: var(--text2);
}

.li {
  display: flex;
  align-items: center;
  gap: 6px;
}

.sq {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.prod-section-lbl {
  font-size: var(--fs-xs);
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .08em;
  color: var(--c-black);
  margin: 8px 0 5px;
  padding-top: 7px;
  border-top: 1px solid var(--c-white);
}

.prod-section-lbl:first-child {
  margin-top: 0;
  border-top: none;
}

.prod-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.prod-lbl {
  width: 180px;
  font-size: 9.5px;
  color: var(--text2);
  flex-shrink: 0;
}

.prod-bars {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mini-bar {
  display: flex;
  align-items: center;
  gap: 4px;
}

.mini-track {
  flex: 1 1;
  background: var(--c-white);
  border-radius: 2px;
  height: 9px;
  overflow: hidden;
}

.mini-fill {
  height: 100%;
  border-radius: 2px;
}

.mini-num {
  width: 16px;
  font-size: var(--fs-xs);
  font-weight: 600;
  text-align: right;
}

.state-row {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 5px;
}

.state-lbl {
  width: 86px;
  font-size: 9.5px;
  color: var(--text2);
  flex-shrink: 0;
}

.state-track {
  flex: 1 1;
  background: var(--c-white);
  border-radius: 3px;
  height: 13px;
  overflow: hidden;
  position: relative;
}

.state-tot {
  width: 52px;
  text-align: right;
  font-size: 9.5px;
  flex-shrink: 0;
}

.hm-header {
  display: flex;
  gap: 5px;
  margin-bottom: 4px;
  padding-left: 106px;
}

.hm-header span {
  flex: 1 1;
  text-align: center;
  font-size: var(--fs-xs);
  color: var(--text3);
}

.hm-row {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 4px;
}

.hm-row.ta {
  background: var(--c-white);
  border-left: 3px solid var(--c-blue-1);
  border-radius: 0 4px 4px 0;
  padding: 2px 4px;
}

.hm-lbl {
  width: 100px;
  font-size: var(--fs-xs);
  flex-shrink: 0;
}

.hm-cells {
  display: flex;
  gap: 3px;
  flex: 1 1;
}

.hm-cell {
  flex: 1 1;
  height: 22px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-xs);
  font-weight: 600;
}

/* --- CompetitiveIntelligenceReport --- */
.competitiveintelligencereport-style-1 {
  padding-left: 106px;
}

.competitiveintelligencereport-style-2 {
  background: var(--color-378add);
}

.competitiveintelligencereport-style-3 {
  background: var(--color-1d9e75);
}

.competitiveintelligencereport-style-4 {
  background: var(--color-ef9f27);
}

.competitiveintelligencereport-style-5 {
  background: var(--color-9ca3af);
}

.competitiveintelligencereport-style-6 {
  position: relative;
  width: 100%;
  height: 220px;
  min-height: 200px;
}

.competitiveintelligencereport-style-7 {
  margin-bottom: 6px;
}

.competitiveintelligencereport-style-8 {
  margin-bottom: 9px;
}

.competitiveintelligencereport-style-9 {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  border-radius: 3px;
}

.competitiveintelligencereport-style-10 {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background: var(--color-1b3a6b);
  border-radius: 3px;
  display: flex;
  align-items: center;
  padding-left: 5px;
  font-size: var(--fs-xs);
  font-weight: 600px;
  color: var(--c-white);
}

.competitiveintelligencereport-style-11 {
  font-size: 9.5px;
  color: var(--color-a32d2d);
  font-weight: 600px;
  margin-bottom: 3px;
}

.competitiveintelligencereport-style-12 {
  font-size: 9.5px;
  color: var(--color-666666);
  margin-bottom: 8px;
}

.competitiveintelligencereport-style-13 {
  font-size: 9.5px;
  color: var(--color-666666);
  margin-bottom: 4px;
  font-weight: 600px;
}

.competitiveintelligencereport-style-14 {
  margin-bottom: 3px;
}

.competitiveintelligencereport-style-15 {
  font-size: var(--fs-xs);
  color: var(--color-888888);
  font-weight: 600px;
}

.competitiveintelligencereport-style-16 {
  grid-column: 1 / -1;
}

.competitiveintelligencereport-style-17 {
  margin-top: 0;
  border-top: none;
  padding-top: 0;
}

.competitiveintelligencereport-style-18 {
  margin-bottom: 8px;
}

.competitiveintelligencereport-style-19 {
  margin-top: 0;
  border-top: none;
  padding-top: 0;
}

.competitiveintelligencereport-style-20 {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* --- CompetitorVolumeChart Styles --- */
.volume-chart-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.volume-chart-main {
  display: flex;
  flex: 1 1;
  position: relative;
  min-height: 180px;
  margin-bottom: 24px;
}

.volume-chart-y-axis {
  position: relative;
  flex-shrink: 0;
  align-self: stretch;
  padding-right: 10px;
  width: 40px;
}

.volume-chart-y-tick {
  position: absolute;
  right: 10px;
  transform: translateY(-50%);
  white-space: nowrap;
}

.volume-chart-grid-container {
  flex: 1 1;
  position: relative;
  border-bottom: 1px solid var(--border);
}

.volume-chart-grid-lines {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 0;
  pointer-events: none;
}

.volume-chart-grid-line {
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  transform: translateY(-50%);
}

.volume-chart-bars-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  justify-content: space-around;
  align-items: flex-end;
  padding: 0 10px;
}

.volume-chart-bar-column {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 12%;
  height: 100%;
  justify-content: flex-end;
  position: relative;
}

.volume-chart-stacked-bar {
  width: 100%;
  display: flex;
  flex-direction: column-reverse;
  min-height: 1px;
}

.volume-chart-bar-segment {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--c-white);
  font-size: var(--fs-sm);
  font-weight: 600;
  overflow: hidden;
}

.volume-chart-label {
  position: absolute;
  top: 100%;
  margin-top: 6px;
  text-align: center;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  max-width: 72px;
  min-width: 0;
}

.volume-chart-label-content {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
}

.volume-chart-company-dot-slot {
  flex-shrink: 0;
  width: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.volume-chart-company-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c-blue-2);
}

/* --- CompetitorCadenceHeatmap Styles --- */
.cadence-heatmap-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: var(--fs-sm);
  /* Fixed total stagger window — --heatmap-cell-delay / --heatmap-row-delay are 0–1 */
  --heatmap-stagger-start: 0.1s;
  --heatmap-stagger-span: 0.55s;
  --heatmap-cell-duration: 0.35s;
  --heatmap-row-duration: 0.4s;
}

.cadence-heatmap-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.cadence-heatmap-header-spacer {
  box-sizing: border-box;
  width: 160px;
  flex-shrink: 0;
  padding-right: 12px;
}

.cadence-heatmap-header-weeks {
  display: flex;
  flex: 1 1;
  gap: 6px;
  min-width: 0;
}

.cadence-heatmap-header-col {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: var(--black);
  font-size: var(--fs-md);
}

.cadence-heatmap-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.cadence-heatmap-company-lbl {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 160px;
  flex-shrink: 0;
  padding-right: 12px;
  cursor: pointer;
  font-weight: 500;
  color: var(--text2);
  min-width: 0;
}

.cadence-heatmap-company-name {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.cadence-heatmap-company-name__text {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Chart axis labels — matches cadence heatmap company name typography (12px) */
.chart-axis-label-text {
  font-weight: 500;
  color: var(--text2);
  font-size: 12px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.chart-axis-tick-value {
  font-weight: 500;
  color: var(--text2);
  font-size: 12px;
  line-height: 1;
}

.chart-axis-label-text--svg {
  fill: var(--text2);
  font-weight: 500;
  font-size: 12px;
}

.chart-axis-tick-value--svg {
  fill: var(--text2);
  font-weight: 500;
  font-size: 12px;
}

/* AI Visibility Index only — viewBox fontSize on <text>, not CSS px */
.geo-insights-visibility-chart__tick,
.geo-insights-visibility-chart__axis-label {
  fill: var(--text2);
  font-weight: 500;
}

.cadence-heatmap-company-dot-slot {
  flex-shrink: 0;
  width: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cadence-heatmap-company-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: var(--c-purple-1);
}

.cadence-heatmap-cells {
  display: flex;
  flex: 1 1;
  gap: 6px;
}

.cadence-heatmap-cell-empty {
  flex: 1 1;
  height: 54px;
  background: var(--c-white);
  color: var(--text3);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-size: var(--fs-sm);
}

.cadence-heatmap-cell-active {
  flex: 1 1;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 6px;
  font-size: var(--fs-sm);
  box-shadow: inset 0 0 0 1px var(--surface-inset-line);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.cadence-heatmap-cell-active:hover {
  transform: translateY(-2px) scale(1.03);
  box-shadow: var(--shadow-panel);
  z-index: 10;
}

.cadence-heatmap-cell-active.is-selected {
  box-shadow:
    0 0 0 2px var(--c-purple-1),
    var(--shadow-panel);
  transform: translateY(-1px) scale(1.02);
  z-index: 11;
}

/* --- KPI Banner Card Styles --- */
.kpi-banner-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 12px;
  margin-bottom: 20px;
  align-items: stretch;
}

.kpi-banner-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 4px;
  min-height: 100px;
  height: auto;
  overflow: visible;
}

.kpi-banner-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--text2);
  letter-spacing: 0.05em;
  line-height: 1.3;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.kpi-banner-value-row {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
  min-height: 1.1em;
}

.kpi-banner-value {
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: var(--c-black);
  line-height: 1.1;
  flex-shrink: 0;
}

@keyframes kpiValueEnter {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes kpiSignalEnter {
  0% {
    opacity: 0;
    transform: scale(0.55) translateY(6px);
  }

  65% {
    transform: scale(1.08) translateY(-1px);
  }

  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.kpi-banner-value--enter {
  display: inline-block;
  opacity: 0;
  animation: kpiValueEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

/* KPI banner compare — signed percent vs competitors (Insights KPICard) */
.kpi-delta {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 1px 5px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}

.kpi-banner-card .kpi-delta-slot {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.kpi-delta--enter {
  display: inline-flex;
  opacity: 0;
  animation: kpiSignalEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.kpi-delta--better {
  color: var(--c-green);
  background: var(--bg-green-soft);
}

.kpi-delta--worse {
  color: var(--c-red);
  background: var(--bg-red-soft);
}

@media (prefers-reduced-motion: reduce) {
  .kpi-banner-value--enter,
  .kpi-delta--enter,
  .sec-filing-insights-card__foot-total--animate {
    animation: none;
    opacity: 1;
    transform: none;
  }
}

.kpi-banner-subtitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
  color: var(--text3);
}

.kpi-banner-subtitle--stacked {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.kpi-compare-annotation {
  font-weight: 500;
  letter-spacing: 0.01em;
  color: var(--text2);
  text-transform: none;
}

.kpi-compare-annotation__value {
  font-weight: 600;
  color: var(--c-black);
  font-variant-numeric: tabular-nums;
}

.kpi-subtitle-detail {
  display: block;
  font-weight: 500;
  color: var(--text2);
  line-height: 1.4;
}

.kpi-product-name {
  display: block;
  font-size: 11px;
  font-weight: 500;
  color: var(--text2);
  line-height: 1.4;
}

.kpi-banner-card--product-focus {
  gap: 8px;
}

.kpi-banner-card--product-focus .kpi-product-focus__label {
  margin: 0;
  font-size: var(--fs-sm);
  font-weight: 600;
  color: var(--c-black);
  line-height: 1.35;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.kpi-product-focus__compare {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 56px;
  width: 100%;
}

.kpi-product-focus__compare--single {
  justify-content: center;
}

.kpi-product-focus__side {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-width: 0;
  flex: 1 1;
  max-width: 42%;
}

.kpi-product-focus__who {
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  line-height: 1.25;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.kpi-product-focus__count {
  font-size: var(--fs-2xl);
  font-weight: 600;
  color: var(--c-black);
  line-height: 1.1;
  margin-top: 4px;
}

.kpi-product-focus__divider {
  flex-shrink: 0;
  font-size: var(--fs-xl);
  font-weight: 400;
  color: var(--text2);
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

.table-area.insights-panel .kpi-banner-card--product-focus {
  grid-column: span 2;
  min-width: 0;
}

@media (max-width: 720px) {
  .table-area.insights-panel .kpi-banner-card--product-focus {
    grid-column: span 1;
  }
}

/* --- Map Toggle Button Selected --- */
.btn-map-toggle.btn-primary {
  background: var(--c-black) !important;
  color: var(--c-white) !important;
  border-color: var(--c-black) !important;
}

.btn-map-toggle:hover:not(.btn-primary) {
  background: var(--c-white) !important;
  color: var(--c-black) !important;
  border-color: var(--text3) !important;
}

/* --- Map Sidebar Rankings Bar Animation --- */
@keyframes mapBarFill {
  from {
    width: 0;
  }
}

.map-bar-animate {
  animation: mapBarFill 1.2s cubic-bezier(0.25, 1, 0.5, 1) forwards !important;
}

/* Objection Dashboard Heatmap Component Enhancements */
.objection-heatmap-scroll {
  overflow-x: auto;
  width: 100%;
  max-width: 100%;
  padding-bottom: 8px;
}

.objection-heatmap-tbl {
  border-collapse: separate;
  border-spacing: 0 16px;
  /* Precise control over vertical gap between rows! */
  font-size: 12px;
  white-space: nowrap;
  width: max-content;
  min-width: 100%;
}

.objection-heatmap-tbl thead th {
  padding: 6px 8px;
  border-bottom: 1px solid var(--border);
  font-weight: 600;
  color: var(--text2, var(--text2));
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background: var(--c-white);
}

.objection-heatmap-tbl thead th.sticky-corner {
  position: sticky;
  left: 0;
  text-align: left;
  z-index: 10;
}

.objection-heatmap-tbl tbody tr {
  height: auto;
}

.objection-heatmap-tbl tbody th.sticky-state {
  font-weight: 600;
  text-align: left;
  padding: 0 8px;
  border-bottom: 1px solid var(--c-white);
  background: var(--c-white);
  position: sticky;
  left: 0;
  z-index: 5;
  font-family: monospace;
  font-size: 13px;
  color: var(--c-black);
  vertical-align: middle;
}

.objection-heatmap-tbl tbody td {
  padding: 0 1px;
  /* Absolute minimum vertical space around cells! */
  vertical-align: middle;
}

.objection-heatmap-cell-block {
  min-width: 44px;
  padding: 6px 2px;
  border-radius: 5px;
  text-align: center;
  font-weight: 600;
  font-family: monospace;
  font-size: 11px;
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.1s ease;
}

.objection-heatmap-cell-block:hover {
  transform: scale(1.05);
  z-index: 2;
}

/* SEC Filing — layout shell (Insights adds gutter below) */
.table-area.sec-filing-panel {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* Insights tab — page padding (Table tab stays full-bleed via filings-table-panel only) */
.table-area.sec-filing-panel.insights-panel {
  padding: 16px 24px 32px;
}



.kpi-banner-card--with-sparkline {
  min-height: 128px;
  gap: 6px;
}

.kpi-banner-sparkline-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-top: 4px;
  width: 100%;
  min-width: 0;
}

.kpi-sparkline {
  flex: 1 1;
  min-width: 0;
  height: 32px;
  display: block;
  overflow: visible;
}

.kpi-sparkline__line {
  fill: none;
  stroke-width: 1.75;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.kpi-sparkline--up .kpi-sparkline__line {
  stroke: var(--c-green);
}

.kpi-sparkline--down .kpi-sparkline__line {
  stroke: var(--c-red);
}

.kpi-sparkline--flat .kpi-sparkline__line {
  stroke: var(--text2);
}

.kpi-trend-indicator {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 4px;
}

.kpi-trend-indicator--up {
  color: var(--c-green);
  background: var(--bg-green-soft);
}

.kpi-trend-indicator--down {
  color: var(--c-red);
  background: var(--bg-red-soft);
}

.kpi-trend-indicator--flat {
  color: var(--text2);
  background: var(--surface-subtle-tint);
}



.sec-filing-period-grid--hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  pointer-events: none;
}

.sec-filing-period-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-bottom: 16px;
}


/* SEC Filing Insights — competitor summary cards (intel_axis_sec_insights) */
/* .sec-filing-insights-summary {
  padding: 0 24px 24px;
} */

.sec-filing-insights-summary__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.sec-filing-insights-summary__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 500;
  color: var(--c-black);
}

.sec-filing-insights-summary__meta {
  font-size: var(--fs-xs);
  color: var(--text3);
  letter-spacing: 0.05em;
}

.sec-filing-insights-summary__grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 12px;
  align-items: stretch;
}

.sec-filing-insights-card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 320px;
  overflow: hidden;
  border: 1px solid var(--border);
  /* border-top: 4px solid var(--c-neon); */
  border-radius: 8px;
  background: var(--c-white);
  transition: opacity 0.2s, border-color 0.15s ease, box-shadow 0.15s ease;
}

.sec-filing-insights-card__head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 12px 10px;
  border-bottom: 1px solid var(--ui-border-divider);
}

.sec-filing-insights-card__our-label {
  margin-bottom: 5px;
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text2);
}

.sec-filing-insights-card__name {
  margin: 0 0 4px;
  font-family: var(--font);
  font-size: var(--fs-sm);
  font-weight: 600;
  line-height: 1.25;
  text-transform: uppercase;
  color: var(--text2);
  flex: 1 1;
  min-width: 0;
}

.sec-filing-insights-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
}

.sec-filing-insights-badge {
  padding: 2px 6px;
  border-radius: 3px;
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.02em;
}

.sec-filing-insights-badge--public {
  color: var(--c-white);
  background: var(--c-black);
}

.sec-filing-insights-badge--mutual {
  color: var(--text3);
  background: var(--ui-surface-muted);
  border: 1px solid var(--border);
}

.sec-filing-insights-badge--foreign {
  color: var(--c-orange);
  background: var(--bg-orange-soft);
  border: 1px solid color-mix(in srgb, var(--c-orange) 35%, transparent);
}

.sec-filing-insights-badge--our {
  color: var(--ink-overlay);
  background: color-mix(in srgb, var(--c-neon) 35%, var(--c-white));
  border: 1px solid color-mix(in srgb, var(--c-neon) 55%, var(--border));
}

.sec-filing-insights-alert {
  display: inline-flex;
  align-items: center;
  margin-top: 0;
  padding: 1px 6px;
  border-radius: 5px;
  font-size: var(--fs-xs);
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.sec-filing-insights-alert--critical {
  color: var(--sec-priority-critical);
  background: color-mix(in srgb, var(--sec-priority-critical) 12%, var(--c-white));
  border: 1px solid color-mix(in srgb, var(--sec-priority-critical) 28%, transparent);
}

.sec-filing-insights-alert--non-critical {
  color: var(--sec-priority-medium);
  background: color-mix(in srgb, var(--sec-priority-medium) 14%, var(--c-white));
  border: 1px solid color-mix(in srgb, var(--sec-priority-medium) 28%, transparent);
}

.sec-filing-insights-alert--no-activity {
  color: var(--c-black);
  border: 1px solid color-mix(in srgb, var(--c-black) 20%, transparent);
}

.sec-filing-insights-card__section {
  flex: 1 1;
  min-width: 0;
  padding: 10px 12px;
  border-bottom: 1px solid var(--ui-border-divider);
}

.sec-filing-insights-card__section-title {
  margin-bottom: 8px;
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  /* color: var(--text3); */
}

.sec-filing-insights-card__row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 6px;
  padding: 3px 0;
  border-bottom: 1px solid var(--border-faint);
}

.sec-filing-insights-card__row:last-of-type {
  border-bottom: none;
}

.sec-filing-insights-card__label {
  flex-shrink: 0;
  font-size: 10px;
  line-height: 1.4;
  color: var(--text3);
}

.sec-filing-insights-card__value {
  font-size: 10px;
  font-weight: 500;
  line-height: 1.4;
  color: var(--c-black);
  text-align: right;
  word-break: break-word;
}

.sec-filing-insights-card__value--mono {
  font-family: var(--mono);
  font-size: 9px;
}

.sec-filing-insights-card__value--muted {
  color: var(--text3);
  font-weight: 400;
  font-style: italic;
}

.sec-filing-insights-card__value--link {
  max-width: 100px;
  overflow: hidden;
  color: var(--ui-text-link);
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
}

.sec-filing-insights-card__value--link:hover {
  text-decoration: underline;
}

.sec-filing-insights-card__chart-block {
  container-type: inline-size;
  container-name: sec-insights-chart;
  width: 100%;
  min-width: 0;
  padding-top: 8px;
}

.sec-filing-insights-card__chart-label {
  margin-bottom: 3px;
  font-size: 10px;
  color: var(--text3);
}

.sec-filing-insights-donut-wrap {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  width: 100%;
  min-width: 0;
  margin-top: 4px;
}

.sec-filing-insights-donut {
  position: relative;
  width: min(100%, max(3.5rem, 72%));
  max-width: 100%;
  aspect-ratio: 1;
  height: auto;
  flex-shrink: 1;
  align-self: center;
  margin-inline: auto;
}

.sec-filing-insights-donut--pie {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes secFilingPieCountIn {
  from {
    opacity: 0;
    transform: translateY(6px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@supports (width: 1cqi) {
  .sec-filing-insights-donut {
    width: min(100%, max(56px, 72cqi));
  }
}

.sec-filing-insights-donut__pie-chart.custom-pie-chart-wrapper {
  width: 100%;
  height: 100%;
}

.sec-filing-insights-donut__pie-chart.custom-pie-chart-wrapper svg {
  display: block;
  animation: none;
}

/* Ring uses segment stroke fill only — no wrapper/center slide */
.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center {
  animation: none;
  transform: none;
}

.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__value {
  animation: secFilingPieCountIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(500ms + var(--pie-chart-stagger, 0ms));
}

.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__label {
  animation: secFilingPieCountIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(580ms + var(--pie-chart-stagger, 0ms));
}

.sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {
  font-size: 14px;
  font-weight: 700;
  color: var(--c-black);
  line-height: 1.1;
}

.sec-filing-insights-donut__pie-chart .pie-chart-center span:last-child {
  font-size: var(--fs-xs);
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--text3);
  margin-top: 1px;
}

@supports (width: 1cqi) {
  .sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {
    font-size: clamp(11px, 14cqi, 22px);
  }

  .sec-filing-insights-donut__pie-chart .pie-chart-center span:last-child {
    font-size: clamp(8px, 6cqi, var(--fs-xs));
  }
}

.sec-filing-insights-donut-wrap--empty .sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {
  color: var(--text3);
}

.sec-filing-insights-donut-legend {
  width: 100%;
}

.sec-filing-insights-donut-legend__item {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  margin-bottom: 4px;
  font-size: 10px;
  color: var(--text2);
}

.sec-filing-insights-donut-legend__item:last-child {
  margin-bottom: 0;
}

.sec-filing-insights-donut-legend__dot {
  width: 8px;
  height: 8px;
  flex-shrink: 0;
  border-radius: 50%;
}

.sec-filing-insights-donut-legend__dot--critical {
  background: var(--sec-priority-critical);
}

.sec-filing-insights-donut-legend__dot--non-critical {
  background: var(--sec-priority-medium);
}

.sec-filing-insights-donut-legend__dot--empty {
  background: var(--border);
}

.sec-filing-insights-donut-wrap--empty .sec-filing-insights-donut-legend__count {
  color: var(--text3);
}

@media (prefers-reduced-motion: reduce) {
  .sec-filing-insights-donut--animate .sec-filing-insights-donut-legend__item,
  .sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__value,
  .sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__label {
    animation: none;
    opacity: 1;
    transform: none;
  }

  .sec-filing-insights-donut__pie-chart .pie-chart-segment {
    transition: none !important;
  }
}

.sec-filing-insights-donut-legend__label {
  flex: 1 1;
  min-width: 0;
  white-space: nowrap;
}

.sec-filing-insights-donut-legend__count {
  margin-left: auto;
  font-family: var(--font);
  font-size: var(--fs-xs);
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  color: var(--c-black);
  text-align: right;
}

.sec-filing-insights-card__foot {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
  margin-top: auto;
  padding: 8px 10px 10px 12px;
  padding-right: 44px;
  border-top: 1px solid var(--ui-border-divider);
}

.sec-filing-insights-card__foot-total {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--c-black);
}

.sec-filing-insights-card__foot-total--animate {
  display: inline-block;
  opacity: 0;
  animation: kpiValueEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.sec-filing-insights-card__foot-total-label {
  font-size: 10px;
  color: var(--text3);
}

.sec-filing-insights-card__foot-date-label {
  font-size: 10px;
  color: var(--text3);
  text-align: left;
}

.sec-filing-insights-card__foot-date-val {
  font-size: 10px;
  font-weight: 500;
  color: var(--c-black);
  text-align: left;
}

.sec-filing-insights-card__view-btn {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid var(--border);
  border-radius: 5px;
  background: var(--c-white);
  color: var(--text2);
  cursor: pointer;
  flex-shrink: 0;
}

.sec-filing-insights-card__view-btn:hover {
  background: color-mix(in srgb, var(--c-black) 6%, var(--c-white));
  color: var(--c-black);
  border-color: color-mix(in srgb, var(--c-black) 20%, var(--border));
}

.sec-filing-insights-card__view-btn.is-active {
  background: var(--c-neon);
  border-color: var(--c-neon);
  color: var(--c-black);
  box-shadow: 0 0 0 1px color-mix(in srgb, var(--c-neon) 40%, transparent);
}

.sec-filing-insights-card__view-btn.is-active:hover {
  background: var(--neon-btn-bg-hover, var(--c-neon));
  border-color: var(--neon-btn-bg-hover, var(--c-neon));
  color: var(--c-black);
}

.sec-filing-insights-card__view-btn:focus-visible {
  outline: 2px solid var(--c-black);
  outline-offset: 1px;
}

@keyframes sec-filing-view-chevron-float {
  0% {
    transform: translateY(0);
  }

  25% {
    transform: translateY(3px);
  }

  50% {
    transform: translateY(-2px);
  }

  75% {
    transform: translateY(3px);
  }

  100% {
    transform: translateY(0);
  }
}

.sec-filing-insights-card__view-btn svg {
  flex-shrink: 0;
}

.sec-filing-insights-card__view-btn:hover:not(:disabled) svg {
  animation: sec-filing-view-chevron-float 1s ease-in-out infinite;
}

/* SEC pagination chevrons — slight directional nudge on hover */
.sec-filing-insights-period-table .pg-controls .pg-btn svg,
.sec-filing-panel.filings-table-panel .pg-controls .pg-btn svg {
  transition: transform 0.2s ease;
}

.sec-filing-insights-period-table .pg-controls .pg-btn:first-of-type:hover:not(:disabled) svg,
.sec-filing-panel.filings-table-panel .pg-controls .pg-btn:first-of-type:hover:not(:disabled) svg {
  transform: translateX(-2px);
}

.sec-filing-insights-period-table .pg-controls .pg-btn:last-of-type:hover:not(:disabled) svg,
.sec-filing-panel.filings-table-panel .pg-controls .pg-btn:last-of-type:hover:not(:disabled) svg {
  transform: translateX(2px);
}

@media (prefers-reduced-motion: reduce) {
  .sec-filing-insights-card__view-btn svg,
  .sec-filing-insights-period-table .pg-controls .pg-btn svg,
  .sec-filing-panel.filings-table-panel .pg-controls .pg-btn svg {
    transition: none;
  }

  .sec-filing-insights-card__view-btn:hover:not(:disabled) svg {
    animation: none;
    transform: none;
  }

  .sec-filing-insights-period-table .pg-controls .pg-btn:hover:not(:disabled) svg,
  .sec-filing-panel.filings-table-panel .pg-controls .pg-btn:hover:not(:disabled) svg {
    transform: none;
  }
}

@media (max-width: 1600px) {
  .sec-filing-insights-summary__grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .sec-filing-insights-summary__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 560px) {
  .sec-filing-insights-summary__grid {
    grid-template-columns: 1fr;
  }
}

/* SEC Insights — period filings table (below company cards) */
.sec-filing-insights-period-table {
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid var(--border);
}

.sec-filing-insights-period-table__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.sec-filing-insights-period-table__header-main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.sec-filing-insights-period-table__title {
  margin: 0;
  font-family: var(--font-display);
  font-size: 18px;
  font-weight: 500;
  color: var(--c-black);
}

.sec-filing-insights-period-table__clear-filter {
  flex-shrink: 0;
  padding: 0;
  border: none;
  background: none;
  font-family: inherit;
  font-size: var(--fs-xs);
  font-weight: 500;
  color: var(--text2);
  text-decoration: underline;
  cursor: pointer;
}

.sec-filing-insights-period-table__clear-filter:hover,
.sec-filing-insights-period-table__clear-filter:focus-visible {
  color: var(--c-black);
}

.sec-filing-insights-period-table__meta {
  font-size: var(--fs-xs);
  color: var(--text3);
  letter-spacing: 0.05em;
}

.sec-filing-insights-period-table__panel {
  overflow: hidden;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: var(--c-white);
}

.sec-filing-insights-period-table__wrap {
  flex: none;
  overflow-x: auto;
  overflow-y: visible;
}

/* Full-width table with balanced fixed column shares */
.sec-filing-insights-data-table {
  table-layout: fixed;
  width: 100%;
}

.sec-filing-insights-data-table th,
.sec-filing-insights-data-table td {
  padding: 10px 8px;
  vertical-align: middle;
  overflow: hidden;
}

.sec-filing-insights-data-table th {
  font-size: 14px;
  font-weight: 500;
}

.sec-filing-insights-data-table td {
  font-size: 13px;
}

.sec-filing-insights-data-table .col-sno {
  width: 5%;
  text-align: center;
}

.sec-filing-insights-data-table .col-company {
  width: 11%;
}

.sec-filing-insights-data-table .col-entity {
  width: 20%;
}

.sec-filing-insights-data-table .col-type {
  width: 8%;
}

.sec-filing-insights-data-table .col-priority {
  width: 9%;
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-accepted {
  width: 11%;
  font-variant-numeric: tabular-nums;
  vertical-align: middle;
}

.sec-filing-table__accepted-date {
  line-height: 1.3;
  white-space: nowrap;
}

.sec-filing-table__accepted-time {
  margin-top: 2px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.2;
  color: var(--text3);
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-date {
  width: 9%;
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-file-film {
  width: 10%;
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-xbrl {
  width: 14%;
}

.sec-filing-insights-data-table .col-xbrl-value {
  width: 13%;
  text-align: left;
}

.sec-filing-insights-data-table .col-actions {
  width: 10%;
  text-align: center;
}

.sec-filing-table__company-group {
  margin-bottom: 3px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--text3);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sec-filing-table__company-name {
  font-size: 13px;
  /* font-weight: 500; */
  line-height: 1.35;
  color: var(--c-black);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sec-filing-table__company-name .geo-brand-name-cell,
.table-area.filings-table-panel .company-cell .geo-brand-name-cell {
  width: 100%;
  min-width: 0;
}

.sec-filing-table__company-name .geo-brand-name-cell__label,
.table-area.filings-table-panel .company-cell .geo-brand-name-cell__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.sec-filing-table__entity-header {
  font-size: 13px;
  /* font-weight: 600; */
  line-height: 1.35;
  color: var(--c-black);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sec-filing-table__filing-desc {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.35;
  color: var(--text2);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.sec-filing-table-drawer__entity-header {
  /* font-weight: 600; */
  line-height: 1.4;
}

.sec-filing-table__file-film {
  line-height: 1.35;
}

.sec-filing-table__file-num {
  font-size: 13px;
  color: var(--text);
}

.sec-filing-table__film-num {
  margin-top: 2px;
  font-size: 11px;
  color: var(--text3);
}

.sec-filing-insights-data-table__actions {
  text-align: center;
  vertical-align: middle;
}

.sec-filing-insights-data-table__action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.sec-filing-insights-data-table__action-empty {
  color: var(--text3);
  font-size: 13px;
}

.sec-filing-insights-data-table__th-stacked {
  display: flex;
  flex-direction: column;
  gap: 1px;
  line-height: 1.2;
}

.sec-filing-insights-data-table__th-sub {
  font-size: 11px;
  font-weight: 500;
  color: var(--text3);
}

.sec-filing-insights-data-table .col-company .company-name {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-type {
  white-space: nowrap;
}

.sec-filing-insights-data-table .col-priority {
  white-space: nowrap;
}

.sec-filing-insights-data-table tbody tr {
  height: 56px;
  cursor: pointer;
}

.sec-filing-insights-data-table__sno {
  text-align: center;
  font-size: 13px;
  color: var(--text2);
  font-variant-numeric: tabular-nums;
}

.sec-filing-insights-data-table__xbrl {
  overflow: hidden;
  font-family: var(--font);
  font-size: 13px;
  line-height: 1.35;
  white-space: normal;
  word-break: break-word;
}

.sec-filing-insights-data-table .col-xbrl-value,
.sec-filing-insights-data-table__xbrl-value {
  font-family: var(--mono);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  color: var(--c-black);
  text-align: left;
  white-space: nowrap;
}

.sec-filing-insights-data-table__xbrl-value--empty {
  color: var(--text3);
  font-weight: 400;
}

.sec-filing-insights-data-table .sec-filing-insights-type-pill {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  font-size: 11px;
  text-overflow: ellipsis;
  vertical-align: middle;
}

/* .sec-filing-insights-data-table__row--critical.selected td,
.sec-filing-insights-data-table__row--critical.selected:hover td {
  background: color-mix(in srgb, var(--sec-priority-critical) 10%, var(--c-cyan-1));
} */

.sec-filing-insights-period-table__empty {
  padding: 32px 16px !important;
  text-align: center;
  color: var(--text3);
  font-size: 13px;
}

.sec-filing-insights-period-table__pagination {
  position: static;
  border-top: 1px solid var(--border);
}

.sec-filing-insights-type-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  white-space: nowrap;
}

.sec-filing-insights-type-pill--critical {
  color: var(--sec-priority-critical);
  background: color-mix(in srgb, var(--sec-priority-critical) 12%, var(--c-white));
  border: 1px solid color-mix(in srgb, var(--sec-priority-critical) 28%, transparent);
}

.sec-filing-insights-type-pill--non-critical {
  color: var(--sec-priority-medium);
  background: color-mix(in srgb, var(--sec-priority-medium) 14%, var(--c-white));
  border: 1px solid color-mix(in srgb, var(--sec-priority-medium) 28%, transparent);
}



@media (max-width: 1100px) {
  .sec-filing-period-grid {
    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  }
}

.sec-filing-period-card {
  cursor: pointer;
  border-radius: 8px;
  outline: none;
}

.sec-filing-period-card:focus-visible {
  box-shadow: 0 0 0 2px var(--focus-border-blue);
}

.sec-filing-period-card .kpi-banner-card {
  height: 100%;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

@keyframes secFilingPeriodCardSelect {
  from {
    opacity: 0.72;
  }

  to {
    opacity: 1;
  }
}

.sec-filing-period-card.is-active .kpi-banner-card {
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}


/* SEC Insights — entrance animations only on first load (not period switches) */
.table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-period-table__panel {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;
}

.table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-data-table tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.12s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.sec-filing-insights-summary__switch {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Period switch — table panel + row stagger (after first load) */
.table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered
  .sec-filing-insights-period-table__panel--period-switch {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;
}

.table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered
  .sec-filing-insights-period-table__panel--period-switch
  .sec-filing-insights-data-table tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}


/* KPI selected state — neon top accent (SEC Filing period cards) */
.kpi-banner-card--accent-neon-top {
  border: 1px solid var(--border);
  border-top: 4px solid var(--c-neon);
  box-shadow: none;
}

.kpi-banner-card--accent-neon-top > .kpi-banner-subtitle {
  /* color: var(--c-teal-active) !important; */
  font-weight: 500;
}


/* SEC filing table — detail drawer (same 360px width as Filings .drawer) */
.sec-filing-table-drawer__more-info-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.sec-filing-table-drawer .drawer-body {
  padding: 16px;
  gap: 14px;
}

.sec-filing-table-drawer__xbrl-tag {
  line-height: 1.4;
  white-space: normal;
  overflow-wrap: anywhere;
}

.sec-filing-table-drawer__xbrl-value {
  font-family: var(--mono);
  font-variant-numeric: tabular-nums;
}

.sec-filing-table-drawer .field-grid .field--span-full {
  grid-column: 1 / -1;
}

.sec-filing-table-drawer__filing-type {
  display: flex;
  align-items: flex-start;
}

.sec-filing-table-drawer__link {
  color: var(--ui-text-link);
  overflow-wrap: anywhere;
  text-decoration: none;
  word-break: break-word;
  font-size: 12px;
}

.sec-filing-table-drawer__link:hover {
  text-decoration: underline;
}

.sec-filing-table-drawer .sec-filing-insights-type-pill {
  max-width: 100%;
  overflow: visible;
  text-overflow: unset;
  white-space: normal;
  word-break: break-word;
}

.sec-filing-insights-type-pill--empty {
  color: var(--text3);
  font-weight: 400;
  background: transparent;
  border: none;
  padding: 0;
}

/* Table view: shrink with drawer (footer already flexes; table-wrap needs min-width + fixed layout) */
.table-area.sec-filing-panel.filings-table-panel {
  min-width: 0;
}

.sec-filing-panel.filings-table-panel .table-wrap {
  flex: 1 1;
  min-width: 0;
  overflow: auto;
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;
}

.sec-filing-panel.filings-table-panel .table-wrap .sec-filing-insights-data-table {
  table-layout: fixed;
  width: 100%;
  max-width: 100%;
}

.sec-filing-panel.filings-table-panel thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;
}

.sec-filing-panel.filings-table-panel .pagination-sticky {
  flex-shrink: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;
}

.col-entity {
  max-width: 220px;
}

.sec-filing-table__entity {
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 12px;
  color: var(--text2);
}

.col-sec-doc {
  width: 72px;
  text-align: center;
}

.sec-filing-table__doc {
  text-align: center;
}

.sec-filing-table__doc-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--c-blue-1);
}

.sec-filing-table__doc-link:hover {
  color: var(--c-black);
}

.sec-filing-drawer.details-drawer {
  width: 420px;
  right: -420px;
}

.sec-filing-drawer.details-drawer.open {
  right: 0;
}

.sec-filing-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  color: var(--text2);
}

/* Insights matrix cell drawer — list layout without section padding */
.sec-filing-drawer:not(.sec-filing-table-drawer) .sec-filing-drawer__body {
  padding: 0;
  gap: 0;
}

.sec-filing-drawer__empty {
  padding: 40px 24px;
  text-align: center;
  color: var(--text3);
  font-size: 13px;
}

.sec-filing-drawer__item {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 24px;
  border-bottom: 1px solid var(--border);
}

.sec-filing-drawer__item:last-child {
  border-bottom: none;
}

.sec-filing-drawer__item:hover {
  background: var(--ui-surface-hover, color-mix(in srgb, var(--border) 25%, var(--c-white)));
}

.sec-filing-drawer__item-main {
  flex: 1 1;
  min-width: 0;
}

.sec-filing-drawer__id {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-blue-1);
  text-decoration: none;
  display: block;
  margin-bottom: 4px;
}

.sec-filing-drawer__id:hover {
  text-decoration: underline;
}

.sec-filing-drawer__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.sec-filing-drawer__date {
  font-size: 11px;
  color: var(--text3);
}

.sec-filing-drawer__toi {
  margin-top: 4px;
  font-size: 11px;
  color: var(--text3);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sec-filing-drawer__ext {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--text3);
}

.sec-filing-drawer__footer {
  display: block;
  font-size: 11px;
  color: var(--text3);
}

/* Prompt Pulse — layout shell (mirrors .table-area.sec-filing-panel) */
.table-area.geo-analytics-panel {
  flex: 1 1;
  min-width: 0;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.table-area.geo-analytics-panel.insights-panel {
  padding: 16px 24px 32px;
}

/* Prompt Pulse Insights — entrance animations (initial load + filter apply) */
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > * {
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(1) { animation-delay: 0.06s; }
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(2) { animation-delay: 0.11s; }
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(3) { animation-delay: 0.16s; }
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(4) { animation-delay: 0.21s; }
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(n + 5) { animation-delay: 0.26s; }

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card,
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card {
  animation: filingsInsightsCardIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card {
  animation-delay: 0.24s;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card {
  animation-delay: 0.42s;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) thead tr {
  animation: filingsInsightsFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.14s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

/* Company Ranking — SEC Filings table entrance */
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-card .geo-insights-table-wrap {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

/* AI Visibility Index — chart static; table matches SEC Filings table entrance */
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table-wrap {
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip {
  transform-box: fill-box;
  transform-origin: left center;
  transform: scaleX(0);
  animation: geoLineClipReveal var(--geo-line-clip-duration, 1.05s) cubic-bezier(0.16, 1, 0.3, 1) var(--geo-line-clip-delay, 0.18s) forwards;
}

@keyframes geoLineClipReveal {
  to {
    transform: scaleX(1);
  }
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__dot {
  opacity: 0;
  transform: scale(0.6);
  transform-box: fill-box;
  transform-origin: center;
  animation: filingsChartPointIn 0.32s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  animation-delay: var(--point-delay, 0.18s);
}

.table-area.geo-analytics-panel.filings-table-panel {
  padding: 16px 24px 32px;
}

/* Prompts table tab — full-bleed like SEC Filings table (no extra footer gutter) */
.table-area.geo-analytics-panel.filings-table-panel.geo-prompts-table-panel {
  padding: 0;
  min-width: 0;
}

.geo-prompts-table-panel .geo-prompts-content {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
}

.geo-prompts-table-panel .geo-prompts-content .table-wrap {
  flex: 1 1;
  min-width: 0;
  overflow: auto;
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.geo-prompts-table-panel .geo-prompts-content thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.geo-prompts-table-panel .geo-prompts-content tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.geo-prompts-table-panel .geo-prompts-content .pagination-sticky {
  flex-shrink: 0;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;
}

/* Pagination rows-per-page — match SEC (28px control, not default 32px select-wrap) */
.table-area.filings-table-panel .table-pagination .select-wrap {
  height: 28px;
}

.table-area.filings-table-panel .table-pagination .select-measure {
  height: 28px;
  line-height: 28px;
  min-height: 28px;
  padding-top: 0;
  padding-bottom: 0;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-sno {
  width: 6%;
  text-align: center;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-rank {
  width: 5%;
  min-width: 52px;
  max-width: 72px;
  padding-left: 16px;
  padding-right: 10px;
  text-align: center;
  white-space: nowrap;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-prompt {
  width: 44%;
  min-width: 0;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .geo-prompt-cell {
  max-width: none;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-mentions {
  width: 12%;
  min-width: 128px;
  white-space: nowrap;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-prompt {
  width: 28%;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-coverage {
  width: 120px;
  min-width: 120px;
  white-space: nowrap;
  text-align: center;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-coverage {
  width: 11%;
  min-width: 120px;
  padding-right: 16px;
  white-space: nowrap;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-position {
  width: 128px;
  min-width: 128px;
  white-space: nowrap;
  text-align: center;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-position {
  width: 12%;
  min-width: 128px;
  white-space: nowrap;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-sentiment {
  width: 168px;
  min-width: 168px;
  text-align: center;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-sentiment {
  width: 16%;
  min-width: 168px;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-coverage .geo-table-header-label,
.geo-prompts-table-panel .sec-filing-insights-data-table .col-position .geo-table-header-label,
.geo-prompts-table-panel .sec-filing-insights-data-table .col-sentiment .geo-table-header-label {
  justify-content: center;
}

.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-mentions,
.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-position,
.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-sentiment,
.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-coverage {
  text-align: center;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-intent {
  width: 14%;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-product-line {
  width: 18%;
}

.geo-prompts-table-panel .sec-filing-insights-data-table .col-priority {
  width: 12%;
}

.geo-prompts-table-panel .sec-filing-insights-data-table th:first-child,
.geo-prompts-table-panel .sec-filing-insights-data-table td:first-child {
  padding-left: 12px;
  padding-right: 12px;
}

/* Edit prompts modal — compact shell; list scrolls inside, not full 85vh stretch */
.geo-prompt-edit-backdrop {
  animation: filingsInsightsFadeIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.configure-dialog.configure-dialog--geo-prompts {
  width: min(720px, calc(100vw - 48px));
  max-width: 720px;
  height: auto;
  max-height: min(85vh, calc(100vh - 48px));
  overflow: hidden;
  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.configure-dialog--geo-prompts .p-dialog-header {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.configure-dialog--geo-prompts .modal-desc {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;
}

.configure-dialog--geo-prompts .geo-prompt-edit-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.configure-dialog--geo-prompts .config-hint {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;
}

.configure-dialog--geo-prompts .geo-prompt-edit-list--entered .competitor-item {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.configure-dialog--geo-prompts .p-dialog-footer {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;
}

.configure-dialog--geo-prompts .p-dialog-content {
  flex: 0 1 auto;
  min-height: unset;
  max-height: none;
  overflow: visible;
}

.configure-dialog--geo-prompts .competitor-picker {
  flex: 0 1 auto;
  min-height: unset;
}

.configure-dialog--geo-prompts .geo-prompt-edit-search {
  flex: 1 1 220px;
  min-width: 0;
  height: 36px;
  padding: 0 12px;
  border: 1px solid var(--border2);
  border-radius: 6px;
  font-family: var(--font);
  font-size: 13px;
  color: var(--c-black);
  background: var(--c-white);
  box-sizing: border-box;
}

.configure-dialog--geo-prompts .geo-prompt-edit-search:focus {
  outline: none;
  border-color: var(--c-black);
}

.configure-dialog--geo-prompts .geo-prompt-edit-toolbar__actions {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  flex-shrink: 0;
}

.configure-dialog--geo-prompts .geo-prompt-edit-toolbar__actions .btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  min-width: 112px;
  white-space: nowrap;
}

.configure-dialog--geo-prompts .geo-prompt-edit-column {
  max-height: min(52vh, 480px);
  overflow: hidden;
  border-radius: var(--border-radius);
  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;
}

.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list {
  max-height: min(52vh, 480px);
  overflow-x: hidden;
  overflow-y: auto;
  border-radius: 0;
  background: var(--ui-surface);
  scrollbar-width: thin;
  scrollbar-color: color-mix(in srgb, var(--c-black) 28%, transparent) transparent;
}

.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar {
  width: 8px;
}

.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar-track {
  background: transparent;
}

.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar-thumb {
  background: color-mix(in srgb, var(--c-black) 28%, transparent);
  border-radius: 4px;
}

.configure-dialog--geo-prompts .geo-prompt-edit-list--loading {
  min-height: 120px;
}

.configure-dialog--geo-prompts .competitor-item input[type='checkbox'] {
  width: 14px;
  height: 14px;
  margin-top: 3px;
  accent-color: var(--c-black);
}

/* Do not use .report-page here — it fixes width to 1460px and centers the shell */
.table-area.geo-analytics-panel .report-page {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  box-shadow: none;
  background: transparent;
}

.geo-insights-toolbar {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 16px;
}

.geo-insights-toolbar__filters {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
}

.geo-insights-select-wrap {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.geo-insights-select-wrap--inline {
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.geo-insights-select-wrap__label {
  font-size: 11px;
  color: var(--text3);
  font-weight: 500;
}

.geo-insights-select {
  min-width: 140px;
  height: 32px;
  padding: 0 10px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text);
  font-size: 13px;
}

.geo-insights-toolbar__meta {
  display: flex;
  align-items: center;
  gap: 12px;
}

.geo-insights-toolbar__summary {
  margin: 0;
  font-size: 12px;
  color: var(--text3);
}

.geo-insights-toolbar__settings {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: var(--surface);
  color: var(--text2);
}

.geo-insights-error {
  margin: 0 0 16px;
}

.geo-insights-top-prompts-card {
  width: 100%;
  margin-bottom: 20px;
  overflow: hidden;
}

.geo-insights-top-prompts-card.geo-insights-table-card {
  display: block;
  height: auto;
}

.geo-insights-top-prompts-card .geo-insights-table-wrap {
  flex: none;
  padding: 0;
  overflow: visible;
  min-height: 0;
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table {
  font-size: 12px;
  table-layout: fixed;
  width: 100%;
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody tr {
  cursor: default;
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table th,
.geo-insights-top-prompts-card .geo-insights-top-prompts-table td {
  padding: 8px 6px;
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table thead th {
  border-bottom: 1px solid var(--border);
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody td {
  border-bottom: 1px solid var(--border);
}

.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody tr:last-child td {
  border-bottom: none;
}

.volume-chart-panel .chart-panel__header .geo-metric-title {
  align-self: stretch;
  box-sizing: border-box;
}

.geo-citations-card__title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.geo-metric-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.geo-metric-title__label {
  min-width: 0;
}

.geo-metric-info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: var(--text3);
  cursor: default;
}

.geo-metric-info:hover {
  color: var(--text2);
}

.geo-metric-info--compact {
  transform: scale(0.92);
}

.geo-metric-info--kpi {
  transform: scale(0.9);
  vertical-align: middle;
}

.kpi-banner-title--with-info {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
}

.kpi-banner-title__label {
  min-width: 0;
}

.geo-table-header-label {
  display: inline-flex;
  align-items: center;
  justify-content: inherit;
  gap: 4px;
  flex-shrink: 0;
  max-width: none;
}

.geo-insights-data-table th:has(.geo-table-header-label),
.sec-filing-insights-data-table th:has(.geo-table-header-label) {
  overflow: visible;
}

.geo-insights-data-table th .geo-table-header-label,
.sec-filing-insights-data-table th .geo-table-header-label {
  white-space: nowrap;
}

.geo-metric-tooltip__body {
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: var(--text2);
  line-height: 1.45;
}

.geo-metric-tooltip.geo-line-chart-tooltip:not(:has(.geo-line-chart-tooltip__date)) {
  padding-top: 10px;
}

.geo-citations-card__info {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--text3);
  cursor: default;
}

.geo-citations-table__col-rank,
.geo-citations-table__col-share,
.geo-citations-table__col-count {
  text-align: center;
}

.geo-citations-table__col-rank {
  width: 72px;
  min-width: 72px;
  white-space: nowrap;
}

.geo-citations-table__col-share,
.geo-citations-table__col-count {
  width: 140px;
  min-width: 140px;
  white-space: nowrap;
}

.geo-citations-table tbody td:first-child,
.geo-citations-table tbody td:nth-child(3),
.geo-citations-table tbody td:nth-child(4) {
  text-align: center;
}

.geo-citations-table__url {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  max-width: 100%;
  color: var(--text);
  text-decoration: none;
  font-size: 13px;
  line-height: 1.35;
}

.geo-citations-table__url:hover {
  color: var(--c-black);
  text-decoration: underline;
}

.geo-citations-table__favicon {
  flex-shrink: 0;
  border-radius: 2px;
}

.geo-citations-table__url-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.geo-insights-data-table td:has(.geo-citations-table__url) {
  max-width: 0;
  width: 55%;
}

.geo-citations-card__footer {
  padding: 10px 24px 14px;
  border-top: 1px solid var(--border);
}

.geo-citations-card__footer-note {
  font-size: 12px;
  color: var(--text3);
}

.geo-insights-visibility-card {
  width: 100%;
  margin-bottom: 20px;
}

.geo-insights-visibility-body {
  display: grid;
  /* 1.5fr ≈ 30% wider chart column vs original 1.15fr (drives SVG width:100% height) */
  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 1fr);
  gap: 24px;
  padding: 0 16px 12px;
  align-items: start;
}

.geo-insights-visibility-chart-wrap {
  display: flex;
  flex-direction: column;
  align-self: start;
  width: 100%;
  min-width: 0;
  overflow: visible;
}

.geo-insights-visibility-chart-wrap .geo-insights-empty--compact {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 244px;
  width: 100%;
}

.geo-insights-visibility-chart {
  display: block;
  width: 100%;
  height: auto;
  flex-shrink: 0;
  vertical-align: top;
  overflow: visible;
}

.geo-insights-visibility-chart__plot-bg {
  fill: var(--c-white);
}

.geo-insights-visibility-chart__axis-line {
  stroke: var(--border);
  stroke-width: 1;
  vector-effect: non-scaling-stroke;
}

.geo-insights-visibility-chart__midline {
  stroke: var(--border);
  stroke-width: 1;
  stroke-dasharray: 3 3;
  vector-effect: non-scaling-stroke;
}

.geo-insights-visibility-chart__quadrant-label {
  font-weight: 600;
}

.geo-insights-visibility-chart__quadrant-label--niche {
  fill: var(--geo-quadrant-niche);
}

.geo-insights-visibility-chart__quadrant-label--leaders {
  fill: var(--geo-quadrant-leaders);
}

.geo-insights-visibility-chart__quadrant-label--low-performance {
  fill: var(--geo-quadrant-low-performance);
}

.geo-insights-visibility-chart__quadrant-label--low-conversion {
  fill: var(--geo-quadrant-low-conversion);
}

.geo-insights-visibility-chart__brand-logo-fo {
  overflow: visible;
  pointer-events: visiblePainted;
}

.geo-insights-visibility-chart__brand-logo-host {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.geo-brand-logo-img {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: 4px;
  object-fit: contain;
  background: var(--c-white);
  border: 1px solid var(--border);
  flex-shrink: 0;
}

.geo-brand-logo-img--chart {
  width: 10px;
  height: 10px;
  border-radius: 2px;
}

.geo-brand-logo-img--client,
.geo-brand-avatar--client {
  box-shadow: 0 0 0 1px #7456da;
}

.geo-insights-visibility-table-wrap {
  min-width: 0;
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  align-self: start;
}

.geo-insights-visibility-table {
  width: 100%;
  table-layout: fixed;
  font-size: 12px;
}

.geo-insights-visibility-table th,
.geo-insights-visibility-table td {
  padding: 10px 12px;
  vertical-align: middle;
}

.geo-insights-visibility-table .col-brand {
  width: 38%;
}

.geo-insights-visibility-table .col-quadrant {
  width: 26%;
  white-space: nowrap;
  text-align: center;
}

.geo-insights-visibility-table .col-metric {
  width: 18%;
  min-width: 128px;
  text-align: center;
  white-space: nowrap;
}

.geo-insights-visibility-table .col-brand .geo-brand-name-cell {
  display: flex;
  margin-bottom: 0;
}

.geo-insights-visibility-table .col-brand .geo-brand-name-cell__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.geo-insights-empty--compact {
  min-height: 160px;
}

@media (max-width: 960px) {
  .geo-insights-visibility-body {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .geo-insights-visibility-chart-wrap {
    width: 100%;
  }
}

/* KPI row + chart + ranking share one 5-column grid */
.geo-insights-kpi-chart-layout {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  margin-bottom: 20px;
}

.geo-insights-kpi-chart-layout > .geo-insights-kpi-grid {
  display: contents;
  margin-bottom: 0;
}

.geo-insights-kpi-chart-layout > .geo-insights-kpi-grid > * {
  min-width: 0;
}

.geo-insights-kpi-chart-layout > .geo-insights-chart-card {
  grid-column: 1 / 4;
  grid-row: 2;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  min-width: 0;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card {
  grid-column: 4 / 6;
  grid-row: 2;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .chart-panel__header {
  flex-wrap: wrap;
  gap: 8px;
}

.geo-insights-ranking-card .geo-insights-table-wrap {
  flex: 1 1;
  min-height: 0;
  padding-left: 0;
  padding-right: 0;
  padding-bottom: 8px;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-table-wrap {
  flex: 1 1;
  min-height: 0;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table {
  font-size: 12px;
  table-layout: fixed;
  width: 100%;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table th,
.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table td {
  padding: 8px 6px;
}

.geo-insights-ranking-card .geo-insights-data-table .col-rank {
  width: 28px;
  padding-left: 16px;
  padding-right: 4px;
  text-align: center;
  white-space: nowrap;
}

.geo-insights-ranking-card .geo-insights-data-table .col-name {
  width: 38%;
  min-width: 0;
}

.geo-insights-ranking-card .geo-insights-data-table .col-sentiment {
  width: 72px;
  text-align: center;
}

.geo-insights-ranking-card .geo-insights-data-table .col-mentions {
  width: 52px;
  text-align: center;
}

.geo-insights-ranking-card .geo-insights-data-table .col-coverage {
  width: 104px;
  min-width: 104px;
  max-width: 104px;
  text-align: center;
  white-space: nowrap;
}

.geo-insights-ranking-card .geo-insights-data-table .col-sov {
  width: 64px;
  min-width: 64px;
  max-width: 64px;
  text-align: center;
  white-space: nowrap;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table th.col-sov,
.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table td.col-sov {
  padding-right: 16px;
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table thead th {
  border-bottom: 1px solid var(--border);
}

.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table tbody td {
  border-bottom: 1px solid var(--border);
}

/* Citations row — chart (3/5) + table (2/5); table sets row height, chart fills it */
.geo-insights-citations-layout {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  align-items: stretch;
  gap: 12px;
  width: 100%;
  margin-top: 20px;
}

.geo-insights-citations-layout > .geo-insights-citations-chart-card {
  grid-column: 1 / 4;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.geo-insights-citations-layout > .geo-insights-citations-card {
  grid-column: 4 / 6;
  width: 100%;
  max-width: 100%;
  margin-bottom: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-self: start;
}


.geo-citations-chart-wrap {
  position: relative;
  flex: 1 1;
  width: 100%;
  min-width: 0;
  min-height: 0;
}

.geo-insights-citations-chart-card .geo-citations-chart {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
}

.geo-citations-chart-labels {
  position: absolute;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
}

.geo-citations-chart-labels__y-tick {
  position: absolute;
  transform: translate(-100%, -50%);
}

.geo-citations-chart-labels__x-tick {
  position: absolute;
  transform: translate(-50%, -50%);
  max-width: 72px;
  text-align: center;
}

.geo-citations-chart-labels__bar-value {
  position: absolute;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: 600;
  color: var(--c-black);
  line-height: 1;
  -webkit-user-select: none;
          user-select: none;
}

.geo-insights-citations-layout > .geo-insights-citations-card .geo-insights-table-wrap {
  flex: none;
  overflow: visible;
  padding: 0;
}

.geo-insights-citations-card .geo-citations-table tbody tr {
  height: auto;
}

.geo-insights-citations-card .geo-citations-table thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background: var(--c-white);
  border-bottom: none;
  box-shadow: inset 0 -1px 0 var(--border);
}

.geo-insights-citations-card .geo-citations-table th,
.geo-insights-citations-card .geo-citations-table td {
  padding: 8px 12px;
}

.geo-insights-citations-card .geo-citations-table th:first-child,
.geo-insights-citations-card .geo-citations-table td:first-child {
  padding-left: 16px;
}

.geo-insights-citations-card .geo-citations-table th:last-child,
.geo-insights-citations-card .geo-citations-table td:last-child {
  padding-right: 16px;
}

.geo-insights-citations-card .geo-citations-table__col-rank,
.geo-insights-citations-card .geo-citations-table__col-share,
.geo-insights-citations-card .geo-citations-table__col-count,
.geo-insights-citations-card .geo-citations-table td:first-child,
.geo-insights-citations-card .geo-citations-table td:nth-child(3),
.geo-insights-citations-card .geo-citations-table td:nth-child(4) {
  text-align: center;
}

.geo-insights-citations-card .geo-citations-table thead th:nth-child(3) .geo-table-header-label {
  justify-content: center;
}

.geo-insights-citations-card .geo-citations-card__footer {
  flex-shrink: 0;
  margin-top: 0;
}

.geo-citations-chart__bar-label {
  fill: var(--c-black);
  font-size: 12px;
  font-weight: 600;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-citations-chart-card .geo-citations-chart__bar {
  transform-box: fill-box;
  transform-origin: center bottom;
  animation: filingsBarGrowUp 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.12s + min(var(--bar-index, 0), 30) * 0.018s);
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card,
.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card {
  animation: filingsInsightsCardIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card {
  animation-delay: 0.48s;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card {
  animation-delay: 0.56s;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table thead tr {
  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;
}

.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table tbody tr {
  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);
}

.geo-insights-ranking-card .geo-brand-name-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  max-width: 100%;
}

.geo-insights-ranking-card .geo-brand-name-cell__label {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.geo-insights-chart-card .chart-panel__body {
  min-height: 0;
  width: 100%;
  flex: none;
  padding-right: 8px;
  box-sizing: border-box;
}

.geo-insights-citations-chart-card.geo-insights-chart-card .chart-panel__body {
  flex: 1 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding-top: 8px;
  padding-bottom: 8px;
}

.geo-insights-citations-chart-card .geo-insights-chart-legend--top {
  margin-bottom: 4px;
}

.geo-insights-table-card__actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-top: 10px;
}

.geo-insights-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 260px;
  color: var(--text3);
  gap: 8px;
}

.geo-insights-empty__icon {
  font-size: 28px;
  opacity: 0.5;
}

.geo-insights-line-chart-wrap {
  position: relative;
  width: 100%;
}

.geo-insights-line-chart {
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 994 / 400;
}

.geo-insights-line-chart__grid {
  stroke: var(--border);
  stroke-width: 1;
}

.geo-insights-line-chart__axis {
  stroke: var(--border);
  stroke-width: 1;
}

.geo-insights-line-chart__tick--x {
  letter-spacing: 0.01em;
}

.geo-insights-line-chart__line {
  vector-effect: non-scaling-stroke;
}

.geo-insights-line-chart__dot {
  fill: var(--c-white);
  stroke-width: 1.5px;
  vector-effect: non-scaling-stroke;
  pointer-events: none;
  transition: r 0.12s ease;
}

.geo-insights-line-chart__dot--hovered {
  stroke-width: 2px;
}

.geo-insights-line-chart__hit {
  cursor: crosshair;
}

.geo-insights-line-chart__cursor {
  stroke: var(--text3);
  stroke-width: 1;
  stroke-dasharray: 4 3;
  pointer-events: none;
}

.geo-line-chart-tooltip {
  transform: translate(-50%, calc(-100% - 14px));
  padding: 10px 12px;
  gap: 0;
  min-width: 200px;
  max-width: min(320px, 90vw);
}

.geo-line-chart-tooltip__date {
  font-size: 12px;
  font-weight: 600;
  color: var(--c-black);
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid var(--border2);
}

.geo-line-chart-tooltip__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.geo-line-chart-tooltip__row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: var(--c-black);
}

.geo-line-chart-tooltip__swatch {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.geo-line-chart-tooltip__brand {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.geo-line-chart-tooltip__value {
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  flex-shrink: 0;
}

.geo-line-chart-tooltip__empty {
  margin: 0;
  font-size: 12px;
  color: var(--text2);
}

.geo-insights-chart-legend--top {
  margin-top: 0;
  margin-bottom: 10px;
}

.geo-insights-kpi-grid {
  margin-bottom: 20px;
}

@media (max-width: 1100px) {
  .geo-insights-kpi-chart-layout {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .geo-insights-kpi-chart-layout > .geo-insights-chart-card {
    grid-column: 1 / -1;
    grid-row: 2;
  }

  .geo-insights-kpi-chart-layout > .geo-insights-ranking-card {
    grid-column: 1 / -1;
    grid-row: 3;
  }

  .geo-insights-citations-layout {
    grid-template-columns: minmax(0, 1fr);
  }

  .geo-insights-citations-layout > .geo-insights-citations-chart-card,
  .geo-insights-citations-layout > .geo-insights-citations-card {
    grid-column: 1 / -1;
  }
}

@media (max-width: 640px) {
  .geo-insights-kpi-chart-layout {
    grid-template-columns: minmax(0, 1fr);
  }
}

.geo-insights-kpi-grid--empty {
  margin-bottom: 20px;
}

.geo-insights-table-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.geo-insights-table-wrap {
  padding: 0 24px 8px;
  overflow-x: auto;
}

.geo-insights-data-table td.geo-prompt-cell {
  max-width: 320px;
  white-space: normal;
  line-height: 1.4;
}

.geo-brand-name-cell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
}

.geo-brand-avatar {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}

.geo-insights-row--client {
  background: rgba(116, 86, 218, 0.04);
}

.geo-insights-pagination {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px 16px 12px;
  font-size: 13px;
}

.geo-insights-link {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-purple, #7456da);
  text-decoration: none;
}

.geo-insights-link:hover {
  text-decoration: underline;
}

.geo-filters-drawer .filters-drawer-body {
  gap: 0;
}

.geo-filters-drawer .accordion-item {
  border-bottom: 1px solid var(--border);
}

.geo-filters-drawer__custom-range {
  padding: 12px 16px 16px;
  border-top: 1px solid var(--border);
}

/* Social Post Card */
.social-post-card {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.social-post-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px;
}

.social-post-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--c-blue-1);
  color: var(--c-white);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
}

.social-post-header-text {
  display: flex;
  flex-direction: column;
}

.social-post-company {
  font-size: 14px;
  font-weight: 600;
  color: var(--c-black);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

.social-post-sponsored {
  font-size: 12px;
  color: var(--text2);
}

.social-post-body {
  padding: 0 16px 16px 16px;
  font-size: 14px;
  line-height: 1.5;
  color: var(--c-black);
  white-space: pre-wrap;
}

.social-post-creative {
  width: 100%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 250px;
}

.social-post-image {
  width: 100%;
  height: 100%;
  min-height: 250px;
  max-height: 700px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-post-image img {
  width: 100% !important;
  height: 100% !important;
  max-height: 700px !important;
  object-fit: contain !important;
}

.social-post-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #f0f2f5;
  border-top: 1px solid #dddfe2;
}

.social-post-footer-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow: hidden;
  padding-right: 12px;
}

.social-post-footer-domain {
  font-size: 11px;
  text-transform: uppercase;
  color: var(--text2);
  letter-spacing: 0.05em;
}

.social-post-footer-title {
  font-size: 15px;
  font-weight: 600;
  color: var(--c-black);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-word;
}

/* Ad Inspector Panel */
.ad-inspector-panel {
  background: var(--c-white);
  border: 1px solid var(--border);
  border-radius: 8px;
  overflow: hidden;
  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;
  animation-delay: 0.24s;
}

.ad-inspector-header {
  padding: 16px;
  font-size: 15px;
  font-weight: 600;
  color: var(--ink-emphasis);
  border-bottom: 1px solid var(--border);
  background: var(--bg2, #f9fafb);
}

.ad-inspector-section {
  padding: 16px;
  border-bottom: 1px solid var(--border);
}

.ad-inspector-section:last-child {
  border-bottom: none;
}

.ad-inspector-section-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--c-black);
  margin-bottom: 14px;
}

.ad-inspector-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 12px;
}

.ad-inspector-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ad-inspector-field.full-width {
  grid-column: 1 / -1;
}

.ad-inspector-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--text2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ad-inspector-label svg {
  color: var(--text3);
}

.ad-inspector-value {
  font-size: 14px;
  font-weight: 500;
  color: var(--c-black);
  line-height: 1.4;
  word-break: break-word;
}
/* Marketing Table Thumbnail */
.marketing-table-thumb {
  width: 64px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  background-color: var(--c-gray-1, #e2e8f0);
}

.marketing-table-thumb .ad-creative-thumb__play-icon {
  width: 20px;
  height: 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.3);
}

.marketing-table-thumb .ad-creative-thumb__play-icon svg {
  width: 10px;
  height: 10px;
}

.marketing-table-thumb .ad-creative-thumb__badge {
  font-size: 8px;
  padding: 1px 4px;
  right: 2px;
  bottom: 2px;
}

.marketing-table-thumb .ad-creative-thumb__spinner {
  width: 16px;
  height: 16px;
  border-width: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/components.css"],"names":[],"mappings":"AAAA;qGACqG;;AAErG,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,uBAAuB;EACvB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,yBAAyB;EACzB,4CAA4C;EAC5C,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA,4FAA4F;AAC5F;;EAEE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,MAAM;EACN,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC;;+CAE6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb;;;;wBAIsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;iEAE+D;EAC/D,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,OAAO;EACP,UAAU;EACV,sEAAsE;AACxE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,WAAW;EACX,SAAS;EACT,wEAAwE;EACxE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,2EAA2E;EAC3E,mBAAmB;AACrB;;AAEA;EACE;;IAEE,wCAAwC;EAC1C;EACA;IACE,kDAAkD;EACpD;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC;;0CAEwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,qCAAqC;EACrC,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB;;;yBAGuB;AACzB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;EAC1B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;yBAGuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;;AAGA,yBAAyB;AACzB;EACE,sBAAsB;EACtB,2CAA2C;EAC3C,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,4CAA4C;EAC5C,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,gCAAgC;EAChC,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4CAA4C;EAC5C,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,qCAAqC;AACvC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,gBAAgB;AAClB;AACA,UAAU;AACV;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA,UAAU;AACV;EACE,SAAO;EACP,cAAc;EACd,uBAAuB;AACzB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B;EAC1B,4CAA4C;EAC5C,4BAA4B;EAC5B,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,yDAAoQ;AACtQ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,wBAAwB;EACxB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,kCAAkC;EAClC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,WAAW;EACX,yDAAwQ;EACxQ,4BAA4B;EAC5B,wBAAwB;EACxB,2BAA2B;EAC3B,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,wCAAwC;EACxC,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;AACA,kBAAkB;AAClB;EACE,YAAY;EACZ,YAAY,EAAE,wBAAwB;EACtC,aAAa,EAAE,gDAAgD;EAC/D,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa,EAAE,mDAAmD;EAClE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,cAAc,EAAE,wDAAwD;AAC1E;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sCAAsC;EACtC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,MAAM;AACR;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;;EAEE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,4BAA4B;EAC5B,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mCAAmC;EACnC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;EAC5C,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,4CAA4C;EAC5C,4CAA4C;EAC5C,0BAA0B;EAC1B,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,4CAA4C;EAC5C,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,yDAAsQ;EACtQ,4BAA4B;EAC5B,qCAAqC;EACrC,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,iCAAiC;EACjC,yDAAkQ;AACpQ;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,sFAAsF;AACtF;;EAEE,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,0BAA0B;EAC1B,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,qBAAqB;EACrB,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;AAC5B;AACA,0BAA0B;AAC1B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,aAAa;EACb,gCAAgC;EAChC,mDAAmD;EACnD,aAAa;EACb,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,SAAO;AACT;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,WAAW;EACX,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,+BAA+B;EAC/B,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,2DAA2D;AAC7D;;AAEA,oCAAoC;AACpC;EACE,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,0BAA0B;EAC1B,uBAAuB;EACvB,0BAA0B;EAC1B,oCAA4B;UAA5B,4BAA4B;EAC5B,iCAAiC;EACjC,kDAAkD;AACpD;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,KAAK,qBAAqB,EAAE,YAAY,EAAE;EAC1C,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE,UAAU,EAAE;AAC1C;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2DAA2D;EAC3D,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,UAAU;EACZ;AACF;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA,2EAA2E;AAC3E;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA,0FAA0F;AAC1F;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;EAC3B,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA,gGAAgG;AAChG;EACE,6BAA6B;EAC7B,6CAA6C;EAC7C,wDAAwD;EACxD,gEAAgE;AAClE;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA,uEAAuE;AACvE;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,yDAAyD;AACzD;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,sDAAsD;EACtD,6BAA6B;EAC7B,2BAA2B;EAC3B,4BAA4B;EAC5B,iBAAiB;EACjB,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8CAA8C;AAC9C;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,2CAA2C;EAC3C,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,wBAAwB;EACxB,4BAA4B;EAC5B,gCAAgC;EAChC,sBAAsB;EACtB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,kDAAkD;EAClD,8BAA8B;EAC9B,qCAAqC;EACrC,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;EACvB,0BAA0B;EAC1B,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;EACzB,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,sDAAsD;AACtD;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;;EAEE,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,0BAA0B;EAC1B,yBAAyB;EACzB,4DAA4D;EAC5D,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;;EAEE,qCAAqC;EACrC,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA,0CAA0C;AAC1C;EACE,wBAAwB;EACxB,oBAAoB;EACpB,6BAA6B;EAC7B,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,oBAAkB;EAClB,kCAAkC;EAClC,mDAAmD;EACnD,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qCAAqC;EACrC,mDAAmD;AACrD;;AAEA;EACE,oBAAkB;EAClB,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;EAChC,2BAA2B;EAC3B,uBAAuB;EACvB,6BAA6B;EAC7B,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,+CAA+C;EAC/C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,yFAAyF;AACzF;EACE,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;;EAGE,WAAW;EACX,iDAAiD;EACjD,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;EAC1B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,8BAA8B;EAC9B,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;EAIE,uEAAuE;EACvE,yFAAyF;EACzF,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,iDAAiD;EACjD,wCAAwC;EACxC,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,2EAA2E;EAC3E,oEAAoE;EACpE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,gCAAgC;EAChC,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,sCAAsC;EACtC,0BAA0B;EAC1B,sHAAsH;AACxH;;AAEA;EACE,WAAW;EACX,iDAAiD;EACjD,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA,qEAAqE;AACrE;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,0CAA0C;EAC1C,qCAAqC;EACrC,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,4DAA4D;EAC5D,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,uCAAuC;EACvC,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA,iDAAiD;AACjD;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;EACpC,sDAAsD;EACtD,gCAAgC;EAChC,oDAAoD;EACpD,0BAA0B;EAC1B,2BAA2B;EAC3B,2CAA2C;EAC3C,0BAA0B;EAC1B,uFAAuF;EACvF,iCAAiC;AACnC;;AAEA;;;;;;;;;EASE,qDAAqD;EACrD,+CAA+C;EAC/C,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;;EAEE,gCAAgC;EAChC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;EAEE,gCAAgC;EAChC,gCAAgC;AAClC;;AAEA,kDAAkD;AAClD;;EAEE,2CAA2C;EAC3C,wDAAwD;EACxD,qBAAqB;EACrB,sBAAsB;EACtB,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA,mKAAmK;;AAEnK,uDAAuD;AACvD;;EAEE,2CAA2C;AAC7C;;AAEA,+FAA+F;AAC/F;;EAEE,0CAA0C;EAC1C,gCAAgC;EAChC,uBAAuB;AACzB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA,iEAAiE;AACjE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gCAAgC;EAChC,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,iDAAiD;EACjD,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,kGAAkG;AAClG;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,sCAAsC;EACtC,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,wBAAwB;EACxB,8BAA8B;EAC9B,sCAAsC;EACtC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;;AAGA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,iCAAiC;EACjC,iCAAiC;EACjC,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA,2FAA2F;AAC3F;EACE,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,yCAAyC,EAAE,4BAA4B;EACvE,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,mFAAmF;AACnF;EACE,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,gEAAgE;AAClE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,8DAA8D;EAC9D,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,2BAA2B;EAC3B,4BAA4B;EAC5B,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0BAA0B;EAC1B,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;EAC5B,yDAA6R;EAC7R,4BAA4B;EAC5B,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,4CAA4C;AAC5C;EACE,+BAA+B;EAC/B,2CAA2C;EAC3C,yCAAyC;EACzC,6BAA6B;EAC7B,4CAA4C;EAC5C,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE;IACE,YAAY;IACZ,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE,sCAAsC;EACtC,mFAAmF,EAAE,iCAAiC;AACxH;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,2CAA2C;EAC3C,kDAAkD;EAClD,4BAA4B;EAC5B,8BAA8B;EAC9B,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,wBAAwB;EACxB,8EAA8E;AAChF;;AAEA,0CAA0C;AAC1C;EACE,0BAA0B;EAC1B,6BAA6B;EAC7B,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,kFAAkF;AAClF;;EAEE,yBAAyB;EACzB,gCAAgC;EAChC,wBAAwB;AAC1B;;AAEA,yCAAyC;AACzC;;EAEE,2CAA2C;EAC3C,qCAAqC;EACrC,0CAA0C;EAC1C,6BAA6B;EAC7B,4CAA4C;EAC5C,uBAAuB;EACvB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA,qDAAqD;AACrD;;EAEE,qBAAqB;AACvB;AACA;;EAEE,kCAAkC;AACpC;AACA;;EAEE,yCAAyC;EACzC,6BAA6B;AAC/B;;AAEA;;EAEE,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,0BAA0B;EAC1B,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;EAC7B,wBAAwB;EACxB,wBAAwB,EAAE,gDAAgD;AAC5E;;AAEA;;EAEE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;;EAEE,0CAA0C;EAC1C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;;EAEE,wBAAwB,EAAE,gEAAgE;AAC5F;;AAEA,uGAAuG;AACvG;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,sCAAsC,EAAE,uEAAuE;EAC/G,kCAAkC;EAClC,qCAAqC;EACrC,0CAA0C;EAC1C,6BAA6B;EAC7B,4BAA4B;EAC5B,0BAA0B;EAC1B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,qCAAqC;EACrC,0BAA0B;EAC1B,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,iCAAiC;AACjC;;EAEE,gCAAgC;EAChC,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;EAC3B,qCAAqC;EACrC,8BAA8B;EAC9B,wCAAwC;EACxC,wBAAwB;EACxB,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB,EAAE,oCAAoC;EAC7D,2BAA2B,EAAE,6CAA6C;EAC1E,4BAA4B;EAC5B,oCAAoC;EACpC,iCAAiC;EACjC,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+BAA+B;AAC/B;;EAEE,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,gDAAgD;EAChD,0CAA0C;EAC1C,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;EAChC,2BAA2B;EAC3B,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;;EAEE,+CAA+C;EAC/C,yCAAyC;EACzC,gCAAgC;EAChC,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;;;;EAIE,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;;EAEE,+CAA+C;EAC/C,yCAAyC;EACzC,gCAAgC;EAChC,2BAA2B;EAC3B,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,wBAAwB;AAC1B;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;AACtB;;AAEA;EACE,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA,yBAAyB;AACzB;EACE,oBAAoB;EACpB,sBAAsB;EACtB,+CAA+C;EAC/C,2CAA2C;EAC3C,6BAA6B;EAC7B,yCAAyC;EACzC,0CAA0C;EAC1C,iCAAiC;EACjC,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,4BAA4B;EAC5B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,iDAAiD;AACnD;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,oDAAoD;AACpD;EACE,2CAA2C;EAC3C,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,4DAA4D,EAAE,qCAAqC;AACrG;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC,EAAE,+BAA+B;AACtE;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,qCAAqC;EACrC,kCAAkC;EAClC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,0BAA0B;EAC1B,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,qDAAqD;AACrD;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,SAAS;AACT;EACE,SAAO;EACP,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,mCAAmC;EACnC,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAO;EACP,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4BAA4B;EAC5B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,sGAAsG;AACtG;EACE,cAAc;EACd,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,uBAAuB;EACvB,sCAAsC;EACtC,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,MAAM;EACN,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,qBAAqB;EACrB,eAAe;EACf,iDAAiD;EACjD,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;EAC1B,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,4CAA4C;EAC5C,6BAA6B;EAC7B,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,qBAAqB;EACrB,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,eAAe;AACf;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0FG;;AAEH,kBAAkB;AAClB;EACE,iBAAiB;EACjB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,0BAA0B;EAC1B,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,SAAS;EACT,0BAA0B;AAC5B;;AAEA,4BAA4B;AAC5B;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,4BAA4B;EAC5B,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,SAAO;EACP,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,sCAAsC;EACtC,0BAA0B;EAC1B,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mEAAmE;EACnE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6EAA6E;EAC7E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kEAAkE;EAClE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qEAAqE;EACrE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,uCAAuC;EACvC,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,uCAAuC;EACvC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,0FAA0F;EAC1F,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAC1B,mBAAmB;EACnB,qCAAqC;EACrC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,8DAA8D;EAC9D,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,iBAAiB;EACjB,8FAA8F;AAChG;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,iDAAiD;EACjD,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,WAAW;EACX,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;EAC5C,iCAAiC;EACjC,mCAAmC;AACrC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,2CAA2C;EAC3C,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,SAAS;EACT,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,yFAAyF;AACzF;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;;;EAGE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,8EAA8E;AAChF;;AAEA,sFAAsF,sBAAsB,EAAE;AAC9G,sFAAsF,sBAAsB,EAAE;AAC9G,sFAAsF,sBAAsB,EAAE;AAC9G,sFAAsF,qBAAqB,EAAE;AAC7G,0FAA0F,sBAAsB,EAAE;;AAElH;EACE,8EAA8E;AAChF;;AAEA,wEAAwE,sBAAsB,EAAE;AAChG,wEAAwE,sBAAsB,EAAE;AAChG,wEAAwE,qBAAqB,EAAE;AAC/F,4EAA4E,sBAAsB,EAAE;;AAEpG,mCAAmC;AACnC;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;;;EAIE,0EAA0E;EAC1E,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,wEAAwE;EACxE,8CAA8C;AAChD;;AAEA;;;EAGE,6BAA6B;EAC7B,4EAA4E;AAC9E;;AAEA,0FAA0F,sBAAsB,EAAE;AAClH,0FAA0F,sBAAsB,EAAE;AAClH,0FAA0F,qBAAqB,EAAE;AACjH,0FAA0F,sBAAsB,EAAE;AAClH,8FAA8F,sBAAsB,EAAE;;AAEtH;EACE,6DAA6D;AAC/D;;AAEA;EACE,oGAAoG;EACpG,gHAAgH;AAClH;;AAEA;EACE,mGAAmG;EACnG,+GAA+G;AACjH;;AAEA;EACE,6EAA6E;EAC7E,kEAAkE;AACpE;;AAEA;EACE,0CAA0C;EAC1C,2CAA2C;EAC3C,oEAAoE;EACpE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,gEAAgE;AAClE;;AAEA;EACE,UAAU;EACV,2EAA2E;EAC3E,yCAAyC;AAC3C;;AAEA,+EAA+E,sBAAsB,EAAE;AACvG,+EAA+E,sBAAsB,EAAE;AACvG,+EAA+E,sBAAsB,EAAE;AACvG,+EAA+E,sBAAsB,EAAE;AACvG,+EAA+E,qBAAqB,EAAE;AACtG,mFAAmF,sBAAsB,EAAE;;AAE3G,4FAA4F,sBAAsB,EAAE;AACpH,4FAA4F,sBAAsB,EAAE;AACpH,4FAA4F,sBAAsB,EAAE;AACpH,4FAA4F,sBAAsB,EAAE;AACpH,gGAAgG,qBAAqB,EAAE;;AAEvH;EACE,6CAA6C;AAC/C;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,sEAAsE;AACxE;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA,0CAA0C;AAC1C;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;EAEE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;;EAEE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA;EACE,8EAA8E;EAC9E,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA,sFAAsF;AACtF;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,iEAAiE,SAAS,EAAE;AAC5E,sEAAsE,UAAU,EAAE;AAClF,oEAAoE,SAAS,EAAE;AAC/E,mEAAmE,SAAS,EAAE;AAC9E,kEAAkE,SAAS,EAAE;AAC7E,sEAAsE,SAAS,EAAE;AACjF,2EAA2E,UAAU,EAAE;AACvF,qEAAqE,SAAS,EAAE;AAChF,mEAAmE,UAAU,EAAE;AAC/E;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;;EAGE,iEAAiE;EACjE,qBAAqB;AACvB;;AAEA;;EAEE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;;;EAGE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB,EAAE,+DAA+D;AACpF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV,mBAAmB;EACnB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sEAAsE;EACtE,iCAAiC;EACjC,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAqDE,eAAe;IACf,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,2EAA2E;EAC3E,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;;AAGA,6EAA6E;;AAE7E;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,0BAA0B;EAC1B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;;;;;EAKE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAS;AACX;;AAEA;EACE,WAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAE1B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,uBAAuB;EACvB,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,SAAO;EACP,YAAY;EACZ,WAAW;AACb;;AAEA,sEAAsE;AACtE;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,8GAA8G;AAC9G;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,sGAAsG;AACtG;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,sCAAsC;EACtC,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mCAAmC;EACnC,aAAa;AACf;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,4EAA4E;AAC5E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,8EAA8E;AAChF;;AAEA,yDAAyD,qBAAqB,EAAE;;AAEhF;EACE,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yDAAyD,sBAAsB,EAAE;AACjF,yDAAyD,sBAAsB,EAAE;;AAEjF;EACE,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,8EAA8E;EAC9E,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,0EAA0E;EAC1E,qBAAqB;AACvB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,0EAA0E;AAC5E;;AAEA,qEAAqE,sBAAsB,EAAE;AAC7F,qEAAqE,sBAAsB,EAAE;AAC7F,qEAAqE,qBAAqB,EAAE;AAC5F,qEAAqE,sBAAsB,EAAE;AAC7F,qEAAqE,sBAAsB,EAAE;;AAE7F;EACE,0EAA0E;AAC5E;;AAEA,uFAAuF,sBAAsB,EAAE;AAC/G,uFAAuF,qBAAqB,EAAE;AAC9G,uFAAuF,sBAAsB,EAAE;AAC/G,uFAAuF,sBAAsB,EAAE;;AAE/G;EACE;;;;;;;IAOE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,oFAAoF;EACpF,6BAA6B;EAC7B,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAO;EACP,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA,sEAAsE;AACtE;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,qDAAqD;EACrD,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,uCAAuC;EACvC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE;;uBAEqB;EACrB,uCAAuC;EACvC,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,sCAAsC;EACxC;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,qEAAqE;AACvE;;AAEA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,sEAAsE;AACxE;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE;;;IAGE,eAAe;IACf,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,SAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA,uCAAuC;AACvC;EACE,qCAAqC;EACrC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA,+CAA+C;AAC/C;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,uDAAuD;AACvD;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,oDAAoD;EACpD,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,0BAA0B;EAC1B,gBAAgB;EAChB,OAAO;EACP,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kDAAkD;EAClD,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0FAA0F;AAC1F;EACE,uBAAuB;AACzB;;;;AAIA;EACE,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;;;AAIA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;;AAGA,6EAA6E;AAC7E;;GAEG;;AAEH;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,+BAA+B;EAC/B,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,wEAAwE;AAC1E;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,uBAAuB;EACvB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EACnC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;EACjC,sEAAsE;AACxE;;AAEA;EACE,yBAAyB;EACzB,iEAAiE;EACjE,sEAAsE;AACxE;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gFAAgF;EAChF,mFAAmF;AACrF;;AAEA;EACE,iCAAiC;EACjC,8EAA8E;EAC9E,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,qEAAqE;AACvE;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,iDAAiD;AACnD;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;EACf,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,iEAAiE;AACjE;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2EAA2E;EAC3E,4DAA4D;AAC9D;;AAEA;EACE,4EAA4E;EAC5E,4DAA4D;AAC9D;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;;;IAGE,eAAe;IACf,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,kCAAkC;EAClC,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,qEAAqE;AACvE;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iEAAiE;EACjE,qBAAqB;EACrB,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,wEAAwE;AAC1E;;AAEA;EACE,mDAAmD;EACnD,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gEAAgE;AAClE;;AAEA,gEAAgE;AAChE;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8DAA8D;AAC9D;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;;GAGG;;AAEH;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gFAAgF;EAChF,mFAAmF;AACrF;;AAEA;EACE,iCAAiC;EACjC,8EAA8E;EAC9E,iFAAiF;AACnF;;;;AAIA;EACE;IACE,2DAA2D;EAC7D;AACF;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,0DAA0D;AAC5D;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0DAA0D;AAC5D;;;AAGA,gFAAgF;AAChF;EACE,oFAAoF;AACtF;;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;AAC5E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iEAAiE;AACjE;;EAEE,oFAAoF;AACtF;;AAEA;;;EAGE,0EAA0E;EAC1E,yEAAyE;AAC3E;;;AAGA,mEAAmE;AACnE;EACE,+BAA+B;EAC/B,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;;AAGA,2EAA2E;AAC3E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,UAAU;AACZ;;AAEA,sGAAsG;AACtG;EACE,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,oFAAoF;AACtF;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE,UAAU;EACV,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0FAA0F;AAC5F;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA,uEAAuE;AACvE;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,8EAA8E;AAC9E;EACE,8EAA8E;AAChF;;AAEA,+GAA+G,sBAAsB,EAAE;AACvI,+GAA+G,sBAAsB,EAAE;AACvI,+GAA+G,sBAAsB,EAAE;AACvI,+GAA+G,sBAAsB,EAAE;AACvI,mHAAmH,sBAAsB,EAAE;;AAE3I;;EAEE,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,0EAA0E;EAC1E,0EAA0E;AAC5E;;AAEA,iDAAiD;AACjD;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA,iFAAiF;AACjF;EACE,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,oBAAoB;EACpB,0IAA0I;AAC5I;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,uBAAuB;EACvB,wBAAwB;EACxB,2EAA2E;EAC3E,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;AACzB;;AAEA,mFAAmF;AACnF;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,cAAc;EACd,mFAAmF;AACrF;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,oFAAoF;AACtF;;AAEA,sFAAsF;AACtF;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,mFAAmF;AACnF;EACE,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,gBAAgB;EAChB,0EAA0E;AAC5E;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mFAAmF;AACrF;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA;EACE,oFAAoF;AACtF;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,mCAAmC;EACnC,mFAAmF;AACrF;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;EAC7B,qBAAqB;EACrB,gFAAgF;AAClF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+DAA+D;EAC/D,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,4BAA4B;AAC9B;;AAEA,kFAAkF;AAClF;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qFAAqF;EACrF,0DAA0D;EAC1D,SAAS;EACT,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,WAAW;EACb;AACF;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA,qFAAqF;AACrF;EACE,aAAa;EACb,gDAAgD;EAChD,oBAAoB;EACpB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;;AAGA;EACE,kBAAkB;EAClB,SAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,yEAAyE;EACzE,oEAAoE;AACtE;;AAEA;;EAEE,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,0EAA0E;EAC1E,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iCAAiC;EACjC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,MAAM;EACN,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA,qBAAqB;AACrB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,8EAA8E;EAC9E,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;AACxB;AACA,8BAA8B;AAC9B;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":["/* Reusable UI components — sidebar, header, footer, buttons, cards, tables, forms, badges, drawers, reports, charts\n   Colors: var(--c-*), var(--text2), var(--ink-*), var(--border-*), var(--shadow-*) from tokens.css */\n\n/* Sidebar */\n.sidebar {\n  width: 260px;\n  min-width: 260px;\n  background: var(--c-white);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  overflow: visible;\n  z-index: 50;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.sidebar.collapsed {\n  width: 64px;\n  min-width: 64px;\n}\n\n.logo {\n  box-sizing: border-box;\n  min-height: var(--layout-logo-block-height);\n  padding: 20px 20px 16px;\n  border-bottom: 1px solid var(--border);\n  overflow: hidden;\n}\n\n.sidebar.collapsed .logo {\n  padding: 20px 0;\n  display: flex;\n  justify-content: center;\n}\n\n.sidebar-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sidebar.collapsed .sidebar-header {\n  flex-direction: column;\n  gap: 12px;\n}\n\n.sidebar-toggle-btn {\n  background: transparent;\n  border: 1px solid var(--border-color-strong);\n  color: var(--text2);\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.1s;\n}\n\n.sidebar-toggle-btn:hover {\n  background: var(--c-black);\n  color: var(--c-white);\n  border-color: var(--ink-emphasis);\n}\n\n.logo-mark {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 4px;\n  white-space: nowrap;\n}\n\n.logo-icon {\n  width: var(--logo-icon-size);\n  height: var(--logo-icon-size);\n  background: var(--c-neon);\n  border: 2px solid var(--border-color-strong);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ink-emphasis);\n  letter-spacing: -0.5px;\n  flex-shrink: 0;\n}\n\n.logo-text {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1.2;\n}\n\n.logo-name {\n  font-size: 22px;\n  font-weight: 600;\n  color: var(--c-black);\n  letter-spacing: -0.3px;\n}\n\n.logo-sub {\n  font-size: 12px;\n  color: var(--text3);\n  padding-left: 0;\n}\n\n.nav {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: visible;\n  padding: 12px 0;\n}\n\n.sidebar.collapsed .nav {\n  overflow: visible;\n}\n\n.nav-section-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  padding: 10px 20px 4px;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 16px;\n  margin: 2px 12px;\n  font-size: 13px !important;\n  font-weight: 500;\n  color: var(--c-black);\n  cursor: pointer;\n  transition: all 0.15s;\n  border-radius: 8px;\n  position: relative;\n  text-decoration: none;\n  white-space: nowrap;\n  overflow: hidden;\n}\n\n.sidebar.collapsed .nav-item {\n  padding: 10px 0;\n  margin: 2px 4px;\n  justify-content: center;\n  gap: 0;\n}\n\n.sidebar.collapsed .nav-item .nav-icon {\n  margin: 0;\n}\n\n.nav-item:hover {\n  background: var(--c-white);\n  color: var(--c-black);\n  border-radius: 8px;\n}\n\n.nav-item.active {\n  background: var(--text3);\n  color: var(--c-white);\n  font-weight: 500;\n  border-radius: 8px;\n}\n\n.nav-item.active.black-active {\n  background: var(--c-black);\n  color: var(--c-white);\n}\n\n/* Accordion parents (State Insurance Filings, Nexus, SEC Filing, Prompt Pulse): grey only */\n.nav-item-group > .nav-item.active,\n.nav-item-group > .nav-item.active.black-active {\n  background: var(--text3);\n  color: var(--c-white);\n}\n\n.nav-item-group > .nav-item.active .nav-icon,\n.nav-item-group > .nav-item.active.black-active .nav-icon {\n  color: var(--c-white);\n}\n\n.nav-item.active.black-active .nav-icon {\n  color: var(--c-white);\n}\n\n.nav-item--disabled {\n  cursor: default;\n  opacity: 0.4;\n  color: var(--c-black);\n  pointer-events: none;\n  user-select: none;\n}\n\n.nav-item--disabled .sidebar-style-1 {\n  color: var(--c-black);\n}\n\n.nav-sub {\n  display: flex;\n  flex-direction: column;\n  margin-top: 2px;\n  margin-bottom: 6px;\n}\n\n.nav-sub-item {\n  display: flex;\n  align-items: center;\n  padding: 6px 16px 6px 42px;\n  margin: 2px 12px;\n  font-size: 12px !important;\n  font-weight: 500;\n  color: var(--c-black);\n  cursor: pointer;\n  text-decoration: none;\n  transition: all 0.15s;\n  white-space: nowrap;\n  border-radius: 8px;\n}\n\n.nav-sub-item:hover {\n  color: var(--c-black);\n  background: var(--c-white);\n  border-radius: 8px;\n}\n\n.nav-sub-item.active {\n  color: var(--c-white);\n  font-weight: 500;\n  background: var(--c-black);\n  border-radius: 8px;\n}\n\n.sidebar.collapsed .nav-sub,\n.sidebar.collapsed .nav-sub--collapsed-flyout {\n  display: flex;\n  position: absolute;\n  left: calc(100% + 8px);\n  top: 0;\n  min-width: 150px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 6px;\n  box-shadow: var(--shadow-dropdown);\n  z-index: 200;\n  transform-origin: left center;\n}\n\n.sidebar.collapsed .nav-sub--collapsed-flyout {\n  opacity: 0;\n  transform: translateX(-10px) scale(0.98);\n  transition:\n    opacity 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n    transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  pointer-events: none;\n}\n\n.sidebar.collapsed .nav-sub--collapsed-flyout.is-open {\n  opacity: 1;\n  transform: translateX(0) scale(1);\n  pointer-events: auto;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sidebar.collapsed .nav-sub--collapsed-flyout {\n    transition: none;\n  }\n}\n\n.sidebar.collapsed .nav-item-group {\n  position: relative;\n  overflow: visible;\n}\n\n.sidebar.collapsed .nav-sub-item {\n  margin: 0;\n  padding: 8px 10px;\n  font-size: 12px;\n}\n\n.nav-icon {\n  width: 16px;\n  height: 16px;\n  opacity: 0.5;\n  flex-shrink: 0;\n}\n\n.nav-item.active .nav-icon {\n  opacity: 1;\n  color: var(--c-white);\n}\n\n.nav-badge {\n  margin-left: auto;\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 10px;\n  background: var(--red-bg);\n  color: var(--red-text);\n}\n\n.nav-badge.amber {\n  background: var(--orange-bg);\n  color: var(--amber-text);\n}\n\n.sidebar-footer {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--c-white);\n  transition: all 0.2s;\n}\n\n.sidebar.collapsed .sidebar-footer {\n  padding: 16px 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.sidebar-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  margin-bottom: 12px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text2);\n  transition: all 0.1s;\n  white-space: nowrap;\n}\n\n.sidebar.collapsed .sidebar-toggle {\n  padding: 8px;\n  margin-bottom: 0;\n}\n\n.sidebar-toggle:hover {\n  background: var(--c-white);\n  color: var(--c-black);\n  border-color: var(--border2);\n}\n\n.sf-user {\n  overflow: hidden;\n}\n\n\n.sf-label {\n  font-size: 10px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sf-time {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 2px;\n}\n\n.sf-status {\n  font-size: 11px;\n  color: var(--c-teal-active);\n  margin-top: 1px;\n}\n\n.sf-logout {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 7px 9px;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--c-white);\n  color: var(--ink-body);\n  font-size: 11px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.sf-logout:hover {\n  border-color: var(--border-hover);\n  background: var(--bar-track-bg);\n  color: var(--c-black);\n}\n\n.sf-logout--collapsed {\n  width: 40px;\n  height: 40px;\n  margin-top: 0;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.sidebar.collapsed .sf-logout {\n  margin-top: 0;\n}\n\n.sidebar-style-1 {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.sidebar-style-2 {\n  flex-shrink: 0;\n  width: 14px;\n  height: 14px;\n  transition: transform 0.2s;\n  opacity: 0.5;\n}\n\n.login-shell {\n  min-height: 100vh;\n  display: grid;\n  place-items: center;\n  position: relative;\n  overflow: hidden;\n  padding: 32px;\n  background:\n    radial-gradient(circle at 20% 20%, var(--glow-neon), transparent 26%),\n    radial-gradient(circle at 78% 18%, var(--glow-purple), transparent 30%),\n    radial-gradient(circle at 80% 86%, var(--glow-teal), transparent 28%),\n    var(--login-bg-base);\n}\n\n.login-shell::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background-image:\n    linear-gradient(var(--grid-line) 1px, transparent 1px),\n    linear-gradient(90deg, var(--grid-line) 1px, transparent 1px);\n  background-size: 42px 42px;\n  mask-image: radial-gradient(circle at center, black 0%, transparent 74%);\n}\n\n.login-orb {\n  position: absolute;\n  border-radius: 999px;\n  filter: blur(1px);\n  opacity: 0.75;\n  animation: loginFloat 9s ease-in-out infinite;\n}\n\n.login-orb-one {\n  width: 280px;\n  height: 280px;\n  top: 9%;\n  right: 12%;\n  background: radial-gradient(circle, var(--glow-blue), transparent 68%);\n}\n\n.login-orb-two {\n  width: 230px;\n  height: 230px;\n  bottom: 14%;\n  left: 10%;\n  background: radial-gradient(circle, var(--glow-orange), transparent 68%);\n  animation-delay: 1.5s;\n}\n\n.login-orb-three {\n  width: 170px;\n  height: 170px;\n  top: 36%;\n  left: 18%;\n  background: radial-gradient(circle, var(--glow-teal-soft), transparent 68%);\n  animation-delay: 3s;\n}\n\n@keyframes loginFloat {\n  0%,\n  100% {\n    transform: translate3d(0, 0, 0) scale(1);\n  }\n  50% {\n    transform: translate3d(10px, -16px, 0) scale(1.04);\n  }\n}\n\n.login-card {\n  width: min(100%, 440px);\n  position: relative;\n  z-index: 1;\n  padding: 28px;\n  border: 1px solid var(--border-panel);\n  border-radius: 24px;\n  background: var(--surface-glass);\n  box-shadow:\n    var(--shadow-card),\n    inset 0 1px 0 var(--surface-highlight);\n  backdrop-filter: blur(18px);\n}\n\n.login-brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 28px;\n}\n\n.login-brand-mark {\n  width: 44px;\n  height: 44px;\n  display: grid;\n  place-items: center;\n  border: 2px solid var(--ink-mark);\n  border-radius: 12px;\n  background: var(--c-neon);\n  color: var(--ink-overlay);\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: -0.04em;\n}\n\n.login-brand-name {\n  color: var(--c-black);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.1;\n}\n\n.login-brand-subtitle {\n  color: var(--text2);\n  font-size: 12px;\n}\n\n.login-copy {\n  margin-bottom: 24px;\n}\n\n.login-kicker {\n  margin: 0 0 8px;\n  color: var(--c-teal-active);\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.login-copy h1 {\n  margin: 0;\n  color: var(--c-black);\n  font-family: var(--font-display);\n  font-size: 36px;\n  line-height: 0.95;\n  letter-spacing: -0.04em;\n}\n\n.login-copy p:last-child {\n  margin: 10px 0 0;\n  color: var(--text2);\n  font-size: 13px;\n  line-height: 1.55;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.login-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  color: var(--ink-body-strong);\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.login-input-wrap {\n  min-height: 46px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 0 13px;\n  border: 1px solid var(--border-input);\n  border-radius: 14px;\n  background: var(--surface-glass);\n  color: var(--text3);\n  transition:\n    border-color 0.15s ease,\n    box-shadow 0.15s ease,\n    background 0.15s ease;\n}\n\n.login-input-wrap:focus-within {\n  border-color: var(--focus-border-blue);\n  background: var(--c-white);\n  box-shadow: 0 0 0 4px var(--focus-shadow-blue);\n}\n\n.login-input-wrap input {\n  min-width: 0;\n  flex: 1;\n  border: 0;\n  outline: 0;\n  background: transparent;\n  color: var(--c-black);\n  font: inherit;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n.login-input-wrap input::placeholder {\n  color: var(--ink-subtle);\n}\n\n.login-password-toggle {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  border: 0;\n  border-radius: 9px;\n  background: transparent;\n  color: var(--ink-faint);\n  cursor: pointer;\n}\n\n.login-password-toggle:hover {\n  background: var(--border-subtle);\n  color: var(--ink-emphasis);\n}\n\n.login-form-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  min-height: 24px;\n}\n\n.login-remember {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--text2);\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.login-remember input {\n  width: 14px;\n  height: 14px;\n  accent-color: var(--c-blue-1);\n}\n\n.login-error {\n  padding: 10px 12px;\n  border: 1px solid var(--error-border);\n  border-radius: 12px;\n  background: var(--red-bg);\n  color: var(--red-text);\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.login-submit {\n  height: 48px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  border: 0;\n  border-radius: 14px;\n  background: var(--c-black);\n  color: var(--c-white);\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.15s ease,\n    background 0.15s ease;\n}\n\n.login-submit:hover:not(:disabled) {\n  transform: translateY(-1px);\n  background: var(--ink-overlay);\n  box-shadow: var(--shadow-submit);\n}\n\n.login-submit:disabled {\n  cursor: not-allowed;\n  opacity: 0.68;\n}\n\n@media (max-width: 560px) {\n  .login-shell {\n    padding: 18px;\n  }\n\n  .login-card {\n    padding: 22px;\n    border-radius: 20px;\n  }\n\n  .login-copy h1 {\n    font-size: 31px;\n  }\n}\n\n\n/* Page header (topbar) */\n.topbar {\n  box-sizing: border-box;\n  min-height: var(--layout-logo-block-height);\n  background: var(--c-white);\n  border-bottom: 1px solid var(--border);\n  padding: 16px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n\n.topbar-left {\n  display: flex;\n  flex-direction: column;\n}\n\n.topbar-title {\n  font-family: var(--font-display);\n  font-size: 20px;\n  font-weight: 500;\n  color: var(--c-black);\n  letter-spacing: -0.3px;\n}\n\n.back-btn {\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  cursor: pointer;\n  color: var(--text3);\n  transition: all 0.1s;\n  border: 1px solid transparent;\n}\n\n.back-btn:hover {\n  background: var(--c-white);\n  color: var(--c-black);\n  border-color: var(--border);\n}\n\n.topbar-sub {\n  font-size: 12px;\n  color: var(--text3);\n  margin-top: 1px;\n}\n\n.topbar-right {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n.page-header-filters {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.page-tabs-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 12px 24px;\n  background: var(--c-white);\n  border-bottom: 1px solid var(--border-panel);\n  position: sticky;\n  top: 53px;\n  z-index: 9;\n}\n\n.page-tabs {\n  display: inline-flex;\n  background: var(--c-white);\n  border: 1px solid var(--ui-border-input);\n  border-radius: 8px;\n  padding: 4px;\n  gap: 4px;\n}\n\n.page-tab {\n  padding: 6px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text2);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n  background: transparent;\n  text-align: center;\n}\n\n.page-tab:hover {\n  color: var(--c-black);\n}\n\n.page-tab.active {\n  background: var(--ink-overlay);\n  color: var(--c-white);\n  box-shadow: var(--shadow-control);\n  font-weight: 500;\n}\n\n.chip {\n  font-size: 11px;\n  padding: 4px 10px;\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  color: var(--text2);\n  background: var(--c-white);\n}\n\n/* Report / document header & footer */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2.5px solid var(--c-blue-1);\n  padding-bottom: 10px;\n  margin-bottom: 13px;\n}\n\n.header-left {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.header-logo {\n  height: 36px;\n  width: auto;\n}\n\n.header-divider {\n  width: 1.5px;\n  height: 32px;\n  background: var(--c-white);\n}\n\n.header-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.report-label {\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  letter-spacing: .14em;\n  text-transform: uppercase;\n  color: var(--c-blue-2);\n}\n\n.report-title {\n  font-size: var(--fs-lg);\n  font-weight: 700;\n  color: var(--c-blue-1);\n}\n\n.header-right {\n  text-align: right;\n  color: var(--text3);\n  font-size: var(--fs-xs);\n  line-height: 1.75;\n}\n\n.week-badge {\n  display: inline-block;\n  background: var(--c-blue-1);\n  color: var(--c-white);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  padding: 3px 11px;\n  border-radius: 20px;\n}\n\n.footer {\n  margin-top: 10px;\n  padding-top: 6px;\n  border-top: 1px solid var(--c-white);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 8.5px;\n  color: var(--text3);\n}\n\n.footer-logo {\n  height: 18px;\n  width: auto;\n  opacity: 0.6;\n}\n\n.btn {\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  padding: 7px 14px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border2);\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.btn:hover {\n  background: var(--c-white);\n}\n\n.btn-export {\n  background: var(--c-white);\n  color: var(--ink-emphasis);\n  border: 1px solid var(--border-color-strong);\n  height: 32px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.btn-export:hover {\n  background: var(--text2);\n  color: var(--c-white);\n  /* border-color: var(--c-purple-1); */\n}\n\n.btn-primary {\n  background: var(--c-black);\n  color: var(--c-white);\n  border-color: var(--ink-emphasis);\n}\n\n.btn-primary:hover {\n  background: var(--ink-emphasis);\n}\n\n/* Map Toggle Buttons */\n.btn-map-toggle {\n  padding: 8px 16px !important;\n  font-size: 11px !important;\n  height: 36px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n/* Content */\n.content {\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex: 1;\n  overflow-y: auto;\n}\n/* Stats */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.stat-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 18px;\n}\n\n.stat-label {\n  font-size: 11px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.stat-value {\n  font-size: 28px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-top: 4px;\n  letter-spacing: -1px;\n}\n\n.stat-sub {\n  font-size: 12px;\n  color: var(--text2);\n  margin-top: 3px;\n}\n\n.stat-delta {\n  font-size: 11px;\n  margin-top: 6px;\n}\n\n.stat-delta.up {\n  color: var(--c-teal-active);\n}\n\n.stat-delta.down {\n  color: var(--c-orange);\n}\n\n/* Panels */\n.panel {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.panel-header {\n  padding: 14px 18px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.panel-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.panel-actions {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Pills */\n.pill {\n  display: inline-flex;\n  align-items: center;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 3px 8px;\n  border-radius: var(--radius);\n}\n\n.pill-blue {\n  background: var(--c-cyan-1);\n  color: var(--c-blue-1);\n}\n\n.pill-green {\n  background: var(--c-aqua-mass);\n  color: var(--green-text);\n}\n\n.pill-amber {\n  background: var(--orange-bg);\n  color: var(--amber-text);\n}\n\n.pill-red {\n  background: var(--red-bg);\n  color: var(--red-text);\n}\n\n.pill-outline {\n  background: transparent;\n  color: var(--text2);\n  border: 1px solid var(--border);\n}\n\n.pill-purple {\n  background: var(--c-purple-4);\n  color: var(--c-purple-1);\n}\n\n/* Table */\n.table-wrap {\n  flex: 1;\n  overflow: auto;\n  /* min-height: 480px; */\n}\n\n.table-wrap table,\n.table-wrap-inline table {\n  table-layout: auto;\n}\n\n.table-wrap-inline {\n  width: 100%;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n  table-layout: fixed;\n  background: var(--c-white);\n}\n\nth {\n  text-align: left;\n  padding: 16px;\n  font-size: var(--fs-md);\n  font-weight: 500;\n  color: var(--ink-emphasis);\n  text-transform: none;\n  letter-spacing: normal;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-bottom: 1px solid var(--border);\n}\n\n.th-sort {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.sort-arrow {\n  font-size: 10px;\n  opacity: 0.3;\n}\n\n.sort-arrow.active {\n  opacity: 1;\n  color: var(--c-black);\n}\n\n.col-tn {\n  /* Dynamic width */\n}\n\n.col-company {\n  /* No fixed width, will take remaining space */\n}\n\n.col-state {\n  /* Dynamic width */\n}\n\n.col-type {\n  /* Dynamic width */\n}\n\n.col-toi {\n  /* Dynamic width */\n}\n\n.col-status {\n  /* Dynamic width */\n}\n\n.date-cell {\n  width: 100px;\n  text-transform: uppercase;\n}\n\n.col-count {\n  width: 60px;\n  text-align: center;\n}\n\n.col-zip {\n  width: 60px;\n  text-align: center;\n}\n\ntd {\n  padding: 18px 16px;\n  border-bottom: 1px solid var(--border);\n  color: var(--c-black);\n  vertical-align: middle;\n}\n\ntr {\n  height: 64px;\n}\n\ntr:last-child td {\n  border-bottom: none;\n}\n\ntr:hover td {\n  background: var(--c-white);\n}\n\ntr.selected td,\ntr.selected:hover td {\n  background: var(--c-cyan-0);\n}\n\n.tn {\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--c-black);\n  font-weight: 500;\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.company {\n  font-weight: 500;\n  color: var(--c-black);\n  max-width: 180px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.zip-yes {\n  color: var(--c-teal-active);\n  font-weight: 500;\n  font-size: 11px;\n}\n\n.zip-no {\n  color: var(--text3);\n  font-size: 11px;\n}\n\n/* Filters */\n.filters {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 12px 18px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.select-wrap {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  background: var(--c-white);\n  border: 1px solid var(--border-color-strong);\n  border-radius: var(--radius);\n  height: 32px;\n  box-sizing: border-box;\n  overflow: hidden;\n  transition: all 0.15s;\n}\n\n.select-wrap:hover {\n  background: var(--ink-emphasis);\n  border-color: var(--ink-emphasis);\n}\n\n.select-wrap:hover .filter-select,\n.select-wrap:hover .select-measure {\n  color: var(--c-white);\n}\n\n.select-wrap:hover::after {\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n\n.select-wrap:focus-within {\n  border-color: var(--c-black);\n}\n\n.select-measure {\n  display: inline-block;\n  visibility: hidden;\n  white-space: pre;\n  padding: 0 28px 0 10px;\n  font-size: 12px;\n  font-family: var(--font);\n  height: 30px;\n  line-height: 30px;\n  min-width: 60px;\n  pointer-events: none;\n}\n\n.filter-select {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: auto;\n  min-width: 100%;\n  height: 100%;\n  font-family: var(--font);\n  font-size: 12px;\n  padding: 0 28px 0 10px;\n  border: none !important;\n  background: transparent !important;\n  color: var(--c-black);\n  cursor: pointer;\n  appearance: none;\n  outline: none !important;\n  box-shadow: none !important;\n  margin: 0;\n  z-index: 1;\n}\n\n.filter-select:focus {\n  border-color: var(--c-black);\n}\n\n.select-wrap::after {\n  content: '';\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  width: 10px;\n  height: 6px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%236B6960' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-size: contain;\n  transform: translateY(-50%);\n  transition: transform 0.2s ease;\n  pointer-events: none;\n}\n\n.select-wrap.is-open::after {\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.filter-select option {\n  font-family: var(--font);\n  background: var(--c-white);\n  color: var(--c-black);\n}\n\n.search-input {\n  font-family: var(--font);\n  font-size: 12px;\n  padding: 0 10px;\n  height: 36px;\n  box-sizing: border-box;\n  border: 1px solid var(--ui-border-input);\n  border-radius: var(--radius);\n  background: var(--c-white);\n  color: var(--c-black);\n  width: 220px;\n}\n\n.search-input::placeholder {\n  font-family: var(--font);\n  color: var(--text3);\n}\n\n.search-input:focus {\n  outline: none;\n  border-color: var(--c-black);\n}\n/* Detail drawer */\n.drawer {\n  width: 360px;\n  min-width: 0; /* Allow interpolation */\n  min-height: 0; /* Allow flex shrink so drawer-body can scroll */\n  background: var(--c-white);\n  border-left: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.drawer-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-shrink: 0;\n  background: var(--c-white);\n}\n\n.drawer-tn {\n  font-family: var(--mono);\n  font-size: 12px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.drawer-company {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-top: 3px;\n  letter-spacing: -0.2px;\n}\n\n.drawer-toi {\n  font-size: 12px;\n  color: var(--text2);\n  margin-top: 3px;\n  line-height: 1.4;\n}\n\n.drawer-close {\n  color: var(--text3);\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  padding: 2px;\n  flex-shrink: 0;\n}\n\n.drawer-close:hover {\n  color: var(--c-black);\n}\n\n.drawer-tabs {\n  display: flex;\n  border-bottom: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.dt {\n  flex: 1;\n  padding: 9px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text2);\n  text-align: center;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.dt:hover {\n  color: var(--c-black);\n}\n\n.dt.active {\n  color: var(--c-black);\n  border-bottom-color: var(--c-black);\n}\n\n.drawer-body {\n  flex: 1;\n  min-height: 0; /* Required for overflow-y in nested flex layouts */\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.drawer-body > * {\n  flex-shrink: 0; /* Scroll instead of squashing preview card / sections */\n}\n\n/* Detail sections */\n.detail-section {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  border-bottom: 1px solid var(--border);\n  padding-bottom: 14px;\n}\n\n.detail-section:last-child {\n  border-bottom: none;\n}\n\n.ds-title {\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--c-black);\n  margin-bottom: 4px;\n}\n\n.field-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.field-label {\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--c-black);\n}\n\n.field-val {\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--c-black);\n}\n\n.field-val.danger {\n  color: var(--c-orange);\n}\n\n.field-val.success {\n  color: var(--c-teal-active);\n}\n\n/* Change timeline in drawer */\n.change-entry {\n  display: flex;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.ce-dot-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0;\n}\n\n.ce-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  margin-top: 4px;\n}\n\n.ce-line {\n  width: 1px;\n  flex: 1;\n  background: var(--border);\n  min-height: 16px;\n  margin: 3px 0;\n}\n\n.ce-body {\n  flex: 1;\n  min-width: 0;\n  padding-bottom: 12px;\n}\n\n.ce-time {\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.ce-type {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 1px;\n}\n\n.ce-detail {\n  font-size: 11px;\n  color: var(--text2);\n  margin-top: 2px;\n  line-height: 1.4;\n}\n\n.ce-approved {\n  background: var(--c-teal-active);\n}\n\n.ce-rejected {\n  background: var(--c-orange);\n}\n\n.ce-objection {\n  background: var(--c-orange);\n}\n\n.ce-document {\n  background: var(--c-purple-1);\n}\n\n.ce-status {\n  background: var(--c-blue-1);\n}\n\n.ce-new {\n  background: var(--text2);\n}\n\n/* Panel bars (doc count visual) */\n.panel-bars {\n  display: flex;\n  gap: 6px;\n  align-items: flex-end;\n  height: 32px;\n}\n\n.pb-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 3px;\n}\n\n.pb-bar {\n  width: 24px;\n  border-radius: 3px 3px 0 0;\n}\n\n.pb-label {\n  font-size: 10px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.drawer-actions {\n  display: flex;\n  gap: 18px;\n  padding: 12px 16px;\n  border-top: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.drawer-actions .btn {\n  flex: 1;\n  text-align: center;\n  font-size: 12px;\n  height: 36px;\n}\n\n/* Filings Grid View */\n.filings-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 16px;\n  padding: 20px;\n  overflow-y: auto;\n  flex: 1;\n  align-content: start;\n}\n\n.filter-btn-wrap {\n  position: relative;\n}\n\n.table-pagination {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.table-pagination__control {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.table-pagination__label {\n  font-size: 11px;\n  color: var(--c-black);\n}\n\n.table-pagination__measure {\n  height: 28px;\n  line-height: 28px;\n  display: inline-flex;\n  align-items: center;\n  visibility: visible;\n  min-width: 40px;\n}\n\n.table-pagination__select {\n  height: 28px;\n  color: transparent;\n}\n\n.table-pagination__option {\n  color: var(--c-black);\n}\n\n.filing-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.filing-card:hover {\n  border-color: var(--border-color-strong);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px var(--surface-pressed-tint);\n}\n\n.filing-card.selected,\n.filing-card.selected:hover {\n  border-color: var(--c-blue-1);\n  background: var(--c-cyan-1);\n}\n\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.card-tn {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.card-company {\n  font-family: var(--font-display);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 4px;\n}\n\n.card-body {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.card-pills {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.field-label {\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 400;\n  color: var(--c-black);\n}\n\n.field-val {\n  font-family: var(--font);\n  font-size: var(--fs-base);\n  color: var(--c-black);\n  margin-top: 1px;\n}\n\n.card-footer {\n  margin-top: auto;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  font-size: 11px;\n  color: var(--text3);\n}\n\n.view-toggle {\n  display: flex;\n  border: 1px solid var(--border-color-strong);\n  border-radius: var(--radius);\n  overflow: hidden;\n  height: 32px;\n  box-sizing: border-box;\n}\n\n.vt-btn {\n  height: 100%;\n  padding: 0 10px;\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n  border: none;\n  font-family: var(--font);\n  font-size: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.vt-btn:not(:last-child) {\n  border-right: 1px solid var(--border-color-strong);\n}\n\n.vt-btn:hover:not(.active) {\n  background: var(--ink-emphasis);\n  color: var(--c-white);\n}\n\n.vt-btn.active {\n  background: var(--ink-emphasis);\n  color: var(--ink-emphasis);\n}\n\n.vt-btn.active:hover {\n  background: var(--c-neon);\n}\n\n.filters-right {\n  margin-left: auto;\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n\n/* Pagination */\n.pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 10px 20px;\n  border-top: 1px solid var(--border);\n  background: var(--c-white);\n  flex-shrink: 0;\n}\n\n.pg-info {\n  font-size: 12px;\n  color: var(--c-black);\n}\n\n.pg-controls {\n  display: flex;\n  gap: 4px;\n}\n\n.pg-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border-color-strong);\n  background: var(--c-white);\n  color: var(--c-black);\n  font-size: 12px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pg-btn:hover:not(.active):not(:disabled) {\n  background: var(--text2);\n  color: var(--c-white);\n  border-color: var(--border-color-strong);\n}\n\n.pg-btn.active {\n  background: var(--c-white);\n  color: var(--ink-emphasis);\n  border: 1px solid var(--border-color-strong);\n}\n\n.pg-input {\n  width: 32px;\n  height: 28px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border-color-strong);\n  border-bottom: 2px solid var(--ink-emphasis);\n  background: var(--c-white);\n  color: var(--ink-emphasis);\n  font-size: 12px;\n  text-align: center;\n  outline: none;\n  font-family: var(--font);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.pg-input:focus {\n  border-color: var(--c-black);\n  border-bottom-color: var(--c-black);\n}\n\n.pg-btn.active:hover {\n  background: var(--c-neon);\n  border: 1px solid var(--border-color-strong);\n}\n\n.pg-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pg-select {\n  font-family: var(--font);\n  font-size: 12px;\n  padding: 0 24px 0 8px;\n  border: 1px solid var(--border-color-strong);\n  border-radius: var(--radius);\n  background: var(--c-white);\n  color: var(--c-black);\n  height: 28px;\n  box-sizing: border-box;\n  transition: all 0.15s;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='%236B6960' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n  background-size: 8px 5px;\n}\n\n.pg-select:hover {\n  background-color: var(--ink-emphasis);\n  color: var(--c-white);\n  border-color: var(--ink-emphasis);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n}\n\n/* Filters Bar */\n.filters-bar {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  flex-shrink: 0;\n  flex-wrap: wrap;\n}\n\n.topbar .filters-bar,\n.filters-bar.page-header-filters {\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  border-bottom: none;\n  box-shadow: none;\n  flex-wrap: nowrap;\n}\n\n/* Secondary outline action — chart “View full report”, Prompts “Edit Prompts”, etc. */\n.geo-card-action-btn.filters-drawer-btn-reset,\n.geo-insights-top-prompts-card__action.filters-drawer-btn-reset {\n  flex: 0 0 auto !important;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: auto !important;\n  min-width: auto !important;\n  padding: 0 14px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.page-header-edit-prompts {\n  flex-shrink: 0;\n}\n\n/* Search */\n.search-wrap {\n  position: relative;\n}\n\n.search-wrap .search-input {\n  padding-left: 30px;\n  width: 240px;\n}\n\n.search-icon {\n  position: absolute;\n  left: 9px;\n  top: 50%;\n  transform: translateY(-50%);\n  opacity: 0.8;\n}\n.btn-sm {\n  padding: 4px 10px;\n  font-size: 11px;\n}\n\n.btn-sm:hover:not(.btn-primary):not(.btn-filters):not(.filings-style-18):not(.filters-drawer-btn-apply) {\n  background: var(--ink-emphasis) !important;\n  color: var(--c-white) !important;\n  border-color: var(--ink-emphasis) !important;\n}\n\n.btn-clear {\n  background: var(--c-white);\n  border: 1px solid var(--border2);\n  color: var(--c-black);\n  cursor: pointer;\n  border-radius: var(--radius);\n  font-weight: 500;\n  transition: all 0.15s;\n}\n\n.btn-clear:hover {\n  background: var(--c-white);\n  color: var(--c-black);\n  border-color: var(--text3);\n}\n/* Details Drawer Styles */\n.drawer-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--shadow-overlay);\n  z-index: 1000;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.drawer-overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n.details-drawer {\n  position: fixed;\n  top: 0;\n  right: -400px;\n  width: 400px;\n  height: 100vh;\n  background: var(--c-white);\n  z-index: 1001;\n  box-shadow: var(--shadow-drawer);\n  transition: right 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: flex;\n  flex-direction: column;\n  font-family: var(--font) !important;\n}\n\n.details-drawer * {\n  font-family: var(--font) !important;\n}\n\n.details-drawer.open {\n  right: 0;\n}\n\n.details-drawer .drawer-header {\n  padding: 20px 24px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-shrink: 0;\n  background: var(--c-white);\n}\n\n.details-drawer .drawer-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.details-drawer .drawer-close {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: var(--text2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4px;\n  border-radius: var(--border-radius-sm);\n}\n\n.details-drawer .drawer-close:hover {\n  background: var(--c-white);\n  color: var(--c-black);\n}\n\n.details-drawer .drawer-body {\n  padding: 24px;\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.details-drawer .drawer-section {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.details-drawer .drawer-label {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.details-drawer .drawer-value {\n  font-size: 14px;\n  color: var(--c-black);\n  font-weight: 500;\n}\n\n.details-drawer .drawer-footer {\n  padding: 20px 24px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 12px;\n  background: var(--c-white);\n}\n\n.details-drawer .drawer-footer .btn {\n  flex: 1;\n}\n\n/* Filters Drawer Custom Styles */\n.filters-drawer-body {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 24px;\n  overflow-y: auto;\n}\n\n.filters-drawer-group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.filters-drawer-label {\n  font-weight: 500;\n  font-size: 12px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.filters-select-wrap {\n  position: relative;\n  overflow: visible;\n  cursor: pointer;\n  width: 100%;\n  height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.filters-select-wrap.active-filter {\n  background: var(--c-black);\n}\n\n.filters-select-measure {\n  color: var(--c-black);\n  visibility: visible !important;\n  display: flex;\n  align-items: center;\n  height: 100% !important;\n  padding-left: 14px;\n}\n\n.filters-select-wrap.active-filter .filters-select-measure {\n  color: var(--c-white);\n}\n\n.filters-popover {\n  left: 0;\n  right: 0;\n  width: 100%;\n  min-width: auto;\n  top: 100%;\n}\n\n.filters-popover-list {\n  max-height: 280px;\n}\n\n.filters-badge-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.filters-badge {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: transparent;\n  border: 1px solid var(--border2);\n  padding: 4px 8px;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black) !important;\n  line-height: 1.2;\n}\n\n.filters-badge-cancel {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1px;\n  color: var(--c-black) !important;\n  transition: color 0.15s ease;\n}\n\n.filters-badge-cancel:hover {\n  color: var(--c-orange) !important;\n}\n\n.filters-drawer-title-wrap {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n  font-weight: 500;\n}\n\n.filters-drawer-close {\n  font-size: 24px;\n  line-height: 1;\n}\n\n.filters-drawer-footer {\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 12px;\n  padding: 20px 24px;\n}\n\n.filters-drawer-btn-reset {\n  flex: 1;\n  background-color: var(--c-white);\n  color: var(--c-black);\n  border: 1px solid var(--text3);\n  border-radius: 6px;\n  height: 36px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.filters-drawer-btn-apply {\n  flex: 1;\n  background-color: var(--c-neon);\n  color: var(--c-black);\n  border: none;\n  border-radius: 6px;\n  height: 36px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.2s ease;\n}\n\n/* Filters Drawer Accordion Design */\n.filters-drawer-body {\n  padding: 0 !important;\n  gap: 0 !important;\n  flex: 1 1 auto !important;\n  min-height: 0 !important;\n  overflow-y: auto !important;\n}\n\n.accordion-item {\n  border-bottom: 1px solid var(--border2);\n  background: var(--c-white);\n}\n\n.accordion-header {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  padding: 0 20px !important;\n  height: 52px !important;\n  cursor: pointer !important;\n  user-select: none !important;\n  box-sizing: border-box !important;\n  transition: background-color 0.15s ease !important;\n}\n\n.accordion-header:hover {\n  background-color: var(--c-white) !important;\n}\n\n.accordion-header-left {\n  display: flex !important;\n  align-items: center !important;\n  gap: 12px !important;\n  height: 100% !important;\n}\n\n.accordion-header-icon {\n  color: var(--text2) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.accordion-header-title {\n  font-size: 14px !important;\n  font-weight: 500 !important;\n  color: var(--c-black) !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.accordion-header-right {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n  height: 100% !important;\n}\n\n@keyframes countPop {\n  0% { transform: scale(0.6); opacity: 0.4; }\n  50% { transform: scale(1.15); }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n.accordion-selected-count {\n  font-size: 11px;\n  background: transparent;\n  border: 1px solid var(--border2);\n  padding: 2px 6px;\n  border-radius: 4px;\n  color: var(--text2);\n  animation: countPop 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);\n  display: inline-block;\n}\n\n.accordion-chevron {\n  color: var(--text3);\n  transition: transform 0.2s ease;\n}\n\n.accordion-chevron.is-open {\n  transform: rotate(180deg);\n}\n\n@keyframes accordionSlideDown {\n  from {\n    max-height: 0;\n    opacity: 0;\n  }\n\n  to {\n    max-height: 500px;\n    opacity: 1;\n  }\n}\n\n/* Animated expand/collapse (grid 0fr → 1fr; avoids max-height clipping) */\n.accordion-panel {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.accordion-panel.is-open {\n  grid-template-rows: 1fr;\n}\n\n.accordion-panel__inner {\n  overflow: hidden;\n  min-height: 0;\n}\n\n.accordion-panel:not(.is-open) {\n  pointer-events: none;\n}\n\n/* Content is always painted; __inner clips it as the row height animates */\n.accordion-panel .accordion-content {\n  overflow: hidden;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .accordion-panel {\n    transition: none;\n  }\n\n  .accordion-panel:not(.is-open) {\n    display: none;\n  }\n}\n\n.accordion-content {\n  padding: 0;\n}\n\n/* Top rule below accordion header (search sections use .custom-dropdown-header instead) */\n.accordion-content-divider {\n  border-top: 1px solid var(--border2);\n}\n\n.accordion-content .custom-dropdown-header {\n  border-radius: 0 !important;\n  padding: 12px 20px !important;\n  background: var(--c-white) !important;\n  border-top: 1px solid var(--border2) !important;\n}\n\n.accordion-content .custom-dropdown-item {\n  padding-left: 20px !important;\n  padding-right: 20px !important;\n}\n\n.accordion-content .date-input {\n  width: calc(100% - 40px) !important;\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n}\n\n.accordion-content .filters-badge-container {\n  margin-left: 20px !important;\n  margin-right: 20px !important;\n  margin-top: 12px !important;\n}\n\n.accordion-search-container {\n  margin-bottom: 12px;\n}\n\n.accordion-search-input {\n  width: 100%;\n}\n\n.accordion-dropdown-list {\n  position: static !important;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  padding: 0 !important;\n}\n\n/* Fixed filters panel only (Answers/Filings FiltersDrawer) — not inline Filings table details */\n.details-drawer.filters-details-drawer {\n  --filters-drawer-width: 420px;\n  width: var(--filters-drawer-width) !important;\n  right: calc(-1 * var(--filters-drawer-width)) !important;\n  transition: right 0.38s cubic-bezier(0.16, 1, 0.3, 1) !important;\n}\n\n.details-drawer.filters-details-drawer.open {\n  right: 0 !important;\n}\n\n/* Answers / shared filters drawer: instant backdrop, smooth panel slide */\n.drawer-overlay:has(+ .details-drawer.filters-details-drawer) {\n  transition: none;\n}\n\n.drawer-overlay:has(+ .details-drawer.filters-details-drawer.open) {\n  opacity: 1;\n  visibility: visible;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .details-drawer.filters-details-drawer {\n    transition: none !important;\n  }\n}\n\n.filters-details-drawer .drawer-header,\n.filters-details-drawer .filters-drawer-header {\n  align-items: flex-start !important;\n  background: var(--c-white) !important;\n}\n\n.filters-drawer-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.filters-drawer-header-sub {\n  margin: 0;\n  padding-left: 26px;\n  color: var(--text2);\n  font-size: 12px;\n  line-height: 1.35;\n}\n\n/* Accordion panels: avoid max-height animation clipping list bottoms */\n.filters-details-drawer .accordion-panel .accordion-content {\n  max-height: none !important;\n  animation: none !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n}\n\n/* Rule between accordion section title and its options */\n.filters-details-drawer .accordion-panel.is-open .accordion-content {\n  border-top: 1px solid var(--border2);\n}\n\n.filters-details-drawer .accordion-content > .custom-dropdown-header:first-child {\n  border-top: none !important;\n}\n\n.filters-details-drawer .accordion-content .custom-dropdown-list.filters-popover-list,\n.filters-details-drawer .accordion-content .accordion-dropdown-list {\n  max-height: min(260px, calc(100vh - 320px)) !important;\n  overflow-x: hidden !important;\n  overflow-y: auto !important;\n  overscroll-behavior: contain;\n  padding-bottom: 0;\n  box-sizing: border-box;\n  border-bottom: 1px solid var(--border2) !important;\n}\n\n.filters-details-drawer .accordion-content .accordion-dropdown-list .custom-dropdown-item {\n  height: 38px;\n  padding: 0 20px !important;\n  border-bottom: 1px solid var(--border2);\n  box-sizing: border-box;\n}\n\n.filters-details-drawer .accordion-content .accordion-dropdown-list .custom-dropdown-item:last-child {\n  border-bottom: none;\n}\n\n.filters-details-drawer .accordion-content .filters-badge-container {\n  margin-bottom: 12px !important;\n}\n\n/* Premium Search Bar Custom Accordion Style */\n.accordion-content .custom-dropdown-search-wrap {\n  position: relative !important;\n  display: flex !important;\n  align-items: center !important;\n  background: var(--c-white) !important;\n  border: 1px solid var(--border2) !important;\n  border-radius: 6px !important;\n  padding: 0 12px !important;\n  height: 36px !important;\n  gap: 8px !important;\n}\n\n.accordion-content .custom-dropdown-search-icon {\n  position: static !important;\n  color: var(--text3) !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.accordion-content .custom-dropdown-search-input {\n  border: none !important;\n  background: transparent !important;\n  outline: none !important;\n  font-size: 13.5px !important;\n  color: var(--c-black) !important;\n  width: 100% !important;\n  padding: 0 !important;\n  font-family: inherit !important;\n}\n\n.accordion-content .custom-dropdown-search-input::placeholder {\n  color: var(--text3) !important;\n  font-weight: 500 !important;\n}\n\n/* Locked Select All Option Styling */\n.accordion-content .select-all {\n  border-bottom: 1px solid var(--border2) !important;\n  font-weight: normal !important;\n  background: var(--c-white) !important;\n  display: flex !important;\n  align-items: center !important;\n  height: 38px !important;\n  padding: 0 20px !important;\n  /* Matches accordion padding */\n  gap: 8px !important;\n  box-sizing: border-box !important;\n}\n\n.accordion-content .select-all input[type=\"checkbox\"] {\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.accordion-content .select-all span {\n  margin: 0 !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* Filters Drawer Title and Close Button Refinements */\n.filters-details-drawer .drawer-title {\n  font-weight: 500 !important;\n  /* Non-bold premium weight */\n}\n\n.filters-details-drawer .drawer-close,\n.filters-drawer-close {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  width: 24px !important;\n  height: 24px !important;\n  border-radius: 4px !important;\n  font-size: 24px !important;\n  line-height: 1 !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  background: transparent !important;\n  border: none !important;\n  color: var(--text2) !important;\n  cursor: pointer !important;\n}\n\n.filters-details-drawer .drawer-close:hover,\n.filters-drawer-close:hover {\n  background: var(--c-black) !important;\n  color: var(--c-white) !important;\n  transform: rotate(90deg) !important;\n}\n\n/* Filters Drawer Footer Buttons Styling */\n.filters-drawer-footer {\n  display: flex !important;\n  gap: 12px !important;\n  padding: 16px 20px !important;\n  border-top: 1px solid var(--border2) !important;\n  background: var(--c-white) !important;\n}\n\n.filters-drawer-btn-reset {\n  flex: 1 !important;\n  background: transparent !important;\n  border: 1px solid var(--ui-border-input) !important;\n  color: var(--c-black) !important;\n  font-weight: 500 !important;\n  height: 36px !important;\n  border-radius: 8px !important;\n  transition: all 0.15s ease !important;\n  cursor: pointer !important;\n}\n\n.filters-drawer-btn-reset:hover {\n  background: var(--c-white) !important;\n  border-color: var(--border-color-strong) !important;\n}\n\n.filters-drawer-btn-apply {\n  flex: 1 !important;\n  background: var(--c-neon) !important;\n  border: none !important;\n  color: var(--c-black) !important;\n  font-weight: 500 !important;\n  height: 36px !important;\n  border-radius: 8px !important;\n  transition: all 0.15s ease !important;\n  cursor: pointer !important;\n}\n\n.filters-drawer-btn-apply:hover {\n  background-color: var(--neon-btn-bg-hover) !important;\n  background: var(--neon-btn-bg-hover) !important;\n  color: var(--c-black) !important;\n  transform: translateY(-1px);\n}\n\n.filters-drawer-btn-apply:active {\n  transform: translateY(0);\n}\n\n/* Answers (RAG) — same drawer shell as FiltersDrawer; fields live in accordion content */\n.filters-details-drawer .filters-drawer-summary-bar {\n  display: grid;\n  gap: var(--space-1);\n  padding: var(--space-3) var(--space-5);\n  border-bottom: 1px solid var(--border2);\n  background: var(--bar-track-bg);\n}\n\n.filters-details-drawer .filters-drawer-summary-title {\n  color: var(--c-black);\n  font-size: var(--fs-sm);\n  font-weight: 500;\n}\n\n.filters-details-drawer .filters-drawer-summary-sub {\n  color: var(--text2);\n  font-size: calc(var(--fs-sm) - 1px);\n  line-height: 1.35;\n}\n\n.answers-shell > .drawer-overlay.open {\n  z-index: 1100;\n}\n\n.answers-shell > .details-drawer.filters-details-drawer {\n  z-index: 1101;\n}\n\n.filters-details-drawer .form-group {\n  position: relative;\n  margin: 0;\n  padding: var(--space-3) var(--space-5);\n  border-bottom: 1px solid var(--border2);\n}\n\n.filters-details-drawer .form-group > label,\n.filters-details-drawer .form-group > .filters-drawer-label {\n  display: block;\n  margin: 0 0 var(--space-2);\n}\n\n.filters-details-drawer .rag-date-range-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--space-2);\n}\n\n.filters-details-drawer .rag-date-field {\n  min-width: 0;\n}\n\n.filters-details-drawer .rag-date-field label {\n  display: block;\n  margin: 0 0 var(--space-2);\n  color: var(--text3);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.filters-details-drawer .rag-objections-dropdown,\n.filters-details-drawer .rag-date-field input,\n.filters-details-drawer .rag-multiselect {\n  width: 100%;\n  min-height: calc(var(--space-6) + var(--space-2));\n  border: 1px solid var(--border2);\n  border-radius: var(--border-radius-md);\n  background: var(--c-white);\n  color: var(--c-black);\n  font-size: var(--fs-sm);\n}\n\n.filters-details-drawer .rag-date-field input,\n.filters-details-drawer .rag-objections-dropdown {\n  padding: 0 var(--space-3);\n}\n\n.filters-details-drawer .rag-multiselect {\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  padding: 0;\n  cursor: pointer;\n  text-align: left;\n}\n\n.filters-details-drawer .rag-multiselect:hover,\n.filters-details-drawer .rag-multiselect.p-focus,\n.filters-details-drawer .rag-objections-dropdown:focus,\n.filters-details-drawer .rag-date-field input:focus {\n  border-color: color-mix(in srgb, var(--c-teal-active) 38%, transparent);\n  box-shadow: 0 0 0 var(--space-2) color-mix(in srgb, var(--c-teal-active) 8%, transparent);\n  outline: none;\n}\n\n.filters-details-drawer .p-multiselect-label {\n  min-width: 0;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 5px;\n  padding: var(--space-2);\n}\n\n.filters-details-drawer .rag-multiselect-trigger {\n  width: calc(var(--space-6) + var(--space-2));\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text3);\n}\n\n.filters-details-drawer .p-multiselect-token,\n.filters-details-drawer .rag-multiselect-more-label,\n.filters-details-drawer .rag-multiselect-clear-all {\n  display: inline-flex;\n  align-items: center;\n  min-height: calc(var(--space-4) + var(--space-3));\n  border-radius: var(--border-radius-pill);\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.filters-details-drawer .p-multiselect-token {\n  max-width: 100%;\n  gap: var(--space-2);\n  padding: 0 var(--space-2);\n  border: 1px solid color-mix(in srgb, var(--c-teal-active) 18%, transparent);\n  background: color-mix(in srgb, var(--c-teal-active) 8%, transparent);\n  color: var(--c-teal-active);\n}\n\n.filters-details-drawer .p-multiselect-token-label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.filters-details-drawer .p-multiselect-token-icon,\n.filters-details-drawer .rag-multiselect-clear-all {\n  color: var(--text2);\n  cursor: pointer;\n}\n\n.filters-details-drawer .rag-multiselect-placeholder-text {\n  color: var(--text3);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n.filters-details-drawer .rag-multiselect-more-label {\n  padding: 0 var(--space-2);\n  background: var(--bar-track-bg);\n  color: var(--text2);\n}\n\n.filters-details-drawer .rag-multiselect-panel {\n  position: absolute;\n  left: var(--space-5);\n  right: var(--space-5);\n  top: calc(100% - var(--space-3));\n  z-index: 1200;\n  overflow: hidden;\n  border: 1px solid var(--border2);\n  border-radius: var(--border-radius-lg);\n  background: var(--c-white);\n  box-shadow: 0 var(--space-4) calc(var(--space-7) + var(--space-2)) color-mix(in srgb, var(--c-black) 12%, transparent);\n}\n\n.filters-details-drawer .rag-multiselect-search {\n  width: 100%;\n  min-height: calc(var(--space-7) + var(--space-1));\n  border: none;\n  border-bottom: 1px solid var(--border2);\n  outline: none;\n  padding: 0 var(--space-3);\n  color: var(--c-black);\n  font-size: var(--fs-sm);\n}\n\n.filters-details-drawer .rag-multiselect-options {\n  max-height: 210px;\n  overflow-y: auto;\n  padding: var(--space-2);\n}\n\n.filters-details-drawer .rag-multiselect-option {\n  min-height: calc(var(--space-6) + var(--space-2));\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  border-radius: var(--border-radius);\n  color: var(--c-black);\n  cursor: pointer;\n  font-size: var(--fs-sm);\n  padding: var(--space-2) 7px;\n}\n\n.filters-details-drawer .rag-multiselect-option:hover {\n  background: color-mix(in srgb, var(--c-teal-active) 8%, transparent);\n}\n\n.filters-details-drawer .rag-multiselect-empty {\n  padding: var(--space-3);\n  color: var(--text2);\n  font-size: calc(var(--fs-base) - 1px);\n}\n\n/* Clear All Filters Button Styling - Matching Filters Button Style */\n.btn-clear-filters {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  height: 36px !important;\n  padding: 0 16px !important;\n  border-radius: 8px !important;\n  border: 1px solid var(--border) !important;\n  background: var(--c-white) !important;\n  color: var(--c-black) !important;\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  text-decoration: none !important;\n  cursor: pointer !important;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;\n  box-sizing: border-box !important;\n}\n\n.btn-clear-filters-icon {\n  display: flex !important;\n  align-items: center !important;\n  color: var(--c-black) !important;\n  transition: all 0.2s ease !important;\n}\n\n.btn-clear-filters:hover {\n  background: var(--c-black) !important;\n  /* Turns solid black on hover */\n  border-color: var(--c-black) !important;\n  color: var(--c-white) !important;\n  /* Turns text white on hover */\n}\n\n.btn-clear-filters:hover .btn-clear-filters-icon {\n  transform: scale(1.1) rotate(90deg) !important;\n  color: var(--c-white) !important;\n  /* Turns close icon white on hover */\n}\n\n/* Filters button — neon yellow toolbar control */\n.btn-filters,\n.filings-style-18 {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 6px !important;\n  height: 36px !important;\n  padding: 0 16px !important;\n  border-radius: 8px !important;\n  border: none !important;\n  /* Removes the border completely */\n  background: var(--c-neon) !important;\n  /* Signature Comply Logo Neon Yellow (var(--c-neon)) */\n  color: var(--c-black) !important;\n  /* Dark black text by default for perfect contrast */\n  font-size: 12px !important;\n  font-weight: 500 !important;\n  /* Semi-bold for clean visibility on neon */\n  cursor: pointer !important;\n  transition: background-color 0.2s ease, transform 0.2s ease, color 0.2s ease !important;\n  box-sizing: border-box !important;\n}\n\n.configure-btn:hover,\n.add-btn:hover:not(:disabled),\n.btn-filters:hover:not(.btn-primary),\n.filings-style-18:hover,\nbutton.btn.btn-sm.btn-filters:hover:not(.btn-primary),\nbutton.btn.btn-filters:hover:not(.btn-primary),\nbutton.btn.filings-style-18:hover,\n.filters-drawer-btn-apply:hover,\nbutton.btn.btn-sm.filters-drawer-btn-apply:hover {\n  background-color: var(--neon-btn-bg-hover) !important;\n  background: var(--neon-btn-bg-hover) !important;\n  color: var(--c-black) !important;\n  transform: translateY(-1px) !important;\n}\n\n.configure-btn:active,\n.add-btn:active:not(:disabled),\n.btn-filters:active:not(.btn-primary),\nbutton.btn.btn-filters:active:not(.btn-primary),\n.filters-drawer-btn-apply:active,\nbutton.btn.btn-sm.filters-drawer-btn-apply:active {\n  transform: translateY(0) !important;\n}\n\n.btn-filters svg,\n.filings-style-18 svg {\n  color: var(--c-black) !important;\n  /* Dark black icon by default */\n  transition: color 0.2s ease !important;\n}\n\n.btn-filters:hover svg,\n.filings-style-18:hover svg {\n  color: var(--c-black) !important;\n  /* Retains icon black on hover */\n}\n\n/* Active-filter indicator dot on filters button */\n.btn-filters-dot,\n.filings-style-19 {\n  background-color: var(--c-black) !important;\n  /* Black dot by default against neon yellow background */\n  width: 6px !important;\n  height: 6px !important;\n  border-radius: 50% !important;\n  display: inline-block !important;\n  margin-left: 6px !important;\n  transition: background-color 0.15s ease !important;\n}\n\n/* The applied indicator dot naturally retains its default black color for flawless visibility against the neon yellow background across all hover/active states. */\n\n/* Filters open (black control) — white indicator dot */\n.btn.btn-sm.btn-primary.btn-filters .btn-filters-dot,\nbutton.btn.btn-sm.btn-primary.btn-filters .btn-filters-dot {\n  background-color: var(--c-white) !important;\n}\n\n/* Filters drawer open — black control (pairs with PageHeader / Filings when panel is active) */\n.btn.btn-sm.btn-primary.btn-filters,\nbutton.btn.btn-sm.btn-primary.btn-filters {\n  background: var(--ink-emphasis) !important;\n  color: var(--c-white) !important;\n  border: none !important;\n}\n\n.btn.btn-sm.btn-primary.btn-filters svg,\nbutton.btn.btn-sm.btn-primary.btn-filters svg {\n  color: var(--c-white) !important;\n}\n\n.btn.btn-sm.btn-primary.btn-filters:hover,\nbutton.btn.btn-sm.btn-primary.btn-filters:hover {\n  background: var(--ink-muted) !important;\n  color: var(--c-white) !important;\n}\n\n.btn.btn-sm.btn-primary.btn-filters:hover svg,\nbutton.btn.btn-sm.btn-primary.btn-filters:hover svg {\n  color: var(--c-white) !important;\n}\n\n/* Toolbar square dismiss — next to Filters (e.g. Answers back) */\n.answers-shell-header .btn-icon-dismiss {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  padding: 0;\n  border-radius: 8px;\n  border: 1px solid var(--border2);\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n.answers-shell-header .btn-icon-dismiss:hover {\n  border-color: var(--text3);\n  color: var(--c-black);\n  background: var(--c-white);\n}\n\n/* Filters drawer date inputs — do not use .filter-select (absolute overlay for toolbar selects) */\n.filters-date-input {\n  position: static;\n  width: auto;\n  min-width: 0;\n  height: 36px;\n  flex: 0 0 auto;\n  padding: 0 10px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-sm);\n  box-sizing: border-box;\n  cursor: pointer;\n  appearance: none;\n  outline: none;\n  z-index: auto;\n}\n\n.filters-date-input:focus {\n  border-color: var(--c-black);\n}\n\n.filters-date-range-item .filters-date-range-header {\n  cursor: default;\n  justify-content: flex-start !important;\n  height: 52px !important;\n  min-height: 52px !important;\n  padding: 0 20px !important;\n  gap: 12px !important;\n}\n\n.filters-date-range-item .filters-date-range-header .accordion-header-left {\n  width: auto;\n  flex-shrink: 0;\n}\n\n.filters-date-range-item .filters-date-range-controls {\n  flex: 1;\n  min-width: 0;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: flex-start !important;\n  height: 100% !important;\n}\n\n.filters-date-range-fields {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  width: 100%;\n}\n\n.filters-date-range-separator {\n  color: var(--text3);\n  font-size: 12px;\n  flex-shrink: 0;\n}\n\n.filters-date-range-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.filters-date-range-picker {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.filters-date-range-picker .react-datepicker-wrapper,\n.filters-date-range-picker .react-datepicker__input-container {\n  display: block;\n  width: 100%;\n}\n\n\n/* Filters Drawer Date Range Section */\n.static-filter-section {\n  margin-top: 16px;\n  padding-left: 16px;\n  padding-right: 16px;\n}\n\n.static-filter-section-title {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 12px;\n}\n\n.custom-date-input-wrapper {\n  position: relative;\n  width: 100%;\n  cursor: pointer;\n}\n\n.custom-date-input-icon {\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--c-black);\n  pointer-events: none;\n}\n\n.custom-date-input-field {\n  width: 100% !important;\n  height: 32px !important;\n  padding: 0 36px 0 12px !important;\n  box-sizing: border-box !important;\n  text-align: left !important;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  background-color: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  outline: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.custom-date-input-field:focus {\n  border-color: var(--c-black);\n  background-color: var(--c-white);\n}\n\n/* Animated State-Driven Detail Drawer: bidirectional interpolation for entrance and exit */\n.drawer {\n  width: 0 !important;\n  min-width: 0 !important;\n  flex-basis: 0 !important;\n  opacity: 0 !important;\n  border-left-color: transparent !important; /* Hide border when closed */\n  overflow: hidden;\n  transition: all 0.35s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n.drawer.drawer-open {\n  width: 360px !important;\n  min-width: 360px !important;\n  flex-basis: 360px !important;\n  opacity: 1 !important;\n  border-left-color: var(--border) !important;\n}\n\n/* Keep content rigid during flex width interpolation so text doesn't wrap/jitter */\n.drawer > * {\n  min-width: 360px;\n}\n\n/* Dropdown, datepicker, map tooltip */\n/* Custom premium design filter dropdown */\n.custom-dropdown-popover {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 0;\n  z-index: 9999;\n  background: var(--c-white);\n  border: 1px solid var(--text3);\n  border-radius: 8px;\n  box-shadow: var(--shadow-popover);\n  min-width: 230px;\n  max-width: 280px;\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-dropdown-popover::before {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 24px;\n  border-width: 6px;\n  border-style: solid;\n  border-color: transparent transparent var(--c-white) transparent;\n}\n\n.custom-dropdown-popover::after {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 23px;\n  border-width: 7px;\n  border-style: solid;\n  border-color: transparent transparent var(--text3) transparent;\n  z-index: -1;\n}\n\n.custom-dropdown-header {\n  background: var(--c-white);\n  padding: 8px 10px;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  border-bottom: 1px solid var(--border2);\n}\n\n.custom-dropdown-search-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: var(--c-white);\n  border: 1px solid var(--text3);\n  border-radius: 6px;\n  padding: 0 10px;\n  height: 28px;\n}\n\n.custom-dropdown-search-input {\n  border: none;\n  background: transparent;\n  outline: none;\n  font-size: 12px;\n  color: var(--c-black);\n  width: 100%;\n  padding-right: 18px;\n  font-family: inherit;\n}\n\n.custom-dropdown-search-icon {\n  position: absolute;\n  right: 10px;\n  color: var(--text2);\n  pointer-events: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.custom-dropdown-list {\n  max-height: 200px;\n  overflow-y: auto;\n  padding: 4px 0;\n}\n\n/* Slim scrollbar design */\n.custom-dropdown-list::-webkit-scrollbar {\n  width: 10px;\n}\n\n.custom-dropdown-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-dropdown-list::-webkit-scrollbar-thumb {\n  background: var(--border2);\n  border-radius: 9999px;\n}\n\n.custom-dropdown-list::-webkit-scrollbar-thumb:hover {\n  background: var(--text2);\n}\n\n.custom-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  font-size: 12px;\n  color: var(--c-black) !important;\n  cursor: pointer;\n  transition: background 0.1s ease;\n}\n\n.custom-dropdown-item:hover {\n  background: var(--c-white);\n}\n\n.custom-dropdown-item.select-all {\n  font-weight: 500;\n  color: var(--c-black);\n  border-bottom: 1px solid var(--c-white);\n}\n\n.custom-dropdown-checkbox {\n  appearance: none;\n  -webkit-appearance: none;\n  width: 14px;\n  height: 14px;\n  border: 1.5px solid var(--text3);\n  border-radius: 3px;\n  outline: none;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--c-white);\n  flex-shrink: 0;\n  position: relative;\n  transition: all 0.1s ease;\n}\n\n.custom-dropdown-checkbox:checked {\n  background-color: var(--c-black);\n  border-color: var(--c-black);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='4' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='20 6 9 17 4 12'%3E%3C/polyline%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 75%;\n}\n\n/* --- Custom Premium DatePicker Theme --- */\n.react-datepicker {\n  font-family: inherit !important;\n  background-color: var(--c-white) !important;\n  border: 1px solid var(--text3) !important;\n  border-radius: 8px !important;\n  box-shadow: var(--shadow-popover) !important;\n  overflow: hidden !important;\n  padding: 0 !important;\n}\n\n.react-datepicker__month-container {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n\n@keyframes calendarMonthIn {\n  0% {\n    opacity: 0.3;\n    transform: scale(0.98);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n.react-datepicker__month {\n  margin: 12px 14px 14px 14px !important;\n  animation: calendarMonthIn 0.22s cubic-bezier(0.2, 0.8, 0.2, 1) forwards !important; /* Seamless re-render animation */\n}\n\n.react-datepicker__children-container {\n  width: 100% !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n\n.react-datepicker__header {\n  background-color: var(--c-white) !important;\n  border-bottom: 1px solid var(--border2) !important;\n  padding-top: 12px !important;\n  padding-bottom: 8px !important;\n  border-top-left-radius: 8px !important;\n  border-top-right-radius: 8px !important;\n}\n\n.react-datepicker__current-month {\n  display: none !important;\n  /* Hide redundant duplicate title now that interactive selectors are enabled */\n}\n\n/* Premium Interactive Dropdown Capsules */\n.react-datepicker__header__dropdown {\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n  gap: 8px !important;\n  width: 100% !important;\n}\n\n/* Group the sub-dropdown container modules closer together to cluster in center */\n.react-datepicker__month-dropdown-container,\n.react-datepicker__year-dropdown-container {\n  flex: 0 0 auto !important;\n  display: inline-block !important;\n  margin: 0 2px !important;\n}\n\n/* Ultimate High-Fidelity Popover Menus */\n.react-datepicker__month-dropdown,\n.react-datepicker__year-dropdown {\n  background-color: var(--c-white) !important;\n  background: var(--c-white) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 8px !important;\n  box-shadow: var(--shadow-popover) !important;\n  padding: 6px !important;\n  z-index: 999 !important;\n  min-width: 120px !important;\n  max-height: 240px !important;\n  overflow-y: auto !important;\n  overflow-x: hidden !important;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Elegant Micro-Scrollbar for month/year selectors */\n.react-datepicker__month-dropdown::-webkit-scrollbar,\n.react-datepicker__year-dropdown::-webkit-scrollbar {\n  width: 4px !important;\n}\n.react-datepicker__month-dropdown::-webkit-scrollbar-track,\n.react-datepicker__year-dropdown::-webkit-scrollbar-track {\n  background: transparent !important;\n}\n.react-datepicker__month-dropdown::-webkit-scrollbar-thumb,\n.react-datepicker__year-dropdown::-webkit-scrollbar-thumb {\n  background-color: var(--text3) !important;\n  border-radius: 4px !important;\n}\n\n.react-datepicker__month-option,\n.react-datepicker__year-option {\n  padding: 6px 12px !important;\n  font-size: 12.5px !important;\n  font-weight: 450 !important;\n  color: var(--text2) !important;\n  line-height: 1.4 !important;\n  cursor: pointer !important;\n  transition: all 0.12s ease !important;\n  text-align: center !important;\n  border-radius: 5px !important;\n  margin: 1px 0 !important;\n  outline: none !important; /* Terminate default heavy browser focus rings */\n}\n\n.react-datepicker__month-option:hover,\n.react-datepicker__year-option:hover {\n  background-color: var(--c-white) !important;\n  color: var(--c-black) !important;\n}\n\n.react-datepicker__month-option--selected_month,\n.react-datepicker__year-option--selected_year {\n  background-color: var(--border) !important;\n  color: var(--c-black) !important;\n  font-weight: 600 !important;\n}\n\n/* Clean standard item ticks if they exist */\n.react-datepicker__month-option--selected,\n.react-datepicker__year-option--selected {\n  display: none !important; /* Text alignment and explicit background are superior anchors */\n}\n\n/* Nuke the legacy navigation footer/header artifacts that now clash with our native scrolling engine */\n.react-datepicker__navigation--years {\n  display: none !important;\n}\n\n.react-datepicker__month-read-view,\n.react-datepicker__year-read-view {\n  display: inline-flex !important;\n  align-items: center !important;\n  flex-direction: row-reverse !important; /* Forces dropdown span to position visually on the RIGHT of the text */\n  justify-content: center !important;\n  background: var(--c-white) !important;\n  border: 1px solid var(--border) !important;\n  border-radius: 6px !important;\n  padding: 4px 10px !important;\n  font-size: 13px !important;\n  font-weight: 500 !important;\n  color: var(--c-black) !important;\n  cursor: pointer !important;\n  transition: all 0.15s ease !important;\n  min-width: 60px !important;\n  height: 28px !important;\n  box-sizing: border-box !important;\n}\n\n.react-datepicker__month-read-view:hover,\n.react-datepicker__year-read-view:hover {\n  background: var(--c-white) !important;\n  border-color: var(--text3) !important;\n  color: var(--c-black) !important;\n}\n\n/* Custom Arrow Inside Capsules */\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__year-read-view--down-arrow {\n  display: inline-block !important;\n  position: static !important;\n  vertical-align: middle !important;\n  margin-left: 6px !important;\n  margin-right: 0 !important;\n  margin-top: -3px !important;\n  border-color: var(--text3) !important;\n  border-style: solid !important;\n  border-width: 1.5px 1.5px 0 0 !important;\n  height: 4.5px !important;\n  width: 4.5px !important;\n  transform: rotate(135deg) !important;\n}\n\n.react-datepicker__day-name {\n  color: var(--text2) !important;\n  opacity: 0.7 !important; /* Softened modern layout emphasis */\n  font-weight: 400 !important; /* Slightly thinner for premium layout feel */\n  font-size: 10.5px !important;\n  text-transform: uppercase !important;\n  letter-spacing: 0.02em !important;\n  width: 34px !important;\n  line-height: 32px !important;\n  margin: 2px 0 !important;\n  display: inline-block !important;\n}\n\n/* Day Cells */\n.react-datepicker__day {\n  color: var(--text2) !important;\n  font-size: 11.5px !important;\n  width: 34px !important;\n  line-height: 32px !important;\n  margin: 2px 0 !important;\n  border-radius: 6px !important;\n  transition: all 0.1s ease !important;\n  display: inline-block !important;\n}\n\n.react-datepicker__day:hover {\n  background-color: var(--c-white) !important;\n  color: var(--c-black) !important;\n}\n\n.react-datepicker__day--outside-month {\n  color: var(--text3) !important;\n}\n\n/* Selected Days & Range Days */\n.react-datepicker .react-datepicker__day--selected,\n.react-datepicker .react-datepicker__day--keyboard-selected {\n  background-color: var(--c-neon) !important;\n  background: var(--c-neon) !important;\n  color: var(--c-black) !important;\n  font-weight: 500 !important;\n}\n\n.react-datepicker .react-datepicker__day--in-range,\n.react-datepicker .react-datepicker__day--in-selecting-range {\n  background-color: var(--bg-neon-soft) !important;\n  background: var(--bg-neon-soft) !important;\n  color: var(--c-black) !important;\n  border-radius: 0 !important;\n}\n\n.react-datepicker .react-datepicker__day--range-start,\n.react-datepicker .react-datepicker__day--selecting-range-start {\n  background-color: var(--c-neon) !important;\n  background: var(--c-neon) !important;\n  color: var(--c-black) !important;\n  border-radius: 0 !important;\n  border-top-left-radius: 6px !important;\n  border-bottom-left-radius: 6px !important;\n}\n\n.react-datepicker .react-datepicker__day--range-end,\n.react-datepicker .react-datepicker__day--selecting-range-end {\n  background-color: var(--ink-overlay) !important;\n  background: var(--ink-overlay) !important;\n  color: var(--c-white) !important;\n  border-radius: 0 !important;\n  border-top-right-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n}\n\n.react-datepicker .react-datepicker__day--selected:hover,\n.react-datepicker .react-datepicker__day--keyboard-selected:hover,\n.react-datepicker .react-datepicker__day--range-start:hover,\n.react-datepicker .react-datepicker__day--selecting-range-start:hover {\n  background-color: var(--c-neon) !important;\n  background: var(--c-neon) !important;\n  color: var(--c-black) !important;\n}\n\n.react-datepicker .react-datepicker__day--range-end:hover,\n.react-datepicker .react-datepicker__day--selecting-range-end:hover {\n  background-color: var(--ink-overlay) !important;\n  background: var(--ink-overlay) !important;\n  color: var(--c-white) !important;\n  border-radius: 0 !important;\n  border-top-right-radius: 6px !important;\n  border-bottom-right-radius: 6px !important;\n}\n\n.react-datepicker__day--disabled {\n  color: var(--text3) !important;\n  cursor: not-allowed !important;\n}\n\n/* Triangle navigation arrow */\n.react-datepicker__triangle {\n  display: none !important;\n}\n\n/* Navigation next/prev arrows */\n.react-datepicker__navigation {\n  top: 10px !important;\n}\n\n.react-datepicker__navigation-icon::before {\n  border-color: var(--border-color-strong) !important;\n  border-width: 2px 2px 0 0 !important;\n}\n\n/* Confirm Bar & Button */\n.calendar-confirm-bar {\n  margin: 0 !important;\n  width: 100% !important;\n  border-top: 1px solid var(--border2) !important;\n  background-color: var(--c-white) !important;\n  padding: 10px 12px !important;\n  border-bottom-left-radius: 8px !important;\n  border-bottom-right-radius: 8px !important;\n  box-sizing: border-box !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n}\n\n.calendar-confirm-bar .btn {\n  background-color: var(--c-neon) !important;\n  background: var(--c-neon) !important;\n  color: var(--c-black) !important;\n  border: none !important;\n  border-radius: 6px !important;\n  padding: 6px 14px !important;\n  font-size: 11.5px !important;\n  font-weight: 500 !important;\n  cursor: pointer !important;\n  transition: background-color 0.1s ease !important;\n}\n\n.calendar-confirm-bar .btn:hover {\n  background-color: var(--c-neon) !important;\n  background: var(--c-neon) !important;\n  color: var(--c-black) !important;\n}\n\n.calendar-confirm-bar .btn:disabled {\n  background-color: var(--border) !important;\n  background: var(--border) !important;\n  color: var(--text3) !important;\n  opacity: 0.65 !important;\n  cursor: not-allowed !important;\n}\n\n/* Custom Premium Close/Cancel Button inside Input */\n.react-datepicker__close-icon::after {\n  background-color: var(--c-black) !important;\n  border-radius: 6px !important;\n  font-size: 11px !important;\n  height: 18px !important;\n  width: 18px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0 !important;\n  line-height: 1 !important;\n  font-weight: 500 !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important; /* Dynamic global interaction curve */\n}\n\n.react-datepicker__close-icon:hover::after {\n  background-color: var(--c-black) !important;\n  transform: rotate(90deg) !important; /* Matched dynamic kinematics */\n}\n\n/* Quick Select Chips */\n.quick-select-chips-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 10px;\n}\n\n.quick-select-chip {\n  padding: 5px 10px;\n  font-size: 11px;\n  font-weight: 500;\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  background-color: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n\n.quick-select-chip:hover {\n  background-color: var(--surface-subtle-tint);\n  color: var(--c-black);\n}\n\n.quick-select-chip.is-selected {\n  border-color: var(--c-black);\n  background-color: var(--c-black);\n  color: var(--c-white);\n}\n\n/* Map Hover Tooltip Architecture */\n.map-hover-tooltip {\n  position: fixed;\n  background: var(--bg, var(--c-white));\n  color: var(--text, var(--c-black));\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  box-shadow: var(--shadow-elevated);\n  pointer-events: none;\n  z-index: 999999;\n  backdrop-filter: blur(8px);\n  border: 1px solid var(--border2, var(--border-panel));\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  max-width: min(420px, 90vw);\n  line-height: 1.45;\n  white-space: normal;\n  word-break: break-word;\n}\n\n/* App shell & shared page layout (from global.css) */\n.layout {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* Main */\n.main {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n}\n\n.body {\n  display: flex;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.table-area,\n.feed-area {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  position: relative;\n}\n\n/* Filing Timeline */\n.filing-timeline {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.ft-event {\n  display: flex;\n  gap: 12px;\n}\n\n.ft-dot-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 12px;\n  flex-shrink: 0;\n}\n\n.ft-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 2px solid var(--c-white);\n  box-shadow: 0 0 0 1px var(--border);\n  z-index: 2;\n  background: var(--text3);\n  margin-top: 4px;\n}\n\n.ft-line {\n  width: 2px;\n  flex: 1;\n  background: var(--border);\n  margin: -2px 0;\n}\n\n.ft-body {\n  flex: 1;\n  padding-bottom: 20px;\n}\n\n.ft-time {\n  font-size: 10px;\n  color: var(--text3);\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.ft-type {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 2px;\n}\n\n.ft-detail {\n  font-size: 11px;\n  color: var(--text2);\n  margin-top: 2px;\n}\n\n/* Two column */\n.two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n  flex-shrink: 0;\n}\n\n/* Change log */\n.change-item {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  padding: 11px 18px;\n  border-bottom: 1px solid var(--border);\n}\n\n.scrollable-changes {\n  max-height: 380px;\n  /* Adjusted to fit exactly 5 entries */\n  overflow-y: auto;\n}\n\n.change-item:last-child {\n  border-bottom: none;\n}\n\n.change-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 4px;\n  flex-shrink: 0;\n}\n\n.dot-approved {\n  background: var(--c-teal-active);\n}\n\n.dot-rejected {\n  background: var(--c-orange);\n}\n\n.dot-objection {\n  background: var(--c-orange);\n}\n\n.dot-document {\n  background: var(--c-purple-1);\n}\n\n.dot-status {\n  background: var(--c-blue-1);\n}\n\n.dot-new {\n  background: var(--text2);\n}\n\n.change-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.change-tn {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n}\n\n.change-company {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 1px;\n}\n\n.change-detail {\n  font-size: 11px;\n  color: var(--text2);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 280px;\n}\n\n.change-time {\n  font-size: 11px;\n  color: var(--text3);\n  white-space: nowrap;\n}\n\n/* State pills */\n.state-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px 18px;\n}\n\n.state-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding: 10px 14px;\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  min-width: 60px;\n}\n\n.state-code {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.state-count {\n  font-size: 11px;\n  color: var(--text2);\n}\n\n/* Analytics — toolbar aligns labels then controls (avoids flex-end drift vs competitor helper text) */\n.analytics-toolbar {\n  flex-shrink: 0;\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  padding: 12px 24px 14px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  box-shadow: 0 2px 8px color-mix(in srgb, var(--c-black) 6%, transparent);\n}\n\n.analytics-toolbar-grid {\n  display: grid;\n  grid-template-columns: minmax(240px, auto) minmax(280px, 1fr) auto;\n  column-gap: 20px;\n  row-gap: 6px;\n  align-items: stretch;\n}\n\n.analytics-toolbar-grid--two-col {\n  grid-template-columns: minmax(240px, auto) auto;\n}\n\n.analytics-toolbar-grid>.df-label {\n  margin: 0;\n  align-self: end;\n  line-height: 1.2;\n}\n\n.analytics-toolbar-grid>.analytics-toolbar-label-spacer {\n  visibility: hidden;\n  user-select: none;\n}\n\n.analytics-toolbar-select.filter-select {\n  max-width: none;\n  width: 100%;\n  min-width: 260px;\n  min-height: 40px;\n  padding: 8px 12px;\n  font-size: 13px;\n}\n\n.analytics-toolbar-loading {\n  display: inline-flex;\n  align-items: center;\n  min-height: 40px;\n}\n\n.analytics-toolbar-control-competitors {\n  min-width: 0;\n}\n\n.analytics-toolbar-actions {\n  display: flex;\n  align-items: stretch;\n}\n\n.analytics-toolbar-actions .btn {\n  align-self: stretch;\n  min-height: 40px;\n  display: inline-flex;\n  align-items: center;\n  white-space: nowrap;\n}\n\n.analytics-toolbar-hint {\n  margin: 10px 0 0;\n  padding: 0;\n  font-size: 11px;\n  color: var(--text3);\n  line-height: 1.4;\n  max-width: 960px;\n}\n\n@media (max-width: 760px) {\n  .analytics-toolbar {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n/* Changelog Specific Styles */\n.stats-strip {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  flex-shrink: 0;\n}\n\n.stat-strip-item {\n  flex: 1;\n  padding: 12px 18px;\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.stat-strip-item:last-child {\n  border-right: none;\n}\n\n.ssl-label {\n  font-size: 10px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.ssl-val {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--c-black);\n  letter-spacing: -0.5px;\n}\n\n.ssl-sub {\n  font-size: 11px;\n  color: var(--c-black);\n}\n\n.type-filters {\n  display: flex;\n  gap: 5px;\n  flex-wrap: wrap;\n  padding: 8px 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  flex-shrink: 0;\n}\n\n.type-chip {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  color: var(--c-black);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  user-select: none;\n}\n\n.type-chip:hover {\n  border-color: var(--border2);\n  background: var(--c-white);\n  color: var(--c-black);\n  transform: translateY(-1px);\n}\n\n.type-chip.active {\n  border-color: var(--c-black);\n  background: var(--c-black);\n  color: var(--c-white);\n  box-shadow: var(--shadow-chip);\n}\n\n.type-chip-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n}\n\n.type-chip-count {\n  font-size: 10px;\n  background: var(--c-white);\n  color: var(--c-black);\n  padding: 1px 6px;\n  border-radius: 10px;\n  margin-left: 2px;\n  font-weight: 500;\n  min-width: 16px;\n  text-align: center;\n}\n\n.pill {\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 500;\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 100%;\n}\n\n.type-chip.active .type-chip-count {\n  background: var(--surface-glass-faint);\n  color: var(--c-white);\n}\n\n.feed-area {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.feed {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.date-group-header {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  padding: 7px 20px;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--c-black);\n  background: var(--c-white);\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-transform: uppercase;\n}\n\n.event-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  padding: 12px 20px;\n  border-bottom: 1px solid var(--border);\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.event-row:hover {\n  background: var(--c-white);\n}\n\n.event-row.active {\n  background: var(--c-cyan-1);\n}\n\n/* Date Filters */\n.date-filters {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-left: 8px;\n}\n\n.df-group {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.df-label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.date-input {\n  font-family: var(--font);\n  background: var(--c-white);\n  border: 1px solid var(--border-color-strong);\n  border-radius: 8px !important;\n  padding: 0 10px;\n  height: 32px;\n  font-size: 12px !important;\n  color: var(--c-black);\n  outline: none;\n  transition: all 0.15s;\n  width: 175px;\n  box-sizing: border-box;\n}\n\n.date-input::placeholder {\n  font-family: var(--font);\n}\n\n.date-input:focus {\n  border-color: var(--c-black);\n}\n\n.calendar-confirm-bar {\n  padding: 10px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  justify-content: flex-end;\n  background: var(--c-white);\n}\n\n.state-pill-mini {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  padding: 3px 8px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.spm-code {\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.spm-count {\n  color: var(--c-black);\n}\n\n.spm-more {\n  font-size: 11px;\n  color: var(--text3);\n  align-self: center;\n  padding-left: 4px;\n}\n\n.event-type-col {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n  padding-top: 3px;\n  flex-shrink: 0;\n}\n\n.event-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.event-time {\n  font-size: 10px;\n  color: var(--text3);\n  white-space: nowrap;\n}\n\n.event-body {\n  flex: 1;\n  min-width: 0;\n}\n\n.event-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.event-tn {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.event-company {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.event-state {\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.event-change {\n  margin-top: 4px;\n}\n\n.event-change-type {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.event-values {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n  font-size: 11px;\n  flex-wrap: wrap;\n}\n\n.ev-old {\n  color: var(--c-black);\n  background: var(--c-white);\n  padding: 2px 7px;\n  border-radius: 3px;\n  border: 1px solid var(--border);\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ev-arrow {\n  color: var(--text3);\n}\n\n.ev-new {\n  color: var(--c-black);\n  background: var(--c-white);\n  padding: 2px 7px;\n  border-radius: 3px;\n  border: 1px solid var(--border2);\n  font-weight: 500;\n  max-width: 200px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ev-new.approved {\n  background: var(--c-aqua-mass);\n  color: var(--green-text);\n  border-color: var(--c-teal-2);\n}\n\n.ev-new.rejected {\n  background: var(--red-bg);\n  color: var(--red-text);\n  border-color: var(--c-orange);\n}\n\n.ev-new.objection {\n  background: var(--orange-bg);\n  color: var(--amber-text);\n  border-color: var(--c-orange);\n}\n\n.ev-new.document {\n  background: var(--c-purple-4);\n  color: var(--c-purple-1);\n  border-color: var(--c-purple-3);\n}\n\n.event-notes {\n  font-size: 11px;\n  color: var(--c-black);\n  margin-top: 3px;\n}\n\n.event-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  align-items: flex-end;\n  flex-shrink: 0;\n}\n\n.detail-panel {\n  width: 340px;\n  min-width: 340px;\n  background: var(--c-white);\n  border-left: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.dp-header {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  flex-shrink: 0;\n}\n\n.dp-tn {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.dp-company {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-top: 3px;\n}\n\n.dp-meta {\n  font-size: 11px;\n  color: var(--c-black);\n  margin-top: 2px;\n}\n\n.dp-close {\n  float: right;\n  color: var(--text3);\n  cursor: pointer;\n  font-size: 18px;\n  line-height: 1;\n  margin-top: -2px;\n}\n\n.dp-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.dp-section-title {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  margin-bottom: 8px;\n}\n\n.event-detail-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 12px 14px;\n}\n\n.edc-type {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edc-time {\n  font-size: 11px;\n  color: var(--text3);\n  margin-top: 3px;\n}\n\n.value-comparison {\n  margin-top: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.vc-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.vc-label {\n  font-size: 10px;\n  color: var(--text3);\n  width: 28px;\n  flex-shrink: 0;\n}\n\n.vc-val {\n  font-size: 11px;\n  padding: 3px 8px;\n  border-radius: 4px;\n  flex: 1;\n}\n\n.vc-old {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  color: var(--c-black);\n  text-decoration: line-through;\n}\n\n.vc-new {\n  background: var(--orange-bg);\n  border: 1px solid var(--c-orange);\n  color: var(--amber-text);\n  font-weight: 500;\n}\n\n.vc-new.approved {\n  background: var(--c-aqua-mass);\n  border-color: var(--c-teal-2);\n  color: var(--green-text);\n}\n\n.vc-new.rejected {\n  background: var(--red-bg);\n  border-color: var(--c-orange);\n  color: var(--red-text);\n}\n\n.vc-notes {\n  font-size: 11px;\n  color: var(--c-black);\n  margin-top: 6px;\n  padding: 6px 8px;\n  background: var(--c-white);\n  border-radius: 4px;\n  border: 1px solid var(--border);\n  line-height: 1.5;\n}\n\n.dp-actions {\n  padding: 12px 16px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.dp-actions .btn {\n  flex: 1;\n  text-align: center;\n  font-size: 12px;\n}\n\n/* Table Column Widths */\n.col-tn {\n  /* Dynamic width */\n}\n\n.col-company {\n  /* No fixed width */\n}\n\n.col-state {\n  /* Dynamic width */\n}\n\n.col-type {\n  /* Dynamic width */\n}\n\n.col-status {\n  /* Dynamic width */\n}\n\n.col-date {\n  width: 100px;\n}\n\n.col-count {\n  width: 65px;\n  text-align: center;\n}\n\n.col-zip {\n  width: 65px;\n  text-align: center;\n}\n\ntable {\n  table-layout: fixed;\n}\n\ntd,\nth {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Pagination */\n/* .pagination {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 20px;\n  background: var(--c-white);\n  border-top: 1px solid var(--border);\n}\n\n.pagination-sticky {\n  position: sticky;\n  bottom: 0;\n  background: var(--c-white);\n  border-top: 1px solid var(--border);\n  box-shadow: 0 -2px 10px var(--surface-pressed-tint);\n  z-index: 50;\n}\n\n.pg-info {\n  font-size: 12px;\n  color: var(--c-black);\n}\n\n.pg-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.pg-btn {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  border: 1px solid var(--border-color-strong);\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.1s;\n}\n\n.pg-btn:hover:not(.active):not(:disabled) {\n  background: var(--text2);\n  color: var(--c-white);\n  border-color: var(--border-color-strong);\n}\n\n.pg-btn.active {\n  background: var(--c-white);\n  color: var(--ink-emphasis);\n  border: 1px solid var(--border-color-strong);\n}\n\n.pg-btn.active:hover {\n  background: var(--c-neon);\n  border: 1px solid var(--border-color-strong);\n}\n\n.pg-btn:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.pg-select {\n  font-family: var(--font);\n  font-size: 11px;\n  padding: 0 20px 0 4px;\n  border: 1px solid var(--border-color-strong);\n  border-radius: 6px;\n  background: var(--c-white);\n  cursor: pointer;\n  height: 28px;\n  box-sizing: border-box;\n  transition: all 0.15s;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='%236B6960' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 6px center;\n  background-size: 8px 5px;\n}\n\n.pg-select:hover {\n  background-color: var(--ink-emphasis);\n  color: var(--c-white);\n  border-color: var(--ink-emphasis);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='5' viewBox='0 0 8 5' fill='none'%3E%3Cpath d='M1 1L4 4L7 1' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n} */\n\n/* Role Switcher */\n.role-switcher {\n  margin: 16px 20px;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n}\n\n.rs-label {\n  font-size: 10px;\n  font-weight: 600;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 8px;\n}\n\n.rs-group {\n  display: flex;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 2px;\n}\n\n.rs-btn {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 6px 4px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text2);\n  cursor: pointer;\n  border-radius: 4px;\n  transition: all 0.15s;\n}\n\n.rs-btn.active {\n  background: var(--c-white);\n  color: var(--c-black);\n  box-shadow: var(--shadow-control);\n}\n\n/* Filing Mini Summary */\n.filing-mini {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.fm-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.fm-label {\n  font-size: 11px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  font-weight: 500;\n}\n\n.fm-val {\n  font-size: 12px;\n  color: var(--c-black);\n  font-weight: 500;\n  text-align: right;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Detail Panel Extras */\n.detail-panel {\n  width: 400px;\n  background: var(--c-white);\n  border-left: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n}\n\n.dp-header {\n  padding: 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.dp-close {\n  float: right;\n  cursor: pointer;\n  color: var(--text3);\n}\n\n.dp-tn {\n  font-family: var(--mono);\n  font-size: 12px;\n  color: var(--c-blue-1);\n}\n\n.dp-company {\n  font-size: 18px;\n  font-weight: 600;\n  margin-top: 4px;\n}\n\n.dp-meta {\n  font-size: 12px;\n  color: var(--text3);\n  margin-top: 2px;\n}\n\n.dp-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n.dp-section-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  margin-bottom: 12px;\n  margin-top: 20px;\n}\n\n.dp-section-title:first-child {\n  margin-top: 0;\n}\n\n.dp-actions {\n  padding: 16px 20px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 12px;\n  background: var(--c-white);\n}\n\n/* ── Objections Layout ── */\n.filing-list {\n  width: 280px;\n  min-width: 280px;\n  background: var(--c-white);\n  border-right: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.list-header {\n  padding: 12px 16px;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.list-header-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.list-search {\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--border);\n}\n\n.list-search input {\n  width: 100%;\n  font-family: var(--font);\n  font-size: 12px;\n  padding: 6px 10px;\n  border: 1px solid var(--border2);\n  border-radius: var(--radius);\n  background: var(--c-white);\n  color: var(--c-black);\n}\n\n.list-search input:focus {\n  outline: none;\n  border-color: var(--c-black);\n}\n\n.list-items {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.filing-item {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.filing-item:hover {\n  background: var(--c-white);\n}\n\n.filing-item.active {\n  background: var(--c-cyan-1);\n  border-left: 3px solid var(--c-blue-1);\n  padding-left: 11px;\n}\n\n.fi-tn {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.fi-co {\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 2px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.fi-meta {\n  display: flex;\n  gap: 5px;\n  margin-top: 5px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.fi-date {\n  font-size: 10px;\n  color: var(--text3);\n  margin-top: 2px;\n}\n\n.detail {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.detail-content {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.filing-header-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.fhc-top {\n  padding: 16px 20px;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.fhc-left {\n  flex: 1;\n}\n\n.fhc-tn {\n  font-family: var(--mono);\n  font-size: 12px;\n  color: var(--c-blue-1);\n  font-weight: 500;\n}\n\n.fhc-company {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-top: 4px;\n  letter-spacing: -0.3px;\n}\n\n.fhc-toi {\n  font-size: 12px;\n  color: var(--text2);\n  margin-top: 3px;\n}\n\n.fhc-meta {\n  display: flex;\n  gap: 0;\n  border-top: 1px solid var(--border);\n}\n\n.fhc-field {\n  flex: 1;\n  padding: 12px 16px;\n  border-right: 1px solid var(--border);\n}\n\n.fhc-field:last-child {\n  border-right: none;\n}\n\n.fhc-label {\n  font-size: 10px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.fhc-val {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-top: 3px;\n}\n\n.fhc-val.danger {\n  color: var(--c-orange);\n}\n\n.fhc-val.success {\n  color: var(--c-teal-active);\n}\n\n.timeline-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 16px 20px;\n}\n\n.timeline-title {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 14px;\n}\n\n.timeline {\n  display: flex;\n  align-items: flex-start;\n  position: relative;\n}\n\n.timeline::before {\n  content: '';\n  position: absolute;\n  top: 12px;\n  left: 12px;\n  right: 12px;\n  height: 1px;\n  background: var(--border);\n  z-index: 0;\n}\n\n.tl-step {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  position: relative;\n  z-index: 1;\n}\n\n.tl-dot {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 11px;\n  font-weight: 600;\n  border: 2px solid transparent;\n}\n\n.tl-done {\n  background: var(--c-aqua-mass);\n  color: var(--green-text);\n  border-color: var(--c-teal-active);\n}\n\n.tl-active {\n  background: var(--orange-bg);\n  color: var(--amber-text);\n  border-color: var(--c-orange);\n}\n\n.tl-pending {\n  background: var(--c-white);\n  color: var(--text3);\n  border-color: var(--border2);\n}\n\n.tl-label {\n  font-size: 10px;\n  color: var(--text2);\n  text-align: center;\n  font-weight: 500;\n  line-height: 1.3;\n}\n\n.tl-date {\n  font-size: 10px;\n  color: var(--text3);\n  text-align: center;\n}\n\n.section-title {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.section-title::after {\n  content: '';\n  flex: 1;\n  height: 1px;\n  background: var(--border);\n}\n\n.obj-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.obj-card-header {\n  padding: 12px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: var(--c-white);\n  border-bottom: 1px solid var(--border);\n}\n\n.obj-card-num {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.obj-card-num-badge {\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: var(--red-bg);\n  color: var(--red-text);\n  font-size: 11px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.obj-card-num-badge.responded {\n  background: var(--c-aqua-mass);\n  color: var(--green-text);\n}\n\n.obj-card-body {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.text-block-label {\n  font-size: 10px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: var(--text3);\n  margin-bottom: 6px;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.text-block-label::before {\n  content: '';\n  width: 3px;\n  height: 12px;\n  border-radius: 2px;\n}\n\n.objection-label::before {\n  background: var(--c-orange);\n}\n\n.response-label::before {\n  background: var(--c-teal-active);\n}\n\n.related-label::before {\n  background: var(--c-orange);\n}\n\n.changed-items-label::before {\n  background: var(--c-purple-1);\n}\n\n.text-block {\n  font-size: 12px;\n  color: var(--c-black);\n  line-height: 1.7;\n  padding: 12px 14px;\n  background: var(--c-white);\n  border-radius: var(--radius);\n  border: 1px solid var(--border);\n}\n\n.no-response {\n  font-size: 12px;\n  color: var(--text3);\n  font-style: italic;\n  padding: 10px 14px;\n  background: var(--c-white);\n  border-radius: var(--radius);\n  border: 1px dashed var(--border2);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.divider {\n  height: 1px;\n  background: var(--border);\n  margin: 4px 0;\n}\n\n.intro-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n}\n\n.intro-header {\n  padding: 10px 16px;\n  background: var(--c-white);\n  border-bottom: 1px solid var(--border);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.intro-body {\n  padding: 14px 16px;\n  font-size: 12px;\n  color: var(--text2);\n  line-height: 1.7;\n}\n\n.stats-bar {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 10px;\n  margin-bottom: 4px;\n}\n\n.stat-mini {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 10px 14px;\n}\n\n.sm-label {\n  font-size: 10px;\n  color: var(--text3);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.sm-val {\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-top: 2px;\n  letter-spacing: -0.5px;\n}\n\n.letter-tabs {\n  display: flex;\n  gap: 0;\n  border-bottom: 1px solid var(--border);\n  background: var(--c-white);\n  padding: 0 20px;\n  flex-shrink: 0;\n}\n\n.letter-tab {\n  padding: 10px 16px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--text2);\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n  transition: all 0.15s;\n  white-space: nowrap;\n}\n\n.letter-tab:hover {\n  color: var(--c-black);\n}\n\n.letter-tab.active {\n  color: var(--c-black);\n  border-bottom-color: var(--c-black);\n}\n\n/* Shared primitives migrated from global.css (Tier 1+2) */\n.chart-thumb-bars {\n  display: flex;\n  align-items: flex-end;\n  gap: 6px;\n  height: 40px;\n  padding-bottom: 4px;\n}\n\n.chart-thumb-bars__bar {\n  width: 10px;\n  height: 60%;\n  background: linear-gradient(180deg, var(--c-black), var(--c-black));\n  border-radius: 2px;\n}\n\n.chart-thumb-bars__bar {\n  width: 10px;\n  height: 85%;\n  background: linear-gradient(180deg, var(--ink-emphasis), var(--ink-emphasis));\n  border-radius: 2px;\n}\n\n.chart-thumb-bars__bar {\n  width: 10px;\n  height: 40%;\n  background: linear-gradient(180deg, var(--c-blue-1), var(--text2));\n  border-radius: 2px;\n}\n\n.chart-thumb-bars__bar {\n  width: 10px;\n  height: 95%;\n  background: linear-gradient(180deg, var(--c-blue-1), var(--ink-half));\n  border-radius: 2px;\n}\n\n.chart-thumb-line {\n  overflow: visible;\n}\n\n.chart-thumb-dots {\n  position: relative;\n  width: 70px;\n  height: 40px;\n}\n\n.chart-thumb-dots__dot {\n  position: absolute;\n  left: 10px;\n  top: 20px;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-blue-1);\n  opacity: 0.8;\n}\n\n.chart-thumb-dots__dot {\n  position: absolute;\n  left: 25px;\n  top: 8px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--ink-muted);\n  opacity: 0.9;\n}\n\n.chart-thumb-dots__dot {\n  position: absolute;\n  left: 20px;\n  top: 25px;\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--c-black);\n  opacity: 0.7;\n}\n\n.chart-thumb-dots__dot {\n  position: absolute;\n  left: 40px;\n  top: 15px;\n  width: 9px;\n  height: 9px;\n  border-radius: 50%;\n  background: var(--ink-emphasis);\n  opacity: 0.8;\n}\n\n.chart-thumb-dots__dot {\n  position: absolute;\n  left: 55px;\n  top: 22px;\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--c-blue-1);\n  opacity: 0.6;\n}\n\n.chart-thumb-pie {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 5px solid var(--border);\n  border-top-color: var(--c-black);\n  border-right-color: var(--ink-emphasis);\n  transform: rotate(45deg);\n}\n\n.chart-thumb-area {\n  overflow: visible;\n}\n\n.chart-thumb-progress {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 70px;\n  justify-content: center;\n}\n\n.chart-thumb-progress__labels {\n  display: flex;\n  justify-content: space-between;\n  font-size: 9px;\n  color: var(--ink-emphasis);\n  font-weight: 500;\n}\n\n.chart-thumb-progress__track {\n  width: 100%;\n  height: 4px;\n  background: var(--surface-pressed-tint);\n  border-radius: 2px;\n  overflow: hidden;\n}\n\n.chart-thumb-progress__fill {\n  width: 98%;\n  height: 100%;\n  background: var(--ink-emphasis);\n  border-radius: 2px;\n}\n\n.chart-thumb-dual {\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n  height: 40px;\n}\n\n.chart-thumb-dual__group {\n  display: flex;\n  gap: 3px;\n  align-items: flex-end;\n  height: 100%;\n}\n\n.chart-thumb-dual__bar {\n  width: 6px;\n  height: 80%;\n  background: var(--ink-muted);\n  border-radius: 1.5px;\n}\n\n.chart-thumb-dual__bar {\n  width: 6px;\n  height: 50%;\n  background: var(--border);\n  border-radius: 1.5px;\n}\n\n.chart-thumb-dual__group {\n  display: flex;\n  gap: 3px;\n  align-items: flex-end;\n  height: 100%;\n}\n\n.chart-thumb-dual__bar {\n  width: 6px;\n  height: 95%;\n  background: var(--ink-muted);\n  border-radius: 1.5px;\n}\n\n.chart-thumb-dual__bar {\n  width: 6px;\n  height: 65%;\n  background: var(--border);\n  border-radius: 1.5px;\n}\n\n.chart-thumb-sentiment {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 70px;\n  justify-content: center;\n}\n\n.chart-thumb-sentiment__row {\n  display: flex;\n  justify-content: space-between;\n  font-size: 8px;\n  color: var(--text3);\n}\n\n.chart-thumb-sentiment__label {\n  color: var(--ink-emphasis);\n  font-weight: 500;\n}\n\n.chart-thumb-sentiment__track {\n  position: relative;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, var(--ink-muted), var(--c-blue-1), var(--ink-emphasis));\n  border-radius: 2px;\n}\n\n.chart-thumb-sentiment__fill {\n  position: absolute;\n  left: 75%;\n  top: -3px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--c-white);\n  border: 2px solid var(--c-black);\n  box-shadow: var(--shadow-control);\n}\n\n.analytics-workspace {\n  padding: 30px;\n  background: var(--c-white);\n  border-radius: 12px;\n  border: 1px solid var(--border-subtle);\n  margin-top: 20px;\n  box-shadow: 0 4px 20px var(--surface-faint-tint);\n}\n\n.analytics-workspace__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 25px;\n  border-bottom: 1px solid var(--border-subtle);\n  padding-bottom: 15px;\n}\n\n.analytics-workspace__badge-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.analytics-workspace__badge {\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n}\n\n.analytics-workspace__title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.analytics-workspace__sub {\n  margin: 5px 0 0 0;\n  color: var(--text2);\n  font-size: 14px;\n}\n\n.analytics-workspace__run-btn {\n  padding: 4px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n}\n\n.analytics-workspace__filters {\n  padding: 12px 15px;\n  background: var(--c-white);\n  border-radius: 8px;\n  border: 1px solid var(--border-subtle);\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-bottom: 25px;\n  align-items: center;\n}\n\n.analytics-workspace__select {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex: 1;\n  min-width: 120px;\n}\n\n.analytics-workspace__select-measure {\n  font-size: 11.5px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.analytics-workspace__select-input {\n  height: 32px;\n  font-size: 11.5px;\n}\n\n.analytics-workspace__select {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex: 1;\n  min-width: 120px;\n}\n\n.analytics-workspace__select-measure {\n  font-size: 11.5px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.analytics-workspace__select-input {\n  height: 32px;\n  font-size: 11.5px;\n}\n\n.analytics-workspace__select {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex: 1;\n  min-width: 120px;\n}\n\n.analytics-workspace__select-measure {\n  font-size: 11.5px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.analytics-workspace__select-input {\n  height: 32px;\n  font-size: 11.5px;\n}\n\n.analytics-workspace__select {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex: 1;\n  min-width: 120px;\n}\n\n.analytics-workspace__select-measure {\n  font-size: 11.5px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.analytics-workspace__select-input {\n  height: 32px;\n  font-size: 11.5px;\n}\n\n.analytics-workspace__select {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex: 1;\n  min-width: 120px;\n}\n\n.analytics-workspace__select-measure {\n  font-size: 11.5px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.analytics-workspace__select-input {\n  height: 32px;\n  font-size: 11.5px;\n}\n\n.analytics-workspace__simulate-btn {\n  height: 32px;\n  font-size: 12px;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  background: var(--c-white);\n  border-radius: 12px;\n  border: 1px solid var(--bar-track-bg);\n  padding: 40px;\n  margin-top: 20px;\n}\n\n.page-empty__icon {\n  padding: 16px;\n  border-radius: 50%;\n  margin-bottom: 16px;\n}\n\n.page-empty__title {\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin: 0 0 6px 0;\n}\n\n.page-empty__text {\n  font-size: 14px;\n  color: var(--text2);\n  margin: 0;\n  text-align: center;\n  max-width: 440px;\n  line-height: 1.5;\n}\n\n.report-results-grid {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr;\n  gap: 24px;\n  padding: 24px;\n  margin-top: 12px;\n  background: var(--c-white);\n  border-radius: 12px;\n  border: 1px solid var(--border-subtle);\n}\n\n.report-results-grid__chart-title {\n  font-size: 13px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: var(--c-black);\n  letter-spacing: 0.5px;\n  margin-bottom: 16px;\n}\n\n.report-results-grid__chart {\n  overflow: visible;\n}\n\n.report-results-grid__insights {\n  border-left: 1px solid var(--border-subtle);\n  padding-left: 24px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.report-results-grid__insights-title {\n  font-size: 15px;\n  font-weight: 500;\n  text-transform: uppercase;\n  color: var(--c-black);\n  letter-spacing: 0.5px;\n  margin-bottom: 24px;\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.insight-list {\n  padding-left: 0;\n  list-style-type: none;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  color: var(--ink-emphasis);\n  font-size: 14px;\n  line-height: 1.8;\n}\n\n.insight-list__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.insight-list__bullet {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-top: 8px;\n  flex-shrink: 0;\n}\n\n.insight-list__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.insight-list__bullet {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--c-black);\n  margin-top: 8px;\n  flex-shrink: 0;\n}\n\n.insight-list__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.insight-list__bullet {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background-color: var(--ink-emphasis);\n  margin-top: 8px;\n  flex-shrink: 0;\n}\n\n.analytics-page-body {\n  flex-direction: column;\n  align-items: stretch;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 24px;\n  min-height: 0;\n  background: var(--c-white);\n}\n\n.template-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 20px;\n}\n\n.template-card {\n  background: var(--c-white);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  padding: 20px;\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s, border-color 0.2s;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 220px;\n  box-shadow: 0 4px 6px -1px var(--surface-faint-tint), 0 2px 4px -1px var(--surface-faint-tint);\n}\n\n.template-card__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 14px;\n}\n\n.template-card__icon-wrap {\n  padding: 6px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n}\n\n.template-card__badge {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 9px;\n  font-weight: 500;\n  letter-spacing: 0.05em;\n}\n\n.template-card__title {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin: 0 0 4px 0;\n}\n\n.template-card__sub {\n  font-size: 11px;\n  color: var(--text3);\n  margin: 0 0 10px 0;\n}\n\n.template-card__desc {\n  font-size: 12px;\n  color: var(--text2);\n  line-height: 1.4;\n  margin: 0;\n}\n\n.template-card__footer {\n  margin-top: 15px;\n  border-top: 1px solid var(--bar-track-bg);\n  padding-top: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.template-card__cta {\n  font-size: 11px;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.analytics-back-row {\n  margin-bottom: 20px;\n}\n\n.analytics-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ink-emphasis);\n  cursor: pointer;\n  box-shadow: 0 1px 2px var(--surface-pressed-tint);\n  transition: background 0.2s;\n}\n\n.analytics-toolbar-panel {\n  background: var(--c-white);\n  border: 1px solid var(--border-subtle);\n  border-radius: 12px;\n  padding: 24px;\n  box-shadow: 0 4px 20px var(--shadow-ghost);\n}\n\n.analytics-toolbar-panel__grid {\n  display: grid;\n  gap: 20px;\n}\n\n.analytics-toolbar-panel__field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.analytics-toolbar-panel__label {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text2);\n  text-transform: uppercase;\n}\n\n.analytics-toolbar-panel__actions {\n  display: flex;\n  align-items: flex-end;\n}\n\n.analytics-toolbar-panel__run {\n  height: 38px;\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.changelog-stat--approvals {\n  color: var(--c-teal-active);\n}\n\n.changelog-stat--rejections {\n  color: var(--c-orange);\n}\n\n.changelog-stat--objections {\n  color: var(--c-orange);\n}\n\n.changelog-stat--documents {\n  color: var(--c-purple-1);\n}\n\n.table-pagination {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.table-pagination__control {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.table-pagination__label {\n  font-size: 11px;\n  color: var(--text3);\n}\n\n.pagination__pages {\n  display: flex;\n  gap: 4px;\n}\n\n.pagination__ellipsis {\n  font-size: 12px;\n  color: var(--text3);\n  padding: 0 4px;\n}\n\n.changelog-tracking {\n  font-family: var(--mono);\n  font-size: 11px;\n  color: var(--c-blue-1);\n}\n\n.changelog-highlight {\n  color: var(--c-orange);\n  font-weight: 500;\n}\n\n.changelog-pill-meta {\n  font-size: 10px;\n}\n\n.link-back {\n  transition: color 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  background: none;\n  border: none;\n  color: var(--text2);\n  cursor: pointer;\n  font-size: 11px;\n  padding: 0;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.link-back:hover {\n  color: var(--c-black);\n}\n\n.milestone-track {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: relative;\n  padding: 0 20px;\n}\n\n.milestone-track__line {\n  position: absolute;\n  left: 40px;\n  right: 40px;\n  top: 15px;\n  height: 2px;\n  background: var(--surface-pressed-tint);\n  z-index: 1;\n}\n\n.milestone-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  z-index: 2;\n  position: relative;\n}\n\n.milestone-step__dot {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.milestone-step__dot.pending {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  color: var(--text3);\n}\n\n.milestone-step__dot.submitted {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-decision);\n  color: var(--milestone-decision);\n  box-shadow: var(--shadow-teal-sm);\n}\n\n.milestone-step__dot.assigned {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-decision);\n  color: var(--milestone-decision);\n  box-shadow: var(--shadow-teal-sm);\n}\n\n.milestone-step__dot.objection-issued {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-objection);\n  color: var(--milestone-objection);\n  box-shadow: var(--shadow-orange-sm);\n}\n\n.milestone-step__dot.response-due {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-decision);\n  color: var(--milestone-decision);\n  box-shadow: var(--shadow-teal-sm);\n}\n\n.milestone-step__dot.in-review {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-decision);\n  color: var(--milestone-decision);\n  box-shadow: var(--shadow-teal-sm);\n}\n\n.milestone-step__dot.final-decision {\n  background: var(--c-white);\n  border: 2px solid var(--milestone-decision);\n  color: var(--milestone-decision);\n  box-shadow: var(--shadow-teal-sm);\n}\n\n.milestone-step__label {\n  font-size: 11px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.milestone-step__label.pending {\n  color: var(--text3);\n}\n\n.milestone-step__label.submitted {\n  color: var(--milestone-decision);\n}\n\n.milestone-step__label.assigned {\n  color: var(--milestone-decision);\n}\n\n.milestone-step__label.objection-issued {\n  color: var(--milestone-objection);\n}\n\n.milestone-step__label.response-due {\n  color: var(--milestone-decision);\n}\n\n.milestone-step__label.in-review {\n  color: var(--milestone-decision);\n}\n\n.milestone-step__label.final-decision {\n  color: var(--milestone-decision);\n}\n\n.milestone-step__date {\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.enhanced-timeline {\n  position: relative;\n}\n\n.page-empty {\n  text-align: center;\n  padding: 60px 0;\n}\n\n.page-empty__icon {\n  margin-bottom: 16px;\n}\n\n.page-empty__text {\n  color: var(--text3);\n  font-size: 14px;\n}\n\n.insights-panel {\n  min-height: 0;\n}\n\n.report-outer--flush {\n  padding: 0;\n}\n\n.report-page--flush {\n  margin: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n  margin-top: 0;\n  font-family: var(--font);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.kpi-strip {\n  display: flex;\n  align-items: center;\n}\n\n.kpi-strip__col {\n  flex: 1;\n}\n\n.kpi-strip__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.kpi-strip__label {\n  font-size: 11px;\n  color: var(--text2);\n  margin-bottom: 4px;\n}\n\n.kpi-strip__value {\n  font-size: 22px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.kpi-strip__aside {\n  text-align: right;\n}\n\n.kpi-strip-delta {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 10px;\n  font-weight: 500;\n}\n\n.kpi-strip-delta--up,\n.kpi-strip-delta--neutral {\n  background: var(--teal-tint);\n  color: var(--c-teal-active);\n}\n\n.kpi-strip-delta--down {\n  background: var(--red-bg);\n  color: var(--c-orange);\n}\n\n.kpi-strip-delta__hint {\n  font-size: 9px;\n  color: var(--text3);\n  margin-top: 4px;\n}\n\n.kpi-strip__divider {\n  width: 1px;\n  height: 40px;\n  background: var(--surface-pressed-tint);\n  margin: 0 32px;\n}\n\n.insights-row {\n  display: grid;\n  grid-template-columns: 1fr 1.2fr 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.metric-panel {\n  position: relative;\n  height: 180px;\n}\n\n.metric-panel__spacer {\n  position: absolute;\n  left: 100px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--surface-pressed-tint);\n}\n\n.metric-panel__list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 10px;\n}\n\n.metric-row {\n  display: flex;\n  align-items: center;\n}\n\n.metric-row__label {\n  width: 90px;\n  text-align: right;\n  font-size: 9px;\n  color: var(--text2);\n  padding-right: 10px;\n}\n\n.metric-row__track {\n  flex: 1;\n  height: 10px;\n  background: var(--surface-faint-tint);\n  border-radius: 2px;\n  position: relative;\n}\n\n.metric-row__fill {\n  height: 100%;\n  border-radius: 2px;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-chart-area {\n  height: 180px;\n  position: relative;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.metric-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.metric-bars__row {\n  display: flex;\n  align-items: center;\n}\n\n.metric-bars__label {\n  width: 70px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-bars__track {\n  flex: 1;\n  height: 16px;\n  background: var(--surface-faint-tint);\n  border-radius: 2px;\n  position: relative;\n}\n\n.metric-bars__fill {\n  height: 100%;\n  border-radius: 2px;\n  opacity: 0.8;\n}\n\n.metric-bars__value {\n  position: absolute;\n  left: 5px;\n  top: 2px;\n  font-size: 8px;\n}\n\n.insights-row {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-chart-area {\n  height: 200px;\n  position: relative;\n}\n\n.insights-chart-labels {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.insights-chart-labels__item {\n  font-size: 9px;\n  color: var(--text3);\n}\n\n.insights-chart-legend {\n  display: flex;\n  gap: 20px;\n  margin-top: 15px;\n}\n\n.insights-chart-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-chart-legend__swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-blue-1);\n}\n\n.insights-chart-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-chart-legend__swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-blue-2);\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-chart-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.insights-donut-legend {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 16px;\n  margin-top: 16px;\n  width: 100%;\n}\n\n.insights-donut-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-donut-legend__swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.insights-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.metric-panel {\n  position: relative;\n  height: 180px;\n}\n\n.metric-panel__list {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 10px;\n}\n\n.metric-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.metric-row__label {\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-row__track {\n  width: 100%;\n  height: 8px;\n  background: var(--surface-faint-tint);\n  border-radius: 4px;\n}\n\n.metric-row__fill {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-chart-area {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.insights-card {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-section-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.metric-bars {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.metric-bars__row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.metric-bars__label {\n  width: 60px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-bars__track {\n  flex: 1;\n  height: 6px;\n  background: var(--surface-faint-tint);\n  border-radius: 3px;\n}\n\n.metric-bars__fill {\n  height: 100%;\n  border-radius: 3px;\n}\n\n.insights-footer-note {\n  margin-top: 30px;\n}\n\n.insights-panel {\n  padding: 0;\n}\n\n.report-outer--flush {\n  margin: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.insights-row {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  position: relative;\n  height: 180px;\n}\n\n.metric-panel {\n  position: absolute;\n  left: 100px;\n  top: 0;\n  bottom: 0;\n  width: 1px;\n  background: var(--surface-pressed-tint);\n}\n\n.metric-panel__spacer {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 10px;\n}\n\n.metric-panel__list {\n  display: flex;\n  align-items: center;\n}\n\n.metric-row {\n  width: 90px;\n  text-align: right;\n  font-size: 9px;\n  color: var(--text2);\n  padding-right: 10px;\n}\n\n.metric-row__label {\n  flex: 1;\n  height: 10px;\n  background: var(--surface-faint-tint);\n  border-radius: 2px;\n  position: relative;\n}\n\n.metric-row__track {\n  height: 100%;\n  border-radius: 2px;\n}\n\n.metric-row__fill {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  height: 180px;\n  position: relative;\n}\n\n.insights-chart-area {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.insights-chart-placeholder {\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-chart-placeholder__bar {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.metric-bars {\n  display: flex;\n  align-items: center;\n}\n\n.metric-bars__row {\n  width: 70px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-bars__label {\n  flex: 1;\n  height: 16px;\n  background: var(--surface-faint-tint);\n  border-radius: 2px;\n  position: relative;\n}\n\n.metric-bars__track {\n  height: 100%;\n  border-radius: 2px;\n  opacity: 0.8;\n}\n\n.metric-bars__fill {\n  position: absolute;\n  left: 5px;\n  top: 2px;\n  font-size: 8px;\n}\n\n.metric-bars__value {\n  display: grid;\n  grid-template-columns: 1.6fr 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-row {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  height: 200px;\n  position: relative;\n}\n\n.insights-chart-area {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 10px;\n}\n\n.insights-chart-labels {\n  font-size: 9px;\n  color: var(--text3);\n}\n\n.insights-chart-labels__item {\n  display: flex;\n  gap: 20px;\n  margin-top: 15px;\n}\n\n.insights-chart-legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-chart-legend__item {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-blue-2);\n}\n\n.insights-chart-legend__swatch {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-chart-legend__item {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--c-blue-1);\n}\n\n.insights-chart-legend__swatch {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.insights-chart-area {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 16px;\n  margin-top: 16px;\n  width: 100%;\n}\n\n.insights-donut-legend {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-donut-legend__item {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n.insights-donut-legend__swatch {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-row {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  position: relative;\n  height: 180px;\n}\n\n.metric-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 10px;\n}\n\n.metric-panel__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.metric-row {\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-row__label {\n  width: 100%;\n  height: 8px;\n  background: var(--surface-faint-tint);\n  border-radius: 4px;\n}\n\n.metric-row__track {\n  height: 100%;\n  border-radius: 4px;\n}\n\n.metric-row__fill {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.insights-chart-area {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 16px;\n  justify-content: center;\n}\n\n.insights-pie-legend {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.insights-pie-legend__item {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n}\n\n.insights-pie-legend__swatch {\n  padding: 24px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-card {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.metric-bars {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.metric-bars__row {\n  width: 80px;\n  font-size: 9px;\n  color: var(--text2);\n}\n\n.metric-bars__label {\n  flex: 1;\n  height: 6px;\n  background: var(--surface-faint-tint);\n  border-radius: 3px;\n}\n\n.metric-bars__track {\n  height: 100%;\n  border-radius: 3px;\n}\n\n.metric-bars__fill {\n  margin-top: 30px;\n}\n\n.insights-panel {\n  padding: 0;\n}\n\n.report-outer--flush {\n  margin: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.insights-row {\n  padding: 16px;\n  position: relative;\n  background: var(--c-white);\n  border-radius: 12px;\n  border: 1px solid var(--border);\n}\n\n.insights-card {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.insights-section-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.metric-panel {\n  display: block;\n}\n\n.metric-panel__spacer {\n  padding: 16px;\n  position: relative;\n  background: var(--c-white);\n  border-radius: 12px;\n  border: 1px solid var(--border);\n}\n\n.metric-panel__list {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 24px;\n}\n\n.metric-row {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin: 0;\n  padding: 0;\n  border: none;\n}\n\n.metric-row__label {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.insights-card {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.insights-section-title {\n  padding: 16px;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  background: var(--c-white);\n}\n\n.insights-chart-area {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--c-black);\n  margin-bottom: 24px;\n}\n\n.insights-chart-labels {\n  position: relative;\n}\n\n.insights-pie-legend__item {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n}\n\n.insights-pie-legend__swatch {\n  text-align: center;\n}\n\n.insights-card {\n  color: var(--c-black);\n  margin-bottom: 8px;\n}\n\n.insights-section-title {\n  color: var(--text3);\n  font-size: 14px;\n}\n\n@keyframes filingsInsightsIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Opacity-only — use inside overflow scroll panels to avoid scrollbar / width glitches */\n@keyframes filingsInsightsFadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes filingsInsightsCardIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) scale(0.99);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.table-area.insights-panel,\n.table-area.alerts-panel,\n.table-area.filings-table-panel {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  padding: 0;\n}\n\n.body.insights-panel {\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  padding: 0;\n}\n\n.table-area.alerts-panel > .report-outer--embedded {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.table-area.alerts-panel .report-page > .report-card {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;\n}\n\n.forward-looking-alerts-panel .forward-looking-alerts-panel__scope {\n  margin: 10px 0 0;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--text2);\n}\n\n/* .forward-looking-alerts-panel .forward-looking-alerts-panel__title::before {\n  content: '⚡';\n  margin-right: 8px;\n  color: var(--c-neon);\n} */\n\n.forward-looking-alerts-panel__body {\n  padding: 16px 24px 24px;\n}\n\n.forward-looking-alert-row__label {\n  display: flex;\n  align-items: flex-start;\n}\n\n.forward-looking-alert__badge {\n  display: inline-block;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.2;\n  padding: 4px 10px;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.forward-looking-alert__badge--allianz {\n  background: var(--bg-red-soft);\n  color: var(--c-red);\n}\n\n.forward-looking-alert__badge--fg-life {\n  background: var(--bg-purple-soft);\n  color: var(--c-purple-1);\n}\n\n.forward-looking-alert__badge--ny-life {\n  background: var(--bg-teal-soft);\n  color: var(--c-teal-active);\n}\n\n.forward-looking-alert__badge--massmutual {\n  background: var(--bg-orange-soft);\n  color: var(--c-orange);\n}\n\n.forward-looking-alert__badge--athene {\n  background: var(--bg-blue-soft);\n  color: var(--c-blue-1);\n}\n\n.forward-looking-alert__copy {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.forward-looking-alert__desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--c-black);\n}\n\n.table-area.insights-panel > .report-outer--embedded,\n.table-area.insights-panel > .report-outer--flush {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.table-area.insights-panel .header {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;\n}\n\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > * {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(1) { animation-delay: 0.12s; }\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(2) { animation-delay: 0.18s; }\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(3) { animation-delay: 0.24s; }\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(4) { animation-delay: 0.3s; }\n.table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *:nth-child(n + 5) { animation-delay: 0.36s; }\n\n.table-area.insights-panel .report-page > .report-card {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.insights-panel .report-page > .report-card:nth-of-type(1) { animation-delay: 0.14s; }\n.table-area.insights-panel .report-page > .report-card:nth-of-type(2) { animation-delay: 0.22s; }\n.table-area.insights-panel .report-page > .report-card:nth-of-type(3) { animation-delay: 0.3s; }\n.table-area.insights-panel .report-page > .report-card:nth-of-type(n + 4) { animation-delay: 0.38s; }\n\n/* Insights chart / graph draw-in */\n@keyframes filingsBarGrowUp {\n  from {\n    opacity: 0.35;\n    transform: scaleY(0);\n  }\n\n  to {\n    opacity: 1;\n    transform: scaleY(1);\n  }\n}\n\n@keyframes filingsBarGrowRight {\n  from {\n    opacity: 0.35;\n    transform: scaleX(0);\n  }\n\n  to {\n    opacity: 1;\n    transform: scaleX(1);\n  }\n}\n\n@keyframes filingsHeatmapCellIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes filingsChartSvgIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.table-area.insights-panel .chart-panel__body > svg,\n.table-area.insights-panel .chart-panel__body > div > svg,\n.table-area.insights-panel .insights-chart-area > svg,\n.table-area.insights-panel .insights-chart-area svg {\n  animation: filingsChartSvgIn 0.65s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.2s;\n}\n\n.table-area.insights-panel .volume-chart-stacked-bar {\n  transform-origin: bottom center;\n  animation: filingsBarGrowUp 0.7s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: var(--chart-bar-delay, 0.22s);\n}\n\n.table-area.insights-panel .product-depth-bar-row__fill,\n.table-area.insights-panel .metric-bars__fill,\n.table-area.insights-panel .metric-row__fill {\n  transform-origin: left center;\n  animation: filingsBarGrowRight 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.insights-panel .product-depth-row:nth-child(1) .product-depth-bar-row__fill { animation-delay: 0.28s; }\n.table-area.insights-panel .product-depth-row:nth-child(2) .product-depth-bar-row__fill { animation-delay: 0.34s; }\n.table-area.insights-panel .product-depth-row:nth-child(3) .product-depth-bar-row__fill { animation-delay: 0.4s; }\n.table-area.insights-panel .product-depth-row:nth-child(4) .product-depth-bar-row__fill { animation-delay: 0.46s; }\n.table-area.insights-panel .product-depth-row:nth-child(n + 5) .product-depth-bar-row__fill { animation-delay: 0.52s; }\n\n.table-area.insights-panel .region-ranking-bar-row .product-depth-bar-row__fill {\n  animation-delay: calc(0.24s + (var(--rank-delay, 0) * 0.04s));\n}\n\n.table-area.insights-panel .cadence-heatmap-cell-active {\n  animation: filingsHeatmapCellIn var(--heatmap-cell-duration) cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(var(--heatmap-stagger-start) + var(--heatmap-cell-delay, 0) * var(--heatmap-stagger-span));\n}\n\n.table-area.insights-panel .cadence-heatmap-row {\n  animation: filingsHeatmapCellIn var(--heatmap-row-duration) cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(var(--heatmap-stagger-start) + var(--heatmap-row-delay, 0) * var(--heatmap-stagger-span));\n}\n\n.table-area.insights-panel .geo-map__state {\n  animation: filingsHeatmapCellIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.15s + (var(--geo-state-delay, 0) * 0.01s));\n}\n\n.table-area.insights-panel .insights-chart-line-path {\n  stroke-dasharray: var(--line-length, 1000);\n  stroke-dashoffset: var(--line-length, 1000);\n  animation: filingsLineDraw 1s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  animation-delay: 0.15s;\n}\n\n.table-area.insights-panel .insights-chart-line-area {\n  opacity: 0;\n  animation: filingsChartAreaFade 0.8s ease forwards;\n  animation-delay: 0.45s;\n}\n\n.table-area.insights-panel .insights-chart-donut-segment {\n  transition: stroke-dasharray 0.85s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.table-area.insights-panel .insights-chart-line-point {\n  opacity: 0;\n  animation: filingsChartPointIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  animation-delay: var(--point-delay, 0.4s);\n}\n\n.table-area.insights-panel .metric-bars__row:nth-child(1) .metric-bars__fill { animation-delay: 0.26s; }\n.table-area.insights-panel .metric-bars__row:nth-child(2) .metric-bars__fill { animation-delay: 0.32s; }\n.table-area.insights-panel .metric-bars__row:nth-child(3) .metric-bars__fill { animation-delay: 0.38s; }\n.table-area.insights-panel .metric-bars__row:nth-child(4) .metric-bars__fill { animation-delay: 0.44s; }\n.table-area.insights-panel .metric-bars__row:nth-child(5) .metric-bars__fill { animation-delay: 0.5s; }\n.table-area.insights-panel .metric-bars__row:nth-child(n + 6) .metric-bars__fill { animation-delay: 0.56s; }\n\n.table-area.insights-panel .metric-panel__list .metric-row:nth-child(1) .metric-row__fill { animation-delay: 0.26s; }\n.table-area.insights-panel .metric-panel__list .metric-row:nth-child(2) .metric-row__fill { animation-delay: 0.32s; }\n.table-area.insights-panel .metric-panel__list .metric-row:nth-child(3) .metric-row__fill { animation-delay: 0.38s; }\n.table-area.insights-panel .metric-panel__list .metric-row:nth-child(4) .metric-row__fill { animation-delay: 0.44s; }\n.table-area.insights-panel .metric-panel__list .metric-row:nth-child(n + 5) .metric-row__fill { animation-delay: 0.5s; }\n\n.table-area.insights-panel .product-depth-bar-row__fill {\n  animation-delay: var(--chart-bar-delay, 0.3s);\n}\n\n.table-area.insights-panel .insights-chart-trend-line {\n  stroke-dasharray: var(--line-length, 600);\n  stroke-dashoffset: var(--line-length, 600);\n  animation: filingsLineDraw 1.1s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.table-area.insights-panel .insights-chart-trend-line--delayed {\n  animation-delay: 0.25s;\n}\n\n@keyframes filingsChartPointIn {\n  from {\n    opacity: 0;\n    transform: scale(0.6);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n@keyframes filingsLineDraw {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n\n@keyframes filingsChartAreaFade {\n  to {\n    opacity: 0.05;\n  }\n}\n\n/* Filings table tab — list / grid enter */\n@keyframes filingsTableHeadIn {\n  from {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes filingsTableRowIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.table-area.filings-table-panel .table-wrap,\n.table-area.filings-table-panel .filings-grid {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.table-area.filings-table-panel thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.table-area.filings-table-panel tbody tr,\n.sec-filing-panel.filings-table-panel tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.table-area.filings-table-panel .filing-card {\n  animation: filingsInsightsFadeIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.08s + min(var(--table-row-delay, 0), 20) * 0.028s);\n}\n\n.table-area.filings-table-panel .pagination-sticky {\n  flex-shrink: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;\n}\n\n/* State Insurance Filings table — compress with drawer (avoid columns under drawer) */\n.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap {\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n}\n\n.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap table {\n  table-layout: fixed;\n  width: 100%;\n  max-width: 100%;\n}\n\n.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap th,\n.table-area.filings-table-panel:not(.sec-filing-panel) .table-wrap td {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-tn { width: 7%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-company { width: 11%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-state { width: 5%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-type { width: 8%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-toi { width: 6%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-sub-toi { width: 6%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-product-name { width: 12%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-status { width: 8%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-date { width: 11%; }\n.table-area.filings-table-panel:not(.sec-filing-panel) .col-actions {\n  width: 7%;\n  text-align: center;\n}\n\n.filings-data-table__actions {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.table-drawer-action-btn,\n.sec-filing-insights-data-table__action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  border: none;\n  border-radius: 6px;\n  background: transparent;\n  color: var(--c-black);\n  cursor: pointer;\n  text-decoration: none;\n  flex-shrink: 0;\n}\n\n.table-drawer-action-btn:hover,\n.sec-filing-insights-data-table__action-btn:hover,\n.sec-filing-insights-data-table__action-btn.is-link:hover {\n  background: color-mix(in srgb, var(--c-black) 6%, var(--c-white));\n  color: var(--c-black);\n}\n\n.table-drawer-action-btn.is-active,\n.sec-filing-insights-data-table__action-btn.is-active {\n  background: var(--c-black);\n  color: var(--c-white);\n}\n\n.table-drawer-action-btn:focus-visible,\n.sec-filing-insights-data-table__action-btn.is-link:focus-visible,\n.sec-filing-insights-data-table__action-btn:focus-visible {\n  outline: 2px solid var(--c-black);\n  outline-offset: 1px;\n}\n\n.table-drawer-action-btn svg,\n.sec-filing-insights-data-table__action-btn svg {\n  flex-shrink: 0;\n}\n\n.table-area.filings-table-panel:not(.sec-filing-panel) .company-cell .company-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table-area.filings-table-panel:not(.sec-filing-panel) .date-cell {\n  width: auto;\n  max-width: 100%;\n}\n\n/* News / PR table */\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-date {\n  width: 112px;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-image {\n  width: 80px;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-company {\n  width: 15%;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-headline {\n  width: 24%;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-summary {\n  width: auto;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) col.news-pr-col-source {\n  width: 124px;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap th.col-date,\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap td.date-cell {\n  width: 112px;\n  min-width: 112px;\n  max-width: 112px;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-preview,\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-preview-cell {\n  width: 80px;\n  min-width: 80px;\n  max-width: 80px;\n  padding-left: 8px;\n  padding-right: 8px;\n  text-align: center;\n  vertical-align: middle;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-company {\n  width: 15%;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .sec-filing-table__company-name {\n  font-size: 13px;\n  line-height: 1.35;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .geo-brand-name-cell {\n  width: 100%;\n  min-width: 0;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .company-cell .geo-brand-name-cell__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-product-name {\n  width: 24%;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-type {\n  width: auto;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap th.col-status,\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .table-wrap td:last-child {\n  width: 124px;\n  min-width: 124px;\n  max-width: 124px;\n  overflow: visible;\n  text-overflow: clip;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .col-status {\n  width: 124px;\n  text-align: center;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) th,\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) td {\n  padding: 14px 10px;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .date-cell {\n  text-transform: none;\n  white-space: nowrap;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-source-cell {\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: middle;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-source-link {\n  margin: 0 auto;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-table-cell {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 0;\n}\n\n.table-area.filings-table-panel.news-pr-table-panel:not(.sec-filing-panel) .news-pr-table-cell__text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.news-pr-table-thumb {\n  width: 64px;\n  height: 40px;\n  margin: 0 auto;\n  flex-shrink: 0;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--c-grey-2, #e5e7eb);\n  background-color: var(--c-gray-1, #f3f4f6);\n}\n\n.news-pr-table-thumb--empty {\n  display: block;\n}\n\n.news-pr-table-thumb__img {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.news-pr-drawer-card {\n  margin-bottom: 24px;\n  overflow: visible; /* Drawer scrolls full summary; keep radius on inner creative */\n}\n\n.drawer-body .news-pr-drawer-card__creative {\n  overflow: hidden;\n  border-radius: 0;\n}\n\n.news-pr-drawer-card__source {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 4px;\n  padding: 16px 16px 12px;\n  min-width: 0;\n  border-bottom: 1px solid var(--border, #e5e7eb);\n}\n\n.news-pr-drawer-card__source-top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n  line-height: 0;\n}\n\n.news-pr-drawer-card__source-top .news-pr-drawer-card__source-name {\n  line-height: 1.3;\n}\n\n.news-pr-drawer-card__source-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--c-black);\n  word-break: break-word;\n}\n\n.news-pr-drawer-card__url {\n  display: block;\n  font-size: 12px;\n  line-height: 1.3;\n  color: var(--text2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.news-pr-drawer-card__headline {\n  margin: 0;\n  padding: 12px 16px 8px;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 1.4;\n  color: var(--c-black);\n}\n\n.news-pr-drawer-card__summary {\n  padding: 12px 16px 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--c-black);\n  border-top: 1px solid var(--border, #e5e7eb);\n}\n\n.news-pr-drawer-card__creative {\n  width: 100%;\n  line-height: 0;\n}\n\n.news-pr-drawer-card__creative .mi-detail-creative-empty {\n  min-height: 120px;\n  margin: 0;\n  padding: 24px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  font-size: 13px;\n  line-height: 1.4;\n  color: var(--text3);\n  background: var(--c-gray-1, #f3f4f6);\n}\n\n.news-pr-drawer-card__image {\n  width: 100%;\n  height: auto;\n  display: block;\n  vertical-align: top;\n}\n\n/* News / PR article detail — side metadata + iframe */\n.mi-detail-page--news-article {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  height: 100%;\n}\n\n.mi-detail-page--news-article > .mi-detail-page {\n  flex: 1;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.mi-detail-page--news-article .mi-detail-content {\n  flex: none;\n  min-height: auto;\n  overflow: visible;\n  padding-bottom: 48px;\n}\n\n.mi-detail-page--news-article .mi-detail-content > .news-article-view {\n  flex: none;\n}\n\n.news-article-view {\n  display: grid;\n  grid-template-columns: minmax(220px, 280px) 1fr;\n  gap: 16px;\n  align-items: start;\n}\n\n.news-article-view__aside {\n  padding: 18px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.news-article-view__aside-label {\n  margin: 13px 0 0;\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--text2);\n  letter-spacing: 0.05em;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.news-article-view__aside-label:first-child {\n  margin-top: 0;\n}\n\n.news-article-view__aside-company {\n  margin: 0;\n}\n\n.news-article-view__aside-company .geo-brand-name-cell__label {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black, #111);\n}\n\n.news-article-view__aside-value {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black, #111);\n}\n\n.news-article-view__aside-summary {\n  margin: 0;\n  font-size: 13px;\n  line-height: 1.55;\n  color: var(--text2, #4b5563);\n  white-space: normal;\n}\n\n.news-article-view__main {\n  min-width: 0;\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.mi-news-iframe-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 0;\n  overflow: hidden;\n  flex: none;\n  border-radius: 12px;\n  border: 1px solid var(--c-grey-2, #e5e7eb);\n  background: var(--c-white, #fff);\n}\n\n.mi-news-iframe-frame {\n  position: relative;\n  width: 100%;\n  min-height: 200px;\n}\n\n.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe-frame {\n  min-height: calc(100vh - 40px);\n}\n\n.mi-news-iframe-loading {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  background: var(--c-gray-1, #f3f4f6);\n}\n\n.mi-news-iframe-loading__spinner {\n  width: 36px;\n  height: 36px;\n  border: 3px solid color-mix(in srgb, var(--c-blue-1) 18%, transparent);\n  border-top-color: var(--c-blue-1);\n  border-radius: 50%;\n  animation: miNewsIframeSpin 0.8s linear infinite;\n}\n\n.mi-news-iframe-loading__text {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text2);\n}\n\n@keyframes miNewsIframeSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.mi-news-iframe--loading {\n  opacity: 0;\n}\n\n.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 40px);\n  min-height: 520px;\n  max-height: none;\n  border: 0;\n  background: #fff;\n}\n\n.mi-detail-page--news-article .mi-news-iframe-panel .mi-news-iframe-fallback {\n  padding: 10px 14px 12px;\n  background: var(--c-white, #fff);\n  border-top: 1px solid var(--c-grey-2, #e5e7eb);\n}\n\n.mi-news-iframe-fallback {\n  margin: 0;\n  padding: 0 4px 8px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: var(--text3, #6b7280);\n}\n\n.mi-news-iframe-fallback a {\n  color: var(--c-blue-1, #2563eb);\n  text-decoration: underline;\n}\n\n.mi-news-iframe-empty {\n  padding: 24px;\n  font-size: 14px;\n  color: var(--text2);\n}\n\n@media (max-width: 960px) {\n  .news-article-view {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .table-area.insights-panel > .report-outer--embedded,\n  .table-area.insights-panel > .report-outer--flush,\n  .table-area.insights-panel .header,\n  .table-area.insights-panel:not(.sec-filing-panel) .kpi-banner-grid > *,\n  .table-area.insights-panel .report-page > .report-card,\n  .table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-period-table__panel,\n  .table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-data-table tbody tr,\n  .table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered\n    .sec-filing-insights-period-table__panel--period-switch,\n  .table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered\n    .sec-filing-insights-period-table__panel--period-switch\n    .sec-filing-insights-data-table tbody tr,\n  .table-area.alerts-panel > .report-outer--embedded,\n  .table-area.alerts-panel .report-page > .report-card,\n  .table-area.filings-table-panel .table-wrap,\n  .table-area.filings-table-panel .filings-grid,\n  .table-area.filings-table-panel thead tr,\n  .table-area.filings-table-panel tbody tr,\n  .sec-filing-panel.filings-table-panel tbody tr,\n  .table-area.filings-table-panel .filing-card,\n  .table-area.filings-table-panel .pagination-sticky,\n  .geo-prompts-table-panel .geo-prompts-content .table-wrap,\n  .geo-prompts-table-panel .geo-prompts-content thead tr,\n  .geo-prompts-table-panel .geo-prompts-content tbody tr,\n  .geo-prompts-table-panel .geo-prompts-content .pagination-sticky,\n  .geo-prompt-edit-backdrop,\n  .configure-dialog.configure-dialog--geo-prompts,\n  .configure-dialog--geo-prompts .p-dialog-header,\n  .configure-dialog--geo-prompts .modal-desc,\n  .configure-dialog--geo-prompts .geo-prompt-edit-toolbar,\n  .configure-dialog--geo-prompts .config-hint,\n  .configure-dialog--geo-prompts .geo-prompt-edit-column,\n  .configure-dialog--geo-prompts .geo-prompt-edit-list--entered .competitor-item,\n  .configure-dialog--geo-prompts .p-dialog-footer,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table thead tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table tbody tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) thead tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) tbody tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-card .geo-insights-table-wrap,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table thead tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table tbody tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table-wrap,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table thead tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table tbody tr,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip,\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__dot,\n  .table-area.insights-panel .cadence-heatmap-cell-active,\n  .table-area.insights-panel .cadence-heatmap-row {\n    animation: none;\n    opacity: 1;\n    transform: none;\n  }\n\n  .table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip {\n    transform: scaleX(1);\n  }\n}\n\n.body.insights-panel > .content {\n  padding-bottom: 0;\n}\n\n.table-area.insights-panel .footer,\n.body.insights-panel .footer {\n  display: none;\n}\n\n.table-area.insights-panel .report-page--flush > *:last-child,\n.table-area.insights-panel .report-page > *:last-child {\n  margin-bottom: 0 !important;\n}\n\n.table-area.insights-panel .product-depth-panel {\n  margin-bottom: 0;\n}\n\n.table-area.insights-panel .product-depth-grid {\n  padding-bottom: 0;\n}\n\n.page-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  min-height: 400px;\n}\n\n.page-empty__inner {\n  text-align: center;\n}\n\n.page-empty__title {\n  color: var(--c-black);\n  margin-bottom: 8px;\n}\n\n.page-empty__text {\n  color: var(--text3);\n  font-size: 14px;\n}\n\n.chip-picker {\n  position: relative;\n  width: 100%;\n}\n\n.chip-picker__control {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  align-items: center;\n  min-height: 40px;\n  padding: 6px 10px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--c-white);\n}\n\n.chip-picker__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 3px 8px 3px 10px;\n  border-radius: 16px;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  font-size: 12px;\n  color: var(--c-black);\n  max-width: 100%;\n}\n\n.chip-picker__chip-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chip-picker__chip-remove {\n  border: none;\n  background: none;\n  cursor: pointer;\n  padding: 2px;\n  display: flex;\n  color: var(--text3);\n  border-radius: 4px;\n}\n\n.chip-picker__input {\n  flex: 1 1 140px;\n  min-width: 140px;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  background: transparent;\n  color: var(--c-black);\n}\n\n.chip-picker__menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  margin-top: 4px;\n  max-height: 240px;\n  overflow-y: auto;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  box-shadow: 0 10px 28px color-mix(in srgb, var(--c-black) 12%, transparent);\n  z-index: 40;\n}\n\n.chip-picker__menu-hint {\n  padding: 10px 12px;\n  font-size: 12px;\n  color: var(--text3);\n}\n\n.chip-picker__menu-add {\n  width: 100%;\n  text-align: left;\n  padding: 10px 12px;\n  font-size: 13px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: var(--c-black);\n}\n\n.chip-picker__menu-option {\n  display: block;\n  width: 100%;\n  text-align: left;\n  padding: 8px 12px;\n  font-size: 12px;\n  border: none;\n  background: none;\n  cursor: pointer;\n  color: var(--c-black);\n}\n\n.page-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 80vh;\n  text-align: center;\n}\n\n.page-empty__title {\n  font-size: 28px;\n  color: var(--c-black);\n  margin-bottom: 16px;\n}\n\n.page-empty__text {\n  font-size: 16px;\n  color: var(--text2);\n}\n\n.table-pagination {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.table-pagination__control {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.table-pagination__label {\n  font-size: 11px;\n  color: var(--c-black);\n}\n\n.table-pagination__measure {\n  height: 28px;\n  line-height: 28px;\n  display: inline-flex;\n  align-items: center;\n  visibility: visible;\n  min-width: 40px;\n}\n\n.table-pagination__select {\n  height: 28px;\n  color: transparent;\n}\n\n.table-pagination__option {\n  color: var(--c-black);\n}\n\n.table-pagination__option {\n  color: var(--c-black);\n}\n\n.table-pagination__option {\n  color: var(--c-black);\n}\n\n\n/* Companies pages — legacy auto-generated classes (revisit / rename later) */\n\n.companies-style-1 {\n  padding: 0;\n}\n\n.companies-style-2 {\n  padding: 40px;\n  text-align: center;\n  color: var(--text3);\n}\n\n.companies-style-3 {\n  align-content: start;\n}\n\n.companies-style-4 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.companies-style-5 {\n  font-size: 15px;\n  margin-top: 4px;\n}\n\n.companies-style-6 {\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 4px;\n}\n\n.companies-style-7 {\n  font-size: 10px;\n  padding: 1px 6px;\n}\n\n.companies-style-8 {\n  color: var(--text3);\n}\n\n.companydetails-style-1 {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-left: -4px;\n}\n\n.companydetails-style-2 {\n  margin-left: 36px;\n}\n\n.companydetails-style-3 {\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.companydetails-style-4 {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.companydetails-style-5 {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.companydetails-style-6 {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  align-items: center;\n}\n\n.companydetails-style-7 {\n  display: flex;\n  gap: 4px;\n  background: var(--c-white);\n  padding: 2px;\n  border-radius: var(--radius);\n}\n\n.companydetails-style-8,\n.companydetails-style-9,\n.companydetails-style-10,\n.companydetails-style-11,\n.companydetails-style-12 {\n  font-size: 12px;\n  padding: 4px 8px;\n  border-radius: 6px;\n}\n\n.companydetails-style-13 {\n  display: flex;\n  gap: 20px;\n  padding: 16px;\n}\n\n.companydetails-style-14 {\n  flex: 1.2;\n}\n\n.companydetails-style-15 {\n  flex: 0.8;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.companydetails-style-16 {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text3);\n  text-transform: uppercase;\n}\n\n.companydetails-style-17 {\n  padding: 0 8px 0 0;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  max-height: 280px;\n  overflow-y: auto;\n}\n\n.companydetails-style-18 {\n  gap: 10px;\n}\n\n.companydetails-style-19 {\n  width: 30px;\n  font-size: 11px;\n}\n\n.companydetails-style-20 {\n  height: 5px;\n}\n\n.companydetails-style-21 {\n  width: 30px;\n}\n\n.companydetails-style-22 {\n  gap: 16px;\n}\n\n.companydetails-style-23 {\n  display: flex;\n  gap: 8px;\n  flex: 1;\n}\n\n.companydetails-style-24 {\n  width: 100px;\n}\n\n.companydetails-style-25 {\n  font-size: 11px;\n  padding: 6px 8px;\n  border-radius: 4px;\n}\n\n.companydetails-style-26 {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.companydetails-style-27 {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.companydetails-style-28 {\n  font-size: 11px;\n  color: var(--c-black);\n}\n\n.companydetails-style-29 {\n  height: 28px;\n  line-height: 28px;\n  display: inline-flex;\n  align-items: center;\n  visibility: visible;\n  min-width: 40px;\n}\n\n.companydetails-style-30 {\n  height: 28px;\n  color: transparent;\n}\n\n.companydetails-style-31,\n.companydetails-style-32 {\n  color: var(--c-black);\n}\n\n.companydetails-style-33 {\n  display: flex;\n  gap: 4px;\n}\n\n/* Report shell & competitive intelligence layout */\n.report-outer {\n  background: var(--c-white);\n  overflow-x: auto;\n  padding: 16px 0 32px;\n  width: 100%;\n}\n\n.report-outer.report-outer--embedded {\n  background: transparent;\n  overflow-x: hidden;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n.report-outer.report-outer--embedded .report-scope {\n  background: transparent;\n}\n\n.report-outer.report-outer--embedded .report-page {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n@media (max-width: 900px) {\n  .report-outer.report-outer--embedded {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n}\n\n.report-scope *,\n.report-scope *::before,\n.report-scope *::after {\n  box-sizing: border-box;\n}\n\n.report-scope {\n  font-family: var(--font);\n  font-size: var(--fs-sm);\n  color: var(--c-black);\n  background: var(--c-white);\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n@page {\n  size: A3 landscape;\n  margin: 8mm;\n}\n\n@media print {\n  .report-scope {\n    background: var(--c-white);\n  }\n\n  .report-outer.report-outer--embedded {\n    padding: 0;\n  }\n\n  .report-scope .report-page {\n    margin: 0;\n    box-shadow: none;\n    border-radius: 0;\n    width: 100%;\n    min-height: unset;\n  }\n\n  .no-print {\n    display: none !important;\n  }\n}\n\n.report-page {\n  width: 1460px;\n  margin: 24px auto;\n  background: var(--c-white);\n  padding: 22px 26px 20px;\n  box-shadow: 0 4px 32px color-mix(in srgb, var(--c-black) 12%, transparent);\n}\n\n.report-grid--asymmetric {\n  display: grid;\n  grid-template-columns: 1.1fr 0.9fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.report-grid--half {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n\n.report-charts-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 20px;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.report-charts-row > .report-card {\n  min-width: 0;\n}\n\n.chart-panel__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n  border-bottom: 1px solid var(--border);\n  padding-bottom: 8px;\n}\n\n.chart-panel__header .report-card-title {\n  margin: 0;\n  border: none;\n  padding: 0;\n}\n\n.chart-panel__body {\n  flex: 1;\n  min-height: 420px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  min-width: 0;\n}\n\n.chart-panel__body .volume-chart-container,\n.chart-panel__body .cadence-heatmap-container {\n  flex: 1;\n  min-width: 0;\n  width: 100%;\n}\n\n/* Undo misapplied metric-row label width when used as chart wrapper */\n.chart-panel__body.metric-row__label,\n.chart-panel__body {\n  width: 100%;\n  min-width: 0;\n  text-align: inherit;\n  padding-right: 0;\n}\n\n/* Product category depth — annuities / life insurance columns (--c-company-bar, --c-orange from tokens.css) */\n.product-depth-panel {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.product-depth-panel .chart-panel__header,\n.volume-chart-panel .chart-panel__header {\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0;\n  margin-bottom: 0;\n  padding: 12px 24px 12px;\n  border-bottom: none;\n}\n\n.product-depth-panel .chart-panel__header .report-card-title,\n.volume-chart-panel .chart-panel__header .report-card-title {\n  width: 100%;\n  margin-bottom: 0;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.volume-chart-panel .chart-panel__header-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  padding-bottom: 8px;\n  border-bottom: 1px solid var(--border);\n}\n\n.volume-chart-panel .chart-panel__header-toolbar .report-card-title {\n  width: auto;\n  flex: 1;\n  min-width: 0;\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.product-depth-legend {\n  display: flex;\n  gap: 16px;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-top: 10px;\n}\n\n.product-depth-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.product-depth-legend__swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px var(--border);\n}\n\n.product-depth-legend__swatch--ours {\n  background: var(--c-orange);\n}\n\n.product-depth-legend__swatch--competitor {\n  background: var(--c-company-bar);\n}\n\n.product-depth-legend__label {\n  font-size: 12px;\n  color: var(--text2);\n  font-weight: 500;\n}\n\n.product-depth-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 32px;\n  width: 100%;\n  min-width: 0;\n  padding: 16px 24px 24px;\n  align-items: start;\n}\n\n.product-depth-grid--quad {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 28px 32px;\n}\n\n.product-depth-grid--quad .product-depth-column + .product-depth-column {\n  border-left: none;\n  padding-left: 0;\n}\n\n.product-depth-column {\n  min-width: 0;\n}\n\n.product-depth-column + .product-depth-column {\n  border-left: 1px solid var(--border);\n  padding-left: 32px;\n}\n\n.page-empty--compact {\n  min-height: 140px;\n  height: auto;\n}\n\n.product-depth-column__title {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--ui-text-heading);\n  margin: 0 0 16px;\n}\n\n.product-depth-chart {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.product-depth-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-bottom: 16px;\n  margin-bottom: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.product-depth-row:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.product-depth-row__category {\n  flex: 0 0 200px;\n  min-width: 0;\n  font-size: 13px;\n  color: var(--text2);\n  font-weight: 600;\n  line-height: 1.35;\n  padding-right: 16px;\n  border-right: 1px solid var(--border);\n  word-break: break-word;\n}\n\n/* Alerts: column must fit badge; generic product-depth min-width:0 caused overlap with border-right */\n.forward-looking-alert-row .product-depth-row__category {\n  flex: 0 0 auto;\n  width: max-content;\n  min-width: 320px;\n  padding-right: 32px;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.product-depth-row__category-parent {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text3);\n  line-height: 1.3;\n  margin-bottom: 2px;\n}\n\n.product-depth-row__category-sub {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1.35;\n}\n\n.product-depth-row__bars {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.product-depth-bar-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  min-width: 0;\n}\n\n.product-depth-bar-row__company {\n  flex: 0 0 140px;\n  min-width: 0;\n  font-size: 12px;\n  color: var(--text2);\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.product-depth-bar-row__track {\n  flex: 1;\n  min-width: 60px;\n  height: 8px;\n  background: var(--bar-track-bg);\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.product-depth-bar-row__fill {\n  height: 100%;\n  border-radius: 4px;\n  border: none;\n  box-shadow: 0 1px 2px var(--border);\n}\n\n.product-depth-bar-row__fill--competitor {\n  background: var(--c-company-bar);\n}\n\n.product-depth-bar-row__fill--ours {\n  background: var(--c-orange);\n}\n\n.product-depth-bar-row__value {\n  flex: 0 0 28px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  text-align: right;\n}\n\n.region-ranking-chart {\n  gap: 6px;\n}\n\n.region-ranking-bar-row__state {\n  flex: 0 0 36px;\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.region-ranking-bar-row__track {\n  position: relative;\n}\n\n.region-ranking-bar-row__track .geo-bar-fill--other {\n  border-radius: 4px;\n}\n\n.region-ranking-bar-row__track .geo-bar-fill--overlay {\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n  border-radius: 4px;\n}\n\n.region-ranking-bar-row__value {\n  flex: 0 0 auto;\n  min-width: 52px;\n}\n\n/* Geographical distribution — map + rankings layout */\n.geo-distribution-panel .chart-panel__body {\n  min-height: 0;\n  padding: 0 24px 16px;\n}\n\n.geo-distribution-grid {\n  display: grid;\n  grid-template-columns: 1.4fr 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n.geo-distribution-map {\n  padding: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 380px;\n}\n\n.geo-distribution-map__inner {\n  width: 100%;\n  max-width: 640px;\n  margin: 0 auto;\n}\n\n.geo-distribution-rankings {\n  display: flex;\n  flex-direction: column;\n  min-height: 380px;\n}\n\n.geo-distribution-rankings .region-ranking-chart {\n  flex: 1;\n  gap: var(--geo-ranking-row-gap, 6px);\n  padding-bottom: var(--space-4);\n  box-sizing: border-box;\n}\n\n.geo-rankings__heading {\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--c-black);\n  letter-spacing: 0.05em;\n  margin: 0 0 8px;\n}\n\n/* Geographical distribution — map, legend, rankings (token-backed) */\n.geo-legend {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding-bottom: 4px;\n  flex-wrap: wrap;\n}\n\n.geo-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.geo-legend__swatch {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n  flex-shrink: 0;\n}\n\n.geo-legend__swatch--ours {\n  background: var(--c-teal-active);\n}\n\n.geo-legend__swatch--other {\n  background: var(--c-aqua-mass);\n}\n\n.geo-legend__label {\n  font-size: 12px;\n  color: var(--text2);\n  font-weight: 500;\n}\n\n.geo-map__state--ours {\n  fill: var(--c-teal-active);\n}\n\n.geo-map__state--other {\n  fill: var(--c-aqua-mass);\n}\n\n.geo-map__state--empty {\n  fill: var(--bar-track-bg);\n}\n\n.geo-bar-fill--ours {\n  background: var(--c-teal-active);\n}\n\n.geo-bar-fill--other {\n  background: var(--c-aqua-mass);\n}\n\n.geo-bar-value--ours {\n  color: var(--c-teal-active);\n}\n\n.report-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: var(--border-radius-md);\n  /* padding: 11px 13px; */\n}\n\n.report-card-title {\n  font-size: var(--fs-lg);\n  font-weight: 400;\n  text-transform: capitalize;\n  color: var(--c-black);\n  margin-bottom: 9px;\n  padding-bottom: 5px;\n  border-bottom: 1px solid var(--border);\n}\n\n.report-chip--gap {\n  display: inline-block;\n  background: var(--orange-bg);\n  border-radius: var(--border-radius-sm);\n  font-size: 9.5px;\n  padding: 2px 7px;\n  margin: 2px 3px;\n  color: var(--c-orange);\n  font-weight: 600;\n}\n\n.report-note {\n  font-size: 9.5px;\n  color: var(--text3);\n  margin-top: 7px;\n  border-top: 1px solid var(--border);\n  padding-top: 6px;\n  line-height: 1.45;\n}\n\n.report-divider {\n  border: none;\n  border-top: 1px solid var(--border);\n  margin: 7px 0;\n}\n\n/* Charts — KPIs, bar charts, heatmaps, legends, map tooltips */\n\n.custom-pie-chart-wrapper {\n  position: relative;\n  width: 240px;\n  height: 240px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Filing Details page (/filings/:id) — scroll shell + entrance animations */\n.filing-details-page {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.filing-details-page .topbar {\n  flex-shrink: 0;\n  animation: filingsInsightsIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;\n}\n\n.filing-details-page .content {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) 0.06s backwards;\n}\n\n.filing-details-page .kpi-banner-grid > * {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.filing-details-page .kpi-banner-grid > *:nth-child(1) { animation-delay: 0.1s; }\n\n.filing-details-page .report-card {\n  padding: 18px 22px 22px;\n}\n\n.filing-details-page .report-card-title {\n  margin-bottom: 14px;\n}\n\n.filing-details-page .kpi-banner-grid > *:nth-child(2) { animation-delay: 0.16s; }\n.filing-details-page .kpi-banner-grid > *:nth-child(3) { animation-delay: 0.22s; }\n\n.filing-details-page .content > .report-card {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.14s;\n}\n\n.filing-details-page .content > div[style*='grid'] > .report-card:nth-child(1) {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.22s;\n}\n\n.filing-details-page .content > div[style*='grid'] > .report-card:nth-child(2) {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.28s;\n}\n\n.filing-details-page .content > .report-card:last-of-type {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.4s;\n}\n\n.filing-details-summary__body {\n  padding: 0;\n}\n\n.filing-details-summary__text {\n  margin: 0;\n  font-size: 13px;\n  color: var(--ui-text-primary);\n  line-height: 1.6;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.filing-details-summary__empty {\n  margin: 0;\n  font-size: 13px;\n  color: var(--ui-text-primary);\n  line-height: 1.5;\n}\n\n.filing-details-page .custom-pie-chart-wrapper {\n  animation: filingsChartSvgIn 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.3s;\n}\n\n.filing-details-page .pie-chart-center {\n  animation: filingsInsightsIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.5s backwards;\n}\n\n.filing-details-page .milestone-step {\n  animation: filingsInsightsIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.filing-details-page .milestone-track .milestone-step:nth-child(2) { animation-delay: 0.38s; }\n.filing-details-page .milestone-track .milestone-step:nth-child(3) { animation-delay: 0.44s; }\n.filing-details-page .milestone-track .milestone-step:nth-child(4) { animation-delay: 0.5s; }\n.filing-details-page .milestone-track .milestone-step:nth-child(5) { animation-delay: 0.56s; }\n.filing-details-page .milestone-track .milestone-step:nth-child(6) { animation-delay: 0.62s; }\n\n.filing-details-page .report-card .custom-pie-chart-wrapper + div > div {\n  animation: filingsInsightsIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(1) { animation-delay: 0.36s; }\n.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(2) { animation-delay: 0.4s; }\n.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(3) { animation-delay: 0.44s; }\n.filing-details-page .report-card .custom-pie-chart-wrapper + div > div:nth-child(4) { animation-delay: 0.48s; }\n\n@media (prefers-reduced-motion: reduce) {\n  .filing-details-page .topbar,\n  .filing-details-page .content,\n  .filing-details-page .kpi-banner-grid > *,\n  .filing-details-page .report-card,\n  .filing-details-page .custom-pie-chart-wrapper,\n  .filing-details-page .pie-chart-center,\n  .filing-details-page .milestone-step {\n    animation: none;\n  }\n\n  .filing-details-page .pie-chart-segment {\n    transition: none !important;\n  }\n}\n\n.chart-side {\n  flex: 1;\n  min-width: 0;\n}\n\n.map-container svg {\n  width: 100%;\n  height: auto;\n  max-height: 280px;\n}\n\n.report-outer.report-outer--embedded .kpi-grid {\n  grid-template-columns: repeat(auto-fit, minmax(128px, 1fr));\n}\n\n.kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 8px;\n  margin-bottom: 13px;\n}\n\n.kpi {\n  background: var(--c-white);\n  border-radius: 6px;\n  padding: 9px 11px;\n  border-left: 3px solid var(--c-blue-2);\n}\n\n.kpi.warn {\n  border-left-color: var(--c-orange);\n}\n\n.kpi.good {\n  border-left-color: var(--c-teal-active);\n}\n\n.kpi.amber {\n  border-left-color: var(--c-orange);\n}\n\n.kpi-lbl {\n  font-size: var(--fs-xs);\n  color: var(--text2);\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  margin-bottom: 3px;\n}\n\n.kpi-val {\n  font-size: var(--fs-xl);\n  font-weight: 700;\n  color: var(--c-blue-1);\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.kpi-sub {\n  font-size: 9.5px;\n  font-weight: 600;\n}\n\n.cr {\n  color: var(--c-orange);\n}\n\n.cg {\n  color: var(--c-teal-active);\n}\n\n.ca {\n  color: var(--c-orange);\n}\n\n.cb {\n  color: var(--c-blue-1);\n}\n\n.legend {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n  font-size: var(--fs-sm);\n  color: var(--text2);\n}\n\n.li {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.sq {\n  width: 12px;\n  height: 12px;\n  border-radius: 3px;\n  flex-shrink: 0;\n}\n\n.prod-section-lbl {\n  font-size: var(--fs-xs);\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: .08em;\n  color: var(--c-black);\n  margin: 8px 0 5px;\n  padding-top: 7px;\n  border-top: 1px solid var(--c-white);\n}\n\n.prod-section-lbl:first-child {\n  margin-top: 0;\n  border-top: none;\n}\n\n.prod-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 4px;\n}\n\n.prod-lbl {\n  width: 180px;\n  font-size: 9.5px;\n  color: var(--text2);\n  flex-shrink: 0;\n}\n\n.prod-bars {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mini-bar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.mini-track {\n  flex: 1;\n  background: var(--c-white);\n  border-radius: 2px;\n  height: 9px;\n  overflow: hidden;\n}\n\n.mini-fill {\n  height: 100%;\n  border-radius: 2px;\n}\n\n.mini-num {\n  width: 16px;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  text-align: right;\n}\n\n.state-row {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  margin-bottom: 5px;\n}\n\n.state-lbl {\n  width: 86px;\n  font-size: 9.5px;\n  color: var(--text2);\n  flex-shrink: 0;\n}\n\n.state-track {\n  flex: 1;\n  background: var(--c-white);\n  border-radius: 3px;\n  height: 13px;\n  overflow: hidden;\n  position: relative;\n}\n\n.state-tot {\n  width: 52px;\n  text-align: right;\n  font-size: 9.5px;\n  flex-shrink: 0;\n}\n\n.hm-header {\n  display: flex;\n  gap: 5px;\n  margin-bottom: 4px;\n  padding-left: 106px;\n}\n\n.hm-header span {\n  flex: 1;\n  text-align: center;\n  font-size: var(--fs-xs);\n  color: var(--text3);\n}\n\n.hm-row {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  margin-bottom: 4px;\n}\n\n.hm-row.ta {\n  background: var(--c-white);\n  border-left: 3px solid var(--c-blue-1);\n  border-radius: 0 4px 4px 0;\n  padding: 2px 4px;\n}\n\n.hm-lbl {\n  width: 100px;\n  font-size: var(--fs-xs);\n  flex-shrink: 0;\n}\n\n.hm-cells {\n  display: flex;\n  gap: 3px;\n  flex: 1;\n}\n\n.hm-cell {\n  flex: 1;\n  height: 22px;\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n}\n\n/* --- CompetitiveIntelligenceReport --- */\n.competitiveintelligencereport-style-1 {\n  padding-left: 106px;\n}\n\n.competitiveintelligencereport-style-2 {\n  background: var(--color-378add);\n}\n\n.competitiveintelligencereport-style-3 {\n  background: var(--color-1d9e75);\n}\n\n.competitiveintelligencereport-style-4 {\n  background: var(--color-ef9f27);\n}\n\n.competitiveintelligencereport-style-5 {\n  background: var(--color-9ca3af);\n}\n\n.competitiveintelligencereport-style-6 {\n  position: relative;\n  width: 100%;\n  height: 220px;\n  min-height: 200px;\n}\n\n.competitiveintelligencereport-style-7 {\n  margin-bottom: 6px;\n}\n\n.competitiveintelligencereport-style-8 {\n  margin-bottom: 9px;\n}\n\n.competitiveintelligencereport-style-9 {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  border-radius: 3px;\n}\n\n.competitiveintelligencereport-style-10 {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background: var(--color-1b3a6b);\n  border-radius: 3px;\n  display: flex;\n  align-items: center;\n  padding-left: 5px;\n  font-size: var(--fs-xs);\n  font-weight: 600px;\n  color: var(--c-white);\n}\n\n.competitiveintelligencereport-style-11 {\n  font-size: 9.5px;\n  color: var(--color-a32d2d);\n  font-weight: 600px;\n  margin-bottom: 3px;\n}\n\n.competitiveintelligencereport-style-12 {\n  font-size: 9.5px;\n  color: var(--color-666666);\n  margin-bottom: 8px;\n}\n\n.competitiveintelligencereport-style-13 {\n  font-size: 9.5px;\n  color: var(--color-666666);\n  margin-bottom: 4px;\n  font-weight: 600px;\n}\n\n.competitiveintelligencereport-style-14 {\n  margin-bottom: 3px;\n}\n\n.competitiveintelligencereport-style-15 {\n  font-size: var(--fs-xs);\n  color: var(--color-888888);\n  font-weight: 600px;\n}\n\n.competitiveintelligencereport-style-16 {\n  grid-column: 1 / -1;\n}\n\n.competitiveintelligencereport-style-17 {\n  margin-top: 0;\n  border-top: none;\n  padding-top: 0;\n}\n\n.competitiveintelligencereport-style-18 {\n  margin-bottom: 8px;\n}\n\n.competitiveintelligencereport-style-19 {\n  margin-top: 0;\n  border-top: none;\n  padding-top: 0;\n}\n\n.competitiveintelligencereport-style-20 {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n/* --- CompetitorVolumeChart Styles --- */\n.volume-chart-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.volume-chart-main {\n  display: flex;\n  flex: 1;\n  position: relative;\n  min-height: 180px;\n  margin-bottom: 24px;\n}\n\n.volume-chart-y-axis {\n  position: relative;\n  flex-shrink: 0;\n  align-self: stretch;\n  padding-right: 10px;\n  width: 40px;\n}\n\n.volume-chart-y-tick {\n  position: absolute;\n  right: 10px;\n  transform: translateY(-50%);\n  white-space: nowrap;\n}\n\n.volume-chart-grid-container {\n  flex: 1;\n  position: relative;\n  border-bottom: 1px solid var(--border);\n}\n\n.volume-chart-grid-lines {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 0;\n  pointer-events: none;\n}\n\n.volume-chart-grid-line {\n  position: absolute;\n  left: 0;\n  right: 0;\n  height: 1px;\n  transform: translateY(-50%);\n}\n\n.volume-chart-bars-wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  justify-content: space-around;\n  align-items: flex-end;\n  padding: 0 10px;\n}\n\n.volume-chart-bar-column {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 12%;\n  height: 100%;\n  justify-content: flex-end;\n  position: relative;\n}\n\n.volume-chart-stacked-bar {\n  width: 100%;\n  display: flex;\n  flex-direction: column-reverse;\n  min-height: 1px;\n}\n\n.volume-chart-bar-segment {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--c-white);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  overflow: hidden;\n}\n\n.volume-chart-label {\n  position: absolute;\n  top: 100%;\n  margin-top: 6px;\n  text-align: center;\n  left: 50%;\n  transform: translateX(-50%);\n  cursor: pointer;\n  max-width: 72px;\n  min-width: 0;\n}\n\n.volume-chart-label-content {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.volume-chart-company-dot-slot {\n  flex-shrink: 0;\n  width: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.volume-chart-company-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--c-blue-2);\n}\n\n/* --- CompetitorCadenceHeatmap Styles --- */\n.cadence-heatmap-container {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  font-size: var(--fs-sm);\n  /* Fixed total stagger window — --heatmap-cell-delay / --heatmap-row-delay are 0–1 */\n  --heatmap-stagger-start: 0.1s;\n  --heatmap-stagger-span: 0.55s;\n  --heatmap-cell-duration: 0.35s;\n  --heatmap-row-duration: 0.4s;\n}\n\n.cadence-heatmap-header {\n  display: flex;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.cadence-heatmap-header-spacer {\n  box-sizing: border-box;\n  width: 160px;\n  flex-shrink: 0;\n  padding-right: 12px;\n}\n\n.cadence-heatmap-header-weeks {\n  display: flex;\n  flex: 1;\n  gap: 6px;\n  min-width: 0;\n}\n\n.cadence-heatmap-header-col {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: var(--black);\n  font-size: var(--fs-md);\n}\n\n.cadence-heatmap-row {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.cadence-heatmap-company-lbl {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  width: 160px;\n  flex-shrink: 0;\n  padding-right: 12px;\n  cursor: pointer;\n  font-weight: 500;\n  color: var(--text2);\n  min-width: 0;\n}\n\n.cadence-heatmap-company-name {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.cadence-heatmap-company-name__text {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Chart axis labels — matches cadence heatmap company name typography (12px) */\n.chart-axis-label-text {\n  font-weight: 500;\n  color: var(--text2);\n  font-size: 12px;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.chart-axis-tick-value {\n  font-weight: 500;\n  color: var(--text2);\n  font-size: 12px;\n  line-height: 1;\n}\n\n.chart-axis-label-text--svg {\n  fill: var(--text2);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n.chart-axis-tick-value--svg {\n  fill: var(--text2);\n  font-weight: 500;\n  font-size: 12px;\n}\n\n/* AI Visibility Index only — viewBox fontSize on <text>, not CSS px */\n.geo-insights-visibility-chart__tick,\n.geo-insights-visibility-chart__axis-label {\n  fill: var(--text2);\n  font-weight: 500;\n}\n\n.cadence-heatmap-company-dot-slot {\n  flex-shrink: 0;\n  width: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cadence-heatmap-company-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: var(--c-purple-1);\n}\n\n.cadence-heatmap-cells {\n  display: flex;\n  flex: 1;\n  gap: 6px;\n}\n\n.cadence-heatmap-cell-empty {\n  flex: 1;\n  height: 54px;\n  background: var(--c-white);\n  color: var(--text3);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  font-size: var(--fs-sm);\n}\n\n.cadence-heatmap-cell-active {\n  flex: 1;\n  height: 54px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 600;\n  border-radius: 6px;\n  font-size: var(--fs-sm);\n  box-shadow: inset 0 0 0 1px var(--surface-inset-line);\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.cadence-heatmap-cell-active:hover {\n  transform: translateY(-2px) scale(1.03);\n  box-shadow: var(--shadow-panel);\n  z-index: 10;\n}\n\n.cadence-heatmap-cell-active.is-selected {\n  box-shadow:\n    0 0 0 2px var(--c-purple-1),\n    var(--shadow-panel);\n  transform: translateY(-1px) scale(1.02);\n  z-index: 11;\n}\n\n/* --- KPI Banner Card Styles --- */\n.kpi-banner-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n  align-items: stretch;\n}\n\n.kpi-banner-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  padding: 12px 16px;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  gap: 4px;\n  min-height: 100px;\n  height: auto;\n  overflow: visible;\n}\n\n.kpi-banner-title {\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--text2);\n  letter-spacing: 0.05em;\n  line-height: 1.3;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.kpi-banner-value-row {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-width: 0;\n  min-height: 1.1em;\n}\n\n.kpi-banner-value {\n  font-size: var(--fs-2xl);\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1.1;\n  flex-shrink: 0;\n}\n\n@keyframes kpiValueEnter {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes kpiSignalEnter {\n  0% {\n    opacity: 0;\n    transform: scale(0.55) translateY(6px);\n  }\n\n  65% {\n    transform: scale(1.08) translateY(-1px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.kpi-banner-value--enter {\n  display: inline-block;\n  opacity: 0;\n  animation: kpiValueEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n/* KPI banner compare — signed percent vs competitors (Insights KPICard) */\n.kpi-delta {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  padding: 1px 5px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1.2;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n}\n\n.kpi-banner-card .kpi-delta-slot {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.kpi-delta--enter {\n  display: inline-flex;\n  opacity: 0;\n  animation: kpiSignalEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.kpi-delta--better {\n  color: var(--c-green);\n  background: var(--bg-green-soft);\n}\n\n.kpi-delta--worse {\n  color: var(--c-red);\n  background: var(--bg-red-soft);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .kpi-banner-value--enter,\n  .kpi-delta--enter,\n  .sec-filing-insights-card__foot-total--animate {\n    animation: none;\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.kpi-banner-subtitle {\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n  color: var(--text3);\n}\n\n.kpi-banner-subtitle--stacked {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.kpi-compare-annotation {\n  font-weight: 500;\n  letter-spacing: 0.01em;\n  color: var(--text2);\n  text-transform: none;\n}\n\n.kpi-compare-annotation__value {\n  font-weight: 600;\n  color: var(--c-black);\n  font-variant-numeric: tabular-nums;\n}\n\n.kpi-subtitle-detail {\n  display: block;\n  font-weight: 500;\n  color: var(--text2);\n  line-height: 1.4;\n}\n\n.kpi-product-name {\n  display: block;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text2);\n  line-height: 1.4;\n}\n\n.kpi-banner-card--product-focus {\n  gap: 8px;\n}\n\n.kpi-banner-card--product-focus .kpi-product-focus__label {\n  margin: 0;\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1.35;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.kpi-product-focus__compare {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 16px;\n  min-height: 56px;\n  width: 100%;\n}\n\n.kpi-product-focus__compare--single {\n  justify-content: center;\n}\n\n.kpi-product-focus__side {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-width: 0;\n  flex: 1 1 0;\n  max-width: 42%;\n}\n\n.kpi-product-focus__who {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  line-height: 1.25;\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.kpi-product-focus__count {\n  font-size: var(--fs-2xl);\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1.1;\n  margin-top: 4px;\n}\n\n.kpi-product-focus__divider {\n  flex-shrink: 0;\n  font-size: var(--fs-xl);\n  font-weight: 400;\n  color: var(--text2);\n  line-height: 1;\n  user-select: none;\n}\n\n.table-area.insights-panel .kpi-banner-card--product-focus {\n  grid-column: span 2;\n  min-width: 0;\n}\n\n@media (max-width: 720px) {\n  .table-area.insights-panel .kpi-banner-card--product-focus {\n    grid-column: span 1;\n  }\n}\n\n/* --- Map Toggle Button Selected --- */\n.btn-map-toggle.btn-primary {\n  background: var(--c-black) !important;\n  color: var(--c-white) !important;\n  border-color: var(--c-black) !important;\n}\n\n.btn-map-toggle:hover:not(.btn-primary) {\n  background: var(--c-white) !important;\n  color: var(--c-black) !important;\n  border-color: var(--text3) !important;\n}\n\n/* --- Map Sidebar Rankings Bar Animation --- */\n@keyframes mapBarFill {\n  from {\n    width: 0;\n  }\n}\n\n.map-bar-animate {\n  animation: mapBarFill 1.2s cubic-bezier(0.25, 1, 0.5, 1) forwards !important;\n}\n\n/* Objection Dashboard Heatmap Component Enhancements */\n.objection-heatmap-scroll {\n  overflow-x: auto;\n  width: 100%;\n  max-width: 100%;\n  padding-bottom: 8px;\n}\n\n.objection-heatmap-tbl {\n  border-collapse: separate;\n  border-spacing: 0 16px;\n  /* Precise control over vertical gap between rows! */\n  font-size: 12px;\n  white-space: nowrap;\n  width: max-content;\n  min-width: 100%;\n}\n\n.objection-heatmap-tbl thead th {\n  padding: 6px 8px;\n  border-bottom: 1px solid var(--border);\n  font-weight: 600;\n  color: var(--text2, var(--text2));\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  background: var(--c-white);\n}\n\n.objection-heatmap-tbl thead th.sticky-corner {\n  position: sticky;\n  left: 0;\n  text-align: left;\n  z-index: 10;\n}\n\n.objection-heatmap-tbl tbody tr {\n  height: auto;\n}\n\n.objection-heatmap-tbl tbody th.sticky-state {\n  font-weight: 600;\n  text-align: left;\n  padding: 0 8px;\n  border-bottom: 1px solid var(--c-white);\n  background: var(--c-white);\n  position: sticky;\n  left: 0;\n  z-index: 5;\n  font-family: monospace;\n  font-size: 13px;\n  color: var(--c-black);\n  vertical-align: middle;\n}\n\n.objection-heatmap-tbl tbody td {\n  padding: 0 1px;\n  /* Absolute minimum vertical space around cells! */\n  vertical-align: middle;\n}\n\n.objection-heatmap-cell-block {\n  min-width: 44px;\n  padding: 6px 2px;\n  border-radius: 5px;\n  text-align: center;\n  font-weight: 600;\n  font-family: monospace;\n  font-size: 11px;\n  line-height: 13px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.1s ease;\n}\n\n.objection-heatmap-cell-block:hover {\n  transform: scale(1.05);\n  z-index: 2;\n}\n\n/* SEC Filing — layout shell (Insights adds gutter below) */\n.table-area.sec-filing-panel {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n/* Insights tab — page padding (Table tab stays full-bleed via filings-table-panel only) */\n.table-area.sec-filing-panel.insights-panel {\n  padding: 16px 24px 32px;\n}\n\n\n\n.kpi-banner-card--with-sparkline {\n  min-height: 128px;\n  gap: 6px;\n}\n\n.kpi-banner-sparkline-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: 4px;\n  width: 100%;\n  min-width: 0;\n}\n\n.kpi-sparkline {\n  flex: 1;\n  min-width: 0;\n  height: 32px;\n  display: block;\n  overflow: visible;\n}\n\n.kpi-sparkline__line {\n  fill: none;\n  stroke-width: 1.75;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n}\n\n.kpi-sparkline--up .kpi-sparkline__line {\n  stroke: var(--c-green);\n}\n\n.kpi-sparkline--down .kpi-sparkline__line {\n  stroke: var(--c-red);\n}\n\n.kpi-sparkline--flat .kpi-sparkline__line {\n  stroke: var(--text2);\n}\n\n.kpi-trend-indicator {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  width: 24px;\n  height: 24px;\n  border-radius: 4px;\n}\n\n.kpi-trend-indicator--up {\n  color: var(--c-green);\n  background: var(--bg-green-soft);\n}\n\n.kpi-trend-indicator--down {\n  color: var(--c-red);\n  background: var(--bg-red-soft);\n}\n\n.kpi-trend-indicator--flat {\n  color: var(--text2);\n  background: var(--surface-subtle-tint);\n}\n\n\n\n.sec-filing-period-grid--hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n  pointer-events: none;\n}\n\n.sec-filing-period-grid {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  margin-bottom: 16px;\n}\n\n\n/* SEC Filing Insights — competitor summary cards (intel_axis_sec_insights) */\n/* .sec-filing-insights-summary {\n  padding: 0 24px 24px;\n} */\n\n.sec-filing-insights-summary__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.sec-filing-insights-summary__title {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.sec-filing-insights-summary__meta {\n  font-size: var(--fs-xs);\n  color: var(--text3);\n  letter-spacing: 0.05em;\n}\n\n.sec-filing-insights-summary__grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 12px;\n  align-items: stretch;\n}\n\n.sec-filing-insights-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  min-height: 320px;\n  overflow: hidden;\n  border: 1px solid var(--border);\n  /* border-top: 4px solid var(--c-neon); */\n  border-radius: 8px;\n  background: var(--c-white);\n  transition: opacity 0.2s, border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.sec-filing-insights-card__head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 12px 12px 10px;\n  border-bottom: 1px solid var(--ui-border-divider);\n}\n\n.sec-filing-insights-card__our-label {\n  margin-bottom: 5px;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text2);\n}\n\n.sec-filing-insights-card__name {\n  margin: 0 0 4px;\n  font-family: var(--font);\n  font-size: var(--fs-sm);\n  font-weight: 600;\n  line-height: 1.25;\n  text-transform: uppercase;\n  color: var(--text2);\n  flex: 1;\n  min-width: 0;\n}\n\n.sec-filing-insights-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3px;\n}\n\n.sec-filing-insights-badge {\n  padding: 2px 6px;\n  border-radius: 3px;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.02em;\n}\n\n.sec-filing-insights-badge--public {\n  color: var(--c-white);\n  background: var(--c-black);\n}\n\n.sec-filing-insights-badge--mutual {\n  color: var(--text3);\n  background: var(--ui-surface-muted);\n  border: 1px solid var(--border);\n}\n\n.sec-filing-insights-badge--foreign {\n  color: var(--c-orange);\n  background: var(--bg-orange-soft);\n  border: 1px solid color-mix(in srgb, var(--c-orange) 35%, transparent);\n}\n\n.sec-filing-insights-badge--our {\n  color: var(--ink-overlay);\n  background: color-mix(in srgb, var(--c-neon) 35%, var(--c-white));\n  border: 1px solid color-mix(in srgb, var(--c-neon) 55%, var(--border));\n}\n\n.sec-filing-insights-alert {\n  display: inline-flex;\n  align-items: center;\n  margin-top: 0;\n  padding: 1px 6px;\n  border-radius: 5px;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.sec-filing-insights-alert--critical {\n  color: var(--sec-priority-critical);\n  background: color-mix(in srgb, var(--sec-priority-critical) 12%, var(--c-white));\n  border: 1px solid color-mix(in srgb, var(--sec-priority-critical) 28%, transparent);\n}\n\n.sec-filing-insights-alert--non-critical {\n  color: var(--sec-priority-medium);\n  background: color-mix(in srgb, var(--sec-priority-medium) 14%, var(--c-white));\n  border: 1px solid color-mix(in srgb, var(--sec-priority-medium) 28%, transparent);\n}\n\n.sec-filing-insights-alert--no-activity {\n  color: var(--c-black);\n  border: 1px solid color-mix(in srgb, var(--c-black) 20%, transparent);\n}\n\n.sec-filing-insights-card__section {\n  flex: 1;\n  min-width: 0;\n  padding: 10px 12px;\n  border-bottom: 1px solid var(--ui-border-divider);\n}\n\n.sec-filing-insights-card__section-title {\n  margin-bottom: 8px;\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  /* color: var(--text3); */\n}\n\n.sec-filing-insights-card__row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 3px 0;\n  border-bottom: 1px solid var(--border-faint);\n}\n\n.sec-filing-insights-card__row:last-of-type {\n  border-bottom: none;\n}\n\n.sec-filing-insights-card__label {\n  flex-shrink: 0;\n  font-size: 10px;\n  line-height: 1.4;\n  color: var(--text3);\n}\n\n.sec-filing-insights-card__value {\n  font-size: 10px;\n  font-weight: 500;\n  line-height: 1.4;\n  color: var(--c-black);\n  text-align: right;\n  word-break: break-word;\n}\n\n.sec-filing-insights-card__value--mono {\n  font-family: var(--mono);\n  font-size: 9px;\n}\n\n.sec-filing-insights-card__value--muted {\n  color: var(--text3);\n  font-weight: 400;\n  font-style: italic;\n}\n\n.sec-filing-insights-card__value--link {\n  max-width: 100px;\n  overflow: hidden;\n  color: var(--ui-text-link);\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  text-decoration: none;\n}\n\n.sec-filing-insights-card__value--link:hover {\n  text-decoration: underline;\n}\n\n.sec-filing-insights-card__chart-block {\n  container-type: inline-size;\n  container-name: sec-insights-chart;\n  width: 100%;\n  min-width: 0;\n  padding-top: 8px;\n}\n\n.sec-filing-insights-card__chart-label {\n  margin-bottom: 3px;\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.sec-filing-insights-donut-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  width: 100%;\n  min-width: 0;\n  margin-top: 4px;\n}\n\n.sec-filing-insights-donut {\n  position: relative;\n  width: min(100%, max(3.5rem, 72%));\n  max-width: 100%;\n  aspect-ratio: 1;\n  height: auto;\n  flex-shrink: 1;\n  align-self: center;\n  margin-inline: auto;\n}\n\n.sec-filing-insights-donut--pie {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes secFilingPieCountIn {\n  from {\n    opacity: 0;\n    transform: translateY(6px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@supports (width: 1cqi) {\n  .sec-filing-insights-donut {\n    width: min(100%, max(56px, 72cqi));\n  }\n}\n\n.sec-filing-insights-donut__pie-chart.custom-pie-chart-wrapper {\n  width: 100%;\n  height: 100%;\n}\n\n.sec-filing-insights-donut__pie-chart.custom-pie-chart-wrapper svg {\n  display: block;\n  animation: none;\n}\n\n/* Ring uses segment stroke fill only — no wrapper/center slide */\n.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center {\n  animation: none;\n  transform: none;\n}\n\n.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__value {\n  animation: secFilingPieCountIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(500ms + var(--pie-chart-stagger, 0ms));\n}\n\n.sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__label {\n  animation: secFilingPieCountIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(580ms + var(--pie-chart-stagger, 0ms));\n}\n\n.sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--c-black);\n  line-height: 1.1;\n}\n\n.sec-filing-insights-donut__pie-chart .pie-chart-center span:last-child {\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--text3);\n  margin-top: 1px;\n}\n\n@supports (width: 1cqi) {\n  .sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {\n    font-size: clamp(11px, 14cqi, 22px);\n  }\n\n  .sec-filing-insights-donut__pie-chart .pie-chart-center span:last-child {\n    font-size: clamp(8px, 6cqi, var(--fs-xs));\n  }\n}\n\n.sec-filing-insights-donut-wrap--empty .sec-filing-insights-donut__pie-chart .pie-chart-center span:first-child {\n  color: var(--text3);\n}\n\n.sec-filing-insights-donut-legend {\n  width: 100%;\n}\n\n.sec-filing-insights-donut-legend__item {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  width: 100%;\n  margin-bottom: 4px;\n  font-size: 10px;\n  color: var(--text2);\n}\n\n.sec-filing-insights-donut-legend__item:last-child {\n  margin-bottom: 0;\n}\n\n.sec-filing-insights-donut-legend__dot {\n  width: 8px;\n  height: 8px;\n  flex-shrink: 0;\n  border-radius: 50%;\n}\n\n.sec-filing-insights-donut-legend__dot--critical {\n  background: var(--sec-priority-critical);\n}\n\n.sec-filing-insights-donut-legend__dot--non-critical {\n  background: var(--sec-priority-medium);\n}\n\n.sec-filing-insights-donut-legend__dot--empty {\n  background: var(--border);\n}\n\n.sec-filing-insights-donut-wrap--empty .sec-filing-insights-donut-legend__count {\n  color: var(--text3);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sec-filing-insights-donut--animate .sec-filing-insights-donut-legend__item,\n  .sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__value,\n  .sec-filing-insights-donut--animate .sec-filing-insights-donut__pie-chart .pie-chart-center__label {\n    animation: none;\n    opacity: 1;\n    transform: none;\n  }\n\n  .sec-filing-insights-donut__pie-chart .pie-chart-segment {\n    transition: none !important;\n  }\n}\n\n.sec-filing-insights-donut-legend__label {\n  flex: 1;\n  min-width: 0;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-donut-legend__count {\n  margin-left: auto;\n  font-family: var(--font);\n  font-size: var(--fs-xs);\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  color: var(--c-black);\n  text-align: right;\n}\n\n.sec-filing-insights-card__foot {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 8px;\n  margin-top: auto;\n  padding: 8px 10px 10px 12px;\n  padding-right: 44px;\n  border-top: 1px solid var(--ui-border-divider);\n}\n\n.sec-filing-insights-card__foot-total {\n  font-size: var(--fs-md);\n  font-weight: 600;\n  color: var(--c-black);\n}\n\n.sec-filing-insights-card__foot-total--animate {\n  display: inline-block;\n  opacity: 0;\n  animation: kpiValueEnter 0.55s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.sec-filing-insights-card__foot-total-label {\n  font-size: 10px;\n  color: var(--text3);\n}\n\n.sec-filing-insights-card__foot-date-label {\n  font-size: 10px;\n  color: var(--text3);\n  text-align: left;\n}\n\n.sec-filing-insights-card__foot-date-val {\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--c-black);\n  text-align: left;\n}\n\n.sec-filing-insights-card__view-btn {\n  position: absolute;\n  right: 10px;\n  bottom: 10px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 1px solid var(--border);\n  border-radius: 5px;\n  background: var(--c-white);\n  color: var(--text2);\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.sec-filing-insights-card__view-btn:hover {\n  background: color-mix(in srgb, var(--c-black) 6%, var(--c-white));\n  color: var(--c-black);\n  border-color: color-mix(in srgb, var(--c-black) 20%, var(--border));\n}\n\n.sec-filing-insights-card__view-btn.is-active {\n  background: var(--c-neon);\n  border-color: var(--c-neon);\n  color: var(--c-black);\n  box-shadow: 0 0 0 1px color-mix(in srgb, var(--c-neon) 40%, transparent);\n}\n\n.sec-filing-insights-card__view-btn.is-active:hover {\n  background: var(--neon-btn-bg-hover, var(--c-neon));\n  border-color: var(--neon-btn-bg-hover, var(--c-neon));\n  color: var(--c-black);\n}\n\n.sec-filing-insights-card__view-btn:focus-visible {\n  outline: 2px solid var(--c-black);\n  outline-offset: 1px;\n}\n\n@keyframes sec-filing-view-chevron-float {\n  0% {\n    transform: translateY(0);\n  }\n\n  25% {\n    transform: translateY(3px);\n  }\n\n  50% {\n    transform: translateY(-2px);\n  }\n\n  75% {\n    transform: translateY(3px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.sec-filing-insights-card__view-btn svg {\n  flex-shrink: 0;\n}\n\n.sec-filing-insights-card__view-btn:hover:not(:disabled) svg {\n  animation: sec-filing-view-chevron-float 1s ease-in-out infinite;\n}\n\n/* SEC pagination chevrons — slight directional nudge on hover */\n.sec-filing-insights-period-table .pg-controls .pg-btn svg,\n.sec-filing-panel.filings-table-panel .pg-controls .pg-btn svg {\n  transition: transform 0.2s ease;\n}\n\n.sec-filing-insights-period-table .pg-controls .pg-btn:first-of-type:hover:not(:disabled) svg,\n.sec-filing-panel.filings-table-panel .pg-controls .pg-btn:first-of-type:hover:not(:disabled) svg {\n  transform: translateX(-2px);\n}\n\n.sec-filing-insights-period-table .pg-controls .pg-btn:last-of-type:hover:not(:disabled) svg,\n.sec-filing-panel.filings-table-panel .pg-controls .pg-btn:last-of-type:hover:not(:disabled) svg {\n  transform: translateX(2px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .sec-filing-insights-card__view-btn svg,\n  .sec-filing-insights-period-table .pg-controls .pg-btn svg,\n  .sec-filing-panel.filings-table-panel .pg-controls .pg-btn svg {\n    transition: none;\n  }\n\n  .sec-filing-insights-card__view-btn:hover:not(:disabled) svg {\n    animation: none;\n    transform: none;\n  }\n\n  .sec-filing-insights-period-table .pg-controls .pg-btn:hover:not(:disabled) svg,\n  .sec-filing-panel.filings-table-panel .pg-controls .pg-btn:hover:not(:disabled) svg {\n    transform: none;\n  }\n}\n\n@media (max-width: 1600px) {\n  .sec-filing-insights-summary__grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 900px) {\n  .sec-filing-insights-summary__grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 560px) {\n  .sec-filing-insights-summary__grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* SEC Insights — period filings table (below company cards) */\n.sec-filing-insights-period-table {\n  margin-top: 20px;\n  padding-top: 20px;\n  border-top: 1px solid var(--border);\n}\n\n.sec-filing-insights-period-table__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.sec-filing-insights-period-table__header-main {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.sec-filing-insights-period-table__title {\n  margin: 0;\n  font-family: var(--font-display);\n  font-size: 18px;\n  font-weight: 500;\n  color: var(--c-black);\n}\n\n.sec-filing-insights-period-table__clear-filter {\n  flex-shrink: 0;\n  padding: 0;\n  border: none;\n  background: none;\n  font-family: inherit;\n  font-size: var(--fs-xs);\n  font-weight: 500;\n  color: var(--text2);\n  text-decoration: underline;\n  cursor: pointer;\n}\n\n.sec-filing-insights-period-table__clear-filter:hover,\n.sec-filing-insights-period-table__clear-filter:focus-visible {\n  color: var(--c-black);\n}\n\n.sec-filing-insights-period-table__meta {\n  font-size: var(--fs-xs);\n  color: var(--text3);\n  letter-spacing: 0.05em;\n}\n\n.sec-filing-insights-period-table__panel {\n  overflow: hidden;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: var(--c-white);\n}\n\n.sec-filing-insights-period-table__wrap {\n  flex: none;\n  overflow-x: auto;\n  overflow-y: visible;\n}\n\n/* Full-width table with balanced fixed column shares */\n.sec-filing-insights-data-table {\n  table-layout: fixed;\n  width: 100%;\n}\n\n.sec-filing-insights-data-table th,\n.sec-filing-insights-data-table td {\n  padding: 10px 8px;\n  vertical-align: middle;\n  overflow: hidden;\n}\n\n.sec-filing-insights-data-table th {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.sec-filing-insights-data-table td {\n  font-size: 13px;\n}\n\n.sec-filing-insights-data-table .col-sno {\n  width: 5%;\n  text-align: center;\n}\n\n.sec-filing-insights-data-table .col-company {\n  width: 11%;\n}\n\n.sec-filing-insights-data-table .col-entity {\n  width: 20%;\n}\n\n.sec-filing-insights-data-table .col-type {\n  width: 8%;\n}\n\n.sec-filing-insights-data-table .col-priority {\n  width: 9%;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-accepted {\n  width: 11%;\n  font-variant-numeric: tabular-nums;\n  vertical-align: middle;\n}\n\n.sec-filing-table__accepted-date {\n  line-height: 1.3;\n  white-space: nowrap;\n}\n\n.sec-filing-table__accepted-time {\n  margin-top: 2px;\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 1.2;\n  color: var(--text3);\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-date {\n  width: 9%;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-file-film {\n  width: 10%;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-xbrl {\n  width: 14%;\n}\n\n.sec-filing-insights-data-table .col-xbrl-value {\n  width: 13%;\n  text-align: left;\n}\n\n.sec-filing-insights-data-table .col-actions {\n  width: 10%;\n  text-align: center;\n}\n\n.sec-filing-table__company-group {\n  margin-bottom: 3px;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--text3);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sec-filing-table__company-name {\n  font-size: 13px;\n  /* font-weight: 500; */\n  line-height: 1.35;\n  color: var(--c-black);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sec-filing-table__company-name .geo-brand-name-cell,\n.table-area.filings-table-panel .company-cell .geo-brand-name-cell {\n  width: 100%;\n  min-width: 0;\n}\n\n.sec-filing-table__company-name .geo-brand-name-cell__label,\n.table-area.filings-table-panel .company-cell .geo-brand-name-cell__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n}\n\n.sec-filing-table__entity-header {\n  font-size: 13px;\n  /* font-weight: 600; */\n  line-height: 1.35;\n  color: var(--c-black);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.sec-filing-table__filing-desc {\n  margin-top: 3px;\n  font-size: 12px;\n  line-height: 1.35;\n  color: var(--text2);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n\n.sec-filing-table-drawer__entity-header {\n  /* font-weight: 600; */\n  line-height: 1.4;\n}\n\n.sec-filing-table__file-film {\n  line-height: 1.35;\n}\n\n.sec-filing-table__file-num {\n  font-size: 13px;\n  color: var(--text);\n}\n\n.sec-filing-table__film-num {\n  margin-top: 2px;\n  font-size: 11px;\n  color: var(--text3);\n}\n\n.sec-filing-insights-data-table__actions {\n  text-align: center;\n  vertical-align: middle;\n}\n\n.sec-filing-insights-data-table__action-group {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n}\n\n.sec-filing-insights-data-table__action-empty {\n  color: var(--text3);\n  font-size: 13px;\n}\n\n.sec-filing-insights-data-table__th-stacked {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  line-height: 1.2;\n}\n\n.sec-filing-insights-data-table__th-sub {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text3);\n}\n\n.sec-filing-insights-data-table .col-company .company-name {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-type {\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table .col-priority {\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table tbody tr {\n  height: 56px;\n  cursor: pointer;\n}\n\n.sec-filing-insights-data-table__sno {\n  text-align: center;\n  font-size: 13px;\n  color: var(--text2);\n  font-variant-numeric: tabular-nums;\n}\n\n.sec-filing-insights-data-table__xbrl {\n  overflow: hidden;\n  font-family: var(--font);\n  font-size: 13px;\n  line-height: 1.35;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.sec-filing-insights-data-table .col-xbrl-value,\n.sec-filing-insights-data-table__xbrl-value {\n  font-family: var(--mono);\n  font-size: 13px;\n  font-variant-numeric: tabular-nums;\n  color: var(--c-black);\n  text-align: left;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-data-table__xbrl-value--empty {\n  color: var(--text3);\n  font-weight: 400;\n}\n\n.sec-filing-insights-data-table .sec-filing-insights-type-pill {\n  display: inline-block;\n  max-width: 100%;\n  overflow: hidden;\n  font-size: 11px;\n  text-overflow: ellipsis;\n  vertical-align: middle;\n}\n\n/* .sec-filing-insights-data-table__row--critical.selected td,\n.sec-filing-insights-data-table__row--critical.selected:hover td {\n  background: color-mix(in srgb, var(--sec-priority-critical) 10%, var(--c-cyan-1));\n} */\n\n.sec-filing-insights-period-table__empty {\n  padding: 32px 16px !important;\n  text-align: center;\n  color: var(--text3);\n  font-size: 13px;\n}\n\n.sec-filing-insights-period-table__pagination {\n  position: static;\n  border-top: 1px solid var(--border);\n}\n\n.sec-filing-insights-type-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 10px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.sec-filing-insights-type-pill--critical {\n  color: var(--sec-priority-critical);\n  background: color-mix(in srgb, var(--sec-priority-critical) 12%, var(--c-white));\n  border: 1px solid color-mix(in srgb, var(--sec-priority-critical) 28%, transparent);\n}\n\n.sec-filing-insights-type-pill--non-critical {\n  color: var(--sec-priority-medium);\n  background: color-mix(in srgb, var(--sec-priority-medium) 14%, var(--c-white));\n  border: 1px solid color-mix(in srgb, var(--sec-priority-medium) 28%, transparent);\n}\n\n\n\n@media (max-width: 1100px) {\n  .sec-filing-period-grid {\n    grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));\n  }\n}\n\n.sec-filing-period-card {\n  cursor: pointer;\n  border-radius: 8px;\n  outline: none;\n}\n\n.sec-filing-period-card:focus-visible {\n  box-shadow: 0 0 0 2px var(--focus-border-blue);\n}\n\n.sec-filing-period-card .kpi-banner-card {\n  height: 100%;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n@keyframes secFilingPeriodCardSelect {\n  from {\n    opacity: 0.72;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n.sec-filing-period-card.is-active .kpi-banner-card {\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n\n/* SEC Insights — entrance animations only on first load (not period switches) */\n.table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-period-table__panel {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;\n}\n\n.table-area.sec-filing-panel.insights-panel:not(.sec-filing-insights--entered) .sec-filing-insights-data-table tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.12s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.sec-filing-insights-summary__switch {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Period switch — table panel + row stagger (after first load) */\n.table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered\n  .sec-filing-insights-period-table__panel--period-switch {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;\n}\n\n.table-area.sec-filing-panel.insights-panel.sec-filing-insights--entered\n  .sec-filing-insights-period-table__panel--period-switch\n  .sec-filing-insights-data-table tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n\n/* KPI selected state — neon top accent (SEC Filing period cards) */\n.kpi-banner-card--accent-neon-top {\n  border: 1px solid var(--border);\n  border-top: 4px solid var(--c-neon);\n  box-shadow: none;\n}\n\n.kpi-banner-card--accent-neon-top > .kpi-banner-subtitle {\n  /* color: var(--c-teal-active) !important; */\n  font-weight: 500;\n}\n\n\n/* SEC filing table — detail drawer (same 360px width as Filings .drawer) */\n.sec-filing-table-drawer__more-info-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.sec-filing-table-drawer .drawer-body {\n  padding: 16px;\n  gap: 14px;\n}\n\n.sec-filing-table-drawer__xbrl-tag {\n  line-height: 1.4;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.sec-filing-table-drawer__xbrl-value {\n  font-family: var(--mono);\n  font-variant-numeric: tabular-nums;\n}\n\n.sec-filing-table-drawer .field-grid .field--span-full {\n  grid-column: 1 / -1;\n}\n\n.sec-filing-table-drawer__filing-type {\n  display: flex;\n  align-items: flex-start;\n}\n\n.sec-filing-table-drawer__link {\n  color: var(--ui-text-link);\n  overflow-wrap: anywhere;\n  text-decoration: none;\n  word-break: break-word;\n  font-size: 12px;\n}\n\n.sec-filing-table-drawer__link:hover {\n  text-decoration: underline;\n}\n\n.sec-filing-table-drawer .sec-filing-insights-type-pill {\n  max-width: 100%;\n  overflow: visible;\n  text-overflow: unset;\n  white-space: normal;\n  word-break: break-word;\n}\n\n.sec-filing-insights-type-pill--empty {\n  color: var(--text3);\n  font-weight: 400;\n  background: transparent;\n  border: none;\n  padding: 0;\n}\n\n/* Table view: shrink with drawer (footer already flexes; table-wrap needs min-width + fixed layout) */\n.table-area.sec-filing-panel.filings-table-panel {\n  min-width: 0;\n}\n\n.sec-filing-panel.filings-table-panel .table-wrap {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.04s backwards;\n}\n\n.sec-filing-panel.filings-table-panel .table-wrap .sec-filing-insights-data-table {\n  table-layout: fixed;\n  width: 100%;\n  max-width: 100%;\n}\n\n.sec-filing-panel.filings-table-panel thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;\n}\n\n.sec-filing-panel.filings-table-panel .pagination-sticky {\n  flex-shrink: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;\n}\n\n.col-entity {\n  max-width: 220px;\n}\n\n.sec-filing-table__entity {\n  max-width: 220px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 12px;\n  color: var(--text2);\n}\n\n.col-sec-doc {\n  width: 72px;\n  text-align: center;\n}\n\n.sec-filing-table__doc {\n  text-align: center;\n}\n\n.sec-filing-table__doc-link {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--c-blue-1);\n}\n\n.sec-filing-table__doc-link:hover {\n  color: var(--c-black);\n}\n\n.sec-filing-drawer.details-drawer {\n  width: 420px;\n  right: -420px;\n}\n\n.sec-filing-drawer.details-drawer.open {\n  right: 0;\n}\n\n.sec-filing-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  color: var(--text2);\n}\n\n/* Insights matrix cell drawer — list layout without section padding */\n.sec-filing-drawer:not(.sec-filing-table-drawer) .sec-filing-drawer__body {\n  padding: 0;\n  gap: 0;\n}\n\n.sec-filing-drawer__empty {\n  padding: 40px 24px;\n  text-align: center;\n  color: var(--text3);\n  font-size: 13px;\n}\n\n.sec-filing-drawer__item {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 12px 24px;\n  border-bottom: 1px solid var(--border);\n}\n\n.sec-filing-drawer__item:last-child {\n  border-bottom: none;\n}\n\n.sec-filing-drawer__item:hover {\n  background: var(--ui-surface-hover, color-mix(in srgb, var(--border) 25%, var(--c-white)));\n}\n\n.sec-filing-drawer__item-main {\n  flex: 1;\n  min-width: 0;\n}\n\n.sec-filing-drawer__id {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-blue-1);\n  text-decoration: none;\n  display: block;\n  margin-bottom: 4px;\n}\n\n.sec-filing-drawer__id:hover {\n  text-decoration: underline;\n}\n\n.sec-filing-drawer__meta {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n}\n\n.sec-filing-drawer__date {\n  font-size: 11px;\n  color: var(--text3);\n}\n\n.sec-filing-drawer__toi {\n  margin-top: 4px;\n  font-size: 11px;\n  color: var(--text3);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.sec-filing-drawer__ext {\n  flex-shrink: 0;\n  margin-top: 2px;\n  color: var(--text3);\n}\n\n.sec-filing-drawer__footer {\n  display: block;\n  font-size: 11px;\n  color: var(--text3);\n}\n\n/* Prompt Pulse — layout shell (mirrors .table-area.sec-filing-panel) */\n.table-area.geo-analytics-panel {\n  flex: 1;\n  min-width: 0;\n  min-height: 0;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.table-area.geo-analytics-panel.insights-panel {\n  padding: 16px 24px 32px;\n}\n\n/* Prompt Pulse Insights — entrance animations (initial load + filter apply) */\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > * {\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(1) { animation-delay: 0.06s; }\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(2) { animation-delay: 0.11s; }\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(3) { animation-delay: 0.16s; }\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(4) { animation-delay: 0.21s; }\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-kpi-grid > *:nth-child(n + 5) { animation-delay: 0.26s; }\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card,\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card {\n  animation: filingsInsightsCardIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-chart-card {\n  animation-delay: 0.24s;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-top-prompts-card {\n  animation-delay: 0.42s;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) thead tr {\n  animation: filingsInsightsFadeIn 0.4s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-data-table:not(.geo-insights-visibility-table):not(.geo-insights-ranking-table) tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.14s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n/* Company Ranking — SEC Filings table entrance */\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-card .geo-insights-table-wrap {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-ranking-table tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n/* AI Visibility Index — chart static; table matches SEC Filings table entrance */\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table-wrap {\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-visibility-table tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__clip {\n  transform-box: fill-box;\n  transform-origin: left center;\n  transform: scaleX(0);\n  animation: geoLineClipReveal var(--geo-line-clip-duration, 1.05s) cubic-bezier(0.16, 1, 0.3, 1) var(--geo-line-clip-delay, 0.18s) forwards;\n}\n\n@keyframes geoLineClipReveal {\n  to {\n    transform: scaleX(1);\n  }\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-line-chart__dot {\n  opacity: 0;\n  transform: scale(0.6);\n  transform-box: fill-box;\n  transform-origin: center;\n  animation: filingsChartPointIn 0.32s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n  animation-delay: var(--point-delay, 0.18s);\n}\n\n.table-area.geo-analytics-panel.filings-table-panel {\n  padding: 16px 24px 32px;\n}\n\n/* Prompts table tab — full-bleed like SEC Filings table (no extra footer gutter) */\n.table-area.geo-analytics-panel.filings-table-panel.geo-prompts-table-panel {\n  padding: 0;\n  min-width: 0;\n}\n\n.geo-prompts-table-panel .geo-prompts-content {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  min-height: 0;\n  min-width: 0;\n}\n\n.geo-prompts-table-panel .geo-prompts-content .table-wrap {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.geo-prompts-table-panel .geo-prompts-content thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.geo-prompts-table-panel .geo-prompts-content tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.geo-prompts-table-panel .geo-prompts-content .pagination-sticky {\n  flex-shrink: 0;\n  min-width: 0;\n  width: 100%;\n  box-sizing: border-box;\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;\n}\n\n/* Pagination rows-per-page — match SEC (28px control, not default 32px select-wrap) */\n.table-area.filings-table-panel .table-pagination .select-wrap {\n  height: 28px;\n}\n\n.table-area.filings-table-panel .table-pagination .select-measure {\n  height: 28px;\n  line-height: 28px;\n  min-height: 28px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-sno {\n  width: 6%;\n  text-align: center;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-rank {\n  width: 5%;\n  min-width: 52px;\n  max-width: 72px;\n  padding-left: 16px;\n  padding-right: 10px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-prompt {\n  width: 44%;\n  min-width: 0;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .geo-prompt-cell {\n  max-width: none;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-mentions {\n  width: 12%;\n  min-width: 128px;\n  white-space: nowrap;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-prompt {\n  width: 28%;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-coverage {\n  width: 120px;\n  min-width: 120px;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-coverage {\n  width: 11%;\n  min-width: 120px;\n  padding-right: 16px;\n  white-space: nowrap;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-position {\n  width: 128px;\n  min-width: 128px;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-position {\n  width: 12%;\n  min-width: 128px;\n  white-space: nowrap;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-sentiment {\n  width: 168px;\n  min-width: 168px;\n  text-align: center;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-sentiment {\n  width: 16%;\n  min-width: 168px;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-coverage .geo-table-header-label,\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-position .geo-table-header-label,\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-sentiment .geo-table-header-label {\n  justify-content: center;\n}\n\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-mentions,\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-position,\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-sentiment,\n.geo-insights-top-prompts-card .sec-filing-insights-data-table .col-coverage {\n  text-align: center;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-intent {\n  width: 14%;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-product-line {\n  width: 18%;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table .col-priority {\n  width: 12%;\n}\n\n.geo-prompts-table-panel .sec-filing-insights-data-table th:first-child,\n.geo-prompts-table-panel .sec-filing-insights-data-table td:first-child {\n  padding-left: 12px;\n  padding-right: 12px;\n}\n\n/* Edit prompts modal — compact shell; list scrolls inside, not full 85vh stretch */\n.geo-prompt-edit-backdrop {\n  animation: filingsInsightsFadeIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.configure-dialog.configure-dialog--geo-prompts {\n  width: min(720px, calc(100vw - 48px));\n  max-width: 720px;\n  height: auto;\n  max-height: min(85vh, calc(100vh - 48px));\n  overflow: hidden;\n  animation: filingsInsightsIn 0.42s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.configure-dialog--geo-prompts .p-dialog-header {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.configure-dialog--geo-prompts .modal-desc {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.08s backwards;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 12px;\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.configure-dialog--geo-prompts .config-hint {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.12s backwards;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-list--entered .competitor-item {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.configure-dialog--geo-prompts .p-dialog-footer {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.16s backwards;\n}\n\n.configure-dialog--geo-prompts .p-dialog-content {\n  flex: 0 1 auto;\n  min-height: unset;\n  max-height: none;\n  overflow: visible;\n}\n\n.configure-dialog--geo-prompts .competitor-picker {\n  flex: 0 1 auto;\n  min-height: unset;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-search {\n  flex: 1 1 220px;\n  min-width: 0;\n  height: 36px;\n  padding: 0 12px;\n  border: 1px solid var(--border2);\n  border-radius: 6px;\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--c-black);\n  background: var(--c-white);\n  box-sizing: border-box;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-search:focus {\n  outline: none;\n  border-color: var(--c-black);\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-toolbar__actions {\n  display: flex;\n  flex-wrap: nowrap;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-toolbar__actions .btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 0;\n  min-width: 112px;\n  white-space: nowrap;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-column {\n  max-height: min(52vh, 480px);\n  overflow: hidden;\n  border-radius: var(--border-radius);\n  animation: filingsInsightsFadeIn 0.5s cubic-bezier(0.16, 1, 0.3, 1) 0.05s backwards;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list {\n  max-height: min(52vh, 480px);\n  overflow-x: hidden;\n  overflow-y: auto;\n  border-radius: 0;\n  background: var(--ui-surface);\n  scrollbar-width: thin;\n  scrollbar-color: color-mix(in srgb, var(--c-black) 28%, transparent) transparent;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar {\n  width: 8px;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-column .competitor-list::-webkit-scrollbar-thumb {\n  background: color-mix(in srgb, var(--c-black) 28%, transparent);\n  border-radius: 4px;\n}\n\n.configure-dialog--geo-prompts .geo-prompt-edit-list--loading {\n  min-height: 120px;\n}\n\n.configure-dialog--geo-prompts .competitor-item input[type='checkbox'] {\n  width: 14px;\n  height: 14px;\n  margin-top: 3px;\n  accent-color: var(--c-black);\n}\n\n/* Do not use .report-page here — it fixes width to 1460px and centers the shell */\n.table-area.geo-analytics-panel .report-page {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n  box-shadow: none;\n  background: transparent;\n}\n\n.geo-insights-toolbar {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.geo-insights-toolbar__filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  align-items: flex-end;\n}\n\n.geo-insights-select-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.geo-insights-select-wrap--inline {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n}\n\n.geo-insights-select-wrap__label {\n  font-size: 11px;\n  color: var(--text3);\n  font-weight: 500;\n}\n\n.geo-insights-select {\n  min-width: 140px;\n  height: 32px;\n  padding: 0 10px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--surface);\n  color: var(--text);\n  font-size: 13px;\n}\n\n.geo-insights-toolbar__meta {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.geo-insights-toolbar__summary {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text3);\n}\n\n.geo-insights-toolbar__settings {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 1px solid var(--border);\n  border-radius: 6px;\n  background: var(--surface);\n  color: var(--text2);\n}\n\n.geo-insights-error {\n  margin: 0 0 16px;\n}\n\n.geo-insights-top-prompts-card {\n  width: 100%;\n  margin-bottom: 20px;\n  overflow: hidden;\n}\n\n.geo-insights-top-prompts-card.geo-insights-table-card {\n  display: block;\n  height: auto;\n}\n\n.geo-insights-top-prompts-card .geo-insights-table-wrap {\n  flex: none;\n  padding: 0;\n  overflow: visible;\n  min-height: 0;\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table {\n  font-size: 12px;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody tr {\n  cursor: default;\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table th,\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table td {\n  padding: 8px 6px;\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table thead th {\n  border-bottom: 1px solid var(--border);\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody td {\n  border-bottom: 1px solid var(--border);\n}\n\n.geo-insights-top-prompts-card .geo-insights-top-prompts-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.volume-chart-panel .chart-panel__header .geo-metric-title {\n  align-self: stretch;\n  box-sizing: border-box;\n}\n\n.geo-citations-card__title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.geo-metric-title {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.geo-metric-title__label {\n  min-width: 0;\n}\n\n.geo-metric-info {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: var(--text3);\n  cursor: default;\n}\n\n.geo-metric-info:hover {\n  color: var(--text2);\n}\n\n.geo-metric-info--compact {\n  transform: scale(0.92);\n}\n\n.geo-metric-info--kpi {\n  transform: scale(0.9);\n  vertical-align: middle;\n}\n\n.kpi-banner-title--with-info {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  max-width: 100%;\n}\n\n.kpi-banner-title__label {\n  min-width: 0;\n}\n\n.geo-table-header-label {\n  display: inline-flex;\n  align-items: center;\n  justify-content: inherit;\n  gap: 4px;\n  flex-shrink: 0;\n  max-width: none;\n}\n\n.geo-insights-data-table th:has(.geo-table-header-label),\n.sec-filing-insights-data-table th:has(.geo-table-header-label) {\n  overflow: visible;\n}\n\n.geo-insights-data-table th .geo-table-header-label,\n.sec-filing-insights-data-table th .geo-table-header-label {\n  white-space: nowrap;\n}\n\n.geo-metric-tooltip__body {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 400;\n  color: var(--text2);\n  line-height: 1.45;\n}\n\n.geo-metric-tooltip.geo-line-chart-tooltip:not(:has(.geo-line-chart-tooltip__date)) {\n  padding-top: 10px;\n}\n\n.geo-citations-card__info {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--text3);\n  cursor: default;\n}\n\n.geo-citations-table__col-rank,\n.geo-citations-table__col-share,\n.geo-citations-table__col-count {\n  text-align: center;\n}\n\n.geo-citations-table__col-rank {\n  width: 72px;\n  min-width: 72px;\n  white-space: nowrap;\n}\n\n.geo-citations-table__col-share,\n.geo-citations-table__col-count {\n  width: 140px;\n  min-width: 140px;\n  white-space: nowrap;\n}\n\n.geo-citations-table tbody td:first-child,\n.geo-citations-table tbody td:nth-child(3),\n.geo-citations-table tbody td:nth-child(4) {\n  text-align: center;\n}\n\n.geo-citations-table__url {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  max-width: 100%;\n  color: var(--text);\n  text-decoration: none;\n  font-size: 13px;\n  line-height: 1.35;\n}\n\n.geo-citations-table__url:hover {\n  color: var(--c-black);\n  text-decoration: underline;\n}\n\n.geo-citations-table__favicon {\n  flex-shrink: 0;\n  border-radius: 2px;\n}\n\n.geo-citations-table__url-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.geo-insights-data-table td:has(.geo-citations-table__url) {\n  max-width: 0;\n  width: 55%;\n}\n\n.geo-citations-card__footer {\n  padding: 10px 24px 14px;\n  border-top: 1px solid var(--border);\n}\n\n.geo-citations-card__footer-note {\n  font-size: 12px;\n  color: var(--text3);\n}\n\n.geo-insights-visibility-card {\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.geo-insights-visibility-body {\n  display: grid;\n  /* 1.5fr ≈ 30% wider chart column vs original 1.15fr (drives SVG width:100% height) */\n  grid-template-columns: minmax(0, 1.5fr) minmax(280px, 1fr);\n  gap: 24px;\n  padding: 0 16px 12px;\n  align-items: start;\n}\n\n.geo-insights-visibility-chart-wrap {\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n  width: 100%;\n  min-width: 0;\n  overflow: visible;\n}\n\n.geo-insights-visibility-chart-wrap .geo-insights-empty--compact {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 244px;\n  width: 100%;\n}\n\n.geo-insights-visibility-chart {\n  display: block;\n  width: 100%;\n  height: auto;\n  flex-shrink: 0;\n  vertical-align: top;\n  overflow: visible;\n}\n\n.geo-insights-visibility-chart__plot-bg {\n  fill: var(--c-white);\n}\n\n.geo-insights-visibility-chart__axis-line {\n  stroke: var(--border);\n  stroke-width: 1;\n  vector-effect: non-scaling-stroke;\n}\n\n.geo-insights-visibility-chart__midline {\n  stroke: var(--border);\n  stroke-width: 1;\n  stroke-dasharray: 3 3;\n  vector-effect: non-scaling-stroke;\n}\n\n.geo-insights-visibility-chart__quadrant-label {\n  font-weight: 600;\n}\n\n.geo-insights-visibility-chart__quadrant-label--niche {\n  fill: var(--geo-quadrant-niche);\n}\n\n.geo-insights-visibility-chart__quadrant-label--leaders {\n  fill: var(--geo-quadrant-leaders);\n}\n\n.geo-insights-visibility-chart__quadrant-label--low-performance {\n  fill: var(--geo-quadrant-low-performance);\n}\n\n.geo-insights-visibility-chart__quadrant-label--low-conversion {\n  fill: var(--geo-quadrant-low-conversion);\n}\n\n.geo-insights-visibility-chart__brand-logo-fo {\n  overflow: visible;\n  pointer-events: visiblePainted;\n}\n\n.geo-insights-visibility-chart__brand-logo-host {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.geo-brand-logo-img {\n  display: block;\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  object-fit: contain;\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  flex-shrink: 0;\n}\n\n.geo-brand-logo-img--chart {\n  width: 10px;\n  height: 10px;\n  border-radius: 2px;\n}\n\n.geo-brand-logo-img--client,\n.geo-brand-avatar--client {\n  box-shadow: 0 0 0 1px #7456da;\n}\n\n.geo-insights-visibility-table-wrap {\n  min-width: 0;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n  align-self: start;\n}\n\n.geo-insights-visibility-table {\n  width: 100%;\n  table-layout: fixed;\n  font-size: 12px;\n}\n\n.geo-insights-visibility-table th,\n.geo-insights-visibility-table td {\n  padding: 10px 12px;\n  vertical-align: middle;\n}\n\n.geo-insights-visibility-table .col-brand {\n  width: 38%;\n}\n\n.geo-insights-visibility-table .col-quadrant {\n  width: 26%;\n  white-space: nowrap;\n  text-align: center;\n}\n\n.geo-insights-visibility-table .col-metric {\n  width: 18%;\n  min-width: 128px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.geo-insights-visibility-table .col-brand .geo-brand-name-cell {\n  display: flex;\n  margin-bottom: 0;\n}\n\n.geo-insights-visibility-table .col-brand .geo-brand-name-cell__label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.geo-insights-empty--compact {\n  min-height: 160px;\n}\n\n@media (max-width: 960px) {\n  .geo-insights-visibility-body {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .geo-insights-visibility-chart-wrap {\n    width: 100%;\n  }\n}\n\n/* KPI row + chart + ranking share one 5-column grid */\n.geo-insights-kpi-chart-layout {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  width: 100%;\n  margin-bottom: 20px;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-kpi-grid {\n  display: contents;\n  margin-bottom: 0;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-kpi-grid > * {\n  min-width: 0;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-chart-card {\n  grid-column: 1 / 4;\n  grid-row: 2;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n  min-width: 0;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card {\n  grid-column: 4 / 6;\n  grid-row: 2;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .chart-panel__header {\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.geo-insights-ranking-card .geo-insights-table-wrap {\n  flex: 1;\n  min-height: 0;\n  padding-left: 0;\n  padding-right: 0;\n  padding-bottom: 8px;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-table-wrap {\n  flex: 1;\n  min-height: 0;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table {\n  font-size: 12px;\n  table-layout: fixed;\n  width: 100%;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table th,\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table td {\n  padding: 8px 6px;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-rank {\n  width: 28px;\n  padding-left: 16px;\n  padding-right: 4px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-name {\n  width: 38%;\n  min-width: 0;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-sentiment {\n  width: 72px;\n  text-align: center;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-mentions {\n  width: 52px;\n  text-align: center;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-coverage {\n  width: 104px;\n  min-width: 104px;\n  max-width: 104px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.geo-insights-ranking-card .geo-insights-data-table .col-sov {\n  width: 64px;\n  min-width: 64px;\n  max-width: 64px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table th.col-sov,\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table td.col-sov {\n  padding-right: 16px;\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table thead th {\n  border-bottom: 1px solid var(--border);\n}\n\n.geo-insights-kpi-chart-layout > .geo-insights-ranking-card .geo-insights-data-table tbody td {\n  border-bottom: 1px solid var(--border);\n}\n\n/* Citations row — chart (3/5) + table (2/5); table sets row height, chart fills it */\n.geo-insights-citations-layout {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  align-items: stretch;\n  gap: 12px;\n  width: 100%;\n  margin-top: 20px;\n}\n\n.geo-insights-citations-layout > .geo-insights-citations-chart-card {\n  grid-column: 1 / 4;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.geo-insights-citations-layout > .geo-insights-citations-card {\n  grid-column: 4 / 6;\n  width: 100%;\n  max-width: 100%;\n  margin-bottom: 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  align-self: start;\n}\n\n\n.geo-citations-chart-wrap {\n  position: relative;\n  flex: 1;\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n}\n\n.geo-insights-citations-chart-card .geo-citations-chart {\n  position: absolute;\n  inset: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.geo-citations-chart-labels {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.geo-citations-chart-labels__y-tick {\n  position: absolute;\n  transform: translate(-100%, -50%);\n}\n\n.geo-citations-chart-labels__x-tick {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  max-width: 72px;\n  text-align: center;\n}\n\n.geo-citations-chart-labels__bar-value {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--c-black);\n  line-height: 1;\n  user-select: none;\n}\n\n.geo-insights-citations-layout > .geo-insights-citations-card .geo-insights-table-wrap {\n  flex: none;\n  overflow: visible;\n  padding: 0;\n}\n\n.geo-insights-citations-card .geo-citations-table tbody tr {\n  height: auto;\n}\n\n.geo-insights-citations-card .geo-citations-table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n  background: var(--c-white);\n  border-bottom: none;\n  box-shadow: inset 0 -1px 0 var(--border);\n}\n\n.geo-insights-citations-card .geo-citations-table th,\n.geo-insights-citations-card .geo-citations-table td {\n  padding: 8px 12px;\n}\n\n.geo-insights-citations-card .geo-citations-table th:first-child,\n.geo-insights-citations-card .geo-citations-table td:first-child {\n  padding-left: 16px;\n}\n\n.geo-insights-citations-card .geo-citations-table th:last-child,\n.geo-insights-citations-card .geo-citations-table td:last-child {\n  padding-right: 16px;\n}\n\n.geo-insights-citations-card .geo-citations-table__col-rank,\n.geo-insights-citations-card .geo-citations-table__col-share,\n.geo-insights-citations-card .geo-citations-table__col-count,\n.geo-insights-citations-card .geo-citations-table td:first-child,\n.geo-insights-citations-card .geo-citations-table td:nth-child(3),\n.geo-insights-citations-card .geo-citations-table td:nth-child(4) {\n  text-align: center;\n}\n\n.geo-insights-citations-card .geo-citations-table thead th:nth-child(3) .geo-table-header-label {\n  justify-content: center;\n}\n\n.geo-insights-citations-card .geo-citations-card__footer {\n  flex-shrink: 0;\n  margin-top: 0;\n}\n\n.geo-citations-chart__bar-label {\n  fill: var(--c-black);\n  font-size: 12px;\n  font-weight: 600;\n  pointer-events: none;\n  user-select: none;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-citations-chart-card .geo-citations-chart__bar {\n  transform-box: fill-box;\n  transform-origin: center bottom;\n  animation: filingsBarGrowUp 0.55s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.12s + min(var(--bar-index, 0), 30) * 0.018s);\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card,\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card {\n  animation: filingsInsightsCardIn 0.48s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-chart-card {\n  animation-delay: 0.48s;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-insights-citations-layout > .geo-insights-citations-card {\n  animation-delay: 0.56s;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table thead tr {\n  animation: filingsInsightsFadeIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) 0.1s backwards;\n}\n\n.table-area.geo-analytics-panel.insights-panel .geo-insights-content .geo-citations-table tbody tr {\n  animation: filingsTableRowIn 0.38s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: calc(0.1s + min(var(--table-row-delay, 0), 24) * 0.022s);\n}\n\n.geo-insights-ranking-card .geo-brand-name-cell {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  max-width: 100%;\n}\n\n.geo-insights-ranking-card .geo-brand-name-cell__label {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.geo-insights-chart-card .chart-panel__body {\n  min-height: 0;\n  width: 100%;\n  flex: none;\n  padding-right: 8px;\n  box-sizing: border-box;\n}\n\n.geo-insights-citations-chart-card.geo-insights-chart-card .chart-panel__body {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.geo-insights-citations-chart-card .geo-insights-chart-legend--top {\n  margin-bottom: 4px;\n}\n\n.geo-insights-table-card__actions {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.geo-insights-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 260px;\n  color: var(--text3);\n  gap: 8px;\n}\n\n.geo-insights-empty__icon {\n  font-size: 28px;\n  opacity: 0.5;\n}\n\n.geo-insights-line-chart-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.geo-insights-line-chart {\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 994 / 400;\n}\n\n.geo-insights-line-chart__grid {\n  stroke: var(--border);\n  stroke-width: 1;\n}\n\n.geo-insights-line-chart__axis {\n  stroke: var(--border);\n  stroke-width: 1;\n}\n\n.geo-insights-line-chart__tick--x {\n  letter-spacing: 0.01em;\n}\n\n.geo-insights-line-chart__line {\n  vector-effect: non-scaling-stroke;\n}\n\n.geo-insights-line-chart__dot {\n  fill: var(--c-white);\n  stroke-width: 1.5px;\n  vector-effect: non-scaling-stroke;\n  pointer-events: none;\n  transition: r 0.12s ease;\n}\n\n.geo-insights-line-chart__dot--hovered {\n  stroke-width: 2px;\n}\n\n.geo-insights-line-chart__hit {\n  cursor: crosshair;\n}\n\n.geo-insights-line-chart__cursor {\n  stroke: var(--text3);\n  stroke-width: 1;\n  stroke-dasharray: 4 3;\n  pointer-events: none;\n}\n\n.geo-line-chart-tooltip {\n  transform: translate(-50%, calc(-100% - 14px));\n  padding: 10px 12px;\n  gap: 0;\n  min-width: 200px;\n  max-width: min(320px, 90vw);\n}\n\n.geo-line-chart-tooltip__date {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-bottom: 8px;\n  padding-bottom: 6px;\n  border-bottom: 1px solid var(--border2);\n}\n\n.geo-line-chart-tooltip__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.geo-line-chart-tooltip__row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  color: var(--c-black);\n}\n\n.geo-line-chart-tooltip__swatch {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.geo-line-chart-tooltip__brand {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.geo-line-chart-tooltip__value {\n  font-variant-numeric: tabular-nums;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.geo-line-chart-tooltip__empty {\n  margin: 0;\n  font-size: 12px;\n  color: var(--text2);\n}\n\n.geo-insights-chart-legend--top {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\n\n.geo-insights-kpi-grid {\n  margin-bottom: 20px;\n}\n\n@media (max-width: 1100px) {\n  .geo-insights-kpi-chart-layout {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .geo-insights-kpi-chart-layout > .geo-insights-chart-card {\n    grid-column: 1 / -1;\n    grid-row: 2;\n  }\n\n  .geo-insights-kpi-chart-layout > .geo-insights-ranking-card {\n    grid-column: 1 / -1;\n    grid-row: 3;\n  }\n\n  .geo-insights-citations-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n\n  .geo-insights-citations-layout > .geo-insights-citations-chart-card,\n  .geo-insights-citations-layout > .geo-insights-citations-card {\n    grid-column: 1 / -1;\n  }\n}\n\n@media (max-width: 640px) {\n  .geo-insights-kpi-chart-layout {\n    grid-template-columns: minmax(0, 1fr);\n  }\n}\n\n.geo-insights-kpi-grid--empty {\n  margin-bottom: 20px;\n}\n\n.geo-insights-table-card {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.geo-insights-table-wrap {\n  padding: 0 24px 8px;\n  overflow-x: auto;\n}\n\n.geo-insights-data-table td.geo-prompt-cell {\n  max-width: 320px;\n  white-space: normal;\n  line-height: 1.4;\n}\n\n.geo-brand-name-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n}\n\n.geo-brand-avatar {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 9px;\n  font-weight: 700;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.geo-insights-row--client {\n  background: rgba(116, 86, 218, 0.04);\n}\n\n.geo-insights-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 8px 16px 12px;\n  font-size: 13px;\n}\n\n.geo-insights-link {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-purple, #7456da);\n  text-decoration: none;\n}\n\n.geo-insights-link:hover {\n  text-decoration: underline;\n}\n\n.geo-filters-drawer .filters-drawer-body {\n  gap: 0;\n}\n\n.geo-filters-drawer .accordion-item {\n  border-bottom: 1px solid var(--border);\n}\n\n.geo-filters-drawer__custom-range {\n  padding: 12px 16px 16px;\n  border-top: 1px solid var(--border);\n}\n\n/* Social Post Card */\n.social-post-card {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.social-post-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 16px;\n}\n\n.social-post-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--c-blue-1);\n  color: var(--c-white);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.social-post-header-text {\n  display: flex;\n  flex-direction: column;\n}\n\n.social-post-company {\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--c-black);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n.social-post-sponsored {\n  font-size: 12px;\n  color: var(--text2);\n}\n\n.social-post-body {\n  padding: 0 16px 16px 16px;\n  font-size: 14px;\n  line-height: 1.5;\n  color: var(--c-black);\n  white-space: pre-wrap;\n}\n\n.social-post-creative {\n  width: 100%;\n  background: #f0f2f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  min-height: 250px;\n}\n\n.social-post-image {\n  width: 100%;\n  height: 100%;\n  min-height: 250px;\n  max-height: 700px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.social-post-image img {\n  width: 100% !important;\n  height: 100% !important;\n  max-height: 700px !important;\n  object-fit: contain !important;\n}\n\n.social-post-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 16px;\n  background: #f0f2f5;\n  border-top: 1px solid #dddfe2;\n}\n\n.social-post-footer-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  overflow: hidden;\n  padding-right: 12px;\n}\n\n.social-post-footer-domain {\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--text2);\n  letter-spacing: 0.05em;\n}\n\n.social-post-footer-title {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--c-black);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  word-break: break-word;\n}\n\n/* Ad Inspector Panel */\n.ad-inspector-panel {\n  background: var(--c-white);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  overflow: hidden;\n  animation: filingsInsightsCardIn 0.45s cubic-bezier(0.16, 1, 0.3, 1) backwards;\n  animation-delay: 0.24s;\n}\n\n.ad-inspector-header {\n  padding: 16px;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--ink-emphasis);\n  border-bottom: 1px solid var(--border);\n  background: var(--bg2, #f9fafb);\n}\n\n.ad-inspector-section {\n  padding: 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.ad-inspector-section:last-child {\n  border-bottom: none;\n}\n\n.ad-inspector-section-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--c-black);\n  margin-bottom: 14px;\n}\n\n.ad-inspector-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px 12px;\n}\n\n.ad-inspector-field {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ad-inspector-field.full-width {\n  grid-column: 1 / -1;\n}\n\n.ad-inspector-label {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ad-inspector-label svg {\n  color: var(--text3);\n}\n\n.ad-inspector-value {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--c-black);\n  line-height: 1.4;\n  word-break: break-word;\n}\n/* Marketing Table Thumbnail */\n.marketing-table-thumb {\n  width: 64px;\n  height: 36px;\n  flex-shrink: 0;\n  border-radius: 4px;\n  overflow: hidden;\n  background-color: var(--c-gray-1, #e2e8f0);\n}\n\n.marketing-table-thumb .ad-creative-thumb__play-icon {\n  width: 20px;\n  height: 20px;\n  box-shadow: 0 1px 4px rgba(0,0,0,0.3);\n}\n\n.marketing-table-thumb .ad-creative-thumb__play-icon svg {\n  width: 10px;\n  height: 10px;\n}\n\n.marketing-table-thumb .ad-creative-thumb__badge {\n  font-size: 8px;\n  padding: 1px 4px;\n  right: 2px;\n  bottom: 2px;\n}\n\n.marketing-table-thumb .ad-creative-thumb__spinner {\n  width: 16px;\n  height: 16px;\n  border-width: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
